/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _app = __webpack_require__(776);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _coupon = __webpack_require__(778);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	var _shop_city = __webpack_require__(786);
	
	var _shop_city2 = _interopRequireDefault(_shop_city);
	
	var _law = __webpack_require__(781);
	
	var _law2 = _interopRequireDefault(_law);
	
	var _platform_protocol = __webpack_require__(784);
	
	var _platform_protocol2 = _interopRequireDefault(_platform_protocol);
	
	var _leasing_contract = __webpack_require__(782);
	
	var _leasing_contract2 = _interopRequireDefault(_leasing_contract);
	
	var _privacy_policy = __webpack_require__(785);
	
	var _privacy_policy2 = _interopRequireDefault(_privacy_policy);
	
	var _help = __webpack_require__(779);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _common_problem = __webpack_require__(777);
	
	var _common_problem2 = _interopRequireDefault(_common_problem);
	
	var _help_detail = __webpack_require__(780);
	
	var _help_detail2 = _interopRequireDefault(_help_detail);
	
	var _license_information = __webpack_require__(783);
	
	var _license_information2 = _interopRequireDefault(_license_information);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//加载格式化样式
	__webpack_require__(60);
	
	// 加载vue框架
	var Vue = __webpack_require__(23);
	var vueRouter = __webpack_require__(163);
	Vue.use(vueRouter);
	
	var router = new vueRouter();
	router.map({
	    'coupon': { //优惠券说明
	        component: _coupon2.default
	    },
	    'shopCity': { //商城说明
	        component: _shop_city2.default
	    },
	    'Law': { //法律条款和隐私政策
	        component: _law2.default
	    },
	    'platformProtocol': { //响车车平台协议
	        component: _platform_protocol2.default
	    },
	    'leasingContract': { //分时租赁合同
	        component: _leasing_contract2.default
	    },
	    'privacyPolicy': { //隐私政策
	        component: _privacy_policy2.default
	    },
	    'help': { //使用帮助3.0
	        component: _help2.default
	    },
	    'commonProblem': { //常见问题
	        component: _common_problem2.default
	    },
	    'helpDetail/:index': { //使用帮助内容3.0
	        component: _help_detail2.default
	
	    },
	    'licenseInformation': { //证照信息
	        component: _license_information2.default
	
	    }
	
	});
	router.redirect({
	    '/': '/coupon'
	});
	router.start(_app2.default, '#app');

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Vue = __webpack_require__(15);
	module.exports = new Vue();

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	var charenc = {
	  // UTF-8 encoding
	  utf8: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	    }
	  },
	
	  // Binary encoding
	  bin: {
	    // Convert a string to a byte array
	    stringToBytes: function(str) {
	      for (var bytes = [], i = 0; i < str.length; i++)
	        bytes.push(str.charCodeAt(i) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a string
	    bytesToString: function(bytes) {
	      for (var str = [], i = 0; i < bytes.length; i++)
	        str.push(String.fromCharCode(bytes[i]));
	      return str.join('');
	    }
	  }
	};
	
	module.exports = charenc;


/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Vue.js v1.0.28
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	function set(obj, key, val) {
	  if (hasOwn(obj, key)) {
	    obj[key] = val;
	    return;
	  }
	  if (obj._isVue) {
	    set(obj._data, key, val);
	    return;
	  }
	  var ob = obj.__ob__;
	  if (!ob) {
	    obj[key] = val;
	    return;
	  }
	  ob.convert(key, val);
	  ob.dep.notify();
	  if (ob.vms) {
	    var i = ob.vms.length;
	    while (i--) {
	      var vm = ob.vms[i];
	      vm._proxy(key);
	      vm._digest();
	    }
	  }
	  return val;
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 */
	
	function del(obj, key) {
	  if (!hasOwn(obj, key)) {
	    return;
	  }
	  delete obj[key];
	  var ob = obj.__ob__;
	  if (!ob) {
	    if (obj._isVue) {
	      delete obj._data[key];
	      obj._digest();
	    }
	    return;
	  }
	  ob.dep.notify();
	  if (ob.vms) {
	    var i = ob.vms.length;
	    while (i--) {
	      var vm = ob.vms[i];
	      vm._unproxy(key);
	      vm._digest();
	    }
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	 * Check whether the object has the property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @return {Boolean}
	 */
	
	function hasOwn(obj, key) {
	  return hasOwnProperty.call(obj, key);
	}
	
	/**
	 * Check if an expression is a literal value.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;
	
	function isLiteral(exp) {
	  return literalValueRE.test(exp);
	}
	
	/**
	 * Check if a string starts with $ or _
	 *
	 * @param {String} str
	 * @return {Boolean}
	 */
	
	function isReserved(str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F;
	}
	
	/**
	 * Guard text output, make sure undefined outputs
	 * empty string
	 *
	 * @param {*} value
	 * @return {String}
	 */
	
	function _toString(value) {
	  return value == null ? '' : value.toString();
	}
	
	/**
	 * Check and convert possible numeric strings to numbers
	 * before setting back to data
	 *
	 * @param {*} value
	 * @return {*|Number}
	 */
	
	function toNumber(value) {
	  if (typeof value !== 'string') {
	    return value;
	  } else {
	    var parsed = Number(value);
	    return isNaN(parsed) ? value : parsed;
	  }
	}
	
	/**
	 * Convert string boolean literals into real booleans.
	 *
	 * @param {*} value
	 * @return {*|Boolean}
	 */
	
	function toBoolean(value) {
	  return value === 'true' ? true : value === 'false' ? false : value;
	}
	
	/**
	 * Strip quotes from a string
	 *
	 * @param {String} str
	 * @return {String | false}
	 */
	
	function stripQuotes(str) {
	  var a = str.charCodeAt(0);
	  var b = str.charCodeAt(str.length - 1);
	  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var camelizeRE = /-(\w)/g;
	
	function camelize(str) {
	  return str.replace(camelizeRE, toUpper);
	}
	
	function toUpper(_, c) {
	  return c ? c.toUpperCase() : '';
	}
	
	/**
	 * Hyphenate a camelCase string.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var hyphenateRE = /([^-])([A-Z])/g;
	
	function hyphenate(str) {
	  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
	}
	
	/**
	 * Converts hyphen/underscore/slash delimitered names into
	 * camelized classNames.
	 *
	 * e.g. my-component => MyComponent
	 *      some_else    => SomeElse
	 *      some/comp    => SomeComp
	 *
	 * @param {String} str
	 * @return {String}
	 */
	
	var classifyRE = /(?:^|[-_\/])(\w)/g;
	
	function classify(str) {
	  return str.replace(classifyRE, toUpper);
	}
	
	/**
	 * Simple bind, faster than native
	 *
	 * @param {Function} fn
	 * @param {Object} ctx
	 * @return {Function}
	 */
	
	function bind(fn, ctx) {
	  return function (a) {
	    var l = arguments.length;
	    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
	  };
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 *
	 * @param {Array-like} list
	 * @param {Number} [start] - start index
	 * @return {Array}
	 */
	
	function toArray(list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret;
	}
	
	/**
	 * Mix properties into target object.
	 *
	 * @param {Object} to
	 * @param {Object} from
	 */
	
	function extend(to, from) {
	  var keys = Object.keys(from);
	  var i = keys.length;
	  while (i--) {
	    to[keys[i]] = from[keys[i]];
	  }
	  return to;
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object';
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	var toString = Object.prototype.toString;
	var OBJECT_STRING = '[object Object]';
	
	function isPlainObject(obj) {
	  return toString.call(obj) === OBJECT_STRING;
	}
	
	/**
	 * Array type check.
	 *
	 * @param {*} obj
	 * @return {Boolean}
	 */
	
	var isArray = Array.isArray;
	
	/**
	 * Define a property.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @param {*} val
	 * @param {Boolean} [enumerable]
	 */
	
	function def(obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Debounce a function so it only gets called after the
	 * input stops arriving after the given wait period.
	 *
	 * @param {Function} func
	 * @param {Number} wait
	 * @return {Function} - the debounced function
	 */
	
	function _debounce(func, wait) {
	  var timeout, args, context, timestamp, result;
	  var later = function later() {
	    var last = Date.now() - timestamp;
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    }
	  };
	  return function () {
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	    return result;
	  };
	}
	
	/**
	 * Manual indexOf because it's slightly faster than
	 * native.
	 *
	 * @param {Array} arr
	 * @param {*} obj
	 */
	
	function indexOf(arr, obj) {
	  var i = arr.length;
	  while (i--) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	}
	
	/**
	 * Make a cancellable version of an async callback.
	 *
	 * @param {Function} fn
	 * @return {Function}
	 */
	
	function cancellable(fn) {
	  var cb = function cb() {
	    if (!cb.cancelled) {
	      return fn.apply(this, arguments);
	    }
	  };
	  cb.cancel = function () {
	    cb.cancelled = true;
	  };
	  return cb;
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 *
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 */
	
	function looseEqual(a, b) {
	  /* eslint-disable eqeqeq */
	  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
	  /* eslint-enable eqeqeq */
	}
	
	var hasProto = ('__proto__' in {});
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	// UA sniffing for working around browser-specific quirks
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && UA.indexOf('trident') > 0;
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	
	var transitionProp = undefined;
	var transitionEndEvent = undefined;
	var animationProp = undefined;
	var animationEndEvent = undefined;
	
	// Transition property/event sniffing
	if (inBrowser && !isIE9) {
	  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
	  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
	  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
	  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
	  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
	  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
	}
	
	/* istanbul ignore next */
	function isNative(Ctor) {
	  return (/native code/.test(Ctor.toString())
	  );
	}
	
	/**
	 * Defer a task to execute it asynchronously. Ideally this
	 * should be executed as a microtask, so we leverage
	 * MutationObserver if it's available, and fallback to
	 * setTimeout(0).
	 *
	 * @param {Function} cb
	 * @param {Object} ctx
	 */
	
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc = undefined;
	
	  function nextTickHandler() {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var noop = function noop() {};
	    timerFunc = function () {
	      p.then(nextTickHandler);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) setTimeout(noop);
	    };
	  } else if (typeof MutationObserver !== 'undefined') {
	    // use MutationObserver where native Promise is not available,
	    // e.g. IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = setTimeout;
	  }
	
	  return function (cb, ctx) {
	    var func = ctx ? function () {
	      cb.call(ctx);
	    } : cb;
	    callbacks.push(func);
	    if (pending) return;
	    pending = true;
	    timerFunc(nextTickHandler, 0);
	  };
	})();
	
	var _Set = undefined;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = function () {
	    this.set = Object.create(null);
	  };
	  _Set.prototype.has = function (key) {
	    return this.set[key] !== undefined;
	  };
	  _Set.prototype.add = function (key) {
	    this.set[key] = 1;
	  };
	  _Set.prototype.clear = function () {
	    this.set = Object.create(null);
	  };
	}
	
	function Cache(limit) {
	  this.size = 0;
	  this.limit = limit;
	  this.head = this.tail = undefined;
	  this._keymap = Object.create(null);
	}
	
	var p = Cache.prototype;
	
	/**
	 * Put <value> into the cache associated with <key>.
	 * Returns the entry which was removed to make room for
	 * the new entry. Otherwise undefined is returned.
	 * (i.e. if there was enough room already).
	 *
	 * @param {String} key
	 * @param {*} value
	 * @return {Entry|undefined}
	 */
	
	p.put = function (key, value) {
	  var removed;
	
	  var entry = this.get(key, true);
	  if (!entry) {
	    if (this.size === this.limit) {
	      removed = this.shift();
	    }
	    entry = {
	      key: key
	    };
	    this._keymap[key] = entry;
	    if (this.tail) {
	      this.tail.newer = entry;
	      entry.older = this.tail;
	    } else {
	      this.head = entry;
	    }
	    this.tail = entry;
	    this.size++;
	  }
	  entry.value = value;
	
	  return removed;
	};
	
	/**
	 * Purge the least recently used (oldest) entry from the
	 * cache. Returns the removed entry or undefined if the
	 * cache was empty.
	 */
	
	p.shift = function () {
	  var entry = this.head;
	  if (entry) {
	    this.head = this.head.newer;
	    this.head.older = undefined;
	    entry.newer = entry.older = undefined;
	    this._keymap[entry.key] = undefined;
	    this.size--;
	  }
	  return entry;
	};
	
	/**
	 * Get and register recent use of <key>. Returns the value
	 * associated with <key> or undefined if not in cache.
	 *
	 * @param {String} key
	 * @param {Boolean} returnEntry
	 * @return {Entry|*}
	 */
	
	p.get = function (key, returnEntry) {
	  var entry = this._keymap[key];
	  if (entry === undefined) return;
	  if (entry === this.tail) {
	    return returnEntry ? entry : entry.value;
	  }
	  // HEAD--------------TAIL
	  //   <.older   .newer>
	  //  <--- add direction --
	  //   A  B  C  <D>  E
	  if (entry.newer) {
	    if (entry === this.head) {
	      this.head = entry.newer;
	    }
	    entry.newer.older = entry.older; // C <-- E.
	  }
	  if (entry.older) {
	    entry.older.newer = entry.newer; // C. --> E
	  }
	  entry.newer = undefined; // D --x
	  entry.older = this.tail; // D. --> E
	  if (this.tail) {
	    this.tail.newer = entry; // E. <-- D
	  }
	  this.tail = entry;
	  return returnEntry ? entry : entry.value;
	};
	
	var cache$1 = new Cache(1000);
	var reservedArgRE = /^in$|^-?\d+/;
	
	/**
	 * Parser state
	 */
	
	var str;
	var dir;
	var len;
	var index;
	var chr;
	var state;
	var startState = 0;
	var filterState = 1;
	var filterNameState = 2;
	var filterArgState = 3;
	
	var doubleChr = 0x22;
	var singleChr = 0x27;
	var pipeChr = 0x7C;
	var escapeChr = 0x5C;
	var spaceChr = 0x20;
	
	var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
	var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };
	
	function peek() {
	  return str.charCodeAt(index + 1);
	}
	
	function next() {
	  return str.charCodeAt(++index);
	}
	
	function eof() {
	  return index >= len;
	}
	
	function eatSpace() {
	  while (peek() === spaceChr) {
	    next();
	  }
	}
	
	function isStringStart(chr) {
	  return chr === doubleChr || chr === singleChr;
	}
	
	function isExpStart(chr) {
	  return expStartChr[chr];
	}
	
	function isExpEnd(start, chr) {
	  return expChrPair[start] === chr;
	}
	
	function parseString() {
	  var stringQuote = next();
	  var chr;
	  while (!eof()) {
	    chr = next();
	    // escape char
	    if (chr === escapeChr) {
	      next();
	    } else if (chr === stringQuote) {
	      break;
	    }
	  }
	}
	
	function parseSpecialExp(chr) {
	  var inExp = 0;
	  var startChr = chr;
	
	  while (!eof()) {
	    chr = peek();
	    if (isStringStart(chr)) {
	      parseString();
	      continue;
	    }
	
	    if (startChr === chr) {
	      inExp++;
	    }
	    if (isExpEnd(startChr, chr)) {
	      inExp--;
	    }
	
	    next();
	
	    if (inExp === 0) {
	      break;
	    }
	  }
	}
	
	/**
	 * syntax:
	 * expression | filterName  [arg  arg [| filterName arg arg]]
	 */
	
	function parseExpression() {
	  var start = index;
	  while (!eof()) {
	    chr = peek();
	    if (isStringStart(chr)) {
	      parseString();
	    } else if (isExpStart(chr)) {
	      parseSpecialExp(chr);
	    } else if (chr === pipeChr) {
	      next();
	      chr = peek();
	      if (chr === pipeChr) {
	        next();
	      } else {
	        if (state === startState || state === filterArgState) {
	          state = filterState;
	        }
	        break;
	      }
	    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
	      eatSpace();
	      break;
	    } else {
	      if (state === filterState) {
	        state = filterNameState;
	      }
	      next();
	    }
	  }
	
	  return str.slice(start + 1, index) || null;
	}
	
	function parseFilterList() {
	  var filters = [];
	  while (!eof()) {
	    filters.push(parseFilter());
	  }
	  return filters;
	}
	
	function parseFilter() {
	  var filter = {};
	  var args;
	
	  state = filterState;
	  filter.name = parseExpression().trim();
	
	  state = filterArgState;
	  args = parseFilterArguments();
	
	  if (args.length) {
	    filter.args = args;
	  }
	  return filter;
	}
	
	function parseFilterArguments() {
	  var args = [];
	  while (!eof() && state !== filterState) {
	    var arg = parseExpression();
	    if (!arg) {
	      break;
	    }
	    args.push(processFilterArg(arg));
	  }
	
	  return args;
	}
	
	/**
	 * Check if an argument is dynamic and strip quotes.
	 *
	 * @param {String} arg
	 * @return {Object}
	 */
	
	function processFilterArg(arg) {
	  if (reservedArgRE.test(arg)) {
	    return {
	      value: toNumber(arg),
	      dynamic: false
	    };
	  } else {
	    var stripped = stripQuotes(arg);
	    var dynamic = stripped === arg;
	    return {
	      value: dynamic ? arg : stripped,
	      dynamic: dynamic
	    };
	  }
	}
	
	/**
	 * Parse a directive value and extract the expression
	 * and its filters into a descriptor.
	 *
	 * Example:
	 *
	 * "a + 1 | uppercase" will yield:
	 * {
	 *   expression: 'a + 1',
	 *   filters: [
	 *     { name: 'uppercase', args: null }
	 *   ]
	 * }
	 *
	 * @param {String} s
	 * @return {Object}
	 */
	
	function parseDirective(s) {
	  var hit = cache$1.get(s);
	  if (hit) {
	    return hit;
	  }
	
	  // reset parser state
	  str = s;
	  dir = {};
	  len = str.length;
	  index = -1;
	  chr = '';
	  state = startState;
	
	  var filters;
	
	  if (str.indexOf('|') < 0) {
	    dir.expression = str.trim();
	  } else {
	    dir.expression = parseExpression().trim();
	    filters = parseFilterList();
	    if (filters.length) {
	      dir.filters = filters;
	    }
	  }
	
	  cache$1.put(s, dir);
	  return dir;
	}
	
	var directive = Object.freeze({
	  parseDirective: parseDirective
	});
	
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	var cache = undefined;
	var tagRE = undefined;
	var htmlRE = undefined;
	/**
	 * Escape a string so it can be used in a RegExp
	 * constructor.
	 *
	 * @param {String} str
	 */
	
	function escapeRegex(str) {
	  return str.replace(regexEscapeRE, '\\$&');
	}
	
	function compileRegex() {
	  var open = escapeRegex(config.delimiters[0]);
	  var close = escapeRegex(config.delimiters[1]);
	  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
	  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
	  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
	  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
	  // reset cache
	  cache = new Cache(1000);
	}
	
	/**
	 * Parse a template text string into an array of tokens.
	 *
	 * @param {String} text
	 * @return {Array<Object> | null}
	 *               - {String} type
	 *               - {String} value
	 *               - {Boolean} [html]
	 *               - {Boolean} [oneTime]
	 */
	
	function parseText(text) {
	  if (!cache) {
	    compileRegex();
	  }
	  var hit = cache.get(text);
	  if (hit) {
	    return hit;
	  }
	  if (!tagRE.test(text)) {
	    return null;
	  }
	  var tokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index, html, value, first, oneTime;
	  /* eslint-disable no-cond-assign */
	  while (match = tagRE.exec(text)) {
	    /* eslint-enable no-cond-assign */
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      tokens.push({
	        value: text.slice(lastIndex, index)
	      });
	    }
	    // tag token
	    html = htmlRE.test(match[0]);
	    value = html ? match[1] : match[2];
	    first = value.charCodeAt(0);
	    oneTime = first === 42; // *
	    value = oneTime ? value.slice(1) : value;
	    tokens.push({
	      tag: true,
	      value: value.trim(),
	      html: html,
	      oneTime: oneTime
	    });
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    tokens.push({
	      value: text.slice(lastIndex)
	    });
	  }
	  cache.put(text, tokens);
	  return tokens;
	}
	
	/**
	 * Format a list of tokens into an expression.
	 * e.g. tokens parsed from 'a {{b}} c' can be serialized
	 * into one single expression as '"a " + b + " c"'.
	 *
	 * @param {Array} tokens
	 * @param {Vue} [vm]
	 * @return {String}
	 */
	
	function tokensToExp(tokens, vm) {
	  if (tokens.length > 1) {
	    return tokens.map(function (token) {
	      return formatToken(token, vm);
	    }).join('+');
	  } else {
	    return formatToken(tokens[0], vm, true);
	  }
	}
	
	/**
	 * Format a single token.
	 *
	 * @param {Object} token
	 * @param {Vue} [vm]
	 * @param {Boolean} [single]
	 * @return {String}
	 */
	
	function formatToken(token, vm, single) {
	  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
	}
	
	/**
	 * For an attribute with multiple interpolation tags,
	 * e.g. attr="some-{{thing | filter}}", in order to combine
	 * the whole thing into a single watchable expression, we
	 * have to inline those filters. This function does exactly
	 * that. This is a bit hacky but it avoids heavy changes
	 * to directive parser and watcher mechanism.
	 *
	 * @param {String} exp
	 * @param {Boolean} single
	 * @return {String}
	 */
	
	var filterRE = /[^|]\|[^|]/;
	function inlineFilters(exp, single) {
	  if (!filterRE.test(exp)) {
	    return single ? exp : '(' + exp + ')';
	  } else {
	    var dir = parseDirective(exp);
	    if (!dir.filters) {
	      return '(' + exp + ')';
	    } else {
	      return 'this._applyFilters(' + dir.expression + // value
	      ',null,' + // oldValue (null for read)
	      JSON.stringify(dir.filters) + // filter descriptors
	      ',false)'; // write?
	    }
	  }
	}
	
	var text = Object.freeze({
	  compileRegex: compileRegex,
	  parseText: parseText,
	  tokensToExp: tokensToExp
	});
	
	var delimiters = ['{{', '}}'];
	var unsafeDelimiters = ['{{{', '}}}'];
	
	var config = Object.defineProperties({
	
	  /**
	   * Whether to print debug messages.
	   * Also enables stack trace for warnings.
	   *
	   * @type {Boolean}
	   */
	
	  debug: false,
	
	  /**
	   * Whether to suppress warnings.
	   *
	   * @type {Boolean}
	   */
	
	  silent: false,
	
	  /**
	   * Whether to use async rendering.
	   */
	
	  async: true,
	
	  /**
	   * Whether to warn against errors caught when evaluating
	   * expressions.
	   */
	
	  warnExpressionErrors: true,
	
	  /**
	   * Whether to allow devtools inspection.
	   * Disabled by default in production builds.
	   */
	
	  devtools: ('production') !== 'production',
	
	  /**
	   * Internal flag to indicate the delimiters have been
	   * changed.
	   *
	   * @type {Boolean}
	   */
	
	  _delimitersChanged: true,
	
	  /**
	   * List of asset types that a component can own.
	   *
	   * @type {Array}
	   */
	
	  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],
	
	  /**
	   * prop binding modes
	   */
	
	  _propBindingModes: {
	    ONE_WAY: 0,
	    TWO_WAY: 1,
	    ONE_TIME: 2
	  },
	
	  /**
	   * Max circular updates allowed in a batcher flush cycle.
	   */
	
	  _maxUpdateCount: 100
	
	}, {
	  delimiters: { /**
	                 * Interpolation delimiters. Changing these would trigger
	                 * the text parser to re-compile the regular expressions.
	                 *
	                 * @type {Array<String>}
	                 */
	
	    get: function get() {
	      return delimiters;
	    },
	    set: function set(val) {
	      delimiters = val;
	      compileRegex();
	    },
	    configurable: true,
	    enumerable: true
	  },
	  unsafeDelimiters: {
	    get: function get() {
	      return unsafeDelimiters;
	    },
	    set: function set(val) {
	      unsafeDelimiters = val;
	      compileRegex();
	    },
	    configurable: true,
	    enumerable: true
	  }
	});
	
	var warn = undefined;
	var formatComponentName = undefined;
	
	if (false) {
	  (function () {
	    var hasConsole = typeof console !== 'undefined';
	
	    warn = function (msg, vm) {
	      if (hasConsole && !config.silent) {
	        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
	      }
	    };
	
	    formatComponentName = function (vm) {
	      var name = vm._isVue ? vm.$options.name : vm.name;
	      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
	    };
	  })();
	}
	
	/**
	 * Append with transition.
	 *
	 * @param {Element} el
	 * @param {Element} target
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function appendWithTransition(el, target, vm, cb) {
	  applyTransition(el, 1, function () {
	    target.appendChild(el);
	  }, vm, cb);
	}
	
	/**
	 * InsertBefore with transition.
	 *
	 * @param {Element} el
	 * @param {Element} target
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function beforeWithTransition(el, target, vm, cb) {
	  applyTransition(el, 1, function () {
	    before(el, target);
	  }, vm, cb);
	}
	
	/**
	 * Remove with transition.
	 *
	 * @param {Element} el
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function removeWithTransition(el, vm, cb) {
	  applyTransition(el, -1, function () {
	    remove(el);
	  }, vm, cb);
	}
	
	/**
	 * Apply transitions with an operation callback.
	 *
	 * @param {Element} el
	 * @param {Number} direction
	 *                  1: enter
	 *                 -1: leave
	 * @param {Function} op - the actual DOM operation
	 * @param {Vue} vm
	 * @param {Function} [cb]
	 */
	
	function applyTransition(el, direction, op, vm, cb) {
	  var transition = el.__v_trans;
	  if (!transition ||
	  // skip if there are no js hooks and CSS transition is
	  // not supported
	  !transition.hooks && !transitionEndEvent ||
	  // skip transitions for initial compile
	  !vm._isCompiled ||
	  // if the vm is being manipulated by a parent directive
	  // during the parent's compilation phase, skip the
	  // animation.
	  vm.$parent && !vm.$parent._isCompiled) {
	    op();
	    if (cb) cb();
	    return;
	  }
	  var action = direction > 0 ? 'enter' : 'leave';
	  transition[action](op, cb);
	}
	
	var transition = Object.freeze({
	  appendWithTransition: appendWithTransition,
	  beforeWithTransition: beforeWithTransition,
	  removeWithTransition: removeWithTransition,
	  applyTransition: applyTransition
	});
	
	/**
	 * Query an element selector if it's not an element already.
	 *
	 * @param {String|Element} el
	 * @return {Element}
	 */
	
	function query(el) {
	  if (typeof el === 'string') {
	    var selector = el;
	    el = document.querySelector(el);
	    if (!el) {
	      ('production') !== 'production' && warn('Cannot find element: ' + selector);
	    }
	  }
	  return el;
	}
	
	/**
	 * Check if a node is in the document.
	 * Note: document.documentElement.contains should work here
	 * but always returns false for comment nodes in phantomjs,
	 * making unit tests difficult. This is fixed by doing the
	 * contains() check on the node's parentNode instead of
	 * the node itself.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function inDoc(node) {
	  if (!node) return false;
	  var doc = node.ownerDocument.documentElement;
	  var parent = node.parentNode;
	  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
	}
	
	/**
	 * Get and remove an attribute from a node.
	 *
	 * @param {Node} node
	 * @param {String} _attr
	 */
	
	function getAttr(node, _attr) {
	  var val = node.getAttribute(_attr);
	  if (val !== null) {
	    node.removeAttribute(_attr);
	  }
	  return val;
	}
	
	/**
	 * Get an attribute with colon or v-bind: prefix.
	 *
	 * @param {Node} node
	 * @param {String} name
	 * @return {String|null}
	 */
	
	function getBindAttr(node, name) {
	  var val = getAttr(node, ':' + name);
	  if (val === null) {
	    val = getAttr(node, 'v-bind:' + name);
	  }
	  return val;
	}
	
	/**
	 * Check the presence of a bind attribute.
	 *
	 * @param {Node} node
	 * @param {String} name
	 * @return {Boolean}
	 */
	
	function hasBindAttr(node, name) {
	  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
	}
	
	/**
	 * Insert el before target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function before(el, target) {
	  target.parentNode.insertBefore(el, target);
	}
	
	/**
	 * Insert el after target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function after(el, target) {
	  if (target.nextSibling) {
	    before(el, target.nextSibling);
	  } else {
	    target.parentNode.appendChild(el);
	  }
	}
	
	/**
	 * Remove el from DOM
	 *
	 * @param {Element} el
	 */
	
	function remove(el) {
	  el.parentNode.removeChild(el);
	}
	
	/**
	 * Prepend el to target
	 *
	 * @param {Element} el
	 * @param {Element} target
	 */
	
	function prepend(el, target) {
	  if (target.firstChild) {
	    before(el, target.firstChild);
	  } else {
	    target.appendChild(el);
	  }
	}
	
	/**
	 * Replace target with el
	 *
	 * @param {Element} target
	 * @param {Element} el
	 */
	
	function replace(target, el) {
	  var parent = target.parentNode;
	  if (parent) {
	    parent.replaceChild(el, target);
	  }
	}
	
	/**
	 * Add event listener shorthand.
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Function} cb
	 * @param {Boolean} [useCapture]
	 */
	
	function on(el, event, cb, useCapture) {
	  el.addEventListener(event, cb, useCapture);
	}
	
	/**
	 * Remove event listener shorthand.
	 *
	 * @param {Element} el
	 * @param {String} event
	 * @param {Function} cb
	 */
	
	function off(el, event, cb) {
	  el.removeEventListener(event, cb);
	}
	
	/**
	 * For IE9 compat: when both class and :class are present
	 * getAttribute('class') returns wrong value...
	 *
	 * @param {Element} el
	 * @return {String}
	 */
	
	function getClass(el) {
	  var classname = el.className;
	  if (typeof classname === 'object') {
	    classname = classname.baseVal || '';
	  }
	  return classname;
	}
	
	/**
	 * In IE9, setAttribute('class') will result in empty class
	 * if the element also has the :class attribute; However in
	 * PhantomJS, setting `className` does not work on SVG elements...
	 * So we have to do a conditional check here.
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function setClass(el, cls) {
	  /* istanbul ignore if */
	  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
	    el.className = cls;
	  } else {
	    el.setAttribute('class', cls);
	  }
	}
	
	/**
	 * Add class with compatibility for IE & SVG
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function addClass(el, cls) {
	  if (el.classList) {
	    el.classList.add(cls);
	  } else {
	    var cur = ' ' + getClass(el) + ' ';
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      setClass(el, (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for IE & SVG
	 *
	 * @param {Element} el
	 * @param {String} cls
	 */
	
	function removeClass(el, cls) {
	  if (el.classList) {
	    el.classList.remove(cls);
	  } else {
	    var cur = ' ' + getClass(el) + ' ';
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    setClass(el, cur.trim());
	  }
	  if (!el.className) {
	    el.removeAttribute('class');
	  }
	}
	
	/**
	 * Extract raw content inside an element into a temporary
	 * container div
	 *
	 * @param {Element} el
	 * @param {Boolean} asFragment
	 * @return {Element|DocumentFragment}
	 */
	
	function extractContent(el, asFragment) {
	  var child;
	  var rawContent;
	  /* istanbul ignore if */
	  if (isTemplate(el) && isFragment(el.content)) {
	    el = el.content;
	  }
	  if (el.hasChildNodes()) {
	    trimNode(el);
	    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
	    /* eslint-disable no-cond-assign */
	    while (child = el.firstChild) {
	      /* eslint-enable no-cond-assign */
	      rawContent.appendChild(child);
	    }
	  }
	  return rawContent;
	}
	
	/**
	 * Trim possible empty head/tail text and comment
	 * nodes inside a parent.
	 *
	 * @param {Node} node
	 */
	
	function trimNode(node) {
	  var child;
	  /* eslint-disable no-sequences */
	  while ((child = node.firstChild, isTrimmable(child))) {
	    node.removeChild(child);
	  }
	  while ((child = node.lastChild, isTrimmable(child))) {
	    node.removeChild(child);
	  }
	  /* eslint-enable no-sequences */
	}
	
	function isTrimmable(node) {
	  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
	}
	
	/**
	 * Check if an element is a template tag.
	 * Note if the template appears inside an SVG its tagName
	 * will be in lowercase.
	 *
	 * @param {Element} el
	 */
	
	function isTemplate(el) {
	  return el.tagName && el.tagName.toLowerCase() === 'template';
	}
	
	/**
	 * Create an "anchor" for performing dom insertion/removals.
	 * This is used in a number of scenarios:
	 * - fragment instance
	 * - v-html
	 * - v-if
	 * - v-for
	 * - component
	 *
	 * @param {String} content
	 * @param {Boolean} persist - IE trashes empty textNodes on
	 *                            cloneNode(true), so in certain
	 *                            cases the anchor needs to be
	 *                            non-empty to be persisted in
	 *                            templates.
	 * @return {Comment|Text}
	 */
	
	function createAnchor(content, persist) {
	  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
	  anchor.__v_anchor = true;
	  return anchor;
	}
	
	/**
	 * Find a component ref attribute that starts with $.
	 *
	 * @param {Element} node
	 * @return {String|undefined}
	 */
	
	var refRE = /^v-ref:/;
	
	function findRef(node) {
	  if (node.hasAttributes()) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var name = attrs[i].name;
	      if (refRE.test(name)) {
	        return camelize(name.replace(refRE, ''));
	      }
	    }
	  }
	}
	
	/**
	 * Map a function to a range of nodes .
	 *
	 * @param {Node} node
	 * @param {Node} end
	 * @param {Function} op
	 */
	
	function mapNodeRange(node, end, op) {
	  var next;
	  while (node !== end) {
	    next = node.nextSibling;
	    op(node);
	    node = next;
	  }
	  op(end);
	}
	
	/**
	 * Remove a range of nodes with transition, store
	 * the nodes in a fragment with correct ordering,
	 * and call callback when done.
	 *
	 * @param {Node} start
	 * @param {Node} end
	 * @param {Vue} vm
	 * @param {DocumentFragment} frag
	 * @param {Function} cb
	 */
	
	function removeNodeRange(start, end, vm, frag, cb) {
	  var done = false;
	  var removed = 0;
	  var nodes = [];
	  mapNodeRange(start, end, function (node) {
	    if (node === end) done = true;
	    nodes.push(node);
	    removeWithTransition(node, vm, onRemoved);
	  });
	  function onRemoved() {
	    removed++;
	    if (done && removed >= nodes.length) {
	      for (var i = 0; i < nodes.length; i++) {
	        frag.appendChild(nodes[i]);
	      }
	      cb && cb();
	    }
	  }
	}
	
	/**
	 * Check if a node is a DocumentFragment.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function isFragment(node) {
	  return node && node.nodeType === 11;
	}
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 *
	 * @param {Element} el
	 * @return {String}
	 */
	
	function getOuterHTML(el) {
	  if (el.outerHTML) {
	    return el.outerHTML;
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML;
	  }
	}
	
	var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
	var reservedTagRE = /^(slot|partial|component)$/i;
	
	var isUnknownElement = undefined;
	if (false) {
	  isUnknownElement = function (el, tag) {
	    if (tag.indexOf('-') > -1) {
	      // http://stackoverflow.com/a/28210364/1070244
	      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
	    } else {
	      return (/HTMLUnknownElement/.test(el.toString()) &&
	        // Chrome returns unknown for several HTML5 elements.
	        // https://code.google.com/p/chromium/issues/detail?id=540526
	        // Firefox returns unknown for some "Interactive elements."
	        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
	      );
	    }
	  };
	}
	
	/**
	 * Check if an element is a component, if yes return its
	 * component id.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Object|undefined}
	 */
	
	function checkComponentAttr(el, options) {
	  var tag = el.tagName.toLowerCase();
	  var hasAttrs = el.hasAttributes();
	  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
	    if (resolveAsset(options, 'components', tag)) {
	      return { id: tag };
	    } else {
	      var is = hasAttrs && getIsBinding(el, options);
	      if (is) {
	        return is;
	      } else if (false) {
	        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
	        if (expectedTag) {
	          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
	        } else if (isUnknownElement(el, tag)) {
	          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
	        }
	      }
	    }
	  } else if (hasAttrs) {
	    return getIsBinding(el, options);
	  }
	}
	
	/**
	 * Get "is" binding from an element.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Object|undefined}
	 */
	
	function getIsBinding(el, options) {
	  // dynamic syntax
	  var exp = el.getAttribute('is');
	  if (exp != null) {
	    if (resolveAsset(options, 'components', exp)) {
	      el.removeAttribute('is');
	      return { id: exp };
	    }
	  } else {
	    exp = getBindAttr(el, 'is');
	    if (exp != null) {
	      return { id: exp, dynamic: true };
	    }
	  }
	}
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 *
	 * All strategy functions follow the same signature:
	 *
	 * @param {*} parentVal
	 * @param {*} childVal
	 * @param {Vue} [vm]
	 */
	
	var strats = config.optionMergeStrategies = Object.create(null);
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	
	function mergeData(to, from) {
	  var key, toVal, fromVal;
	  for (key in from) {
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isObject(toVal) && isObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to;
	}
	
	/**
	 * Data
	 */
	
	strats.data = function (parentVal, childVal, vm) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal;
	    }
	    if (typeof childVal !== 'function') {
	      ('production') !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
	      return parentVal;
	    }
	    if (!parentVal) {
	      return childVal;
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn() {
	      return mergeData(childVal.call(this), parentVal.call(this));
	    };
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn() {
	      // instance merge
	      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
	      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData);
	      } else {
	        return defaultData;
	      }
	    };
	  }
	};
	
	/**
	 * El
	 */
	
	strats.el = function (parentVal, childVal, vm) {
	  if (!vm && childVal && typeof childVal !== 'function') {
	    ('production') !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
	    return;
	  }
	  var ret = childVal || parentVal;
	  // invoke the element factory if this is instance merge
	  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
	};
	
	/**
	 * Hooks and param attributes are merged as arrays.
	 */
	
	strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
	  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
	};
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	
	function mergeAssets(parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
	}
	
	config._assetTypes.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Events & Watchers.
	 *
	 * Events & watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	
	strats.watch = strats.events = function (parentVal, childVal) {
	  if (!childVal) return parentVal;
	  if (!parentVal) return childVal;
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent ? parent.concat(child) : [child];
	  }
	  return ret;
	};
	
	/**
	 * Other object hashes.
	 */
	
	strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
	  if (!childVal) return parentVal;
	  if (!parentVal) return childVal;
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret;
	};
	
	/**
	 * Default strategy.
	 */
	
	var defaultStrat = function defaultStrat(parentVal, childVal) {
	  return childVal === undefined ? parentVal : childVal;
	};
	
	/**
	 * Make sure component options get converted to actual
	 * constructors.
	 *
	 * @param {Object} options
	 */
	
	function guardComponents(options) {
	  if (options.components) {
	    var components = options.components = guardArrayAssets(options.components);
	    var ids = Object.keys(components);
	    var def;
	    if (false) {
	      var map = options._componentNameMap = {};
	    }
	    for (var i = 0, l = ids.length; i < l; i++) {
	      var key = ids[i];
	      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
	        ('production') !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
	        continue;
	      }
	      // record a all lowercase <-> kebab-case mapping for
	      // possible custom element case error warning
	      if (false) {
	        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
	      }
	      def = components[key];
	      if (isPlainObject(def)) {
	        components[key] = Vue.extend(def);
	      }
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 *
	 * @param {Object} options
	 */
	
	function guardProps(options) {
	  var props = options.props;
	  var i, val;
	  if (isArray(props)) {
	    options.props = {};
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        options.props[val] = null;
	      } else if (val.name) {
	        options.props[val.name] = val;
	      }
	    }
	  } else if (isPlainObject(props)) {
	    var keys = Object.keys(props);
	    i = keys.length;
	    while (i--) {
	      val = props[keys[i]];
	      if (typeof val === 'function') {
	        props[keys[i]] = { type: val };
	      }
	    }
	  }
	}
	
	/**
	 * Guard an Array-format assets option and converted it
	 * into the key-value Object format.
	 *
	 * @param {Object|Array} assets
	 * @return {Object}
	 */
	
	function guardArrayAssets(assets) {
	  if (isArray(assets)) {
	    var res = {};
	    var i = assets.length;
	    var asset;
	    while (i--) {
	      asset = assets[i];
	      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
	      if (!id) {
	        ('production') !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
	      } else {
	        res[id] = asset;
	      }
	    }
	    return res;
	  }
	  return assets;
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 *
	 * @param {Object} parent
	 * @param {Object} child
	 * @param {Vue} [vm] - if vm is present, indicates this is
	 *                     an instantiation merge.
	 */
	
	function mergeOptions(parent, child, vm) {
	  guardComponents(child);
	  guardProps(child);
	  if (false) {
	    if (child.propsData && !vm) {
	      warn('propsData can only be used as an instantiation option.');
	    }
	  }
	  var options = {};
	  var key;
	  if (child['extends']) {
	    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      var mixin = child.mixins[i];
	      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
	      parent = mergeOptions(parent, mixinOptions, vm);
	    }
	  }
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField(key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options;
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 *
	 * @param {Object} options
	 * @param {String} type
	 * @param {String} id
	 * @param {Boolean} warnMissing
	 * @return {Object|Function}
	 */
	
	function resolveAsset(options, type, id, warnMissing) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return;
	  }
	  var assets = options[type];
	  var camelizedId;
	  var res = assets[id] ||
	  // camelCase ID
	  assets[camelizedId = camelize(id)] ||
	  // Pascal Case ID
	  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
	  if (false) {
	    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
	  }
	  return res;
	}
	
	var uid$1 = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 *
	 * @constructor
	 */
	function Dep() {
	  this.id = uid$1++;
	  this.subs = [];
	}
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	
	/**
	 * Add a directive subscriber.
	 *
	 * @param {Directive} sub
	 */
	
	Dep.prototype.addSub = function (sub) {
	  this.subs.push(sub);
	};
	
	/**
	 * Remove a directive subscriber.
	 *
	 * @param {Directive} sub
	 */
	
	Dep.prototype.removeSub = function (sub) {
	  this.subs.$remove(sub);
	};
	
	/**
	 * Add self as a dependency to the target watcher.
	 */
	
	Dep.prototype.depend = function () {
	  Dep.target.addDep(this);
	};
	
	/**
	 * Notify all subscribers of a new value.
	 */
	
	Dep.prototype.notify = function () {
	  // stablize the subscriber list first
	  var subs = toArray(this.subs);
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto)
	
	/**
	 * Intercept mutating methods and emit events
	 */
	
	;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator() {
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break;
	      case 'unshift':
	        inserted = args;
	        break;
	      case 'splice':
	        inserted = args.slice(2);
	        break;
	    }
	    if (inserted) ob.observeArray(inserted);
	    // notify change
	    ob.dep.notify();
	    return result;
	  });
	});
	
	/**
	 * Swap the element at the given index with a new value
	 * and emits corresponding event.
	 *
	 * @param {Number} index
	 * @param {*} val
	 * @return {*} - replaced element
	 */
	
	def(arrayProto, '$set', function $set(index, val) {
	  if (index >= this.length) {
	    this.length = Number(index) + 1;
	  }
	  return this.splice(index, 1, val)[0];
	});
	
	/**
	 * Convenience method to remove the element at given index or target element reference.
	 *
	 * @param {*} item
	 */
	
	def(arrayProto, '$remove', function $remove(item) {
	  /* istanbul ignore if */
	  if (!this.length) return;
	  var index = indexOf(this, item);
	  if (index > -1) {
	    return this.splice(index, 1);
	  }
	});
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However in certain cases, e.g.
	 * v-for scope alias and props, we don't want to force conversion
	 * because the value may be a nested value under a frozen data structure.
	 *
	 * So whenever we want to set a reactive property without forcing
	 * conversion on the new value, we wrap that call inside this function.
	 */
	
	var shouldConvert = true;
	
	function withoutConversion(fn) {
	  shouldConvert = false;
	  fn();
	  shouldConvert = true;
	}
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 *
	 * @param {Array|Object} value
	 * @constructor
	 */
	
	function Observer(value) {
	  this.value = value;
	  this.dep = new Dep();
	  def(value, '__ob__', this);
	  if (isArray(value)) {
	    var augment = hasProto ? protoAugment : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	}
	
	// Instance methods
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 *
	 * @param {Object} obj
	 */
	
	Observer.prototype.walk = function (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    this.convert(keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 *
	 * @param {Array} items
	 */
	
	Observer.prototype.observeArray = function (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	/**
	 * Convert a property into getter/setter so we can emit
	 * the events when the property is accessed/changed.
	 *
	 * @param {String} key
	 * @param {*} val
	 */
	
	Observer.prototype.convert = function (key, val) {
	  defineReactive(this.value, key, val);
	};
	
	/**
	 * Add an owner vm, so that when $set/$delete mutations
	 * happen we can notify owner vms to proxy the keys and
	 * digest the watchers. This is only called when the object
	 * is observed as an instance's root $data.
	 *
	 * @param {Vue} vm
	 */
	
	Observer.prototype.addVm = function (vm) {
	  (this.vms || (this.vms = [])).push(vm);
	};
	
	/**
	 * Remove an owner vm. This is called when the object is
	 * swapped out as an instance's $data object.
	 *
	 * @param {Vue} vm
	 */
	
	Observer.prototype.removeVm = function (vm) {
	  this.vms.$remove(vm);
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 *
	 * @param {Object|Array} target
	 * @param {Object} src
	 */
	
	function protoAugment(target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 *
	 * @param {Object|Array} target
	 * @param {Object} proto
	 */
	
	function copyAugment(target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 *
	 * @param {*} value
	 * @param {Vue} [vm]
	 * @return {Observer|undefined}
	 * @static
	 */
	
	function observe(value, vm) {
	  if (!value || typeof value !== 'object') {
	    return;
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
	    ob = new Observer(value);
	  }
	  if (ob && vm) {
	    ob.addVm(vm);
	  }
	  return ob;
	}
	
	/**
	 * Define a reactive property on an Object.
	 *
	 * @param {Object} obj
	 * @param {String} key
	 * @param {*} val
	 */
	
	function defineReactive(obj, key, val) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return;
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter() {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (isArray(value)) {
	          for (var e, i = 0, l = value.length; i < l; i++) {
	            e = value[i];
	            e && e.__ob__ && e.__ob__.dep.depend();
	          }
	        }
	      }
	      return value;
	    },
	    set: function reactiveSetter(newVal) {
	      var value = getter ? getter.call(obj) : val;
	      if (newVal === value) {
	        return;
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	
	
	var util = Object.freeze({
		defineReactive: defineReactive,
		set: set,
		del: del,
		hasOwn: hasOwn,
		isLiteral: isLiteral,
		isReserved: isReserved,
		_toString: _toString,
		toNumber: toNumber,
		toBoolean: toBoolean,
		stripQuotes: stripQuotes,
		camelize: camelize,
		hyphenate: hyphenate,
		classify: classify,
		bind: bind,
		toArray: toArray,
		extend: extend,
		isObject: isObject,
		isPlainObject: isPlainObject,
		def: def,
		debounce: _debounce,
		indexOf: indexOf,
		cancellable: cancellable,
		looseEqual: looseEqual,
		isArray: isArray,
		hasProto: hasProto,
		inBrowser: inBrowser,
		devtools: devtools,
		isIE: isIE,
		isIE9: isIE9,
		isAndroid: isAndroid,
		isIOS: isIOS,
		get transitionProp () { return transitionProp; },
		get transitionEndEvent () { return transitionEndEvent; },
		get animationProp () { return animationProp; },
		get animationEndEvent () { return animationEndEvent; },
		nextTick: nextTick,
		get _Set () { return _Set; },
		query: query,
		inDoc: inDoc,
		getAttr: getAttr,
		getBindAttr: getBindAttr,
		hasBindAttr: hasBindAttr,
		before: before,
		after: after,
		remove: remove,
		prepend: prepend,
		replace: replace,
		on: on,
		off: off,
		setClass: setClass,
		addClass: addClass,
		removeClass: removeClass,
		extractContent: extractContent,
		trimNode: trimNode,
		isTemplate: isTemplate,
		createAnchor: createAnchor,
		findRef: findRef,
		mapNodeRange: mapNodeRange,
		removeNodeRange: removeNodeRange,
		isFragment: isFragment,
		getOuterHTML: getOuterHTML,
		mergeOptions: mergeOptions,
		resolveAsset: resolveAsset,
		checkComponentAttr: checkComponentAttr,
		commonTagRE: commonTagRE,
		reservedTagRE: reservedTagRE,
		get warn () { return warn; }
	});
	
	var uid = 0;
	
	function initMixin (Vue) {
	  /**
	   * The main init sequence. This is called for every
	   * instance, including ones that are created from extended
	   * constructors.
	   *
	   * @param {Object} options - this options object should be
	   *                           the result of merging class
	   *                           options and the options passed
	   *                           in to the constructor.
	   */
	
	  Vue.prototype._init = function (options) {
	    options = options || {};
	
	    this.$el = null;
	    this.$parent = options.parent;
	    this.$root = this.$parent ? this.$parent.$root : this;
	    this.$children = [];
	    this.$refs = {}; // child vm references
	    this.$els = {}; // element references
	    this._watchers = []; // all watchers as an array
	    this._directives = []; // all directives
	
	    // a uid
	    this._uid = uid++;
	
	    // a flag to avoid this being observed
	    this._isVue = true;
	
	    // events bookkeeping
	    this._events = {}; // registered callbacks
	    this._eventsCount = {}; // for $broadcast optimization
	
	    // fragment instance properties
	    this._isFragment = false;
	    this._fragment = // @type {DocumentFragment}
	    this._fragmentStart = // @type {Text|Comment}
	    this._fragmentEnd = null; // @type {Text|Comment}
	
	    // lifecycle state
	    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
	    this._unlinkFn = null;
	
	    // context:
	    // if this is a transcluded component, context
	    // will be the common parent vm of this instance
	    // and its host.
	    this._context = options._context || this.$parent;
	
	    // scope:
	    // if this is inside an inline v-for, the scope
	    // will be the intermediate scope created for this
	    // repeat fragment. this is used for linking props
	    // and container directives.
	    this._scope = options._scope;
	
	    // fragment:
	    // if this instance is compiled inside a Fragment, it
	    // needs to register itself as a child of that fragment
	    // for attach/detach to work properly.
	    this._frag = options._frag;
	    if (this._frag) {
	      this._frag.children.push(this);
	    }
	
	    // push self into parent / transclusion host
	    if (this.$parent) {
	      this.$parent.$children.push(this);
	    }
	
	    // merge options.
	    options = this.$options = mergeOptions(this.constructor.options, options, this);
	
	    // set ref
	    this._updateRef();
	
	    // initialize data as empty object.
	    // it will be filled up in _initData().
	    this._data = {};
	
	    // call init hook
	    this._callHook('init');
	
	    // initialize data observation and scope inheritance.
	    this._initState();
	
	    // setup event system and option events.
	    this._initEvents();
	
	    // call created hook
	    this._callHook('created');
	
	    // if `el` option is passed, start compilation.
	    if (options.el) {
	      this.$mount(options.el);
	    }
	  };
	}
	
	var pathCache = new Cache(1000);
	
	// actions
	var APPEND = 0;
	var PUSH = 1;
	var INC_SUB_PATH_DEPTH = 2;
	var PUSH_SUB_PATH = 3;
	
	// states
	var BEFORE_PATH = 0;
	var IN_PATH = 1;
	var BEFORE_IDENT = 2;
	var IN_IDENT = 3;
	var IN_SUB_PATH = 4;
	var IN_SINGLE_QUOTE = 5;
	var IN_DOUBLE_QUOTE = 6;
	var AFTER_PATH = 7;
	var ERROR = 8;
	
	var pathStateMachine = [];
	
	pathStateMachine[BEFORE_PATH] = {
	  'ws': [BEFORE_PATH],
	  'ident': [IN_IDENT, APPEND],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[IN_PATH] = {
	  'ws': [IN_PATH],
	  '.': [BEFORE_IDENT],
	  '[': [IN_SUB_PATH],
	  'eof': [AFTER_PATH]
	};
	
	pathStateMachine[BEFORE_IDENT] = {
	  'ws': [BEFORE_IDENT],
	  'ident': [IN_IDENT, APPEND]
	};
	
	pathStateMachine[IN_IDENT] = {
	  'ident': [IN_IDENT, APPEND],
	  '0': [IN_IDENT, APPEND],
	  'number': [IN_IDENT, APPEND],
	  'ws': [IN_PATH, PUSH],
	  '.': [BEFORE_IDENT, PUSH],
	  '[': [IN_SUB_PATH, PUSH],
	  'eof': [AFTER_PATH, PUSH]
	};
	
	pathStateMachine[IN_SUB_PATH] = {
	  "'": [IN_SINGLE_QUOTE, APPEND],
	  '"': [IN_DOUBLE_QUOTE, APPEND],
	  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
	  ']': [IN_PATH, PUSH_SUB_PATH],
	  'eof': ERROR,
	  'else': [IN_SUB_PATH, APPEND]
	};
	
	pathStateMachine[IN_SINGLE_QUOTE] = {
	  "'": [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_SINGLE_QUOTE, APPEND]
	};
	
	pathStateMachine[IN_DOUBLE_QUOTE] = {
	  '"': [IN_SUB_PATH, APPEND],
	  'eof': ERROR,
	  'else': [IN_DOUBLE_QUOTE, APPEND]
	};
	
	/**
	 * Determine the type of a character in a keypath.
	 *
	 * @param {Char} ch
	 * @return {String} type
	 */
	
	function getPathCharType(ch) {
	  if (ch === undefined) {
	    return 'eof';
	  }
	
	  var code = ch.charCodeAt(0);
	
	  switch (code) {
	    case 0x5B: // [
	    case 0x5D: // ]
	    case 0x2E: // .
	    case 0x22: // "
	    case 0x27: // '
	    case 0x30:
	      // 0
	      return ch;
	
	    case 0x5F: // _
	    case 0x24:
	      // $
	      return 'ident';
	
	    case 0x20: // Space
	    case 0x09: // Tab
	    case 0x0A: // Newline
	    case 0x0D: // Return
	    case 0xA0: // No-break space
	    case 0xFEFF: // Byte Order Mark
	    case 0x2028: // Line Separator
	    case 0x2029:
	      // Paragraph Separator
	      return 'ws';
	  }
	
	  // a-z, A-Z
	  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
	    return 'ident';
	  }
	
	  // 1-9
	  if (code >= 0x31 && code <= 0x39) {
	    return 'number';
	  }
	
	  return 'else';
	}
	
	/**
	 * Format a subPath, return its plain form if it is
	 * a literal string or number. Otherwise prepend the
	 * dynamic indicator (*).
	 *
	 * @param {String} path
	 * @return {String}
	 */
	
	function formatSubPath(path) {
	  var trimmed = path.trim();
	  // invalid leading 0
	  if (path.charAt(0) === '0' && isNaN(path)) {
	    return false;
	  }
	  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
	}
	
	/**
	 * Parse a string path into an array of segments
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parse(path) {
	  var keys = [];
	  var index = -1;
	  var mode = BEFORE_PATH;
	  var subPathDepth = 0;
	  var c, newChar, key, type, transition, action, typeMap;
	
	  var actions = [];
	
	  actions[PUSH] = function () {
	    if (key !== undefined) {
	      keys.push(key);
	      key = undefined;
	    }
	  };
	
	  actions[APPEND] = function () {
	    if (key === undefined) {
	      key = newChar;
	    } else {
	      key += newChar;
	    }
	  };
	
	  actions[INC_SUB_PATH_DEPTH] = function () {
	    actions[APPEND]();
	    subPathDepth++;
	  };
	
	  actions[PUSH_SUB_PATH] = function () {
	    if (subPathDepth > 0) {
	      subPathDepth--;
	      mode = IN_SUB_PATH;
	      actions[APPEND]();
	    } else {
	      subPathDepth = 0;
	      key = formatSubPath(key);
	      if (key === false) {
	        return false;
	      } else {
	        actions[PUSH]();
	      }
	    }
	  };
	
	  function maybeUnescapeQuote() {
	    var nextChar = path[index + 1];
	    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
	      index++;
	      newChar = '\\' + nextChar;
	      actions[APPEND]();
	      return true;
	    }
	  }
	
	  while (mode != null) {
	    index++;
	    c = path[index];
	
	    if (c === '\\' && maybeUnescapeQuote()) {
	      continue;
	    }
	
	    type = getPathCharType(c);
	    typeMap = pathStateMachine[mode];
	    transition = typeMap[type] || typeMap['else'] || ERROR;
	
	    if (transition === ERROR) {
	      return; // parse error
	    }
	
	    mode = transition[0];
	    action = actions[transition[1]];
	    if (action) {
	      newChar = transition[2];
	      newChar = newChar === undefined ? c : newChar;
	      if (action() === false) {
	        return;
	      }
	    }
	
	    if (mode === AFTER_PATH) {
	      keys.raw = path;
	      return keys;
	    }
	  }
	}
	
	/**
	 * External parse that check for a cache hit first
	 *
	 * @param {String} path
	 * @return {Array|undefined}
	 */
	
	function parsePath(path) {
	  var hit = pathCache.get(path);
	  if (!hit) {
	    hit = parse(path);
	    if (hit) {
	      pathCache.put(path, hit);
	    }
	  }
	  return hit;
	}
	
	/**
	 * Get from an object from a path string
	 *
	 * @param {Object} obj
	 * @param {String} path
	 */
	
	function getPath(obj, path) {
	  return parseExpression$1(path).get(obj);
	}
	
	/**
	 * Warn against setting non-existent root path on a vm.
	 */
	
	var warnNonExistent;
	if (false) {
	  warnNonExistent = function (path, vm) {
	    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
	  };
	}
	
	/**
	 * Set on an object from a path
	 *
	 * @param {Object} obj
	 * @param {String | Array} path
	 * @param {*} val
	 */
	
	function setPath(obj, path, val) {
	  var original = obj;
	  if (typeof path === 'string') {
	    path = parse(path);
	  }
	  if (!path || !isObject(obj)) {
	    return false;
	  }
	  var last, key;
	  for (var i = 0, l = path.length; i < l; i++) {
	    last = obj;
	    key = path[i];
	    if (key.charAt(0) === '*') {
	      key = parseExpression$1(key.slice(1)).get.call(original, original);
	    }
	    if (i < l - 1) {
	      obj = obj[key];
	      if (!isObject(obj)) {
	        obj = {};
	        if (false) {
	          warnNonExistent(path, last);
	        }
	        set(last, key, obj);
	      }
	    } else {
	      if (isArray(obj)) {
	        obj.$set(key, val);
	      } else if (key in obj) {
	        obj[key] = val;
	      } else {
	        if (false) {
	          warnNonExistent(path, obj);
	        }
	        set(obj, key, val);
	      }
	    }
	  }
	  return true;
	}
	
	var path = Object.freeze({
	  parsePath: parsePath,
	  getPath: getPath,
	  setPath: setPath
	});
	
	var expressionCache = new Cache(1000);
	
	var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
	var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');
	
	// keywords that don't make sense inside expressions
	var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
	var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');
	
	var wsRE = /\s/g;
	var newlineRE = /\n/g;
	var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
	var restoreRE = /"(\d+)"/g;
	var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
	var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
	var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;
	
	function noop() {}
	
	/**
	 * Save / Rewrite / Restore
	 *
	 * When rewriting paths found in an expression, it is
	 * possible for the same letter sequences to be found in
	 * strings and Object literal property keys. Therefore we
	 * remove and store these parts in a temporary array, and
	 * restore them after the path rewrite.
	 */
	
	var saved = [];
	
	/**
	 * Save replacer
	 *
	 * The save regex can match two possible cases:
	 * 1. An opening object literal
	 * 2. A string
	 * If matched as a plain string, we need to escape its
	 * newlines, since the string needs to be preserved when
	 * generating the function body.
	 *
	 * @param {String} str
	 * @param {String} isString - str if matched as a string
	 * @return {String} - placeholder with index
	 */
	
	function save(str, isString) {
	  var i = saved.length;
	  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
	  return '"' + i + '"';
	}
	
	/**
	 * Path rewrite replacer
	 *
	 * @param {String} raw
	 * @return {String}
	 */
	
	function rewrite(raw) {
	  var c = raw.charAt(0);
	  var path = raw.slice(1);
	  if (allowedKeywordsRE.test(path)) {
	    return raw;
	  } else {
	    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
	    return c + 'scope.' + path;
	  }
	}
	
	/**
	 * Restore replacer
	 *
	 * @param {String} str
	 * @param {String} i - matched save index
	 * @return {String}
	 */
	
	function restore(str, i) {
	  return saved[i];
	}
	
	/**
	 * Rewrite an expression, prefixing all path accessors with
	 * `scope.` and generate getter/setter functions.
	 *
	 * @param {String} exp
	 * @return {Function}
	 */
	
	function compileGetter(exp) {
	  if (improperKeywordsRE.test(exp)) {
	    ('production') !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
	  }
	  // reset state
	  saved.length = 0;
	  // save strings and object literal keys
	  var body = exp.replace(saveRE, save).replace(wsRE, '');
	  // rewrite all paths
	  // pad 1 space here because the regex matches 1 extra char
	  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
	  return makeGetterFn(body);
	}
	
	/**
	 * Build a getter function. Requires eval.
	 *
	 * We isolate the try/catch so it doesn't affect the
	 * optimization of the parse function when it is not called.
	 *
	 * @param {String} body
	 * @return {Function|undefined}
	 */
	
	function makeGetterFn(body) {
	  try {
	    /* eslint-disable no-new-func */
	    return new Function('scope', 'return ' + body + ';');
	    /* eslint-enable no-new-func */
	  } catch (e) {
	    if (false) {
	      /* istanbul ignore if */
	      if (e.toString().match(/unsafe-eval|CSP/)) {
	        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
	      } else {
	        warn('Invalid expression. ' + 'Generated function body: ' + body);
	      }
	    }
	    return noop;
	  }
	}
	
	/**
	 * Compile a setter function for the expression.
	 *
	 * @param {String} exp
	 * @return {Function|undefined}
	 */
	
	function compileSetter(exp) {
	  var path = parsePath(exp);
	  if (path) {
	    return function (scope, val) {
	      setPath(scope, path, val);
	    };
	  } else {
	    ('production') !== 'production' && warn('Invalid setter expression: ' + exp);
	  }
	}
	
	/**
	 * Parse an expression into re-written getter/setters.
	 *
	 * @param {String} exp
	 * @param {Boolean} needSet
	 * @return {Function}
	 */
	
	function parseExpression$1(exp, needSet) {
	  exp = exp.trim();
	  // try cache
	  var hit = expressionCache.get(exp);
	  if (hit) {
	    if (needSet && !hit.set) {
	      hit.set = compileSetter(hit.exp);
	    }
	    return hit;
	  }
	  var res = { exp: exp };
	  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
	  // optimized super simple getter
	  ? makeGetterFn('scope.' + exp)
	  // dynamic getter
	  : compileGetter(exp);
	  if (needSet) {
	    res.set = compileSetter(exp);
	  }
	  expressionCache.put(exp, res);
	  return res;
	}
	
	/**
	 * Check if an expression is a simple path.
	 *
	 * @param {String} exp
	 * @return {Boolean}
	 */
	
	function isSimplePath(exp) {
	  return pathTestRE.test(exp) &&
	  // don't treat literal values as paths
	  !literalValueRE$1.test(exp) &&
	  // Math constants e.g. Math.PI, Math.E etc.
	  exp.slice(0, 5) !== 'Math.';
	}
	
	var expression = Object.freeze({
	  parseExpression: parseExpression$1,
	  isSimplePath: isSimplePath
	});
	
	// we have two separate queues: one for directive updates
	// and one for user watcher registered via $watch().
	// we want to guarantee directive updates to be called
	// before user watchers so that when user watchers are
	// triggered, the DOM would have already been in updated
	// state.
	
	var queue = [];
	var userQueue = [];
	var has = {};
	var circular = {};
	var waiting = false;
	
	/**
	 * Reset the batcher's state.
	 */
	
	function resetBatcherState() {
	  queue.length = 0;
	  userQueue.length = 0;
	  has = {};
	  circular = {};
	  waiting = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	
	function flushBatcherQueue() {
	  var _again = true;
	
	  _function: while (_again) {
	    _again = false;
	
	    runBatcherQueue(queue);
	    runBatcherQueue(userQueue);
	    // user watchers triggered more watchers,
	    // keep flushing until it depletes
	    if (queue.length) {
	      _again = true;
	      continue _function;
	    }
	    // dev tool hook
	    /* istanbul ignore if */
	    if (devtools && config.devtools) {
	      devtools.emit('flush');
	    }
	    resetBatcherState();
	  }
	}
	
	/**
	 * Run the watchers in a single queue.
	 *
	 * @param {Array} queue
	 */
	
	function runBatcherQueue(queue) {
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (var i = 0; i < queue.length; i++) {
	    var watcher = queue[i];
	    var id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > config._maxUpdateCount) {
	        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
	        break;
	      }
	    }
	  }
	  queue.length = 0;
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 *
	 * @param {Watcher} watcher
	 *   properties:
	 *   - {Number} id
	 *   - {Function} run
	 */
	
	function pushWatcher(watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    // push watcher into appropriate queue
	    var q = watcher.user ? userQueue : queue;
	    has[id] = q.length;
	    q.push(watcher);
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushBatcherQueue);
	    }
	  }
	}
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 *
	 * @param {Vue} vm
	 * @param {String|Function} expOrFn
	 * @param {Function} cb
	 * @param {Object} options
	 *                 - {Array} filters
	 *                 - {Boolean} twoWay
	 *                 - {Boolean} deep
	 *                 - {Boolean} user
	 *                 - {Boolean} sync
	 *                 - {Boolean} lazy
	 *                 - {Function} [preProcess]
	 *                 - {Function} [postProcess]
	 * @constructor
	 */
	function Watcher(vm, expOrFn, cb, options) {
	  // mix in options
	  if (options) {
	    extend(this, options);
	  }
	  var isFn = typeof expOrFn === 'function';
	  this.vm = vm;
	  vm._watchers.push(this);
	  this.expression = expOrFn;
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.prevError = null; // for async error stacks
	  // parse expression for getter/setter
	  if (isFn) {
	    this.getter = expOrFn;
	    this.setter = undefined;
	  } else {
	    var res = parseExpression$1(expOrFn, this.twoWay);
	    this.getter = res.get;
	    this.setter = res.set;
	  }
	  this.value = this.lazy ? undefined : this.get();
	  // state for avoiding false triggers for deep and Array
	  // watchers during vm._digest()
	  this.queued = this.shallow = false;
	}
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	
	Watcher.prototype.get = function () {
	  this.beforeGet();
	  var scope = this.scope || this.vm;
	  var value;
	  try {
	    value = this.getter.call(scope, scope);
	  } catch (e) {
	    if (false) {
	      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
	    }
	  }
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  if (this.preProcess) {
	    value = this.preProcess(value);
	  }
	  if (this.filters) {
	    value = scope._applyFilters(value, null, this.filters, false);
	  }
	  if (this.postProcess) {
	    value = this.postProcess(value);
	  }
	  this.afterGet();
	  return value;
	};
	
	/**
	 * Set the corresponding value with the setter.
	 *
	 * @param {*} value
	 */
	
	Watcher.prototype.set = function (value) {
	  var scope = this.scope || this.vm;
	  if (this.filters) {
	    value = scope._applyFilters(value, this.value, this.filters, true);
	  }
	  try {
	    this.setter.call(scope, scope, value);
	  } catch (e) {
	    if (false) {
	      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
	    }
	  }
	  // two-way sync for v-for alias
	  var forContext = scope.$forContext;
	  if (forContext && forContext.alias === this.expression) {
	    if (forContext.filters) {
	      ('production') !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
	      return;
	    }
	    forContext._withLock(function () {
	      if (scope.$key) {
	        // original is an object
	        forContext.rawValue[scope.$key] = value;
	      } else {
	        forContext.rawValue.$set(scope.$index, value);
	      }
	    });
	  }
	};
	
	/**
	 * Prepare for dependency collection.
	 */
	
	Watcher.prototype.beforeGet = function () {
	  Dep.target = this;
	};
	
	/**
	 * Add a dependency to this directive.
	 *
	 * @param {Dep} dep
	 */
	
	Watcher.prototype.addDep = function (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	
	Watcher.prototype.afterGet = function () {
	  Dep.target = null;
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this.deps[i];
	    if (!this.newDepIds.has(dep.id)) {
	      dep.removeSub(this);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 *
	 * @param {Boolean} shallow
	 */
	
	Watcher.prototype.update = function (shallow) {
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync || !config.async) {
	    this.run();
	  } else {
	    // if queued, only overwrite shallow with non-shallow,
	    // but not the other way around.
	    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
	    this.queued = true;
	    // record before-push error stack in debug mode
	    /* istanbul ignore if */
	    if (false) {
	      this.prevError = new Error('[vue] async stack trace');
	    }
	    pushWatcher(this);
	  }
	};
	
	/**
	 * Batcher job interface.
	 * Will be called by the batcher.
	 */
	
	Watcher.prototype.run = function () {
	  if (this.active) {
	    var value = this.get();
	    if (value !== this.value ||
	    // Deep watchers and watchers on Object/Arrays should fire even
	    // when the value is the same, because the value may
	    // have mutated; but only do so if this is a
	    // non-shallow update (caused by a vm digest).
	    (isObject(value) || this.deep) && !this.shallow) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      // in debug + async mode, when a watcher callbacks
	      // throws, we also throw the saved before-push error
	      // so the full cross-tick stack trace is available.
	      var prevError = this.prevError;
	      /* istanbul ignore if */
	      if (false) {
	        this.prevError = null;
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          nextTick(function () {
	            throw prevError;
	          }, 0);
	          throw e;
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	    this.queued = this.shallow = false;
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	
	Watcher.prototype.evaluate = function () {
	  // avoid overwriting another watcher that is being
	  // collected.
	  var current = Dep.target;
	  this.value = this.get();
	  this.dirty = false;
	  Dep.target = current;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	
	Watcher.prototype.depend = function () {
	  var i = this.deps.length;
	  while (i--) {
	    this.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subcriber list.
	 */
	
	Watcher.prototype.teardown = function () {
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed or is performing a v-for
	    // re-render (the watcher list is then filtered by v-for).
	    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
	      this.vm._watchers.$remove(this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this.deps[i].removeSub(this);
	    }
	    this.active = false;
	    this.vm = this.cb = this.value = null;
	  }
	};
	
	/**
	 * Recrusively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 *
	 * @param {*} val
	 */
	
	var seenObjects = new _Set();
	function traverse(val, seen) {
	  var i = undefined,
	      keys = undefined;
	  if (!seen) {
	    seen = seenObjects;
	    seen.clear();
	  }
	  var isA = isArray(val);
	  var isO = isObject(val);
	  if ((isA || isO) && Object.isExtensible(val)) {
	    if (val.__ob__) {
	      var depId = val.__ob__.dep.id;
	      if (seen.has(depId)) {
	        return;
	      } else {
	        seen.add(depId);
	      }
	    }
	    if (isA) {
	      i = val.length;
	      while (i--) traverse(val[i], seen);
	    } else if (isO) {
	      keys = Object.keys(val);
	      i = keys.length;
	      while (i--) traverse(val[keys[i]], seen);
	    }
	  }
	}
	
	var text$1 = {
	
	  bind: function bind() {
	    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
	  },
	
	  update: function update(value) {
	    this.el[this.attr] = _toString(value);
	  }
	};
	
	var templateCache = new Cache(1000);
	var idSelectorCache = new Cache(1000);
	
	var map = {
	  efault: [0, '', ''],
	  legend: [1, '<fieldset>', '</fieldset>'],
	  tr: [2, '<table><tbody>', '</tbody></table>'],
	  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
	};
	
	map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];
	
	map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];
	
	map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];
	
	/**
	 * Check if a node is a supported template node with a
	 * DocumentFragment content.
	 *
	 * @param {Node} node
	 * @return {Boolean}
	 */
	
	function isRealTemplate(node) {
	  return isTemplate(node) && isFragment(node.content);
	}
	
	var tagRE$1 = /<([\w:-]+)/;
	var entityRE = /&#?\w+?;/;
	var commentRE = /<!--/;
	
	/**
	 * Convert a string template to a DocumentFragment.
	 * Determines correct wrapping by tag types. Wrapping
	 * strategy found in jQuery & component/domify.
	 *
	 * @param {String} templateString
	 * @param {Boolean} raw
	 * @return {DocumentFragment}
	 */
	
	function stringToFragment(templateString, raw) {
	  // try a cache hit first
	  var cacheKey = raw ? templateString : templateString.trim();
	  var hit = templateCache.get(cacheKey);
	  if (hit) {
	    return hit;
	  }
	
	  var frag = document.createDocumentFragment();
	  var tagMatch = templateString.match(tagRE$1);
	  var entityMatch = entityRE.test(templateString);
	  var commentMatch = commentRE.test(templateString);
	
	  if (!tagMatch && !entityMatch && !commentMatch) {
	    // text only, return a single text node.
	    frag.appendChild(document.createTextNode(templateString));
	  } else {
	    var tag = tagMatch && tagMatch[1];
	    var wrap = map[tag] || map.efault;
	    var depth = wrap[0];
	    var prefix = wrap[1];
	    var suffix = wrap[2];
	    var node = document.createElement('div');
	
	    node.innerHTML = prefix + templateString + suffix;
	    while (depth--) {
	      node = node.lastChild;
	    }
	
	    var child;
	    /* eslint-disable no-cond-assign */
	    while (child = node.firstChild) {
	      /* eslint-enable no-cond-assign */
	      frag.appendChild(child);
	    }
	  }
	  if (!raw) {
	    trimNode(frag);
	  }
	  templateCache.put(cacheKey, frag);
	  return frag;
	}
	
	/**
	 * Convert a template node to a DocumentFragment.
	 *
	 * @param {Node} node
	 * @return {DocumentFragment}
	 */
	
	function nodeToFragment(node) {
	  // if its a template tag and the browser supports it,
	  // its content is already a document fragment. However, iOS Safari has
	  // bug when using directly cloned template content with touch
	  // events and can cause crashes when the nodes are removed from DOM, so we
	  // have to treat template elements as string templates. (#2805)
	  /* istanbul ignore if */
	  if (isRealTemplate(node)) {
	    return stringToFragment(node.innerHTML);
	  }
	  // script template
	  if (node.tagName === 'SCRIPT') {
	    return stringToFragment(node.textContent);
	  }
	  // normal node, clone it to avoid mutating the original
	  var clonedNode = cloneNode(node);
	  var frag = document.createDocumentFragment();
	  var child;
	  /* eslint-disable no-cond-assign */
	  while (child = clonedNode.firstChild) {
	    /* eslint-enable no-cond-assign */
	    frag.appendChild(child);
	  }
	  trimNode(frag);
	  return frag;
	}
	
	// Test for the presence of the Safari template cloning bug
	// https://bugs.webkit.org/showug.cgi?id=137755
	var hasBrokenTemplate = (function () {
	  /* istanbul ignore else */
	  if (inBrowser) {
	    var a = document.createElement('div');
	    a.innerHTML = '<template>1</template>';
	    return !a.cloneNode(true).firstChild.innerHTML;
	  } else {
	    return false;
	  }
	})();
	
	// Test for IE10/11 textarea placeholder clone bug
	var hasTextareaCloneBug = (function () {
	  /* istanbul ignore else */
	  if (inBrowser) {
	    var t = document.createElement('textarea');
	    t.placeholder = 't';
	    return t.cloneNode(true).value === 't';
	  } else {
	    return false;
	  }
	})();
	
	/**
	 * 1. Deal with Safari cloning nested <template> bug by
	 *    manually cloning all template instances.
	 * 2. Deal with IE10/11 textarea placeholder bug by setting
	 *    the correct value after cloning.
	 *
	 * @param {Element|DocumentFragment} node
	 * @return {Element|DocumentFragment}
	 */
	
	function cloneNode(node) {
	  /* istanbul ignore if */
	  if (!node.querySelectorAll) {
	    return node.cloneNode();
	  }
	  var res = node.cloneNode(true);
	  var i, original, cloned;
	  /* istanbul ignore if */
	  if (hasBrokenTemplate) {
	    var tempClone = res;
	    if (isRealTemplate(node)) {
	      node = node.content;
	      tempClone = res.content;
	    }
	    original = node.querySelectorAll('template');
	    if (original.length) {
	      cloned = tempClone.querySelectorAll('template');
	      i = cloned.length;
	      while (i--) {
	        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
	      }
	    }
	  }
	  /* istanbul ignore if */
	  if (hasTextareaCloneBug) {
	    if (node.tagName === 'TEXTAREA') {
	      res.value = node.value;
	    } else {
	      original = node.querySelectorAll('textarea');
	      if (original.length) {
	        cloned = res.querySelectorAll('textarea');
	        i = cloned.length;
	        while (i--) {
	          cloned[i].value = original[i].value;
	        }
	      }
	    }
	  }
	  return res;
	}
	
	/**
	 * Process the template option and normalizes it into a
	 * a DocumentFragment that can be used as a partial or a
	 * instance template.
	 *
	 * @param {*} template
	 *        Possible values include:
	 *        - DocumentFragment object
	 *        - Node object of type Template
	 *        - id selector: '#some-template-id'
	 *        - template string: '<div><span>{{msg}}</span></div>'
	 * @param {Boolean} shouldClone
	 * @param {Boolean} raw
	 *        inline HTML interpolation. Do not check for id
	 *        selector and keep whitespace in the string.
	 * @return {DocumentFragment|undefined}
	 */
	
	function parseTemplate(template, shouldClone, raw) {
	  var node, frag;
	
	  // if the template is already a document fragment,
	  // do nothing
	  if (isFragment(template)) {
	    trimNode(template);
	    return shouldClone ? cloneNode(template) : template;
	  }
	
	  if (typeof template === 'string') {
	    // id selector
	    if (!raw && template.charAt(0) === '#') {
	      // id selector can be cached too
	      frag = idSelectorCache.get(template);
	      if (!frag) {
	        node = document.getElementById(template.slice(1));
	        if (node) {
	          frag = nodeToFragment(node);
	          // save selector to cache
	          idSelectorCache.put(template, frag);
	        }
	      }
	    } else {
	      // normal string template
	      frag = stringToFragment(template, raw);
	    }
	  } else if (template.nodeType) {
	    // a direct node
	    frag = nodeToFragment(template);
	  }
	
	  return frag && shouldClone ? cloneNode(frag) : frag;
	}
	
	var template = Object.freeze({
	  cloneNode: cloneNode,
	  parseTemplate: parseTemplate
	});
	
	var html = {
	
	  bind: function bind() {
	    // a comment node means this is a binding for
	    // {{{ inline unescaped html }}}
	    if (this.el.nodeType === 8) {
	      // hold nodes
	      this.nodes = [];
	      // replace the placeholder with proper anchor
	      this.anchor = createAnchor('v-html');
	      replace(this.el, this.anchor);
	    }
	  },
	
	  update: function update(value) {
	    value = _toString(value);
	    if (this.nodes) {
	      this.swap(value);
	    } else {
	      this.el.innerHTML = value;
	    }
	  },
	
	  swap: function swap(value) {
	    // remove old nodes
	    var i = this.nodes.length;
	    while (i--) {
	      remove(this.nodes[i]);
	    }
	    // convert new value to a fragment
	    // do not attempt to retrieve from id selector
	    var frag = parseTemplate(value, true, true);
	    // save a reference to these nodes so we can remove later
	    this.nodes = toArray(frag.childNodes);
	    before(frag, this.anchor);
	  }
	};
	
	/**
	 * Abstraction for a partially-compiled fragment.
	 * Can optionally compile content with a child scope.
	 *
	 * @param {Function} linker
	 * @param {Vue} vm
	 * @param {DocumentFragment} frag
	 * @param {Vue} [host]
	 * @param {Object} [scope]
	 * @param {Fragment} [parentFrag]
	 */
	function Fragment(linker, vm, frag, host, scope, parentFrag) {
	  this.children = [];
	  this.childFrags = [];
	  this.vm = vm;
	  this.scope = scope;
	  this.inserted = false;
	  this.parentFrag = parentFrag;
	  if (parentFrag) {
	    parentFrag.childFrags.push(this);
	  }
	  this.unlink = linker(vm, frag, host, scope, this);
	  var single = this.single = frag.childNodes.length === 1 &&
	  // do not go single mode if the only node is an anchor
	  !frag.childNodes[0].__v_anchor;
	  if (single) {
	    this.node = frag.childNodes[0];
	    this.before = singleBefore;
	    this.remove = singleRemove;
	  } else {
	    this.node = createAnchor('fragment-start');
	    this.end = createAnchor('fragment-end');
	    this.frag = frag;
	    prepend(this.node, frag);
	    frag.appendChild(this.end);
	    this.before = multiBefore;
	    this.remove = multiRemove;
	  }
	  this.node.__v_frag = this;
	}
	
	/**
	 * Call attach/detach for all components contained within
	 * this fragment. Also do so recursively for all child
	 * fragments.
	 *
	 * @param {Function} hook
	 */
	
	Fragment.prototype.callHook = function (hook) {
	  var i, l;
	  for (i = 0, l = this.childFrags.length; i < l; i++) {
	    this.childFrags[i].callHook(hook);
	  }
	  for (i = 0, l = this.children.length; i < l; i++) {
	    hook(this.children[i]);
	  }
	};
	
	/**
	 * Insert fragment before target, single node version
	 *
	 * @param {Node} target
	 * @param {Boolean} withTransition
	 */
	
	function singleBefore(target, withTransition) {
	  this.inserted = true;
	  var method = withTransition !== false ? beforeWithTransition : before;
	  method(this.node, target, this.vm);
	  if (inDoc(this.node)) {
	    this.callHook(attach);
	  }
	}
	
	/**
	 * Remove fragment, single node version
	 */
	
	function singleRemove() {
	  this.inserted = false;
	  var shouldCallRemove = inDoc(this.node);
	  var self = this;
	  this.beforeRemove();
	  removeWithTransition(this.node, this.vm, function () {
	    if (shouldCallRemove) {
	      self.callHook(detach);
	    }
	    self.destroy();
	  });
	}
	
	/**
	 * Insert fragment before target, multi-nodes version
	 *
	 * @param {Node} target
	 * @param {Boolean} withTransition
	 */
	
	function multiBefore(target, withTransition) {
	  this.inserted = true;
	  var vm = this.vm;
	  var method = withTransition !== false ? beforeWithTransition : before;
	  mapNodeRange(this.node, this.end, function (node) {
	    method(node, target, vm);
	  });
	  if (inDoc(this.node)) {
	    this.callHook(attach);
	  }
	}
	
	/**
	 * Remove fragment, multi-nodes version
	 */
	
	function multiRemove() {
	  this.inserted = false;
	  var self = this;
	  var shouldCallRemove = inDoc(this.node);
	  this.beforeRemove();
	  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
	    if (shouldCallRemove) {
	      self.callHook(detach);
	    }
	    self.destroy();
	  });
	}
	
	/**
	 * Prepare the fragment for removal.
	 */
	
	Fragment.prototype.beforeRemove = function () {
	  var i, l;
	  for (i = 0, l = this.childFrags.length; i < l; i++) {
	    // call the same method recursively on child
	    // fragments, depth-first
	    this.childFrags[i].beforeRemove(false);
	  }
	  for (i = 0, l = this.children.length; i < l; i++) {
	    // Call destroy for all contained instances,
	    // with remove:false and defer:true.
	    // Defer is necessary because we need to
	    // keep the children to call detach hooks
	    // on them.
	    this.children[i].$destroy(false, true);
	  }
	  var dirs = this.unlink.dirs;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    // disable the watchers on all the directives
	    // so that the rendered content stays the same
	    // during removal.
	    dirs[i]._watcher && dirs[i]._watcher.teardown();
	  }
	};
	
	/**
	 * Destroy the fragment.
	 */
	
	Fragment.prototype.destroy = function () {
	  if (this.parentFrag) {
	    this.parentFrag.childFrags.$remove(this);
	  }
	  this.node.__v_frag = null;
	  this.unlink();
	};
	
	/**
	 * Call attach hook for a Vue instance.
	 *
	 * @param {Vue} child
	 */
	
	function attach(child) {
	  if (!child._isAttached && inDoc(child.$el)) {
	    child._callHook('attached');
	  }
	}
	
	/**
	 * Call detach hook for a Vue instance.
	 *
	 * @param {Vue} child
	 */
	
	function detach(child) {
	  if (child._isAttached && !inDoc(child.$el)) {
	    child._callHook('detached');
	  }
	}
	
	var linkerCache = new Cache(5000);
	
	/**
	 * A factory that can be used to create instances of a
	 * fragment. Caches the compiled linker if possible.
	 *
	 * @param {Vue} vm
	 * @param {Element|String} el
	 */
	function FragmentFactory(vm, el) {
	  this.vm = vm;
	  var template;
	  var isString = typeof el === 'string';
	  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
	    template = parseTemplate(el, true);
	  } else {
	    template = document.createDocumentFragment();
	    template.appendChild(el);
	  }
	  this.template = template;
	  // linker can be cached, but only for components
	  var linker;
	  var cid = vm.constructor.cid;
	  if (cid > 0) {
	    var cacheId = cid + (isString ? el : getOuterHTML(el));
	    linker = linkerCache.get(cacheId);
	    if (!linker) {
	      linker = compile(template, vm.$options, true);
	      linkerCache.put(cacheId, linker);
	    }
	  } else {
	    linker = compile(template, vm.$options, true);
	  }
	  this.linker = linker;
	}
	
	/**
	 * Create a fragment instance with given host and scope.
	 *
	 * @param {Vue} host
	 * @param {Object} scope
	 * @param {Fragment} parentFrag
	 */
	
	FragmentFactory.prototype.create = function (host, scope, parentFrag) {
	  var frag = cloneNode(this.template);
	  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
	};
	
	var ON = 700;
	var MODEL = 800;
	var BIND = 850;
	var TRANSITION = 1100;
	var EL = 1500;
	var COMPONENT = 1500;
	var PARTIAL = 1750;
	var IF = 2100;
	var FOR = 2200;
	var SLOT = 2300;
	
	var uid$3 = 0;
	
	var vFor = {
	
	  priority: FOR,
	  terminal: true,
	
	  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],
	
	  bind: function bind() {
	    if (false) {
	      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
	    }
	
	    // support "item in/of items" syntax
	    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
	    if (inMatch) {
	      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
	      if (itMatch) {
	        this.iterator = itMatch[1].trim();
	        this.alias = itMatch[2].trim();
	      } else {
	        this.alias = inMatch[1].trim();
	      }
	      this.expression = inMatch[2];
	    }
	
	    if (!this.alias) {
	      ('production') !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
	      return;
	    }
	
	    // uid as a cache identifier
	    this.id = '__v-for__' + ++uid$3;
	
	    // check if this is an option list,
	    // so that we know if we need to update the <select>'s
	    // v-model when the option list has changed.
	    // because v-model has a lower priority than v-for,
	    // the v-model is not bound here yet, so we have to
	    // retrive it in the actual updateModel() function.
	    var tag = this.el.tagName;
	    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';
	
	    // setup anchor nodes
	    this.start = createAnchor('v-for-start');
	    this.end = createAnchor('v-for-end');
	    replace(this.el, this.end);
	    before(this.start, this.end);
	
	    // cache
	    this.cache = Object.create(null);
	
	    // fragment factory
	    this.factory = new FragmentFactory(this.vm, this.el);
	  },
	
	  update: function update(data) {
	    this.diff(data);
	    this.updateRef();
	    this.updateModel();
	  },
	
	  /**
	   * Diff, based on new data and old data, determine the
	   * minimum amount of DOM manipulations needed to make the
	   * DOM reflect the new data Array.
	   *
	   * The algorithm diffs the new data Array by storing a
	   * hidden reference to an owner vm instance on previously
	   * seen data. This allows us to achieve O(n) which is
	   * better than a levenshtein distance based algorithm,
	   * which is O(m * n).
	   *
	   * @param {Array} data
	   */
	
	  diff: function diff(data) {
	    // check if the Array was converted from an Object
	    var item = data[0];
	    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');
	
	    var trackByKey = this.params.trackBy;
	    var oldFrags = this.frags;
	    var frags = this.frags = new Array(data.length);
	    var alias = this.alias;
	    var iterator = this.iterator;
	    var start = this.start;
	    var end = this.end;
	    var inDocument = inDoc(start);
	    var init = !oldFrags;
	    var i, l, frag, key, value, primitive;
	
	    // First pass, go through the new Array and fill up
	    // the new frags array. If a piece of data has a cached
	    // instance for it, we reuse it. Otherwise build a new
	    // instance.
	    for (i = 0, l = data.length; i < l; i++) {
	      item = data[i];
	      key = convertedFromObject ? item.$key : null;
	      value = convertedFromObject ? item.$value : item;
	      primitive = !isObject(value);
	      frag = !init && this.getCachedFrag(value, i, key);
	      if (frag) {
	        // reusable fragment
	        frag.reused = true;
	        // update $index
	        frag.scope.$index = i;
	        // update $key
	        if (key) {
	          frag.scope.$key = key;
	        }
	        // update iterator
	        if (iterator) {
	          frag.scope[iterator] = key !== null ? key : i;
	        }
	        // update data for track-by, object repeat &
	        // primitive values.
	        if (trackByKey || convertedFromObject || primitive) {
	          withoutConversion(function () {
	            frag.scope[alias] = value;
	          });
	        }
	      } else {
	        // new instance
	        frag = this.create(value, alias, i, key);
	        frag.fresh = !init;
	      }
	      frags[i] = frag;
	      if (init) {
	        frag.before(end);
	      }
	    }
	
	    // we're done for the initial render.
	    if (init) {
	      return;
	    }
	
	    // Second pass, go through the old fragments and
	    // destroy those who are not reused (and remove them
	    // from cache)
	    var removalIndex = 0;
	    var totalRemoved = oldFrags.length - frags.length;
	    // when removing a large number of fragments, watcher removal
	    // turns out to be a perf bottleneck, so we batch the watcher
	    // removals into a single filter call!
	    this.vm._vForRemoving = true;
	    for (i = 0, l = oldFrags.length; i < l; i++) {
	      frag = oldFrags[i];
	      if (!frag.reused) {
	        this.deleteCachedFrag(frag);
	        this.remove(frag, removalIndex++, totalRemoved, inDocument);
	      }
	    }
	    this.vm._vForRemoving = false;
	    if (removalIndex) {
	      this.vm._watchers = this.vm._watchers.filter(function (w) {
	        return w.active;
	      });
	    }
	
	    // Final pass, move/insert new fragments into the
	    // right place.
	    var targetPrev, prevEl, currentPrev;
	    var insertionIndex = 0;
	    for (i = 0, l = frags.length; i < l; i++) {
	      frag = frags[i];
	      // this is the frag that we should be after
	      targetPrev = frags[i - 1];
	      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
	      if (frag.reused && !frag.staggerCb) {
	        currentPrev = findPrevFrag(frag, start, this.id);
	        if (currentPrev !== targetPrev && (!currentPrev ||
	        // optimization for moving a single item.
	        // thanks to suggestions by @livoras in #1807
	        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
	          this.move(frag, prevEl);
	        }
	      } else {
	        // new instance, or still in stagger.
	        // insert with updated stagger index.
	        this.insert(frag, insertionIndex++, prevEl, inDocument);
	      }
	      frag.reused = frag.fresh = false;
	    }
	  },
	
	  /**
	   * Create a new fragment instance.
	   *
	   * @param {*} value
	   * @param {String} alias
	   * @param {Number} index
	   * @param {String} [key]
	   * @return {Fragment}
	   */
	
	  create: function create(value, alias, index, key) {
	    var host = this._host;
	    // create iteration scope
	    var parentScope = this._scope || this.vm;
	    var scope = Object.create(parentScope);
	    // ref holder for the scope
	    scope.$refs = Object.create(parentScope.$refs);
	    scope.$els = Object.create(parentScope.$els);
	    // make sure point $parent to parent scope
	    scope.$parent = parentScope;
	    // for two-way binding on alias
	    scope.$forContext = this;
	    // define scope properties
	    // important: define the scope alias without forced conversion
	    // so that frozen data structures remain non-reactive.
	    withoutConversion(function () {
	      defineReactive(scope, alias, value);
	    });
	    defineReactive(scope, '$index', index);
	    if (key) {
	      defineReactive(scope, '$key', key);
	    } else if (scope.$key) {
	      // avoid accidental fallback
	      def(scope, '$key', null);
	    }
	    if (this.iterator) {
	      defineReactive(scope, this.iterator, key !== null ? key : index);
	    }
	    var frag = this.factory.create(host, scope, this._frag);
	    frag.forId = this.id;
	    this.cacheFrag(value, frag, index, key);
	    return frag;
	  },
	
	  /**
	   * Update the v-ref on owner vm.
	   */
	
	  updateRef: function updateRef() {
	    var ref = this.descriptor.ref;
	    if (!ref) return;
	    var hash = (this._scope || this.vm).$refs;
	    var refs;
	    if (!this.fromObject) {
	      refs = this.frags.map(findVmFromFrag);
	    } else {
	      refs = {};
	      this.frags.forEach(function (frag) {
	        refs[frag.scope.$key] = findVmFromFrag(frag);
	      });
	    }
	    hash[ref] = refs;
	  },
	
	  /**
	   * For option lists, update the containing v-model on
	   * parent <select>.
	   */
	
	  updateModel: function updateModel() {
	    if (this.isOption) {
	      var parent = this.start.parentNode;
	      var model = parent && parent.__v_model;
	      if (model) {
	        model.forceUpdate();
	      }
	    }
	  },
	
	  /**
	   * Insert a fragment. Handles staggering.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Node} prevEl
	   * @param {Boolean} inDocument
	   */
	
	  insert: function insert(frag, index, prevEl, inDocument) {
	    if (frag.staggerCb) {
	      frag.staggerCb.cancel();
	      frag.staggerCb = null;
	    }
	    var staggerAmount = this.getStagger(frag, index, null, 'enter');
	    if (inDocument && staggerAmount) {
	      // create an anchor and insert it synchronously,
	      // so that we can resolve the correct order without
	      // worrying about some elements not inserted yet
	      var anchor = frag.staggerAnchor;
	      if (!anchor) {
	        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
	        anchor.__v_frag = frag;
	      }
	      after(anchor, prevEl);
	      var op = frag.staggerCb = cancellable(function () {
	        frag.staggerCb = null;
	        frag.before(anchor);
	        remove(anchor);
	      });
	      setTimeout(op, staggerAmount);
	    } else {
	      var target = prevEl.nextSibling;
	      /* istanbul ignore if */
	      if (!target) {
	        // reset end anchor position in case the position was messed up
	        // by an external drag-n-drop library.
	        after(this.end, prevEl);
	        target = this.end;
	      }
	      frag.before(target);
	    }
	  },
	
	  /**
	   * Remove a fragment. Handles staggering.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Number} total
	   * @param {Boolean} inDocument
	   */
	
	  remove: function remove(frag, index, total, inDocument) {
	    if (frag.staggerCb) {
	      frag.staggerCb.cancel();
	      frag.staggerCb = null;
	      // it's not possible for the same frag to be removed
	      // twice, so if we have a pending stagger callback,
	      // it means this frag is queued for enter but removed
	      // before its transition started. Since it is already
	      // destroyed, we can just leave it in detached state.
	      return;
	    }
	    var staggerAmount = this.getStagger(frag, index, total, 'leave');
	    if (inDocument && staggerAmount) {
	      var op = frag.staggerCb = cancellable(function () {
	        frag.staggerCb = null;
	        frag.remove();
	      });
	      setTimeout(op, staggerAmount);
	    } else {
	      frag.remove();
	    }
	  },
	
	  /**
	   * Move a fragment to a new position.
	   * Force no transition.
	   *
	   * @param {Fragment} frag
	   * @param {Node} prevEl
	   */
	
	  move: function move(frag, prevEl) {
	    // fix a common issue with Sortable:
	    // if prevEl doesn't have nextSibling, this means it's
	    // been dragged after the end anchor. Just re-position
	    // the end anchor to the end of the container.
	    /* istanbul ignore if */
	    if (!prevEl.nextSibling) {
	      this.end.parentNode.appendChild(this.end);
	    }
	    frag.before(prevEl.nextSibling, false);
	  },
	
	  /**
	   * Cache a fragment using track-by or the object key.
	   *
	   * @param {*} value
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {String} [key]
	   */
	
	  cacheFrag: function cacheFrag(value, frag, index, key) {
	    var trackByKey = this.params.trackBy;
	    var cache = this.cache;
	    var primitive = !isObject(value);
	    var id;
	    if (key || trackByKey || primitive) {
	      id = getTrackByKey(index, key, value, trackByKey);
	      if (!cache[id]) {
	        cache[id] = frag;
	      } else if (trackByKey !== '$index') {
	        ('production') !== 'production' && this.warnDuplicate(value);
	      }
	    } else {
	      id = this.id;
	      if (hasOwn(value, id)) {
	        if (value[id] === null) {
	          value[id] = frag;
	        } else {
	          ('production') !== 'production' && this.warnDuplicate(value);
	        }
	      } else if (Object.isExtensible(value)) {
	        def(value, id, frag);
	      } else if (false) {
	        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
	      }
	    }
	    frag.raw = value;
	  },
	
	  /**
	   * Get a cached fragment from the value/index/key
	   *
	   * @param {*} value
	   * @param {Number} index
	   * @param {String} key
	   * @return {Fragment}
	   */
	
	  getCachedFrag: function getCachedFrag(value, index, key) {
	    var trackByKey = this.params.trackBy;
	    var primitive = !isObject(value);
	    var frag;
	    if (key || trackByKey || primitive) {
	      var id = getTrackByKey(index, key, value, trackByKey);
	      frag = this.cache[id];
	    } else {
	      frag = value[this.id];
	    }
	    if (frag && (frag.reused || frag.fresh)) {
	      ('production') !== 'production' && this.warnDuplicate(value);
	    }
	    return frag;
	  },
	
	  /**
	   * Delete a fragment from cache.
	   *
	   * @param {Fragment} frag
	   */
	
	  deleteCachedFrag: function deleteCachedFrag(frag) {
	    var value = frag.raw;
	    var trackByKey = this.params.trackBy;
	    var scope = frag.scope;
	    var index = scope.$index;
	    // fix #948: avoid accidentally fall through to
	    // a parent repeater which happens to have $key.
	    var key = hasOwn(scope, '$key') && scope.$key;
	    var primitive = !isObject(value);
	    if (trackByKey || key || primitive) {
	      var id = getTrackByKey(index, key, value, trackByKey);
	      this.cache[id] = null;
	    } else {
	      value[this.id] = null;
	      frag.raw = null;
	    }
	  },
	
	  /**
	   * Get the stagger amount for an insertion/removal.
	   *
	   * @param {Fragment} frag
	   * @param {Number} index
	   * @param {Number} total
	   * @param {String} type
	   */
	
	  getStagger: function getStagger(frag, index, total, type) {
	    type = type + 'Stagger';
	    var trans = frag.node.__v_trans;
	    var hooks = trans && trans.hooks;
	    var hook = hooks && (hooks[type] || hooks.stagger);
	    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
	  },
	
	  /**
	   * Pre-process the value before piping it through the
	   * filters. This is passed to and called by the watcher.
	   */
	
	  _preProcess: function _preProcess(value) {
	    // regardless of type, store the un-filtered raw value.
	    this.rawValue = value;
	    return value;
	  },
	
	  /**
	   * Post-process the value after it has been piped through
	   * the filters. This is passed to and called by the watcher.
	   *
	   * It is necessary for this to be called during the
	   * watcher's dependency collection phase because we want
	   * the v-for to update when the source Object is mutated.
	   */
	
	  _postProcess: function _postProcess(value) {
	    if (isArray(value)) {
	      return value;
	    } else if (isPlainObject(value)) {
	      // convert plain object to array.
	      var keys = Object.keys(value);
	      var i = keys.length;
	      var res = new Array(i);
	      var key;
	      while (i--) {
	        key = keys[i];
	        res[i] = {
	          $key: key,
	          $value: value[key]
	        };
	      }
	      return res;
	    } else {
	      if (typeof value === 'number' && !isNaN(value)) {
	        value = range(value);
	      }
	      return value || [];
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.descriptor.ref) {
	      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
	    }
	    if (this.frags) {
	      var i = this.frags.length;
	      var frag;
	      while (i--) {
	        frag = this.frags[i];
	        this.deleteCachedFrag(frag);
	        frag.destroy();
	      }
	    }
	  }
	};
	
	/**
	 * Helper to find the previous element that is a fragment
	 * anchor. This is necessary because a destroyed frag's
	 * element could still be lingering in the DOM before its
	 * leaving transition finishes, but its inserted flag
	 * should have been set to false so we can skip them.
	 *
	 * If this is a block repeat, we want to make sure we only
	 * return frag that is bound to this v-for. (see #929)
	 *
	 * @param {Fragment} frag
	 * @param {Comment|Text} anchor
	 * @param {String} id
	 * @return {Fragment}
	 */
	
	function findPrevFrag(frag, anchor, id) {
	  var el = frag.node.previousSibling;
	  /* istanbul ignore if */
	  if (!el) return;
	  frag = el.__v_frag;
	  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
	    el = el.previousSibling;
	    /* istanbul ignore if */
	    if (!el) return;
	    frag = el.__v_frag;
	  }
	  return frag;
	}
	
	/**
	 * Create a range array from given number.
	 *
	 * @param {Number} n
	 * @return {Array}
	 */
	
	function range(n) {
	  var i = -1;
	  var ret = new Array(Math.floor(n));
	  while (++i < n) {
	    ret[i] = i;
	  }
	  return ret;
	}
	
	/**
	 * Get the track by key for an item.
	 *
	 * @param {Number} index
	 * @param {String} key
	 * @param {*} value
	 * @param {String} [trackByKey]
	 */
	
	function getTrackByKey(index, key, value, trackByKey) {
	  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
	}
	
	if (false) {
	  vFor.warnDuplicate = function (value) {
	    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
	  };
	}
	
	/**
	 * Find a vm from a fragment.
	 *
	 * @param {Fragment} frag
	 * @return {Vue|undefined}
	 */
	
	function findVmFromFrag(frag) {
	  var node = frag.node;
	  // handle multi-node frag
	  if (frag.end) {
	    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
	      node = node.nextSibling;
	    }
	  }
	  return node.__vue__;
	}
	
	var vIf = {
	
	  priority: IF,
	  terminal: true,
	
	  bind: function bind() {
	    var el = this.el;
	    if (!el.__vue__) {
	      // check else block
	      var next = el.nextElementSibling;
	      if (next && getAttr(next, 'v-else') !== null) {
	        remove(next);
	        this.elseEl = next;
	      }
	      // check main block
	      this.anchor = createAnchor('v-if');
	      replace(el, this.anchor);
	    } else {
	      ('production') !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
	      this.invalid = true;
	    }
	  },
	
	  update: function update(value) {
	    if (this.invalid) return;
	    if (value) {
	      if (!this.frag) {
	        this.insert();
	      }
	    } else {
	      this.remove();
	    }
	  },
	
	  insert: function insert() {
	    if (this.elseFrag) {
	      this.elseFrag.remove();
	      this.elseFrag = null;
	    }
	    // lazy init factory
	    if (!this.factory) {
	      this.factory = new FragmentFactory(this.vm, this.el);
	    }
	    this.frag = this.factory.create(this._host, this._scope, this._frag);
	    this.frag.before(this.anchor);
	  },
	
	  remove: function remove() {
	    if (this.frag) {
	      this.frag.remove();
	      this.frag = null;
	    }
	    if (this.elseEl && !this.elseFrag) {
	      if (!this.elseFactory) {
	        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
	      }
	      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
	      this.elseFrag.before(this.anchor);
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.frag) {
	      this.frag.destroy();
	    }
	    if (this.elseFrag) {
	      this.elseFrag.destroy();
	    }
	  }
	};
	
	var show = {
	
	  bind: function bind() {
	    // check else block
	    var next = this.el.nextElementSibling;
	    if (next && getAttr(next, 'v-else') !== null) {
	      this.elseEl = next;
	    }
	  },
	
	  update: function update(value) {
	    this.apply(this.el, value);
	    if (this.elseEl) {
	      this.apply(this.elseEl, !value);
	    }
	  },
	
	  apply: function apply(el, value) {
	    if (inDoc(el)) {
	      applyTransition(el, value ? 1 : -1, toggle, this.vm);
	    } else {
	      toggle();
	    }
	    function toggle() {
	      el.style.display = value ? '' : 'none';
	    }
	  }
	};
	
	var text$2 = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	    var isRange = el.type === 'range';
	    var lazy = this.params.lazy;
	    var number = this.params.number;
	    var debounce = this.params.debounce;
	
	    // handle composition events.
	    //   http://blog.evanyou.me/2014/01/03/composition-event/
	    // skip this for Android because it handles composition
	    // events quite differently. Android doesn't trigger
	    // composition events for language input methods e.g.
	    // Chinese, but instead triggers them for spelling
	    // suggestions... (see Discussion/#162)
	    var composing = false;
	    if (!isAndroid && !isRange) {
	      this.on('compositionstart', function () {
	        composing = true;
	      });
	      this.on('compositionend', function () {
	        composing = false;
	        // in IE11 the "compositionend" event fires AFTER
	        // the "input" event, so the input handler is blocked
	        // at the end... have to call it here.
	        //
	        // #1327: in lazy mode this is unecessary.
	        if (!lazy) {
	          self.listener();
	        }
	      });
	    }
	
	    // prevent messing with the input when user is typing,
	    // and force update on blur.
	    this.focused = false;
	    if (!isRange && !lazy) {
	      this.on('focus', function () {
	        self.focused = true;
	      });
	      this.on('blur', function () {
	        self.focused = false;
	        // do not sync value after fragment removal (#2017)
	        if (!self._frag || self._frag.inserted) {
	          self.rawListener();
	        }
	      });
	    }
	
	    // Now attach the main listener
	    this.listener = this.rawListener = function () {
	      if (composing || !self._bound) {
	        return;
	      }
	      var val = number || isRange ? toNumber(el.value) : el.value;
	      self.set(val);
	      // force update on next tick to avoid lock & same value
	      // also only update when user is not typing
	      nextTick(function () {
	        if (self._bound && !self.focused) {
	          self.update(self._watcher.value);
	        }
	      });
	    };
	
	    // apply debounce
	    if (debounce) {
	      this.listener = _debounce(this.listener, debounce);
	    }
	
	    // Support jQuery events, since jQuery.trigger() doesn't
	    // trigger native events in some cases and some plugins
	    // rely on $.trigger()
	    //
	    // We want to make sure if a listener is attached using
	    // jQuery, it is also removed with jQuery, that's why
	    // we do the check for each directive instance and
	    // store that check result on itself. This also allows
	    // easier test coverage control by unsetting the global
	    // jQuery variable in tests.
	    this.hasjQuery = typeof jQuery === 'function';
	    if (this.hasjQuery) {
	      var method = jQuery.fn.on ? 'on' : 'bind';
	      jQuery(el)[method]('change', this.rawListener);
	      if (!lazy) {
	        jQuery(el)[method]('input', this.listener);
	      }
	    } else {
	      this.on('change', this.rawListener);
	      if (!lazy) {
	        this.on('input', this.listener);
	      }
	    }
	
	    // IE9 doesn't fire input event on backspace/del/cut
	    if (!lazy && isIE9) {
	      this.on('cut', function () {
	        nextTick(self.listener);
	      });
	      this.on('keyup', function (e) {
	        if (e.keyCode === 46 || e.keyCode === 8) {
	          self.listener();
	        }
	      });
	    }
	
	    // set initial value if present
	    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    // #3029 only update when the value changes. This prevent
	    // browsers from overwriting values like selectionStart
	    value = _toString(value);
	    if (value !== this.el.value) this.el.value = value;
	  },
	
	  unbind: function unbind() {
	    var el = this.el;
	    if (this.hasjQuery) {
	      var method = jQuery.fn.off ? 'off' : 'unbind';
	      jQuery(el)[method]('change', this.listener);
	      jQuery(el)[method]('input', this.listener);
	    }
	  }
	};
	
	var radio = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	
	    this.getValue = function () {
	      // value overwrite via v-bind:value
	      if (el.hasOwnProperty('_value')) {
	        return el._value;
	      }
	      var val = el.value;
	      if (self.params.number) {
	        val = toNumber(val);
	      }
	      return val;
	    };
	
	    this.listener = function () {
	      self.set(self.getValue());
	    };
	    this.on('change', this.listener);
	
	    if (el.hasAttribute('checked')) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    this.el.checked = looseEqual(value, this.getValue());
	  }
	};
	
	var select = {
	
	  bind: function bind() {
	    var _this = this;
	
	    var self = this;
	    var el = this.el;
	
	    // method to force update DOM using latest value.
	    this.forceUpdate = function () {
	      if (self._watcher) {
	        self.update(self._watcher.get());
	      }
	    };
	
	    // check if this is a multiple select
	    var multiple = this.multiple = el.hasAttribute('multiple');
	
	    // attach listener
	    this.listener = function () {
	      var value = getValue(el, multiple);
	      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
	      self.set(value);
	    };
	    this.on('change', this.listener);
	
	    // if has initial value, set afterBind
	    var initValue = getValue(el, multiple, true);
	    if (multiple && initValue.length || !multiple && initValue !== null) {
	      this.afterBind = this.listener;
	    }
	
	    // All major browsers except Firefox resets
	    // selectedIndex with value -1 to 0 when the element
	    // is appended to a new parent, therefore we have to
	    // force a DOM update whenever that happens...
	    this.vm.$on('hook:attached', function () {
	      nextTick(_this.forceUpdate);
	    });
	    if (!inDoc(el)) {
	      nextTick(this.forceUpdate);
	    }
	  },
	
	  update: function update(value) {
	    var el = this.el;
	    el.selectedIndex = -1;
	    var multi = this.multiple && isArray(value);
	    var options = el.options;
	    var i = options.length;
	    var op, val;
	    while (i--) {
	      op = options[i];
	      val = op.hasOwnProperty('_value') ? op._value : op.value;
	      /* eslint-disable eqeqeq */
	      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
	      /* eslint-enable eqeqeq */
	    }
	  },
	
	  unbind: function unbind() {
	    /* istanbul ignore next */
	    this.vm.$off('hook:attached', this.forceUpdate);
	  }
	};
	
	/**
	 * Get select value
	 *
	 * @param {SelectElement} el
	 * @param {Boolean} multi
	 * @param {Boolean} init
	 * @return {Array|*}
	 */
	
	function getValue(el, multi, init) {
	  var res = multi ? [] : null;
	  var op, val, selected;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    op = el.options[i];
	    selected = init ? op.hasAttribute('selected') : op.selected;
	    if (selected) {
	      val = op.hasOwnProperty('_value') ? op._value : op.value;
	      if (multi) {
	        res.push(val);
	      } else {
	        return val;
	      }
	    }
	  }
	  return res;
	}
	
	/**
	 * Native Array.indexOf uses strict equal, but in this
	 * case we need to match string/numbers with custom equal.
	 *
	 * @param {Array} arr
	 * @param {*} val
	 */
	
	function indexOf$1(arr, val) {
	  var i = arr.length;
	  while (i--) {
	    if (looseEqual(arr[i], val)) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	var checkbox = {
	
	  bind: function bind() {
	    var self = this;
	    var el = this.el;
	
	    this.getValue = function () {
	      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
	    };
	
	    function getBooleanValue() {
	      var val = el.checked;
	      if (val && el.hasOwnProperty('_trueValue')) {
	        return el._trueValue;
	      }
	      if (!val && el.hasOwnProperty('_falseValue')) {
	        return el._falseValue;
	      }
	      return val;
	    }
	
	    this.listener = function () {
	      var model = self._watcher.get();
	      if (isArray(model)) {
	        var val = self.getValue();
	        var i = indexOf(model, val);
	        if (el.checked) {
	          if (i < 0) {
	            self.set(model.concat(val));
	          }
	        } else if (i > -1) {
	          self.set(model.slice(0, i).concat(model.slice(i + 1)));
	        }
	      } else {
	        self.set(getBooleanValue());
	      }
	    };
	
	    this.on('change', this.listener);
	    if (el.hasAttribute('checked')) {
	      this.afterBind = this.listener;
	    }
	  },
	
	  update: function update(value) {
	    var el = this.el;
	    if (isArray(value)) {
	      el.checked = indexOf(value, this.getValue()) > -1;
	    } else {
	      if (el.hasOwnProperty('_trueValue')) {
	        el.checked = looseEqual(value, el._trueValue);
	      } else {
	        el.checked = !!value;
	      }
	    }
	  }
	};
	
	var handlers = {
	  text: text$2,
	  radio: radio,
	  select: select,
	  checkbox: checkbox
	};
	
	var model = {
	
	  priority: MODEL,
	  twoWay: true,
	  handlers: handlers,
	  params: ['lazy', 'number', 'debounce'],
	
	  /**
	   * Possible elements:
	   *   <select>
	   *   <textarea>
	   *   <input type="*">
	   *     - text
	   *     - checkbox
	   *     - radio
	   *     - number
	   */
	
	  bind: function bind() {
	    // friendly warning...
	    this.checkFilters();
	    if (this.hasRead && !this.hasWrite) {
	      ('production') !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
	    }
	    var el = this.el;
	    var tag = el.tagName;
	    var handler;
	    if (tag === 'INPUT') {
	      handler = handlers[el.type] || handlers.text;
	    } else if (tag === 'SELECT') {
	      handler = handlers.select;
	    } else if (tag === 'TEXTAREA') {
	      handler = handlers.text;
	    } else {
	      ('production') !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
	      return;
	    }
	    el.__v_model = this;
	    handler.bind.call(this);
	    this.update = handler.update;
	    this._unbind = handler.unbind;
	  },
	
	  /**
	   * Check read/write filter stats.
	   */
	
	  checkFilters: function checkFilters() {
	    var filters = this.filters;
	    if (!filters) return;
	    var i = filters.length;
	    while (i--) {
	      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
	      if (typeof filter === 'function' || filter.read) {
	        this.hasRead = true;
	      }
	      if (filter.write) {
	        this.hasWrite = true;
	      }
	    }
	  },
	
	  unbind: function unbind() {
	    this.el.__v_model = null;
	    this._unbind && this._unbind();
	  }
	};
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  'delete': [8, 46],
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40
	};
	
	function keyFilter(handler, keys) {
	  var codes = keys.map(function (key) {
	    var charCode = key.charCodeAt(0);
	    if (charCode > 47 && charCode < 58) {
	      return parseInt(key, 10);
	    }
	    if (key.length === 1) {
	      charCode = key.toUpperCase().charCodeAt(0);
	      if (charCode > 64 && charCode < 91) {
	        return charCode;
	      }
	    }
	    return keyCodes[key];
	  });
	  codes = [].concat.apply([], codes);
	  return function keyHandler(e) {
	    if (codes.indexOf(e.keyCode) > -1) {
	      return handler.call(this, e);
	    }
	  };
	}
	
	function stopFilter(handler) {
	  return function stopHandler(e) {
	    e.stopPropagation();
	    return handler.call(this, e);
	  };
	}
	
	function preventFilter(handler) {
	  return function preventHandler(e) {
	    e.preventDefault();
	    return handler.call(this, e);
	  };
	}
	
	function selfFilter(handler) {
	  return function selfHandler(e) {
	    if (e.target === e.currentTarget) {
	      return handler.call(this, e);
	    }
	  };
	}
	
	var on$1 = {
	
	  priority: ON,
	  acceptStatement: true,
	  keyCodes: keyCodes,
	
	  bind: function bind() {
	    // deal with iframes
	    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
	      var self = this;
	      this.iframeBind = function () {
	        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
	      };
	      this.on('load', this.iframeBind);
	    }
	  },
	
	  update: function update(handler) {
	    // stub a noop for v-on with no value,
	    // e.g. @mousedown.prevent
	    if (!this.descriptor.raw) {
	      handler = function () {};
	    }
	
	    if (typeof handler !== 'function') {
	      ('production') !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
	      return;
	    }
	
	    // apply modifiers
	    if (this.modifiers.stop) {
	      handler = stopFilter(handler);
	    }
	    if (this.modifiers.prevent) {
	      handler = preventFilter(handler);
	    }
	    if (this.modifiers.self) {
	      handler = selfFilter(handler);
	    }
	    // key filter
	    var keys = Object.keys(this.modifiers).filter(function (key) {
	      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
	    });
	    if (keys.length) {
	      handler = keyFilter(handler, keys);
	    }
	
	    this.reset();
	    this.handler = handler;
	
	    if (this.iframeBind) {
	      this.iframeBind();
	    } else {
	      on(this.el, this.arg, this.handler, this.modifiers.capture);
	    }
	  },
	
	  reset: function reset() {
	    var el = this.iframeBind ? this.el.contentWindow : this.el;
	    if (this.handler) {
	      off(el, this.arg, this.handler);
	    }
	  },
	
	  unbind: function unbind() {
	    this.reset();
	  }
	};
	
	var prefixes = ['-webkit-', '-moz-', '-ms-'];
	var camelPrefixes = ['Webkit', 'Moz', 'ms'];
	var importantRE = /!important;?$/;
	var propCache = Object.create(null);
	
	var testEl = null;
	
	var style = {
	
	  deep: true,
	
	  update: function update(value) {
	    if (typeof value === 'string') {
	      this.el.style.cssText = value;
	    } else if (isArray(value)) {
	      this.handleObject(value.reduce(extend, {}));
	    } else {
	      this.handleObject(value || {});
	    }
	  },
	
	  handleObject: function handleObject(value) {
	    // cache object styles so that only changed props
	    // are actually updated.
	    var cache = this.cache || (this.cache = {});
	    var name, val;
	    for (name in cache) {
	      if (!(name in value)) {
	        this.handleSingle(name, null);
	        delete cache[name];
	      }
	    }
	    for (name in value) {
	      val = value[name];
	      if (val !== cache[name]) {
	        cache[name] = val;
	        this.handleSingle(name, val);
	      }
	    }
	  },
	
	  handleSingle: function handleSingle(prop, value) {
	    prop = normalize(prop);
	    if (!prop) return; // unsupported prop
	    // cast possible numbers/booleans into strings
	    if (value != null) value += '';
	    if (value) {
	      var isImportant = importantRE.test(value) ? 'important' : '';
	      if (isImportant) {
	        /* istanbul ignore if */
	        if (false) {
	          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
	        }
	        value = value.replace(importantRE, '').trim();
	        this.el.style.setProperty(prop.kebab, value, isImportant);
	      } else {
	        this.el.style[prop.camel] = value;
	      }
	    } else {
	      this.el.style[prop.camel] = '';
	    }
	  }
	
	};
	
	/**
	 * Normalize a CSS property name.
	 * - cache result
	 * - auto prefix
	 * - camelCase -> dash-case
	 *
	 * @param {String} prop
	 * @return {String}
	 */
	
	function normalize(prop) {
	  if (propCache[prop]) {
	    return propCache[prop];
	  }
	  var res = prefix(prop);
	  propCache[prop] = propCache[res] = res;
	  return res;
	}
	
	/**
	 * Auto detect the appropriate prefix for a CSS property.
	 * https://gist.github.com/paulirish/523692
	 *
	 * @param {String} prop
	 * @return {String}
	 */
	
	function prefix(prop) {
	  prop = hyphenate(prop);
	  var camel = camelize(prop);
	  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
	  if (!testEl) {
	    testEl = document.createElement('div');
	  }
	  var i = prefixes.length;
	  var prefixed;
	  if (camel !== 'filter' && camel in testEl.style) {
	    return {
	      kebab: prop,
	      camel: camel
	    };
	  }
	  while (i--) {
	    prefixed = camelPrefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return {
	        kebab: prefixes[i] + prop,
	        camel: prefixed
	      };
	    }
	  }
	}
	
	// xlink
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	var xlinkRE = /^xlink:/;
	
	// check for attributes that prohibit interpolations
	var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
	// these attributes should also set their corresponding properties
	// because they only affect the initial state of the element
	var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
	// these attributes expect enumrated values of "true" or "false"
	// but are not boolean attributes
	var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;
	
	// these attributes should set a hidden property for
	// binding v-model to object values
	var modelProps = {
	  value: '_value',
	  'true-value': '_trueValue',
	  'false-value': '_falseValue'
	};
	
	var bind$1 = {
	
	  priority: BIND,
	
	  bind: function bind() {
	    var attr = this.arg;
	    var tag = this.el.tagName;
	    // should be deep watch on object mode
	    if (!attr) {
	      this.deep = true;
	    }
	    // handle interpolation bindings
	    var descriptor = this.descriptor;
	    var tokens = descriptor.interp;
	    if (tokens) {
	      // handle interpolations with one-time tokens
	      if (descriptor.hasOneTime) {
	        this.expression = tokensToExp(tokens, this._scope || this.vm);
	      }
	
	      // only allow binding on native attributes
	      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
	        ('production') !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
	        this.el.removeAttribute(attr);
	        this.invalid = true;
	      }
	
	      /* istanbul ignore if */
	      if (false) {
	        var raw = attr + '="' + descriptor.raw + '": ';
	        // warn src
	        if (attr === 'src') {
	          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
	        }
	
	        // warn style
	        if (attr === 'style') {
	          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
	        }
	      }
	    }
	  },
	
	  update: function update(value) {
	    if (this.invalid) {
	      return;
	    }
	    var attr = this.arg;
	    if (this.arg) {
	      this.handleSingle(attr, value);
	    } else {
	      this.handleObject(value || {});
	    }
	  },
	
	  // share object handler with v-bind:class
	  handleObject: style.handleObject,
	
	  handleSingle: function handleSingle(attr, value) {
	    var el = this.el;
	    var interp = this.descriptor.interp;
	    if (this.modifiers.camel) {
	      attr = camelize(attr);
	    }
	    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
	      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
	      ? '' : value : value;
	
	      if (el[attr] !== attrValue) {
	        el[attr] = attrValue;
	      }
	    }
	    // set model props
	    var modelProp = modelProps[attr];
	    if (!interp && modelProp) {
	      el[modelProp] = value;
	      // update v-model if present
	      var model = el.__v_model;
	      if (model) {
	        model.listener();
	      }
	    }
	    // do not set value attribute for textarea
	    if (attr === 'value' && el.tagName === 'TEXTAREA') {
	      el.removeAttribute(attr);
	      return;
	    }
	    // update attribute
	    if (enumeratedAttrRE.test(attr)) {
	      el.setAttribute(attr, value ? 'true' : 'false');
	    } else if (value != null && value !== false) {
	      if (attr === 'class') {
	        // handle edge case #1960:
	        // class interpolation should not overwrite Vue transition class
	        if (el.__v_trans) {
	          value += ' ' + el.__v_trans.id + '-transition';
	        }
	        setClass(el, value);
	      } else if (xlinkRE.test(attr)) {
	        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
	      } else {
	        el.setAttribute(attr, value === true ? '' : value);
	      }
	    } else {
	      el.removeAttribute(attr);
	    }
	  }
	};
	
	var el = {
	
	  priority: EL,
	
	  bind: function bind() {
	    /* istanbul ignore if */
	    if (!this.arg) {
	      return;
	    }
	    var id = this.id = camelize(this.arg);
	    var refs = (this._scope || this.vm).$els;
	    if (hasOwn(refs, id)) {
	      refs[id] = this.el;
	    } else {
	      defineReactive(refs, id, this.el);
	    }
	  },
	
	  unbind: function unbind() {
	    var refs = (this._scope || this.vm).$els;
	    if (refs[this.id] === this.el) {
	      refs[this.id] = null;
	    }
	  }
	};
	
	var ref = {
	  bind: function bind() {
	    ('production') !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
	  }
	};
	
	var cloak = {
	  bind: function bind() {
	    var el = this.el;
	    this.vm.$once('pre-hook:compiled', function () {
	      el.removeAttribute('v-cloak');
	    });
	  }
	};
	
	// logic control
	// two-way binding
	// event handling
	// attributes
	// ref & el
	// cloak
	// must export plain object
	var directives = {
	  text: text$1,
	  html: html,
	  'for': vFor,
	  'if': vIf,
	  show: show,
	  model: model,
	  on: on$1,
	  bind: bind$1,
	  el: el,
	  ref: ref,
	  cloak: cloak
	};
	
	var vClass = {
	
	  deep: true,
	
	  update: function update(value) {
	    if (!value) {
	      this.cleanup();
	    } else if (typeof value === 'string') {
	      this.setClass(value.trim().split(/\s+/));
	    } else {
	      this.setClass(normalize$1(value));
	    }
	  },
	
	  setClass: function setClass(value) {
	    this.cleanup(value);
	    for (var i = 0, l = value.length; i < l; i++) {
	      var val = value[i];
	      if (val) {
	        apply(this.el, val, addClass);
	      }
	    }
	    this.prevKeys = value;
	  },
	
	  cleanup: function cleanup(value) {
	    var prevKeys = this.prevKeys;
	    if (!prevKeys) return;
	    var i = prevKeys.length;
	    while (i--) {
	      var key = prevKeys[i];
	      if (!value || value.indexOf(key) < 0) {
	        apply(this.el, key, removeClass);
	      }
	    }
	  }
	};
	
	/**
	 * Normalize objects and arrays (potentially containing objects)
	 * into array of strings.
	 *
	 * @param {Object|Array<String|Object>} value
	 * @return {Array<String>}
	 */
	
	function normalize$1(value) {
	  var res = [];
	  if (isArray(value)) {
	    for (var i = 0, l = value.length; i < l; i++) {
	      var _key = value[i];
	      if (_key) {
	        if (typeof _key === 'string') {
	          res.push(_key);
	        } else {
	          for (var k in _key) {
	            if (_key[k]) res.push(k);
	          }
	        }
	      }
	    }
	  } else if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) res.push(key);
	    }
	  }
	  return res;
	}
	
	/**
	 * Add or remove a class/classes on an element
	 *
	 * @param {Element} el
	 * @param {String} key The class name. This may or may not
	 *                     contain a space character, in such a
	 *                     case we'll deal with multiple class
	 *                     names at once.
	 * @param {Function} fn
	 */
	
	function apply(el, key, fn) {
	  key = key.trim();
	  if (key.indexOf(' ') === -1) {
	    fn(el, key);
	    return;
	  }
	  // The key contains one or more space characters.
	  // Since a class name doesn't accept such characters, we
	  // treat it as multiple classes.
	  var keys = key.split(/\s+/);
	  for (var i = 0, l = keys.length; i < l; i++) {
	    fn(el, keys[i]);
	  }
	}
	
	var component = {
	
	  priority: COMPONENT,
	
	  params: ['keep-alive', 'transition-mode', 'inline-template'],
	
	  /**
	   * Setup. Two possible usages:
	   *
	   * - static:
	   *   <comp> or <div v-component="comp">
	   *
	   * - dynamic:
	   *   <component :is="view">
	   */
	
	  bind: function bind() {
	    if (!this.el.__vue__) {
	      // keep-alive cache
	      this.keepAlive = this.params.keepAlive;
	      if (this.keepAlive) {
	        this.cache = {};
	      }
	      // check inline-template
	      if (this.params.inlineTemplate) {
	        // extract inline template as a DocumentFragment
	        this.inlineTemplate = extractContent(this.el, true);
	      }
	      // component resolution related state
	      this.pendingComponentCb = this.Component = null;
	      // transition related state
	      this.pendingRemovals = 0;
	      this.pendingRemovalCb = null;
	      // create a ref anchor
	      this.anchor = createAnchor('v-component');
	      replace(this.el, this.anchor);
	      // remove is attribute.
	      // this is removed during compilation, but because compilation is
	      // cached, when the component is used elsewhere this attribute
	      // will remain at link time.
	      this.el.removeAttribute('is');
	      this.el.removeAttribute(':is');
	      // remove ref, same as above
	      if (this.descriptor.ref) {
	        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
	      }
	      // if static, build right now.
	      if (this.literal) {
	        this.setComponent(this.expression);
	      }
	    } else {
	      ('production') !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
	    }
	  },
	
	  /**
	   * Public update, called by the watcher in the dynamic
	   * literal scenario, e.g. <component :is="view">
	   */
	
	  update: function update(value) {
	    if (!this.literal) {
	      this.setComponent(value);
	    }
	  },
	
	  /**
	   * Switch dynamic components. May resolve the component
	   * asynchronously, and perform transition based on
	   * specified transition mode. Accepts a few additional
	   * arguments specifically for vue-router.
	   *
	   * The callback is called when the full transition is
	   * finished.
	   *
	   * @param {String} value
	   * @param {Function} [cb]
	   */
	
	  setComponent: function setComponent(value, cb) {
	    this.invalidatePending();
	    if (!value) {
	      // just remove current
	      this.unbuild(true);
	      this.remove(this.childVM, cb);
	      this.childVM = null;
	    } else {
	      var self = this;
	      this.resolveComponent(value, function () {
	        self.mountComponent(cb);
	      });
	    }
	  },
	
	  /**
	   * Resolve the component constructor to use when creating
	   * the child vm.
	   *
	   * @param {String|Function} value
	   * @param {Function} cb
	   */
	
	  resolveComponent: function resolveComponent(value, cb) {
	    var self = this;
	    this.pendingComponentCb = cancellable(function (Component) {
	      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
	      self.Component = Component;
	      cb();
	    });
	    this.vm._resolveComponent(value, this.pendingComponentCb);
	  },
	
	  /**
	   * Create a new instance using the current constructor and
	   * replace the existing instance. This method doesn't care
	   * whether the new component and the old one are actually
	   * the same.
	   *
	   * @param {Function} [cb]
	   */
	
	  mountComponent: function mountComponent(cb) {
	    // actual mount
	    this.unbuild(true);
	    var self = this;
	    var activateHooks = this.Component.options.activate;
	    var cached = this.getCached();
	    var newComponent = this.build();
	    if (activateHooks && !cached) {
	      this.waitingFor = newComponent;
	      callActivateHooks(activateHooks, newComponent, function () {
	        if (self.waitingFor !== newComponent) {
	          return;
	        }
	        self.waitingFor = null;
	        self.transition(newComponent, cb);
	      });
	    } else {
	      // update ref for kept-alive component
	      if (cached) {
	        newComponent._updateRef();
	      }
	      this.transition(newComponent, cb);
	    }
	  },
	
	  /**
	   * When the component changes or unbinds before an async
	   * constructor is resolved, we need to invalidate its
	   * pending callback.
	   */
	
	  invalidatePending: function invalidatePending() {
	    if (this.pendingComponentCb) {
	      this.pendingComponentCb.cancel();
	      this.pendingComponentCb = null;
	    }
	  },
	
	  /**
	   * Instantiate/insert a new child vm.
	   * If keep alive and has cached instance, insert that
	   * instance; otherwise build a new one and cache it.
	   *
	   * @param {Object} [extraOptions]
	   * @return {Vue} - the created instance
	   */
	
	  build: function build(extraOptions) {
	    var cached = this.getCached();
	    if (cached) {
	      return cached;
	    }
	    if (this.Component) {
	      // default options
	      var options = {
	        name: this.ComponentName,
	        el: cloneNode(this.el),
	        template: this.inlineTemplate,
	        // make sure to add the child with correct parent
	        // if this is a transcluded component, its parent
	        // should be the transclusion host.
	        parent: this._host || this.vm,
	        // if no inline-template, then the compiled
	        // linker can be cached for better performance.
	        _linkerCachable: !this.inlineTemplate,
	        _ref: this.descriptor.ref,
	        _asComponent: true,
	        _isRouterView: this._isRouterView,
	        // if this is a transcluded component, context
	        // will be the common parent vm of this instance
	        // and its host.
	        _context: this.vm,
	        // if this is inside an inline v-for, the scope
	        // will be the intermediate scope created for this
	        // repeat fragment. this is used for linking props
	        // and container directives.
	        _scope: this._scope,
	        // pass in the owner fragment of this component.
	        // this is necessary so that the fragment can keep
	        // track of its contained components in order to
	        // call attach/detach hooks for them.
	        _frag: this._frag
	      };
	      // extra options
	      // in 1.0.0 this is used by vue-router only
	      /* istanbul ignore if */
	      if (extraOptions) {
	        extend(options, extraOptions);
	      }
	      var child = new this.Component(options);
	      if (this.keepAlive) {
	        this.cache[this.Component.cid] = child;
	      }
	      /* istanbul ignore if */
	      if (false) {
	        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
	      }
	      return child;
	    }
	  },
	
	  /**
	   * Try to get a cached instance of the current component.
	   *
	   * @return {Vue|undefined}
	   */
	
	  getCached: function getCached() {
	    return this.keepAlive && this.cache[this.Component.cid];
	  },
	
	  /**
	   * Teardown the current child, but defers cleanup so
	   * that we can separate the destroy and removal steps.
	   *
	   * @param {Boolean} defer
	   */
	
	  unbuild: function unbuild(defer) {
	    if (this.waitingFor) {
	      if (!this.keepAlive) {
	        this.waitingFor.$destroy();
	      }
	      this.waitingFor = null;
	    }
	    var child = this.childVM;
	    if (!child || this.keepAlive) {
	      if (child) {
	        // remove ref
	        child._inactive = true;
	        child._updateRef(true);
	      }
	      return;
	    }
	    // the sole purpose of `deferCleanup` is so that we can
	    // "deactivate" the vm right now and perform DOM removal
	    // later.
	    child.$destroy(false, defer);
	  },
	
	  /**
	   * Remove current destroyed child and manually do
	   * the cleanup after removal.
	   *
	   * @param {Function} cb
	   */
	
	  remove: function remove(child, cb) {
	    var keepAlive = this.keepAlive;
	    if (child) {
	      // we may have a component switch when a previous
	      // component is still being transitioned out.
	      // we want to trigger only one lastest insertion cb
	      // when the existing transition finishes. (#1119)
	      this.pendingRemovals++;
	      this.pendingRemovalCb = cb;
	      var self = this;
	      child.$remove(function () {
	        self.pendingRemovals--;
	        if (!keepAlive) child._cleanup();
	        if (!self.pendingRemovals && self.pendingRemovalCb) {
	          self.pendingRemovalCb();
	          self.pendingRemovalCb = null;
	        }
	      });
	    } else if (cb) {
	      cb();
	    }
	  },
	
	  /**
	   * Actually swap the components, depending on the
	   * transition mode. Defaults to simultaneous.
	   *
	   * @param {Vue} target
	   * @param {Function} [cb]
	   */
	
	  transition: function transition(target, cb) {
	    var self = this;
	    var current = this.childVM;
	    // for devtool inspection
	    if (current) current._inactive = true;
	    target._inactive = false;
	    this.childVM = target;
	    switch (self.params.transitionMode) {
	      case 'in-out':
	        target.$before(self.anchor, function () {
	          self.remove(current, cb);
	        });
	        break;
	      case 'out-in':
	        self.remove(current, function () {
	          target.$before(self.anchor, cb);
	        });
	        break;
	      default:
	        self.remove(current);
	        target.$before(self.anchor, cb);
	    }
	  },
	
	  /**
	   * Unbind.
	   */
	
	  unbind: function unbind() {
	    this.invalidatePending();
	    // Do not defer cleanup when unbinding
	    this.unbuild();
	    // destroy all keep-alive cached instances
	    if (this.cache) {
	      for (var key in this.cache) {
	        this.cache[key].$destroy();
	      }
	      this.cache = null;
	    }
	  }
	};
	
	/**
	 * Call activate hooks in order (asynchronous)
	 *
	 * @param {Array} hooks
	 * @param {Vue} vm
	 * @param {Function} cb
	 */
	
	function callActivateHooks(hooks, vm, cb) {
	  var total = hooks.length;
	  var called = 0;
	  hooks[0].call(vm, next);
	  function next() {
	    if (++called >= total) {
	      cb();
	    } else {
	      hooks[called].call(vm, next);
	    }
	  }
	}
	
	var propBindingModes = config._propBindingModes;
	var empty = {};
	
	// regexes
	var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
	var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;
	
	/**
	 * Compile props on a root element and return
	 * a props link function.
	 *
	 * @param {Element|DocumentFragment} el
	 * @param {Array} propOptions
	 * @param {Vue} vm
	 * @return {Function} propsLinkFn
	 */
	
	function compileProps(el, propOptions, vm) {
	  var props = [];
	  var propsData = vm.$options.propsData;
	  var names = Object.keys(propOptions);
	  var i = names.length;
	  var options, name, attr, value, path, parsed, prop;
	  while (i--) {
	    name = names[i];
	    options = propOptions[name] || empty;
	
	    if (false) {
	      warn('Do not use $data as prop.', vm);
	      continue;
	    }
	
	    // props could contain dashes, which will be
	    // interpreted as minus calculations by the parser
	    // so we need to camelize the path here
	    path = camelize(name);
	    if (!identRE$1.test(path)) {
	      ('production') !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
	      continue;
	    }
	
	    prop = {
	      name: name,
	      path: path,
	      options: options,
	      mode: propBindingModes.ONE_WAY,
	      raw: null
	    };
	
	    attr = hyphenate(name);
	    // first check dynamic version
	    if ((value = getBindAttr(el, attr)) === null) {
	      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
	        prop.mode = propBindingModes.TWO_WAY;
	      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
	        prop.mode = propBindingModes.ONE_TIME;
	      }
	    }
	    if (value !== null) {
	      // has dynamic binding!
	      prop.raw = value;
	      parsed = parseDirective(value);
	      value = parsed.expression;
	      prop.filters = parsed.filters;
	      // check binding type
	      if (isLiteral(value) && !parsed.filters) {
	        // for expressions containing literal numbers and
	        // booleans, there's no need to setup a prop binding,
	        // so we can optimize them as a one-time set.
	        prop.optimizedLiteral = true;
	      } else {
	        prop.dynamic = true;
	        // check non-settable path for two-way bindings
	        if (false) {
	          prop.mode = propBindingModes.ONE_WAY;
	          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
	        }
	      }
	      prop.parentPath = value;
	
	      // warn required two-way
	      if (false) {
	        warn('Prop "' + name + '" expects a two-way binding type.', vm);
	      }
	    } else if ((value = getAttr(el, attr)) !== null) {
	      // has literal binding!
	      prop.raw = value;
	    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
	      // has propsData
	      prop.raw = value;
	    } else if (false) {
	      // check possible camelCase prop usage
	      var lowerCaseName = path.toLowerCase();
	      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
	      if (value) {
	        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
	      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
	        // warn missing required
	        warn('Missing required prop: ' + name, vm);
	      }
	    }
	    // push prop
	    props.push(prop);
	  }
	  return makePropsLinkFn(props);
	}
	
	/**
	 * Build a function that applies props to a vm.
	 *
	 * @param {Array} props
	 * @return {Function} propsLinkFn
	 */
	
	function makePropsLinkFn(props) {
	  return function propsLinkFn(vm, scope) {
	    // store resolved props info
	    vm._props = {};
	    var inlineProps = vm.$options.propsData;
	    var i = props.length;
	    var prop, path, options, value, raw;
	    while (i--) {
	      prop = props[i];
	      raw = prop.raw;
	      path = prop.path;
	      options = prop.options;
	      vm._props[path] = prop;
	      if (inlineProps && hasOwn(inlineProps, path)) {
	        initProp(vm, prop, inlineProps[path]);
	      }if (raw === null) {
	        // initialize absent prop
	        initProp(vm, prop, undefined);
	      } else if (prop.dynamic) {
	        // dynamic prop
	        if (prop.mode === propBindingModes.ONE_TIME) {
	          // one time binding
	          value = (scope || vm._context || vm).$get(prop.parentPath);
	          initProp(vm, prop, value);
	        } else {
	          if (vm._context) {
	            // dynamic binding
	            vm._bindDir({
	              name: 'prop',
	              def: propDef,
	              prop: prop
	            }, null, null, scope); // el, host, scope
	          } else {
	              // root instance
	              initProp(vm, prop, vm.$get(prop.parentPath));
	            }
	        }
	      } else if (prop.optimizedLiteral) {
	        // optimized literal, cast it and just set once
	        var stripped = stripQuotes(raw);
	        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
	        initProp(vm, prop, value);
	      } else {
	        // string literal, but we need to cater for
	        // Boolean props with no value, or with same
	        // literal value (e.g. disabled="disabled")
	        // see https://github.com/vuejs/vue-loader/issues/182
	        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
	        initProp(vm, prop, value);
	      }
	    }
	  };
	}
	
	/**
	 * Process a prop with a rawValue, applying necessary coersions,
	 * default values & assertions and call the given callback with
	 * processed value.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} rawValue
	 * @param {Function} fn
	 */
	
	function processPropValue(vm, prop, rawValue, fn) {
	  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
	  var value = rawValue;
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop);
	  }
	  value = coerceProp(prop, value, vm);
	  var coerced = value !== rawValue;
	  if (!assertProp(prop, value, vm)) {
	    value = undefined;
	  }
	  if (isSimple && !coerced) {
	    withoutConversion(function () {
	      fn(value);
	    });
	  } else {
	    fn(value);
	  }
	}
	
	/**
	 * Set a prop's initial value on a vm and its data object.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} value
	 */
	
	function initProp(vm, prop, value) {
	  processPropValue(vm, prop, value, function (value) {
	    defineReactive(vm, prop.path, value);
	  });
	}
	
	/**
	 * Update a prop's value on a vm.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @param {*} value
	 */
	
	function updateProp(vm, prop, value) {
	  processPropValue(vm, prop, value, function (value) {
	    vm[prop.path] = value;
	  });
	}
	
	/**
	 * Get the default value of a prop.
	 *
	 * @param {Vue} vm
	 * @param {Object} prop
	 * @return {*}
	 */
	
	function getPropDefaultValue(vm, prop) {
	  // no default, return undefined
	  var options = prop.options;
	  if (!hasOwn(options, 'default')) {
	    // absent boolean value defaults to false
	    return options.type === Boolean ? false : undefined;
	  }
	  var def = options['default'];
	  // warn against non-factory defaults for Object & Array
	  if (isObject(def)) {
	    ('production') !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
	  }
	  // call factory function for non-Function types
	  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
	}
	
	/**
	 * Assert whether a prop is valid.
	 *
	 * @param {Object} prop
	 * @param {*} value
	 * @param {Vue} vm
	 */
	
	function assertProp(prop, value, vm) {
	  if (!prop.options.required && ( // non-required
	  prop.raw === null || // abscent
	  value == null) // null or undefined
	  ) {
	      return true;
	    }
	  var options = prop.options;
	  var type = options.type;
	  var valid = !type;
	  var expectedTypes = [];
	  if (type) {
	    if (!isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType);
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    if (false) {
	      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
	    }
	    return false;
	  }
	  var validator = options.validator;
	  if (validator) {
	    if (!validator(value)) {
	      ('production') !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Force parsing value with coerce option.
	 *
	 * @param {*} value
	 * @param {Object} options
	 * @return {*}
	 */
	
	function coerceProp(prop, value, vm) {
	  var coerce = prop.options.coerce;
	  if (!coerce) {
	    return value;
	  }
	  if (typeof coerce === 'function') {
	    return coerce(value);
	  } else {
	    ('production') !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
	    return value;
	  }
	}
	
	/**
	 * Assert the type of a value
	 *
	 * @param {*} value
	 * @param {Function} type
	 * @return {Object}
	 */
	
	function assertType(value, type) {
	  var valid;
	  var expectedType;
	  if (type === String) {
	    expectedType = 'string';
	    valid = typeof value === expectedType;
	  } else if (type === Number) {
	    expectedType = 'number';
	    valid = typeof value === expectedType;
	  } else if (type === Boolean) {
	    expectedType = 'boolean';
	    valid = typeof value === expectedType;
	  } else if (type === Function) {
	    expectedType = 'function';
	    valid = typeof value === expectedType;
	  } else if (type === Object) {
	    expectedType = 'object';
	    valid = isPlainObject(value);
	  } else if (type === Array) {
	    expectedType = 'array';
	    valid = isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  };
	}
	
	/**
	 * Format type for output
	 *
	 * @param {String} type
	 * @return {String}
	 */
	
	function formatType(type) {
	  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
	}
	
	/**
	 * Format value
	 *
	 * @param {*} value
	 * @return {String}
	 */
	
	function formatValue(val) {
	  return Object.prototype.toString.call(val).slice(8, -1);
	}
	
	var bindingModes = config._propBindingModes;
	
	var propDef = {
	
	  bind: function bind() {
	    var child = this.vm;
	    var parent = child._context;
	    // passed in from compiler directly
	    var prop = this.descriptor.prop;
	    var childKey = prop.path;
	    var parentKey = prop.parentPath;
	    var twoWay = prop.mode === bindingModes.TWO_WAY;
	
	    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
	      updateProp(child, prop, val);
	    }, {
	      twoWay: twoWay,
	      filters: prop.filters,
	      // important: props need to be observed on the
	      // v-for scope if present
	      scope: this._scope
	    });
	
	    // set the child initial value.
	    initProp(child, prop, parentWatcher.value);
	
	    // setup two-way binding
	    if (twoWay) {
	      // important: defer the child watcher creation until
	      // the created hook (after data observation)
	      var self = this;
	      child.$once('pre-hook:created', function () {
	        self.childWatcher = new Watcher(child, childKey, function (val) {
	          parentWatcher.set(val);
	        }, {
	          // ensure sync upward before parent sync down.
	          // this is necessary in cases e.g. the child
	          // mutates a prop array, then replaces it. (#1683)
	          sync: true
	        });
	      });
	    }
	  },
	
	  unbind: function unbind() {
	    this.parentWatcher.teardown();
	    if (this.childWatcher) {
	      this.childWatcher.teardown();
	    }
	  }
	};
	
	var queue$1 = [];
	var queued = false;
	
	/**
	 * Push a job into the queue.
	 *
	 * @param {Function} job
	 */
	
	function pushJob(job) {
	  queue$1.push(job);
	  if (!queued) {
	    queued = true;
	    nextTick(flush);
	  }
	}
	
	/**
	 * Flush the queue, and do one forced reflow before
	 * triggering transitions.
	 */
	
	function flush() {
	  // Force layout
	  var f = document.documentElement.offsetHeight;
	  for (var i = 0; i < queue$1.length; i++) {
	    queue$1[i]();
	  }
	  queue$1 = [];
	  queued = false;
	  // dummy return, so js linters don't complain about
	  // unused variable f
	  return f;
	}
	
	var TYPE_TRANSITION = 'transition';
	var TYPE_ANIMATION = 'animation';
	var transDurationProp = transitionProp + 'Duration';
	var animDurationProp = animationProp + 'Duration';
	
	/**
	 * If a just-entered element is applied the
	 * leave class while its enter transition hasn't started yet,
	 * and the transitioned property has the same value for both
	 * enter/leave, then the leave transition will be skipped and
	 * the transitionend event never fires. This function ensures
	 * its callback to be called after a transition has started
	 * by waiting for double raf.
	 *
	 * It falls back to setTimeout on devices that support CSS
	 * transitions but not raf (e.g. Android 4.2 browser) - since
	 * these environments are usually slow, we are giving it a
	 * relatively large timeout.
	 */
	
	var raf = inBrowser && window.requestAnimationFrame;
	var waitForTransitionStart = raf
	/* istanbul ignore next */
	? function (fn) {
	  raf(function () {
	    raf(fn);
	  });
	} : function (fn) {
	  setTimeout(fn, 50);
	};
	
	/**
	 * A Transition object that encapsulates the state and logic
	 * of the transition.
	 *
	 * @param {Element} el
	 * @param {String} id
	 * @param {Object} hooks
	 * @param {Vue} vm
	 */
	function Transition(el, id, hooks, vm) {
	  this.id = id;
	  this.el = el;
	  this.enterClass = hooks && hooks.enterClass || id + '-enter';
	  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
	  this.hooks = hooks;
	  this.vm = vm;
	  // async state
	  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
	  this.justEntered = false;
	  this.entered = this.left = false;
	  this.typeCache = {};
	  // check css transition type
	  this.type = hooks && hooks.type;
	  /* istanbul ignore if */
	  if (false) {
	    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
	      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
	    }
	  }
	  // bind
	  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
	    self[m] = bind(self[m], self);
	  });
	}
	
	var p$1 = Transition.prototype;
	
	/**
	 * Start an entering transition.
	 *
	 * 1. enter transition triggered
	 * 2. call beforeEnter hook
	 * 3. add enter class
	 * 4. insert/show element
	 * 5. call enter hook (with possible explicit js callback)
	 * 6. reflow
	 * 7. based on transition type:
	 *    - transition:
	 *        remove class now, wait for transitionend,
	 *        then done if there's no explicit js callback.
	 *    - animation:
	 *        wait for animationend, remove class,
	 *        then done if there's no explicit js callback.
	 *    - no css transition:
	 *        done now if there's no explicit js callback.
	 * 8. wait for either done or js callback, then call
	 *    afterEnter hook.
	 *
	 * @param {Function} op - insert/show the element
	 * @param {Function} [cb]
	 */
	
	p$1.enter = function (op, cb) {
	  this.cancelPending();
	  this.callHook('beforeEnter');
	  this.cb = cb;
	  addClass(this.el, this.enterClass);
	  op();
	  this.entered = false;
	  this.callHookWithCb('enter');
	  if (this.entered) {
	    return; // user called done synchronously.
	  }
	  this.cancel = this.hooks && this.hooks.enterCancelled;
	  pushJob(this.enterNextTick);
	};
	
	/**
	 * The "nextTick" phase of an entering transition, which is
	 * to be pushed into a queue and executed after a reflow so
	 * that removing the class can trigger a CSS transition.
	 */
	
	p$1.enterNextTick = function () {
	  var _this = this;
	
	  // prevent transition skipping
	  this.justEntered = true;
	  waitForTransitionStart(function () {
	    _this.justEntered = false;
	  });
	  var enterDone = this.enterDone;
	  var type = this.getCssTransitionType(this.enterClass);
	  if (!this.pendingJsCb) {
	    if (type === TYPE_TRANSITION) {
	      // trigger transition by removing enter class now
	      removeClass(this.el, this.enterClass);
	      this.setupCssCb(transitionEndEvent, enterDone);
	    } else if (type === TYPE_ANIMATION) {
	      this.setupCssCb(animationEndEvent, enterDone);
	    } else {
	      enterDone();
	    }
	  } else if (type === TYPE_TRANSITION) {
	    removeClass(this.el, this.enterClass);
	  }
	};
	
	/**
	 * The "cleanup" phase of an entering transition.
	 */
	
	p$1.enterDone = function () {
	  this.entered = true;
	  this.cancel = this.pendingJsCb = null;
	  removeClass(this.el, this.enterClass);
	  this.callHook('afterEnter');
	  if (this.cb) this.cb();
	};
	
	/**
	 * Start a leaving transition.
	 *
	 * 1. leave transition triggered.
	 * 2. call beforeLeave hook
	 * 3. add leave class (trigger css transition)
	 * 4. call leave hook (with possible explicit js callback)
	 * 5. reflow if no explicit js callback is provided
	 * 6. based on transition type:
	 *    - transition or animation:
	 *        wait for end event, remove class, then done if
	 *        there's no explicit js callback.
	 *    - no css transition:
	 *        done if there's no explicit js callback.
	 * 7. wait for either done or js callback, then call
	 *    afterLeave hook.
	 *
	 * @param {Function} op - remove/hide the element
	 * @param {Function} [cb]
	 */
	
	p$1.leave = function (op, cb) {
	  this.cancelPending();
	  this.callHook('beforeLeave');
	  this.op = op;
	  this.cb = cb;
	  addClass(this.el, this.leaveClass);
	  this.left = false;
	  this.callHookWithCb('leave');
	  if (this.left) {
	    return; // user called done synchronously.
	  }
	  this.cancel = this.hooks && this.hooks.leaveCancelled;
	  // only need to handle leaveDone if
	  // 1. the transition is already done (synchronously called
	  //    by the user, which causes this.op set to null)
	  // 2. there's no explicit js callback
	  if (this.op && !this.pendingJsCb) {
	    // if a CSS transition leaves immediately after enter,
	    // the transitionend event never fires. therefore we
	    // detect such cases and end the leave immediately.
	    if (this.justEntered) {
	      this.leaveDone();
	    } else {
	      pushJob(this.leaveNextTick);
	    }
	  }
	};
	
	/**
	 * The "nextTick" phase of a leaving transition.
	 */
	
	p$1.leaveNextTick = function () {
	  var type = this.getCssTransitionType(this.leaveClass);
	  if (type) {
	    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
	    this.setupCssCb(event, this.leaveDone);
	  } else {
	    this.leaveDone();
	  }
	};
	
	/**
	 * The "cleanup" phase of a leaving transition.
	 */
	
	p$1.leaveDone = function () {
	  this.left = true;
	  this.cancel = this.pendingJsCb = null;
	  this.op();
	  removeClass(this.el, this.leaveClass);
	  this.callHook('afterLeave');
	  if (this.cb) this.cb();
	  this.op = null;
	};
	
	/**
	 * Cancel any pending callbacks from a previously running
	 * but not finished transition.
	 */
	
	p$1.cancelPending = function () {
	  this.op = this.cb = null;
	  var hasPending = false;
	  if (this.pendingCssCb) {
	    hasPending = true;
	    off(this.el, this.pendingCssEvent, this.pendingCssCb);
	    this.pendingCssEvent = this.pendingCssCb = null;
	  }
	  if (this.pendingJsCb) {
	    hasPending = true;
	    this.pendingJsCb.cancel();
	    this.pendingJsCb = null;
	  }
	  if (hasPending) {
	    removeClass(this.el, this.enterClass);
	    removeClass(this.el, this.leaveClass);
	  }
	  if (this.cancel) {
	    this.cancel.call(this.vm, this.el);
	    this.cancel = null;
	  }
	};
	
	/**
	 * Call a user-provided synchronous hook function.
	 *
	 * @param {String} type
	 */
	
	p$1.callHook = function (type) {
	  if (this.hooks && this.hooks[type]) {
	    this.hooks[type].call(this.vm, this.el);
	  }
	};
	
	/**
	 * Call a user-provided, potentially-async hook function.
	 * We check for the length of arguments to see if the hook
	 * expects a `done` callback. If true, the transition's end
	 * will be determined by when the user calls that callback;
	 * otherwise, the end is determined by the CSS transition or
	 * animation.
	 *
	 * @param {String} type
	 */
	
	p$1.callHookWithCb = function (type) {
	  var hook = this.hooks && this.hooks[type];
	  if (hook) {
	    if (hook.length > 1) {
	      this.pendingJsCb = cancellable(this[type + 'Done']);
	    }
	    hook.call(this.vm, this.el, this.pendingJsCb);
	  }
	};
	
	/**
	 * Get an element's transition type based on the
	 * calculated styles.
	 *
	 * @param {String} className
	 * @return {Number}
	 */
	
	p$1.getCssTransitionType = function (className) {
	  /* istanbul ignore if */
	  if (!transitionEndEvent ||
	  // skip CSS transitions if page is not visible -
	  // this solves the issue of transitionend events not
	  // firing until the page is visible again.
	  // pageVisibility API is supported in IE10+, same as
	  // CSS transitions.
	  document.hidden ||
	  // explicit js-only transition
	  this.hooks && this.hooks.css === false ||
	  // element is hidden
	  isHidden(this.el)) {
	    return;
	  }
	  var type = this.type || this.typeCache[className];
	  if (type) return type;
	  var inlineStyles = this.el.style;
	  var computedStyles = window.getComputedStyle(this.el);
	  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
	  if (transDuration && transDuration !== '0s') {
	    type = TYPE_TRANSITION;
	  } else {
	    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
	    if (animDuration && animDuration !== '0s') {
	      type = TYPE_ANIMATION;
	    }
	  }
	  if (type) {
	    this.typeCache[className] = type;
	  }
	  return type;
	};
	
	/**
	 * Setup a CSS transitionend/animationend callback.
	 *
	 * @param {String} event
	 * @param {Function} cb
	 */
	
	p$1.setupCssCb = function (event, cb) {
	  this.pendingCssEvent = event;
	  var self = this;
	  var el = this.el;
	  var onEnd = this.pendingCssCb = function (e) {
	    if (e.target === el) {
	      off(el, event, onEnd);
	      self.pendingCssEvent = self.pendingCssCb = null;
	      if (!self.pendingJsCb && cb) {
	        cb();
	      }
	    }
	  };
	  on(el, event, onEnd);
	};
	
	/**
	 * Check if an element is hidden - in that case we can just
	 * skip the transition alltogether.
	 *
	 * @param {Element} el
	 * @return {Boolean}
	 */
	
	function isHidden(el) {
	  if (/svg$/.test(el.namespaceURI)) {
	    // SVG elements do not have offset(Width|Height)
	    // so we need to check the client rect
	    var rect = el.getBoundingClientRect();
	    return !(rect.width || rect.height);
	  } else {
	    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	  }
	}
	
	var transition$1 = {
	
	  priority: TRANSITION,
	
	  update: function update(id, oldId) {
	    var el = this.el;
	    // resolve on owner vm
	    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
	    id = id || 'v';
	    oldId = oldId || 'v';
	    el.__v_trans = new Transition(el, id, hooks, this.vm);
	    removeClass(el, oldId + '-transition');
	    addClass(el, id + '-transition');
	  }
	};
	
	var internalDirectives = {
	  style: style,
	  'class': vClass,
	  component: component,
	  prop: propDef,
	  transition: transition$1
	};
	
	// special binding prefixes
	var bindRE = /^v-bind:|^:/;
	var onRE = /^v-on:|^@/;
	var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
	var modifierRE = /\.[^\.]+/g;
	var transitionRE = /^(v-bind:|:)?transition$/;
	
	// default directive priority
	var DEFAULT_PRIORITY = 1000;
	var DEFAULT_TERMINAL_PRIORITY = 2000;
	
	/**
	 * Compile a template and return a reusable composite link
	 * function, which recursively contains more link functions
	 * inside. This top level compile function would normally
	 * be called on instance root nodes, but can also be used
	 * for partial compilation if the partial argument is true.
	 *
	 * The returned composite link function, when called, will
	 * return an unlink function that tearsdown all directives
	 * created during the linking phase.
	 *
	 * @param {Element|DocumentFragment} el
	 * @param {Object} options
	 * @param {Boolean} partial
	 * @return {Function}
	 */
	
	function compile(el, options, partial) {
	  // link function for the node itself.
	  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
	  // link function for the childNodes
	  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;
	
	  /**
	   * A composite linker function to be called on a already
	   * compiled piece of DOM, which instantiates all directive
	   * instances.
	   *
	   * @param {Vue} vm
	   * @param {Element|DocumentFragment} el
	   * @param {Vue} [host] - host vm of transcluded content
	   * @param {Object} [scope] - v-for scope
	   * @param {Fragment} [frag] - link context fragment
	   * @return {Function|undefined}
	   */
	
	  return function compositeLinkFn(vm, el, host, scope, frag) {
	    // cache childNodes before linking parent, fix #657
	    var childNodes = toArray(el.childNodes);
	    // link
	    var dirs = linkAndCapture(function compositeLinkCapturer() {
	      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
	      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
	    }, vm);
	    return makeUnlinkFn(vm, dirs);
	  };
	}
	
	/**
	 * Apply a linker to a vm/element pair and capture the
	 * directives created during the process.
	 *
	 * @param {Function} linker
	 * @param {Vue} vm
	 */
	
	function linkAndCapture(linker, vm) {
	  /* istanbul ignore if */
	  if (true) {
	    // reset directives before every capture in production
	    // mode, so that when unlinking we don't need to splice
	    // them out (which turns out to be a perf hit).
	    // they are kept in development mode because they are
	    // useful for Vue's own tests.
	    vm._directives = [];
	  }
	  var originalDirCount = vm._directives.length;
	  linker();
	  var dirs = vm._directives.slice(originalDirCount);
	  sortDirectives(dirs);
	  for (var i = 0, l = dirs.length; i < l; i++) {
	    dirs[i]._bind();
	  }
	  return dirs;
	}
	
	/**
	 * sort directives by priority (stable sort)
	 *
	 * @param {Array} dirs
	 */
	function sortDirectives(dirs) {
	  if (dirs.length === 0) return;
	
	  var groupedMap = {};
	  var i, j, k, l;
	  var index = 0;
	  var priorities = [];
	  for (i = 0, j = dirs.length; i < j; i++) {
	    var dir = dirs[i];
	    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
	    var array = groupedMap[priority];
	    if (!array) {
	      array = groupedMap[priority] = [];
	      priorities.push(priority);
	    }
	    array.push(dir);
	  }
	
	  priorities.sort(function (a, b) {
	    return a > b ? -1 : a === b ? 0 : 1;
	  });
	  for (i = 0, j = priorities.length; i < j; i++) {
	    var group = groupedMap[priorities[i]];
	    for (k = 0, l = group.length; k < l; k++) {
	      dirs[index++] = group[k];
	    }
	  }
	}
	
	/**
	 * Linker functions return an unlink function that
	 * tearsdown all directives instances generated during
	 * the process.
	 *
	 * We create unlink functions with only the necessary
	 * information to avoid retaining additional closures.
	 *
	 * @param {Vue} vm
	 * @param {Array} dirs
	 * @param {Vue} [context]
	 * @param {Array} [contextDirs]
	 * @return {Function}
	 */
	
	function makeUnlinkFn(vm, dirs, context, contextDirs) {
	  function unlink(destroying) {
	    teardownDirs(vm, dirs, destroying);
	    if (context && contextDirs) {
	      teardownDirs(context, contextDirs);
	    }
	  }
	  // expose linked directives
	  unlink.dirs = dirs;
	  return unlink;
	}
	
	/**
	 * Teardown partial linked directives.
	 *
	 * @param {Vue} vm
	 * @param {Array} dirs
	 * @param {Boolean} destroying
	 */
	
	function teardownDirs(vm, dirs, destroying) {
	  var i = dirs.length;
	  while (i--) {
	    dirs[i]._teardown();
	    if (false) {
	      vm._directives.$remove(dirs[i]);
	    }
	  }
	}
	
	/**
	 * Compile link props on an instance.
	 *
	 * @param {Vue} vm
	 * @param {Element} el
	 * @param {Object} props
	 * @param {Object} [scope]
	 * @return {Function}
	 */
	
	function compileAndLinkProps(vm, el, props, scope) {
	  var propsLinkFn = compileProps(el, props, vm);
	  var propDirs = linkAndCapture(function () {
	    propsLinkFn(vm, scope);
	  }, vm);
	  return makeUnlinkFn(vm, propDirs);
	}
	
	/**
	 * Compile the root element of an instance.
	 *
	 * 1. attrs on context container (context scope)
	 * 2. attrs on the component template root node, if
	 *    replace:true (child scope)
	 *
	 * If this is a fragment instance, we only need to compile 1.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @param {Object} contextOptions
	 * @return {Function}
	 */
	
	function compileRoot(el, options, contextOptions) {
	  var containerAttrs = options._containerAttrs;
	  var replacerAttrs = options._replacerAttrs;
	  var contextLinkFn, replacerLinkFn;
	
	  // only need to compile other attributes for
	  // non-fragment instances
	  if (el.nodeType !== 11) {
	    // for components, container and replacer need to be
	    // compiled separately and linked in different scopes.
	    if (options._asComponent) {
	      // 2. container attributes
	      if (containerAttrs && contextOptions) {
	        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
	      }
	      if (replacerAttrs) {
	        // 3. replacer attributes
	        replacerLinkFn = compileDirectives(replacerAttrs, options);
	      }
	    } else {
	      // non-component, just compile as a normal element.
	      replacerLinkFn = compileDirectives(el.attributes, options);
	    }
	  } else if (false) {
	    // warn container directives for fragment instances
	    var names = containerAttrs.filter(function (attr) {
	      // allow vue-loader/vueify scoped css attributes
	      return attr.name.indexOf('_v-') < 0 &&
	      // allow event listeners
	      !onRE.test(attr.name) &&
	      // allow slots
	      attr.name !== 'slot';
	    }).map(function (attr) {
	      return '"' + attr.name + '"';
	    });
	    if (names.length) {
	      var plural = names.length > 1;
	
	      var componentName = options.el.tagName.toLowerCase();
	      if (componentName === 'component' && options.name) {
	        componentName += ':' + options.name;
	      }
	
	      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
	    }
	  }
	
	  options._containerAttrs = options._replacerAttrs = null;
	  return function rootLinkFn(vm, el, scope) {
	    // link context scope dirs
	    var context = vm._context;
	    var contextDirs;
	    if (context && contextLinkFn) {
	      contextDirs = linkAndCapture(function () {
	        contextLinkFn(context, el, null, scope);
	      }, context);
	    }
	
	    // link self
	    var selfDirs = linkAndCapture(function () {
	      if (replacerLinkFn) replacerLinkFn(vm, el);
	    }, vm);
	
	    // return the unlink function that tearsdown context
	    // container directives.
	    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
	  };
	}
	
	/**
	 * Compile a node and return a nodeLinkFn based on the
	 * node type.
	 *
	 * @param {Node} node
	 * @param {Object} options
	 * @return {Function|null}
	 */
	
	function compileNode(node, options) {
	  var type = node.nodeType;
	  if (type === 1 && !isScript(node)) {
	    return compileElement(node, options);
	  } else if (type === 3 && node.data.trim()) {
	    return compileTextNode(node, options);
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Compile an element and return a nodeLinkFn.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Function|null}
	 */
	
	function compileElement(el, options) {
	  // preprocess textareas.
	  // textarea treats its text content as the initial value.
	  // just bind it as an attr directive for value.
	  if (el.tagName === 'TEXTAREA') {
	    // a textarea which has v-pre attr should skip complie.
	    if (getAttr(el, 'v-pre') !== null) {
	      return skip;
	    }
	    var tokens = parseText(el.value);
	    if (tokens) {
	      el.setAttribute(':value', tokensToExp(tokens));
	      el.value = '';
	    }
	  }
	  var linkFn;
	  var hasAttrs = el.hasAttributes();
	  var attrs = hasAttrs && toArray(el.attributes);
	  // check terminal directives (for & if)
	  if (hasAttrs) {
	    linkFn = checkTerminalDirectives(el, attrs, options);
	  }
	  // check element directives
	  if (!linkFn) {
	    linkFn = checkElementDirectives(el, options);
	  }
	  // check component
	  if (!linkFn) {
	    linkFn = checkComponent(el, options);
	  }
	  // normal directives
	  if (!linkFn && hasAttrs) {
	    linkFn = compileDirectives(attrs, options);
	  }
	  return linkFn;
	}
	
	/**
	 * Compile a textNode and return a nodeLinkFn.
	 *
	 * @param {TextNode} node
	 * @param {Object} options
	 * @return {Function|null} textNodeLinkFn
	 */
	
	function compileTextNode(node, options) {
	  // skip marked text nodes
	  if (node._skip) {
	    return removeText;
	  }
	
	  var tokens = parseText(node.wholeText);
	  if (!tokens) {
	    return null;
	  }
	
	  // mark adjacent text nodes as skipped,
	  // because we are using node.wholeText to compile
	  // all adjacent text nodes together. This fixes
	  // issues in IE where sometimes it splits up a single
	  // text node into multiple ones.
	  var next = node.nextSibling;
	  while (next && next.nodeType === 3) {
	    next._skip = true;
	    next = next.nextSibling;
	  }
	
	  var frag = document.createDocumentFragment();
	  var el, token;
	  for (var i = 0, l = tokens.length; i < l; i++) {
	    token = tokens[i];
	    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
	    frag.appendChild(el);
	  }
	  return makeTextNodeLinkFn(tokens, frag, options);
	}
	
	/**
	 * Linker for an skipped text node.
	 *
	 * @param {Vue} vm
	 * @param {Text} node
	 */
	
	function removeText(vm, node) {
	  remove(node);
	}
	
	/**
	 * Process a single text token.
	 *
	 * @param {Object} token
	 * @param {Object} options
	 * @return {Node}
	 */
	
	function processTextToken(token, options) {
	  var el;
	  if (token.oneTime) {
	    el = document.createTextNode(token.value);
	  } else {
	    if (token.html) {
	      el = document.createComment('v-html');
	      setTokenType('html');
	    } else {
	      // IE will clean up empty textNodes during
	      // frag.cloneNode(true), so we have to give it
	      // something here...
	      el = document.createTextNode(' ');
	      setTokenType('text');
	    }
	  }
	  function setTokenType(type) {
	    if (token.descriptor) return;
	    var parsed = parseDirective(token.value);
	    token.descriptor = {
	      name: type,
	      def: directives[type],
	      expression: parsed.expression,
	      filters: parsed.filters
	    };
	  }
	  return el;
	}
	
	/**
	 * Build a function that processes a textNode.
	 *
	 * @param {Array<Object>} tokens
	 * @param {DocumentFragment} frag
	 */
	
	function makeTextNodeLinkFn(tokens, frag) {
	  return function textNodeLinkFn(vm, el, host, scope) {
	    var fragClone = frag.cloneNode(true);
	    var childNodes = toArray(fragClone.childNodes);
	    var token, value, node;
	    for (var i = 0, l = tokens.length; i < l; i++) {
	      token = tokens[i];
	      value = token.value;
	      if (token.tag) {
	        node = childNodes[i];
	        if (token.oneTime) {
	          value = (scope || vm).$eval(value);
	          if (token.html) {
	            replace(node, parseTemplate(value, true));
	          } else {
	            node.data = _toString(value);
	          }
	        } else {
	          vm._bindDir(token.descriptor, node, host, scope);
	        }
	      }
	    }
	    replace(el, fragClone);
	  };
	}
	
	/**
	 * Compile a node list and return a childLinkFn.
	 *
	 * @param {NodeList} nodeList
	 * @param {Object} options
	 * @return {Function|undefined}
	 */
	
	function compileNodeList(nodeList, options) {
	  var linkFns = [];
	  var nodeLinkFn, childLinkFn, node;
	  for (var i = 0, l = nodeList.length; i < l; i++) {
	    node = nodeList[i];
	    nodeLinkFn = compileNode(node, options);
	    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
	    linkFns.push(nodeLinkFn, childLinkFn);
	  }
	  return linkFns.length ? makeChildLinkFn(linkFns) : null;
	}
	
	/**
	 * Make a child link function for a node's childNodes.
	 *
	 * @param {Array<Function>} linkFns
	 * @return {Function} childLinkFn
	 */
	
	function makeChildLinkFn(linkFns) {
	  return function childLinkFn(vm, nodes, host, scope, frag) {
	    var node, nodeLinkFn, childrenLinkFn;
	    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
	      node = nodes[n];
	      nodeLinkFn = linkFns[i++];
	      childrenLinkFn = linkFns[i++];
	      // cache childNodes before linking parent, fix #657
	      var childNodes = toArray(node.childNodes);
	      if (nodeLinkFn) {
	        nodeLinkFn(vm, node, host, scope, frag);
	      }
	      if (childrenLinkFn) {
	        childrenLinkFn(vm, childNodes, host, scope, frag);
	      }
	    }
	  };
	}
	
	/**
	 * Check for element directives (custom elements that should
	 * be resovled as terminal directives).
	 *
	 * @param {Element} el
	 * @param {Object} options
	 */
	
	function checkElementDirectives(el, options) {
	  var tag = el.tagName.toLowerCase();
	  if (commonTagRE.test(tag)) {
	    return;
	  }
	  var def = resolveAsset(options, 'elementDirectives', tag);
	  if (def) {
	    return makeTerminalNodeLinkFn(el, tag, '', options, def);
	  }
	}
	
	/**
	 * Check if an element is a component. If yes, return
	 * a component link function.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Function|undefined}
	 */
	
	function checkComponent(el, options) {
	  var component = checkComponentAttr(el, options);
	  if (component) {
	    var ref = findRef(el);
	    var descriptor = {
	      name: 'component',
	      ref: ref,
	      expression: component.id,
	      def: internalDirectives.component,
	      modifiers: {
	        literal: !component.dynamic
	      }
	    };
	    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
	      if (ref) {
	        defineReactive((scope || vm).$refs, ref, null);
	      }
	      vm._bindDir(descriptor, el, host, scope, frag);
	    };
	    componentLinkFn.terminal = true;
	    return componentLinkFn;
	  }
	}
	
	/**
	 * Check an element for terminal directives in fixed order.
	 * If it finds one, return a terminal link function.
	 *
	 * @param {Element} el
	 * @param {Array} attrs
	 * @param {Object} options
	 * @return {Function} terminalLinkFn
	 */
	
	function checkTerminalDirectives(el, attrs, options) {
	  // skip v-pre
	  if (getAttr(el, 'v-pre') !== null) {
	    return skip;
	  }
	  // skip v-else block, but only if following v-if
	  if (el.hasAttribute('v-else')) {
	    var prev = el.previousElementSibling;
	    if (prev && prev.hasAttribute('v-if')) {
	      return skip;
	    }
	  }
	
	  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
	  for (var i = 0, j = attrs.length; i < j; i++) {
	    attr = attrs[i];
	    name = attr.name.replace(modifierRE, '');
	    if (matched = name.match(dirAttrRE)) {
	      def = resolveAsset(options, 'directives', matched[1]);
	      if (def && def.terminal) {
	        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
	          termDef = def;
	          rawName = attr.name;
	          modifiers = parseModifiers(attr.name);
	          value = attr.value;
	          dirName = matched[1];
	          arg = matched[2];
	        }
	      }
	    }
	  }
	
	  if (termDef) {
	    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
	  }
	}
	
	function skip() {}
	skip.terminal = true;
	
	/**
	 * Build a node link function for a terminal directive.
	 * A terminal link function terminates the current
	 * compilation recursion and handles compilation of the
	 * subtree in the directive.
	 *
	 * @param {Element} el
	 * @param {String} dirName
	 * @param {String} value
	 * @param {Object} options
	 * @param {Object} def
	 * @param {String} [rawName]
	 * @param {String} [arg]
	 * @param {Object} [modifiers]
	 * @return {Function} terminalLinkFn
	 */
	
	function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
	  var parsed = parseDirective(value);
	  var descriptor = {
	    name: dirName,
	    arg: arg,
	    expression: parsed.expression,
	    filters: parsed.filters,
	    raw: value,
	    attr: rawName,
	    modifiers: modifiers,
	    def: def
	  };
	  // check ref for v-for, v-if and router-view
	  if (dirName === 'for' || dirName === 'router-view') {
	    descriptor.ref = findRef(el);
	  }
	  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
	    if (descriptor.ref) {
	      defineReactive((scope || vm).$refs, descriptor.ref, null);
	    }
	    vm._bindDir(descriptor, el, host, scope, frag);
	  };
	  fn.terminal = true;
	  return fn;
	}
	
	/**
	 * Compile the directives on an element and return a linker.
	 *
	 * @param {Array|NamedNodeMap} attrs
	 * @param {Object} options
	 * @return {Function}
	 */
	
	function compileDirectives(attrs, options) {
	  var i = attrs.length;
	  var dirs = [];
	  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
	  while (i--) {
	    attr = attrs[i];
	    name = rawName = attr.name;
	    value = rawValue = attr.value;
	    tokens = parseText(value);
	    // reset arg
	    arg = null;
	    // check modifiers
	    modifiers = parseModifiers(name);
	    name = name.replace(modifierRE, '');
	
	    // attribute interpolations
	    if (tokens) {
	      value = tokensToExp(tokens);
	      arg = name;
	      pushDir('bind', directives.bind, tokens);
	      // warn against mixing mustaches with v-bind
	      if (false) {
	        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
	          return attr.name === ':class' || attr.name === 'v-bind:class';
	        })) {
	          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
	        }
	      }
	    } else
	
	      // special attribute: transition
	      if (transitionRE.test(name)) {
	        modifiers.literal = !bindRE.test(name);
	        pushDir('transition', internalDirectives.transition);
	      } else
	
	        // event handlers
	        if (onRE.test(name)) {
	          arg = name.replace(onRE, '');
	          pushDir('on', directives.on);
	        } else
	
	          // attribute bindings
	          if (bindRE.test(name)) {
	            dirName = name.replace(bindRE, '');
	            if (dirName === 'style' || dirName === 'class') {
	              pushDir(dirName, internalDirectives[dirName]);
	            } else {
	              arg = dirName;
	              pushDir('bind', directives.bind);
	            }
	          } else
	
	            // normal directives
	            if (matched = name.match(dirAttrRE)) {
	              dirName = matched[1];
	              arg = matched[2];
	
	              // skip v-else (when used with v-show)
	              if (dirName === 'else') {
	                continue;
	              }
	
	              dirDef = resolveAsset(options, 'directives', dirName, true);
	              if (dirDef) {
	                pushDir(dirName, dirDef);
	              }
	            }
	  }
	
	  /**
	   * Push a directive.
	   *
	   * @param {String} dirName
	   * @param {Object|Function} def
	   * @param {Array} [interpTokens]
	   */
	
	  function pushDir(dirName, def, interpTokens) {
	    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
	    var parsed = !hasOneTimeToken && parseDirective(value);
	    dirs.push({
	      name: dirName,
	      attr: rawName,
	      raw: rawValue,
	      def: def,
	      arg: arg,
	      modifiers: modifiers,
	      // conversion from interpolation strings with one-time token
	      // to expression is differed until directive bind time so that we
	      // have access to the actual vm context for one-time bindings.
	      expression: parsed && parsed.expression,
	      filters: parsed && parsed.filters,
	      interp: interpTokens,
	      hasOneTime: hasOneTimeToken
	    });
	  }
	
	  if (dirs.length) {
	    return makeNodeLinkFn(dirs);
	  }
	}
	
	/**
	 * Parse modifiers from directive attribute name.
	 *
	 * @param {String} name
	 * @return {Object}
	 */
	
	function parseModifiers(name) {
	  var res = Object.create(null);
	  var match = name.match(modifierRE);
	  if (match) {
	    var i = match.length;
	    while (i--) {
	      res[match[i].slice(1)] = true;
	    }
	  }
	  return res;
	}
	
	/**
	 * Build a link function for all directives on a single node.
	 *
	 * @param {Array} directives
	 * @return {Function} directivesLinkFn
	 */
	
	function makeNodeLinkFn(directives) {
	  return function nodeLinkFn(vm, el, host, scope, frag) {
	    // reverse apply because it's sorted low to high
	    var i = directives.length;
	    while (i--) {
	      vm._bindDir(directives[i], el, host, scope, frag);
	    }
	  };
	}
	
	/**
	 * Check if an interpolation string contains one-time tokens.
	 *
	 * @param {Array} tokens
	 * @return {Boolean}
	 */
	
	function hasOneTime(tokens) {
	  var i = tokens.length;
	  while (i--) {
	    if (tokens[i].oneTime) return true;
	  }
	}
	
	function isScript(el) {
	  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
	}
	
	var specialCharRE = /[^\w\-:\.]/;
	
	/**
	 * Process an element or a DocumentFragment based on a
	 * instance option object. This allows us to transclude
	 * a template node/fragment before the instance is created,
	 * so the processed fragment can then be cloned and reused
	 * in v-for.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Element|DocumentFragment}
	 */
	
	function transclude(el, options) {
	  // extract container attributes to pass them down
	  // to compiler, because they need to be compiled in
	  // parent scope. we are mutating the options object here
	  // assuming the same object will be used for compile
	  // right after this.
	  if (options) {
	    options._containerAttrs = extractAttrs(el);
	  }
	  // for template tags, what we want is its content as
	  // a documentFragment (for fragment instances)
	  if (isTemplate(el)) {
	    el = parseTemplate(el);
	  }
	  if (options) {
	    if (options._asComponent && !options.template) {
	      options.template = '<slot></slot>';
	    }
	    if (options.template) {
	      options._content = extractContent(el);
	      el = transcludeTemplate(el, options);
	    }
	  }
	  if (isFragment(el)) {
	    // anchors for fragment instance
	    // passing in `persist: true` to avoid them being
	    // discarded by IE during template cloning
	    prepend(createAnchor('v-start', true), el);
	    el.appendChild(createAnchor('v-end', true));
	  }
	  return el;
	}
	
	/**
	 * Process the template option.
	 * If the replace option is true this will swap the $el.
	 *
	 * @param {Element} el
	 * @param {Object} options
	 * @return {Element|DocumentFragment}
	 */
	
	function transcludeTemplate(el, options) {
	  var template = options.template;
	  var frag = parseTemplate(template, true);
	  if (frag) {
	    var replacer = frag.firstChild;
	    if (!replacer) {
	      return frag;
	    }
	    var tag = replacer.tagName && replacer.tagName.toLowerCase();
	    if (options.replace) {
	      /* istanbul ignore if */
	      if (el === document.body) {
	        ('production') !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
	      }
	      // there are many cases where the instance must
	      // become a fragment instance: basically anything that
	      // can create more than 1 root nodes.
	      if (
	      // multi-children template
	      frag.childNodes.length > 1 ||
	      // non-element template
	      replacer.nodeType !== 1 ||
	      // single nested component
	      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
	      // element directive
	      resolveAsset(options, 'elementDirectives', tag) ||
	      // for block
	      replacer.hasAttribute('v-for') ||
	      // if block
	      replacer.hasAttribute('v-if')) {
	        return frag;
	      } else {
	        options._replacerAttrs = extractAttrs(replacer);
	        mergeAttrs(el, replacer);
	        return replacer;
	      }
	    } else {
	      el.appendChild(frag);
	      return el;
	    }
	  } else {
	    ('production') !== 'production' && warn('Invalid template option: ' + template);
	  }
	}
	
	/**
	 * Helper to extract a component container's attributes
	 * into a plain object array.
	 *
	 * @param {Element} el
	 * @return {Array}
	 */
	
	function extractAttrs(el) {
	  if (el.nodeType === 1 && el.hasAttributes()) {
	    return toArray(el.attributes);
	  }
	}
	
	/**
	 * Merge the attributes of two elements, and make sure
	 * the class names are merged properly.
	 *
	 * @param {Element} from
	 * @param {Element} to
	 */
	
	function mergeAttrs(from, to) {
	  var attrs = from.attributes;
	  var i = attrs.length;
	  var name, value;
	  while (i--) {
	    name = attrs[i].name;
	    value = attrs[i].value;
	    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
	      to.setAttribute(name, value);
	    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
	      value.split(/\s+/).forEach(function (cls) {
	        addClass(to, cls);
	      });
	    }
	  }
	}
	
	/**
	 * Scan and determine slot content distribution.
	 * We do this during transclusion instead at compile time so that
	 * the distribution is decoupled from the compilation order of
	 * the slots.
	 *
	 * @param {Element|DocumentFragment} template
	 * @param {Element} content
	 * @param {Vue} vm
	 */
	
	function resolveSlots(vm, content) {
	  if (!content) {
	    return;
	  }
	  var contents = vm._slotContents = Object.create(null);
	  var el, name;
	  for (var i = 0, l = content.children.length; i < l; i++) {
	    el = content.children[i];
	    /* eslint-disable no-cond-assign */
	    if (name = el.getAttribute('slot')) {
	      (contents[name] || (contents[name] = [])).push(el);
	    }
	    /* eslint-enable no-cond-assign */
	    if (false) {
	      warn('The "slot" attribute must be static.', vm.$parent);
	    }
	  }
	  for (name in contents) {
	    contents[name] = extractFragment(contents[name], content);
	  }
	  if (content.hasChildNodes()) {
	    var nodes = content.childNodes;
	    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
	      return;
	    }
	    contents['default'] = extractFragment(content.childNodes, content);
	  }
	}
	
	/**
	 * Extract qualified content nodes from a node list.
	 *
	 * @param {NodeList} nodes
	 * @return {DocumentFragment}
	 */
	
	function extractFragment(nodes, parent) {
	  var frag = document.createDocumentFragment();
	  nodes = toArray(nodes);
	  for (var i = 0, l = nodes.length; i < l; i++) {
	    var node = nodes[i];
	    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
	      parent.removeChild(node);
	      node = parseTemplate(node, true);
	    }
	    frag.appendChild(node);
	  }
	  return frag;
	}
	
	
	
	var compiler = Object.freeze({
		compile: compile,
		compileAndLinkProps: compileAndLinkProps,
		compileRoot: compileRoot,
		transclude: transclude,
		resolveSlots: resolveSlots
	});
	
	function stateMixin (Vue) {
	  /**
	   * Accessor for `$data` property, since setting $data
	   * requires observing the new object and updating
	   * proxied properties.
	   */
	
	  Object.defineProperty(Vue.prototype, '$data', {
	    get: function get() {
	      return this._data;
	    },
	    set: function set(newData) {
	      if (newData !== this._data) {
	        this._setData(newData);
	      }
	    }
	  });
	
	  /**
	   * Setup the scope of an instance, which contains:
	   * - observed data
	   * - computed properties
	   * - user methods
	   * - meta properties
	   */
	
	  Vue.prototype._initState = function () {
	    this._initProps();
	    this._initMeta();
	    this._initMethods();
	    this._initData();
	    this._initComputed();
	  };
	
	  /**
	   * Initialize props.
	   */
	
	  Vue.prototype._initProps = function () {
	    var options = this.$options;
	    var el = options.el;
	    var props = options.props;
	    if (props && !el) {
	      ('production') !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
	    }
	    // make sure to convert string selectors into element now
	    el = options.el = query(el);
	    this._propsUnlinkFn = el && el.nodeType === 1 && props
	    // props must be linked in proper scope if inside v-for
	    ? compileAndLinkProps(this, el, props, this._scope) : null;
	  };
	
	  /**
	   * Initialize the data.
	   */
	
	  Vue.prototype._initData = function () {
	    var dataFn = this.$options.data;
	    var data = this._data = dataFn ? dataFn() : {};
	    if (!isPlainObject(data)) {
	      data = {};
	      ('production') !== 'production' && warn('data functions should return an object.', this);
	    }
	    var props = this._props;
	    // proxy data on instance
	    var keys = Object.keys(data);
	    var i, key;
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      // there are two scenarios where we can proxy a data key:
	      // 1. it's not already defined as a prop
	      // 2. it's provided via a instantiation option AND there are no
	      //    template prop present
	      if (!props || !hasOwn(props, key)) {
	        this._proxy(key);
	      } else if (false) {
	        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
	      }
	    }
	    // observe data
	    observe(data, this);
	  };
	
	  /**
	   * Swap the instance's $data. Called in $data's setter.
	   *
	   * @param {Object} newData
	   */
	
	  Vue.prototype._setData = function (newData) {
	    newData = newData || {};
	    var oldData = this._data;
	    this._data = newData;
	    var keys, key, i;
	    // unproxy keys not present in new data
	    keys = Object.keys(oldData);
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      if (!(key in newData)) {
	        this._unproxy(key);
	      }
	    }
	    // proxy keys not already proxied,
	    // and trigger change for changed values
	    keys = Object.keys(newData);
	    i = keys.length;
	    while (i--) {
	      key = keys[i];
	      if (!hasOwn(this, key)) {
	        // new property
	        this._proxy(key);
	      }
	    }
	    oldData.__ob__.removeVm(this);
	    observe(newData, this);
	    this._digest();
	  };
	
	  /**
	   * Proxy a property, so that
	   * vm.prop === vm._data.prop
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype._proxy = function (key) {
	    if (!isReserved(key)) {
	      // need to store ref to self here
	      // because these getter/setters might
	      // be called by child scopes via
	      // prototype inheritance.
	      var self = this;
	      Object.defineProperty(self, key, {
	        configurable: true,
	        enumerable: true,
	        get: function proxyGetter() {
	          return self._data[key];
	        },
	        set: function proxySetter(val) {
	          self._data[key] = val;
	        }
	      });
	    }
	  };
	
	  /**
	   * Unproxy a property.
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype._unproxy = function (key) {
	    if (!isReserved(key)) {
	      delete this[key];
	    }
	  };
	
	  /**
	   * Force update on every watcher in scope.
	   */
	
	  Vue.prototype._digest = function () {
	    for (var i = 0, l = this._watchers.length; i < l; i++) {
	      this._watchers[i].update(true); // shallow updates
	    }
	  };
	
	  /**
	   * Setup computed properties. They are essentially
	   * special getter/setters
	   */
	
	  function noop() {}
	  Vue.prototype._initComputed = function () {
	    var computed = this.$options.computed;
	    if (computed) {
	      for (var key in computed) {
	        var userDef = computed[key];
	        var def = {
	          enumerable: true,
	          configurable: true
	        };
	        if (typeof userDef === 'function') {
	          def.get = makeComputedGetter(userDef, this);
	          def.set = noop;
	        } else {
	          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
	          def.set = userDef.set ? bind(userDef.set, this) : noop;
	        }
	        Object.defineProperty(this, key, def);
	      }
	    }
	  };
	
	  function makeComputedGetter(getter, owner) {
	    var watcher = new Watcher(owner, getter, null, {
	      lazy: true
	    });
	    return function computedGetter() {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value;
	    };
	  }
	
	  /**
	   * Setup instance methods. Methods must be bound to the
	   * instance since they might be passed down as a prop to
	   * child components.
	   */
	
	  Vue.prototype._initMethods = function () {
	    var methods = this.$options.methods;
	    if (methods) {
	      for (var key in methods) {
	        this[key] = bind(methods[key], this);
	      }
	    }
	  };
	
	  /**
	   * Initialize meta information like $index, $key & $value.
	   */
	
	  Vue.prototype._initMeta = function () {
	    var metas = this.$options._meta;
	    if (metas) {
	      for (var key in metas) {
	        defineReactive(this, key, metas[key]);
	      }
	    }
	  };
	}
	
	var eventRE = /^v-on:|^@/;
	
	function eventsMixin (Vue) {
	  /**
	   * Setup the instance's option events & watchers.
	   * If the value is a string, we pull it from the
	   * instance's methods by name.
	   */
	
	  Vue.prototype._initEvents = function () {
	    var options = this.$options;
	    if (options._asComponent) {
	      registerComponentEvents(this, options.el);
	    }
	    registerCallbacks(this, '$on', options.events);
	    registerCallbacks(this, '$watch', options.watch);
	  };
	
	  /**
	   * Register v-on events on a child component
	   *
	   * @param {Vue} vm
	   * @param {Element} el
	   */
	
	  function registerComponentEvents(vm, el) {
	    var attrs = el.attributes;
	    var name, value, handler;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      name = attrs[i].name;
	      if (eventRE.test(name)) {
	        name = name.replace(eventRE, '');
	        // force the expression into a statement so that
	        // it always dynamically resolves the method to call (#2670)
	        // kinda ugly hack, but does the job.
	        value = attrs[i].value;
	        if (isSimplePath(value)) {
	          value += '.apply(this, $arguments)';
	        }
	        handler = (vm._scope || vm._context).$eval(value, true);
	        handler._fromParent = true;
	        vm.$on(name.replace(eventRE), handler);
	      }
	    }
	  }
	
	  /**
	   * Register callbacks for option events and watchers.
	   *
	   * @param {Vue} vm
	   * @param {String} action
	   * @param {Object} hash
	   */
	
	  function registerCallbacks(vm, action, hash) {
	    if (!hash) return;
	    var handlers, key, i, j;
	    for (key in hash) {
	      handlers = hash[key];
	      if (isArray(handlers)) {
	        for (i = 0, j = handlers.length; i < j; i++) {
	          register(vm, action, key, handlers[i]);
	        }
	      } else {
	        register(vm, action, key, handlers);
	      }
	    }
	  }
	
	  /**
	   * Helper to register an event/watch callback.
	   *
	   * @param {Vue} vm
	   * @param {String} action
	   * @param {String} key
	   * @param {Function|String|Object} handler
	   * @param {Object} [options]
	   */
	
	  function register(vm, action, key, handler, options) {
	    var type = typeof handler;
	    if (type === 'function') {
	      vm[action](key, handler, options);
	    } else if (type === 'string') {
	      var methods = vm.$options.methods;
	      var method = methods && methods[handler];
	      if (method) {
	        vm[action](key, method, options);
	      } else {
	        ('production') !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
	      }
	    } else if (handler && type === 'object') {
	      register(vm, action, key, handler.handler, handler);
	    }
	  }
	
	  /**
	   * Setup recursive attached/detached calls
	   */
	
	  Vue.prototype._initDOMHooks = function () {
	    this.$on('hook:attached', onAttached);
	    this.$on('hook:detached', onDetached);
	  };
	
	  /**
	   * Callback to recursively call attached hook on children
	   */
	
	  function onAttached() {
	    if (!this._isAttached) {
	      this._isAttached = true;
	      this.$children.forEach(callAttach);
	    }
	  }
	
	  /**
	   * Iterator to call attached hook
	   *
	   * @param {Vue} child
	   */
	
	  function callAttach(child) {
	    if (!child._isAttached && inDoc(child.$el)) {
	      child._callHook('attached');
	    }
	  }
	
	  /**
	   * Callback to recursively call detached hook on children
	   */
	
	  function onDetached() {
	    if (this._isAttached) {
	      this._isAttached = false;
	      this.$children.forEach(callDetach);
	    }
	  }
	
	  /**
	   * Iterator to call detached hook
	   *
	   * @param {Vue} child
	   */
	
	  function callDetach(child) {
	    if (child._isAttached && !inDoc(child.$el)) {
	      child._callHook('detached');
	    }
	  }
	
	  /**
	   * Trigger all handlers for a hook
	   *
	   * @param {String} hook
	   */
	
	  Vue.prototype._callHook = function (hook) {
	    this.$emit('pre-hook:' + hook);
	    var handlers = this.$options[hook];
	    if (handlers) {
	      for (var i = 0, j = handlers.length; i < j; i++) {
	        handlers[i].call(this);
	      }
	    }
	    this.$emit('hook:' + hook);
	  };
	}
	
	function noop$1() {}
	
	/**
	 * A directive links a DOM element with a piece of data,
	 * which is the result of evaluating an expression.
	 * It registers a watcher with the expression and calls
	 * the DOM update function when a change is triggered.
	 *
	 * @param {Object} descriptor
	 *                 - {String} name
	 *                 - {Object} def
	 *                 - {String} expression
	 *                 - {Array<Object>} [filters]
	 *                 - {Object} [modifiers]
	 *                 - {Boolean} literal
	 *                 - {String} attr
	 *                 - {String} arg
	 *                 - {String} raw
	 *                 - {String} [ref]
	 *                 - {Array<Object>} [interp]
	 *                 - {Boolean} [hasOneTime]
	 * @param {Vue} vm
	 * @param {Node} el
	 * @param {Vue} [host] - transclusion host component
	 * @param {Object} [scope] - v-for scope
	 * @param {Fragment} [frag] - owner fragment
	 * @constructor
	 */
	function Directive(descriptor, vm, el, host, scope, frag) {
	  this.vm = vm;
	  this.el = el;
	  // copy descriptor properties
	  this.descriptor = descriptor;
	  this.name = descriptor.name;
	  this.expression = descriptor.expression;
	  this.arg = descriptor.arg;
	  this.modifiers = descriptor.modifiers;
	  this.filters = descriptor.filters;
	  this.literal = this.modifiers && this.modifiers.literal;
	  // private
	  this._locked = false;
	  this._bound = false;
	  this._listeners = null;
	  // link context
	  this._host = host;
	  this._scope = scope;
	  this._frag = frag;
	  // store directives on node in dev mode
	  if (false) {
	    this.el._vue_directives = this.el._vue_directives || [];
	    this.el._vue_directives.push(this);
	  }
	}
	
	/**
	 * Initialize the directive, mixin definition properties,
	 * setup the watcher, call definition bind() and update()
	 * if present.
	 */
	
	Directive.prototype._bind = function () {
	  var name = this.name;
	  var descriptor = this.descriptor;
	
	  // remove attribute
	  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
	    var attr = descriptor.attr || 'v-' + name;
	    this.el.removeAttribute(attr);
	  }
	
	  // copy def properties
	  var def = descriptor.def;
	  if (typeof def === 'function') {
	    this.update = def;
	  } else {
	    extend(this, def);
	  }
	
	  // setup directive params
	  this._setupParams();
	
	  // initial bind
	  if (this.bind) {
	    this.bind();
	  }
	  this._bound = true;
	
	  if (this.literal) {
	    this.update && this.update(descriptor.raw);
	  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
	    // wrapped updater for context
	    var dir = this;
	    if (this.update) {
	      this._update = function (val, oldVal) {
	        if (!dir._locked) {
	          dir.update(val, oldVal);
	        }
	      };
	    } else {
	      this._update = noop$1;
	    }
	    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
	    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
	    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
	    {
	      filters: this.filters,
	      twoWay: this.twoWay,
	      deep: this.deep,
	      preProcess: preProcess,
	      postProcess: postProcess,
	      scope: this._scope
	    });
	    // v-model with inital inline value need to sync back to
	    // model instead of update to DOM on init. They would
	    // set the afterBind hook to indicate that.
	    if (this.afterBind) {
	      this.afterBind();
	    } else if (this.update) {
	      this.update(watcher.value);
	    }
	  }
	};
	
	/**
	 * Setup all param attributes, e.g. track-by,
	 * transition-mode, etc...
	 */
	
	Directive.prototype._setupParams = function () {
	  if (!this.params) {
	    return;
	  }
	  var params = this.params;
	  // swap the params array with a fresh object.
	  this.params = Object.create(null);
	  var i = params.length;
	  var key, val, mappedKey;
	  while (i--) {
	    key = hyphenate(params[i]);
	    mappedKey = camelize(key);
	    val = getBindAttr(this.el, key);
	    if (val != null) {
	      // dynamic
	      this._setupParamWatcher(mappedKey, val);
	    } else {
	      // static
	      val = getAttr(this.el, key);
	      if (val != null) {
	        this.params[mappedKey] = val === '' ? true : val;
	      }
	    }
	  }
	};
	
	/**
	 * Setup a watcher for a dynamic param.
	 *
	 * @param {String} key
	 * @param {String} expression
	 */
	
	Directive.prototype._setupParamWatcher = function (key, expression) {
	  var self = this;
	  var called = false;
	  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
	    self.params[key] = val;
	    // since we are in immediate mode,
	    // only call the param change callbacks if this is not the first update.
	    if (called) {
	      var cb = self.paramWatchers && self.paramWatchers[key];
	      if (cb) {
	        cb.call(self, val, oldVal);
	      }
	    } else {
	      called = true;
	    }
	  }, {
	    immediate: true,
	    user: false
	  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
	};
	
	/**
	 * Check if the directive is a function caller
	 * and if the expression is a callable one. If both true,
	 * we wrap up the expression and use it as the event
	 * handler.
	 *
	 * e.g. on-click="a++"
	 *
	 * @return {Boolean}
	 */
	
	Directive.prototype._checkStatement = function () {
	  var expression = this.expression;
	  if (expression && this.acceptStatement && !isSimplePath(expression)) {
	    var fn = parseExpression$1(expression).get;
	    var scope = this._scope || this.vm;
	    var handler = function handler(e) {
	      scope.$event = e;
	      fn.call(scope, scope);
	      scope.$event = null;
	    };
	    if (this.filters) {
	      handler = scope._applyFilters(handler, null, this.filters);
	    }
	    this.update(handler);
	    return true;
	  }
	};
	
	/**
	 * Set the corresponding value with the setter.
	 * This should only be used in two-way directives
	 * e.g. v-model.
	 *
	 * @param {*} value
	 * @public
	 */
	
	Directive.prototype.set = function (value) {
	  /* istanbul ignore else */
	  if (this.twoWay) {
	    this._withLock(function () {
	      this._watcher.set(value);
	    });
	  } else if (false) {
	    warn('Directive.set() can only be used inside twoWay' + 'directives.');
	  }
	};
	
	/**
	 * Execute a function while preventing that function from
	 * triggering updates on this directive instance.
	 *
	 * @param {Function} fn
	 */
	
	Directive.prototype._withLock = function (fn) {
	  var self = this;
	  self._locked = true;
	  fn.call(self);
	  nextTick(function () {
	    self._locked = false;
	  });
	};
	
	/**
	 * Convenience method that attaches a DOM event listener
	 * to the directive element and autometically tears it down
	 * during unbind.
	 *
	 * @param {String} event
	 * @param {Function} handler
	 * @param {Boolean} [useCapture]
	 */
	
	Directive.prototype.on = function (event, handler, useCapture) {
	  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
	};
	
	/**
	 * Teardown the watcher and call unbind.
	 */
	
	Directive.prototype._teardown = function () {
	  if (this._bound) {
	    this._bound = false;
	    if (this.unbind) {
	      this.unbind();
	    }
	    if (this._watcher) {
	      this._watcher.teardown();
	    }
	    var listeners = this._listeners;
	    var i;
	    if (listeners) {
	      i = listeners.length;
	      while (i--) {
	        off(this.el, listeners[i][0], listeners[i][1]);
	      }
	    }
	    var unwatchFns = this._paramUnwatchFns;
	    if (unwatchFns) {
	      i = unwatchFns.length;
	      while (i--) {
	        unwatchFns[i]();
	      }
	    }
	    if (false) {
	      this.el._vue_directives.$remove(this);
	    }
	    this.vm = this.el = this._watcher = this._listeners = null;
	  }
	};
	
	function lifecycleMixin (Vue) {
	  /**
	   * Update v-ref for component.
	   *
	   * @param {Boolean} remove
	   */
	
	  Vue.prototype._updateRef = function (remove) {
	    var ref = this.$options._ref;
	    if (ref) {
	      var refs = (this._scope || this._context).$refs;
	      if (remove) {
	        if (refs[ref] === this) {
	          refs[ref] = null;
	        }
	      } else {
	        refs[ref] = this;
	      }
	    }
	  };
	
	  /**
	   * Transclude, compile and link element.
	   *
	   * If a pre-compiled linker is available, that means the
	   * passed in element will be pre-transcluded and compiled
	   * as well - all we need to do is to call the linker.
	   *
	   * Otherwise we need to call transclude/compile/link here.
	   *
	   * @param {Element} el
	   */
	
	  Vue.prototype._compile = function (el) {
	    var options = this.$options;
	
	    // transclude and init element
	    // transclude can potentially replace original
	    // so we need to keep reference; this step also injects
	    // the template and caches the original attributes
	    // on the container node and replacer node.
	    var original = el;
	    el = transclude(el, options);
	    this._initElement(el);
	
	    // handle v-pre on root node (#2026)
	    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
	      return;
	    }
	
	    // root is always compiled per-instance, because
	    // container attrs and props can be different every time.
	    var contextOptions = this._context && this._context.$options;
	    var rootLinker = compileRoot(el, options, contextOptions);
	
	    // resolve slot distribution
	    resolveSlots(this, options._content);
	
	    // compile and link the rest
	    var contentLinkFn;
	    var ctor = this.constructor;
	    // component compilation can be cached
	    // as long as it's not using inline-template
	    if (options._linkerCachable) {
	      contentLinkFn = ctor.linker;
	      if (!contentLinkFn) {
	        contentLinkFn = ctor.linker = compile(el, options);
	      }
	    }
	
	    // link phase
	    // make sure to link root with prop scope!
	    var rootUnlinkFn = rootLinker(this, el, this._scope);
	    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);
	
	    // register composite unlink function
	    // to be called during instance destruction
	    this._unlinkFn = function () {
	      rootUnlinkFn();
	      // passing destroying: true to avoid searching and
	      // splicing the directives
	      contentUnlinkFn(true);
	    };
	
	    // finally replace original
	    if (options.replace) {
	      replace(original, el);
	    }
	
	    this._isCompiled = true;
	    this._callHook('compiled');
	  };
	
	  /**
	   * Initialize instance element. Called in the public
	   * $mount() method.
	   *
	   * @param {Element} el
	   */
	
	  Vue.prototype._initElement = function (el) {
	    if (isFragment(el)) {
	      this._isFragment = true;
	      this.$el = this._fragmentStart = el.firstChild;
	      this._fragmentEnd = el.lastChild;
	      // set persisted text anchors to empty
	      if (this._fragmentStart.nodeType === 3) {
	        this._fragmentStart.data = this._fragmentEnd.data = '';
	      }
	      this._fragment = el;
	    } else {
	      this.$el = el;
	    }
	    this.$el.__vue__ = this;
	    this._callHook('beforeCompile');
	  };
	
	  /**
	   * Create and bind a directive to an element.
	   *
	   * @param {Object} descriptor - parsed directive descriptor
	   * @param {Node} node   - target node
	   * @param {Vue} [host] - transclusion host component
	   * @param {Object} [scope] - v-for scope
	   * @param {Fragment} [frag] - owner fragment
	   */
	
	  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
	    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
	  };
	
	  /**
	   * Teardown an instance, unobserves the data, unbind all the
	   * directives, turn off all the event listeners, etc.
	   *
	   * @param {Boolean} remove - whether to remove the DOM node.
	   * @param {Boolean} deferCleanup - if true, defer cleanup to
	   *                                 be called later
	   */
	
	  Vue.prototype._destroy = function (remove, deferCleanup) {
	    if (this._isBeingDestroyed) {
	      if (!deferCleanup) {
	        this._cleanup();
	      }
	      return;
	    }
	
	    var destroyReady;
	    var pendingRemoval;
	
	    var self = this;
	    // Cleanup should be called either synchronously or asynchronoysly as
	    // callback of this.$remove(), or if remove and deferCleanup are false.
	    // In any case it should be called after all other removing, unbinding and
	    // turning of is done
	    var cleanupIfPossible = function cleanupIfPossible() {
	      if (destroyReady && !pendingRemoval && !deferCleanup) {
	        self._cleanup();
	      }
	    };
	
	    // remove DOM element
	    if (remove && this.$el) {
	      pendingRemoval = true;
	      this.$remove(function () {
	        pendingRemoval = false;
	        cleanupIfPossible();
	      });
	    }
	
	    this._callHook('beforeDestroy');
	    this._isBeingDestroyed = true;
	    var i;
	    // remove self from parent. only necessary
	    // if parent is not being destroyed as well.
	    var parent = this.$parent;
	    if (parent && !parent._isBeingDestroyed) {
	      parent.$children.$remove(this);
	      // unregister ref (remove: true)
	      this._updateRef(true);
	    }
	    // destroy all children.
	    i = this.$children.length;
	    while (i--) {
	      this.$children[i].$destroy();
	    }
	    // teardown props
	    if (this._propsUnlinkFn) {
	      this._propsUnlinkFn();
	    }
	    // teardown all directives. this also tearsdown all
	    // directive-owned watchers.
	    if (this._unlinkFn) {
	      this._unlinkFn();
	    }
	    i = this._watchers.length;
	    while (i--) {
	      this._watchers[i].teardown();
	    }
	    // remove reference to self on $el
	    if (this.$el) {
	      this.$el.__vue__ = null;
	    }
	
	    destroyReady = true;
	    cleanupIfPossible();
	  };
	
	  /**
	   * Clean up to ensure garbage collection.
	   * This is called after the leave transition if there
	   * is any.
	   */
	
	  Vue.prototype._cleanup = function () {
	    if (this._isDestroyed) {
	      return;
	    }
	    // remove self from owner fragment
	    // do it in cleanup so that we can call $destroy with
	    // defer right when a fragment is about to be removed.
	    if (this._frag) {
	      this._frag.children.$remove(this);
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (this._data && this._data.__ob__) {
	      this._data.__ob__.removeVm(this);
	    }
	    // Clean up references to private properties and other
	    // instances. preserve reference to _data so that proxy
	    // accessors still work. The only potential side effect
	    // here is that mutating the instance after it's destroyed
	    // may affect the state of other components that are still
	    // observing the same object, but that seems to be a
	    // reasonable responsibility for the user rather than
	    // always throwing an error on them.
	    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
	    // call the last hook...
	    this._isDestroyed = true;
	    this._callHook('destroyed');
	    // turn off all instance listeners.
	    this.$off();
	  };
	}
	
	function miscMixin (Vue) {
	  /**
	   * Apply a list of filter (descriptors) to a value.
	   * Using plain for loops here because this will be called in
	   * the getter of any watcher with filters so it is very
	   * performance sensitive.
	   *
	   * @param {*} value
	   * @param {*} [oldValue]
	   * @param {Array} filters
	   * @param {Boolean} write
	   * @return {*}
	   */
	
	  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
	    var filter, fn, args, arg, offset, i, l, j, k;
	    for (i = 0, l = filters.length; i < l; i++) {
	      filter = filters[write ? l - i - 1 : i];
	      fn = resolveAsset(this.$options, 'filters', filter.name, true);
	      if (!fn) continue;
	      fn = write ? fn.write : fn.read || fn;
	      if (typeof fn !== 'function') continue;
	      args = write ? [value, oldValue] : [value];
	      offset = write ? 2 : 1;
	      if (filter.args) {
	        for (j = 0, k = filter.args.length; j < k; j++) {
	          arg = filter.args[j];
	          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
	        }
	      }
	      value = fn.apply(this, args);
	    }
	    return value;
	  };
	
	  /**
	   * Resolve a component, depending on whether the component
	   * is defined normally or using an async factory function.
	   * Resolves synchronously if already resolved, otherwise
	   * resolves asynchronously and caches the resolved
	   * constructor on the factory.
	   *
	   * @param {String|Function} value
	   * @param {Function} cb
	   */
	
	  Vue.prototype._resolveComponent = function (value, cb) {
	    var factory;
	    if (typeof value === 'function') {
	      factory = value;
	    } else {
	      factory = resolveAsset(this.$options, 'components', value, true);
	    }
	    /* istanbul ignore if */
	    if (!factory) {
	      return;
	    }
	    // async component factory
	    if (!factory.options) {
	      if (factory.resolved) {
	        // cached
	        cb(factory.resolved);
	      } else if (factory.requested) {
	        // pool callbacks
	        factory.pendingCallbacks.push(cb);
	      } else {
	        factory.requested = true;
	        var cbs = factory.pendingCallbacks = [cb];
	        factory.call(this, function resolve(res) {
	          if (isPlainObject(res)) {
	            res = Vue.extend(res);
	          }
	          // cache resolved
	          factory.resolved = res;
	          // invoke callbacks
	          for (var i = 0, l = cbs.length; i < l; i++) {
	            cbs[i](res);
	          }
	        }, function reject(reason) {
	          ('production') !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
	        });
	      }
	    } else {
	      // normal component
	      cb(factory);
	    }
	  };
	}
	
	var filterRE$1 = /[^|]\|[^|]/;
	
	function dataAPI (Vue) {
	  /**
	   * Get the value from an expression on this vm.
	   *
	   * @param {String} exp
	   * @param {Boolean} [asStatement]
	   * @return {*}
	   */
	
	  Vue.prototype.$get = function (exp, asStatement) {
	    var res = parseExpression$1(exp);
	    if (res) {
	      if (asStatement) {
	        var self = this;
	        return function statementHandler() {
	          self.$arguments = toArray(arguments);
	          var result = res.get.call(self, self);
	          self.$arguments = null;
	          return result;
	        };
	      } else {
	        try {
	          return res.get.call(this, this);
	        } catch (e) {}
	      }
	    }
	  };
	
	  /**
	   * Set the value from an expression on this vm.
	   * The expression must be a valid left-hand
	   * expression in an assignment.
	   *
	   * @param {String} exp
	   * @param {*} val
	   */
	
	  Vue.prototype.$set = function (exp, val) {
	    var res = parseExpression$1(exp, true);
	    if (res && res.set) {
	      res.set.call(this, this, val);
	    }
	  };
	
	  /**
	   * Delete a property on the VM
	   *
	   * @param {String} key
	   */
	
	  Vue.prototype.$delete = function (key) {
	    del(this._data, key);
	  };
	
	  /**
	   * Watch an expression, trigger callback when its
	   * value changes.
	   *
	   * @param {String|Function} expOrFn
	   * @param {Function} cb
	   * @param {Object} [options]
	   *                 - {Boolean} deep
	   *                 - {Boolean} immediate
	   * @return {Function} - unwatchFn
	   */
	
	  Vue.prototype.$watch = function (expOrFn, cb, options) {
	    var vm = this;
	    var parsed;
	    if (typeof expOrFn === 'string') {
	      parsed = parseDirective(expOrFn);
	      expOrFn = parsed.expression;
	    }
	    var watcher = new Watcher(vm, expOrFn, cb, {
	      deep: options && options.deep,
	      sync: options && options.sync,
	      filters: parsed && parsed.filters,
	      user: !options || options.user !== false
	    });
	    if (options && options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn() {
	      watcher.teardown();
	    };
	  };
	
	  /**
	   * Evaluate a text directive, including filters.
	   *
	   * @param {String} text
	   * @param {Boolean} [asStatement]
	   * @return {String}
	   */
	
	  Vue.prototype.$eval = function (text, asStatement) {
	    // check for filters.
	    if (filterRE$1.test(text)) {
	      var dir = parseDirective(text);
	      // the filter regex check might give false positive
	      // for pipes inside strings, so it's possible that
	      // we don't get any filters here
	      var val = this.$get(dir.expression, asStatement);
	      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
	    } else {
	      // no filter
	      return this.$get(text, asStatement);
	    }
	  };
	
	  /**
	   * Interpolate a piece of template text.
	   *
	   * @param {String} text
	   * @return {String}
	   */
	
	  Vue.prototype.$interpolate = function (text) {
	    var tokens = parseText(text);
	    var vm = this;
	    if (tokens) {
	      if (tokens.length === 1) {
	        return vm.$eval(tokens[0].value) + '';
	      } else {
	        return tokens.map(function (token) {
	          return token.tag ? vm.$eval(token.value) : token.value;
	        }).join('');
	      }
	    } else {
	      return text;
	    }
	  };
	
	  /**
	   * Log instance data as a plain JS object
	   * so that it is easier to inspect in console.
	   * This method assumes console is available.
	   *
	   * @param {String} [path]
	   */
	
	  Vue.prototype.$log = function (path) {
	    var data = path ? getPath(this._data, path) : this._data;
	    if (data) {
	      data = clean(data);
	    }
	    // include computed fields
	    if (!path) {
	      var key;
	      for (key in this.$options.computed) {
	        data[key] = clean(this[key]);
	      }
	      if (this._props) {
	        for (key in this._props) {
	          data[key] = clean(this[key]);
	        }
	      }
	    }
	    console.log(data);
	  };
	
	  /**
	   * "clean" a getter/setter converted object into a plain
	   * object copy.
	   *
	   * @param {Object} - obj
	   * @return {Object}
	   */
	
	  function clean(obj) {
	    return JSON.parse(JSON.stringify(obj));
	  }
	}
	
	function domAPI (Vue) {
	  /**
	   * Convenience on-instance nextTick. The callback is
	   * auto-bound to the instance, and this avoids component
	   * modules having to rely on the global Vue.
	   *
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$nextTick = function (fn) {
	    nextTick(fn, this);
	  };
	
	  /**
	   * Append instance to target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$appendTo = function (target, cb, withTransition) {
	    return insert(this, target, cb, withTransition, append, appendWithTransition);
	  };
	
	  /**
	   * Prepend instance to target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$prependTo = function (target, cb, withTransition) {
	    target = query(target);
	    if (target.hasChildNodes()) {
	      this.$before(target.firstChild, cb, withTransition);
	    } else {
	      this.$appendTo(target, cb, withTransition);
	    }
	    return this;
	  };
	
	  /**
	   * Insert instance before target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$before = function (target, cb, withTransition) {
	    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
	  };
	
	  /**
	   * Insert instance after target
	   *
	   * @param {Node} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$after = function (target, cb, withTransition) {
	    target = query(target);
	    if (target.nextSibling) {
	      this.$before(target.nextSibling, cb, withTransition);
	    } else {
	      this.$appendTo(target.parentNode, cb, withTransition);
	    }
	    return this;
	  };
	
	  /**
	   * Remove instance from DOM
	   *
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition] - defaults to true
	   */
	
	  Vue.prototype.$remove = function (cb, withTransition) {
	    if (!this.$el.parentNode) {
	      return cb && cb();
	    }
	    var inDocument = this._isAttached && inDoc(this.$el);
	    // if we are not in document, no need to check
	    // for transitions
	    if (!inDocument) withTransition = false;
	    var self = this;
	    var realCb = function realCb() {
	      if (inDocument) self._callHook('detached');
	      if (cb) cb();
	    };
	    if (this._isFragment) {
	      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
	    } else {
	      var op = withTransition === false ? removeWithCb : removeWithTransition;
	      op(this.$el, this, realCb);
	    }
	    return this;
	  };
	
	  /**
	   * Shared DOM insertion function.
	   *
	   * @param {Vue} vm
	   * @param {Element} target
	   * @param {Function} [cb]
	   * @param {Boolean} [withTransition]
	   * @param {Function} op1 - op for non-transition insert
	   * @param {Function} op2 - op for transition insert
	   * @return vm
	   */
	
	  function insert(vm, target, cb, withTransition, op1, op2) {
	    target = query(target);
	    var targetIsDetached = !inDoc(target);
	    var op = withTransition === false || targetIsDetached ? op1 : op2;
	    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
	    if (vm._isFragment) {
	      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
	        op(node, target, vm);
	      });
	      cb && cb();
	    } else {
	      op(vm.$el, target, vm, cb);
	    }
	    if (shouldCallHook) {
	      vm._callHook('attached');
	    }
	    return vm;
	  }
	
	  /**
	   * Check for selectors
	   *
	   * @param {String|Element} el
	   */
	
	  function query(el) {
	    return typeof el === 'string' ? document.querySelector(el) : el;
	  }
	
	  /**
	   * Append operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Node} target
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function append(el, target, vm, cb) {
	    target.appendChild(el);
	    if (cb) cb();
	  }
	
	  /**
	   * InsertBefore operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Node} target
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function beforeWithCb(el, target, vm, cb) {
	    before(el, target);
	    if (cb) cb();
	  }
	
	  /**
	   * Remove operation that takes a callback.
	   *
	   * @param {Node} el
	   * @param {Vue} vm - unused
	   * @param {Function} [cb]
	   */
	
	  function removeWithCb(el, vm, cb) {
	    remove(el);
	    if (cb) cb();
	  }
	}
	
	function eventsAPI (Vue) {
	  /**
	   * Listen on the given `event` with `fn`.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$on = function (event, fn) {
	    (this._events[event] || (this._events[event] = [])).push(fn);
	    modifyListenerCount(this, event, 1);
	    return this;
	  };
	
	  /**
	   * Adds an `event` listener that will be invoked a single
	   * time then automatically removed.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$once = function (event, fn) {
	    var self = this;
	    function on() {
	      self.$off(event, on);
	      fn.apply(this, arguments);
	    }
	    on.fn = fn;
	    this.$on(event, on);
	    return this;
	  };
	
	  /**
	   * Remove the given callback for `event` or all
	   * registered callbacks.
	   *
	   * @param {String} event
	   * @param {Function} fn
	   */
	
	  Vue.prototype.$off = function (event, fn) {
	    var cbs;
	    // all
	    if (!arguments.length) {
	      if (this.$parent) {
	        for (event in this._events) {
	          cbs = this._events[event];
	          if (cbs) {
	            modifyListenerCount(this, event, -cbs.length);
	          }
	        }
	      }
	      this._events = {};
	      return this;
	    }
	    // specific event
	    cbs = this._events[event];
	    if (!cbs) {
	      return this;
	    }
	    if (arguments.length === 1) {
	      modifyListenerCount(this, event, -cbs.length);
	      this._events[event] = null;
	      return this;
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        modifyListenerCount(this, event, -1);
	        cbs.splice(i, 1);
	        break;
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Trigger an event on self.
	   *
	   * @param {String|Object} event
	   * @return {Boolean} shouldPropagate
	   */
	
	  Vue.prototype.$emit = function (event) {
	    var isSource = typeof event === 'string';
	    event = isSource ? event : event.name;
	    var cbs = this._events[event];
	    var shouldPropagate = isSource || !cbs;
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      // this is a somewhat hacky solution to the question raised
	      // in #2102: for an inline component listener like <comp @test="doThis">,
	      // the propagation handling is somewhat broken. Therefore we
	      // need to treat these inline callbacks differently.
	      var hasParentCbs = isSource && cbs.some(function (cb) {
	        return cb._fromParent;
	      });
	      if (hasParentCbs) {
	        shouldPropagate = false;
	      }
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        var cb = cbs[i];
	        var res = cb.apply(this, args);
	        if (res === true && (!hasParentCbs || cb._fromParent)) {
	          shouldPropagate = true;
	        }
	      }
	    }
	    return shouldPropagate;
	  };
	
	  /**
	   * Recursively broadcast an event to all children instances.
	   *
	   * @param {String|Object} event
	   * @param {...*} additional arguments
	   */
	
	  Vue.prototype.$broadcast = function (event) {
	    var isSource = typeof event === 'string';
	    event = isSource ? event : event.name;
	    // if no child has registered for this event,
	    // then there's no need to broadcast.
	    if (!this._eventsCount[event]) return;
	    var children = this.$children;
	    var args = toArray(arguments);
	    if (isSource) {
	      // use object event to indicate non-source emit
	      // on children
	      args[0] = { name: event, source: this };
	    }
	    for (var i = 0, l = children.length; i < l; i++) {
	      var child = children[i];
	      var shouldPropagate = child.$emit.apply(child, args);
	      if (shouldPropagate) {
	        child.$broadcast.apply(child, args);
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Recursively propagate an event up the parent chain.
	   *
	   * @param {String} event
	   * @param {...*} additional arguments
	   */
	
	  Vue.prototype.$dispatch = function (event) {
	    var shouldPropagate = this.$emit.apply(this, arguments);
	    if (!shouldPropagate) return;
	    var parent = this.$parent;
	    var args = toArray(arguments);
	    // use object event to indicate non-source emit
	    // on parents
	    args[0] = { name: event, source: this };
	    while (parent) {
	      shouldPropagate = parent.$emit.apply(parent, args);
	      parent = shouldPropagate ? parent.$parent : null;
	    }
	    return this;
	  };
	
	  /**
	   * Modify the listener counts on all parents.
	   * This bookkeeping allows $broadcast to return early when
	   * no child has listened to a certain event.
	   *
	   * @param {Vue} vm
	   * @param {String} event
	   * @param {Number} count
	   */
	
	  var hookRE = /^hook:/;
	  function modifyListenerCount(vm, event, count) {
	    var parent = vm.$parent;
	    // hooks do not get broadcasted so no need
	    // to do bookkeeping for them
	    if (!parent || !count || hookRE.test(event)) return;
	    while (parent) {
	      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
	      parent = parent.$parent;
	    }
	  }
	}
	
	function lifecycleAPI (Vue) {
	  /**
	   * Set instance target element and kick off the compilation
	   * process. The passed in `el` can be a selector string, an
	   * existing Element, or a DocumentFragment (for block
	   * instances).
	   *
	   * @param {Element|DocumentFragment|string} el
	   * @public
	   */
	
	  Vue.prototype.$mount = function (el) {
	    if (this._isCompiled) {
	      ('production') !== 'production' && warn('$mount() should be called only once.', this);
	      return;
	    }
	    el = query(el);
	    if (!el) {
	      el = document.createElement('div');
	    }
	    this._compile(el);
	    this._initDOMHooks();
	    if (inDoc(this.$el)) {
	      this._callHook('attached');
	      ready.call(this);
	    } else {
	      this.$once('hook:attached', ready);
	    }
	    return this;
	  };
	
	  /**
	   * Mark an instance as ready.
	   */
	
	  function ready() {
	    this._isAttached = true;
	    this._isReady = true;
	    this._callHook('ready');
	  }
	
	  /**
	   * Teardown the instance, simply delegate to the internal
	   * _destroy.
	   *
	   * @param {Boolean} remove
	   * @param {Boolean} deferCleanup
	   */
	
	  Vue.prototype.$destroy = function (remove, deferCleanup) {
	    this._destroy(remove, deferCleanup);
	  };
	
	  /**
	   * Partially compile a piece of DOM and return a
	   * decompile function.
	   *
	   * @param {Element|DocumentFragment} el
	   * @param {Vue} [host]
	   * @param {Object} [scope]
	   * @param {Fragment} [frag]
	   * @return {Function}
	   */
	
	  Vue.prototype.$compile = function (el, host, scope, frag) {
	    return compile(el, this.$options, true)(this, el, host, scope, frag);
	  };
	}
	
	/**
	 * The exposed Vue constructor.
	 *
	 * API conventions:
	 * - public API methods/properties are prefixed with `$`
	 * - internal methods/properties are prefixed with `_`
	 * - non-prefixed properties are assumed to be proxied user
	 *   data.
	 *
	 * @constructor
	 * @param {Object} [options]
	 * @public
	 */
	
	function Vue(options) {
	  this._init(options);
	}
	
	// install internals
	initMixin(Vue);
	stateMixin(Vue);
	eventsMixin(Vue);
	lifecycleMixin(Vue);
	miscMixin(Vue);
	
	// install instance APIs
	dataAPI(Vue);
	domAPI(Vue);
	eventsAPI(Vue);
	lifecycleAPI(Vue);
	
	var slot = {
	
	  priority: SLOT,
	  params: ['name'],
	
	  bind: function bind() {
	    // this was resolved during component transclusion
	    var name = this.params.name || 'default';
	    var content = this.vm._slotContents && this.vm._slotContents[name];
	    if (!content || !content.hasChildNodes()) {
	      this.fallback();
	    } else {
	      this.compile(content.cloneNode(true), this.vm._context, this.vm);
	    }
	  },
	
	  compile: function compile(content, context, host) {
	    if (content && context) {
	      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
	        // if the inserted slot has v-if
	        // inject fallback content as the v-else
	        var elseBlock = document.createElement('template');
	        elseBlock.setAttribute('v-else', '');
	        elseBlock.innerHTML = this.el.innerHTML;
	        // the else block should be compiled in child scope
	        elseBlock._context = this.vm;
	        content.appendChild(elseBlock);
	      }
	      var scope = host ? host._scope : this._scope;
	      this.unlink = context.$compile(content, host, scope, this._frag);
	    }
	    if (content) {
	      replace(this.el, content);
	    } else {
	      remove(this.el);
	    }
	  },
	
	  fallback: function fallback() {
	    this.compile(extractContent(this.el, true), this.vm);
	  },
	
	  unbind: function unbind() {
	    if (this.unlink) {
	      this.unlink();
	    }
	  }
	};
	
	var partial = {
	
	  priority: PARTIAL,
	
	  params: ['name'],
	
	  // watch changes to name for dynamic partials
	  paramWatchers: {
	    name: function name(value) {
	      vIf.remove.call(this);
	      if (value) {
	        this.insert(value);
	      }
	    }
	  },
	
	  bind: function bind() {
	    this.anchor = createAnchor('v-partial');
	    replace(this.el, this.anchor);
	    this.insert(this.params.name);
	  },
	
	  insert: function insert(id) {
	    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
	    if (partial) {
	      this.factory = new FragmentFactory(this.vm, partial);
	      vIf.insert.call(this);
	    }
	  },
	
	  unbind: function unbind() {
	    if (this.frag) {
	      this.frag.destroy();
	    }
	  }
	};
	
	var elementDirectives = {
	  slot: slot,
	  partial: partial
	};
	
	var convertArray = vFor._postProcess;
	
	/**
	 * Limit filter for arrays
	 *
	 * @param {Number} n
	 * @param {Number} offset (Decimal expected)
	 */
	
	function limitBy(arr, n, offset) {
	  offset = offset ? parseInt(offset, 10) : 0;
	  n = toNumber(n);
	  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
	}
	
	/**
	 * Filter filter for arrays
	 *
	 * @param {String} search
	 * @param {String} [delimiter]
	 * @param {String} ...dataKeys
	 */
	
	function filterBy(arr, search, delimiter) {
	  arr = convertArray(arr);
	  if (search == null) {
	    return arr;
	  }
	  if (typeof search === 'function') {
	    return arr.filter(search);
	  }
	  // cast to lowercase string
	  search = ('' + search).toLowerCase();
	  // allow optional `in` delimiter
	  // because why not
	  var n = delimiter === 'in' ? 3 : 2;
	  // extract and flatten keys
	  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
	  var res = [];
	  var item, key, val, j;
	  for (var i = 0, l = arr.length; i < l; i++) {
	    item = arr[i];
	    val = item && item.$value || item;
	    j = keys.length;
	    if (j) {
	      while (j--) {
	        key = keys[j];
	        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
	          res.push(item);
	          break;
	        }
	      }
	    } else if (contains(item, search)) {
	      res.push(item);
	    }
	  }
	  return res;
	}
	
	/**
	 * Order filter for arrays
	 *
	 * @param {String|Array<String>|Function} ...sortKeys
	 * @param {Number} [order]
	 */
	
	function orderBy(arr) {
	  var comparator = null;
	  var sortKeys = undefined;
	  arr = convertArray(arr);
	
	  // determine order (last argument)
	  var args = toArray(arguments, 1);
	  var order = args[args.length - 1];
	  if (typeof order === 'number') {
	    order = order < 0 ? -1 : 1;
	    args = args.length > 1 ? args.slice(0, -1) : args;
	  } else {
	    order = 1;
	  }
	
	  // determine sortKeys & comparator
	  var firstArg = args[0];
	  if (!firstArg) {
	    return arr;
	  } else if (typeof firstArg === 'function') {
	    // custom comparator
	    comparator = function (a, b) {
	      return firstArg(a, b) * order;
	    };
	  } else {
	    // string keys. flatten first
	    sortKeys = Array.prototype.concat.apply([], args);
	    comparator = function (a, b, i) {
	      i = i || 0;
	      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
	    };
	  }
	
	  function baseCompare(a, b, sortKeyIndex) {
	    var sortKey = sortKeys[sortKeyIndex];
	    if (sortKey) {
	      if (sortKey !== '$key') {
	        if (isObject(a) && '$value' in a) a = a.$value;
	        if (isObject(b) && '$value' in b) b = b.$value;
	      }
	      a = isObject(a) ? getPath(a, sortKey) : a;
	      b = isObject(b) ? getPath(b, sortKey) : b;
	    }
	    return a === b ? 0 : a > b ? order : -order;
	  }
	
	  // sort on a copy to avoid mutating original array
	  return arr.slice().sort(comparator);
	}
	
	/**
	 * String contain helper
	 *
	 * @param {*} val
	 * @param {String} search
	 */
	
	function contains(val, search) {
	  var i;
	  if (isPlainObject(val)) {
	    var keys = Object.keys(val);
	    i = keys.length;
	    while (i--) {
	      if (contains(val[keys[i]], search)) {
	        return true;
	      }
	    }
	  } else if (isArray(val)) {
	    i = val.length;
	    while (i--) {
	      if (contains(val[i], search)) {
	        return true;
	      }
	    }
	  } else if (val != null) {
	    return val.toString().toLowerCase().indexOf(search) > -1;
	  }
	}
	
	var digitsRE = /(\d{3})(?=\d)/g;
	
	// asset collections must be a plain object.
	var filters = {
	
	  orderBy: orderBy,
	  filterBy: filterBy,
	  limitBy: limitBy,
	
	  /**
	   * Stringify value.
	   *
	   * @param {Number} indent
	   */
	
	  json: {
	    read: function read(value, indent) {
	      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
	    },
	    write: function write(value) {
	      try {
	        return JSON.parse(value);
	      } catch (e) {
	        return value;
	      }
	    }
	  },
	
	  /**
	   * 'abc' => 'Abc'
	   */
	
	  capitalize: function capitalize(value) {
	    if (!value && value !== 0) return '';
	    value = value.toString();
	    return value.charAt(0).toUpperCase() + value.slice(1);
	  },
	
	  /**
	   * 'abc' => 'ABC'
	   */
	
	  uppercase: function uppercase(value) {
	    return value || value === 0 ? value.toString().toUpperCase() : '';
	  },
	
	  /**
	   * 'AbC' => 'abc'
	   */
	
	  lowercase: function lowercase(value) {
	    return value || value === 0 ? value.toString().toLowerCase() : '';
	  },
	
	  /**
	   * 12345 => $12,345.00
	   *
	   * @param {String} sign
	   * @param {Number} decimals Decimal places
	   */
	
	  currency: function currency(value, _currency, decimals) {
	    value = parseFloat(value);
	    if (!isFinite(value) || !value && value !== 0) return '';
	    _currency = _currency != null ? _currency : '$';
	    decimals = decimals != null ? decimals : 2;
	    var stringified = Math.abs(value).toFixed(decimals);
	    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
	    var i = _int.length % 3;
	    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
	    var _float = decimals ? stringified.slice(-1 - decimals) : '';
	    var sign = value < 0 ? '-' : '';
	    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
	  },
	
	  /**
	   * 'item' => 'items'
	   *
	   * @params
	   *  an array of strings corresponding to
	   *  the single, double, triple ... forms of the word to
	   *  be pluralized. When the number to be pluralized
	   *  exceeds the length of the args, it will use the last
	   *  entry in the array.
	   *
	   *  e.g. ['single', 'double', 'triple', 'multiple']
	   */
	
	  pluralize: function pluralize(value) {
	    var args = toArray(arguments, 1);
	    var length = args.length;
	    if (length > 1) {
	      var index = value % 10 - 1;
	      return index in args ? args[index] : args[length - 1];
	    } else {
	      return args[0] + (value === 1 ? '' : 's');
	    }
	  },
	
	  /**
	   * Debounce a handler function.
	   *
	   * @param {Function} handler
	   * @param {Number} delay = 300
	   * @return {Function}
	   */
	
	  debounce: function debounce(handler, delay) {
	    if (!handler) return;
	    if (!delay) {
	      delay = 300;
	    }
	    return _debounce(handler, delay);
	  }
	};
	
	function installGlobalAPI (Vue) {
	  /**
	   * Vue and every constructor that extends Vue has an
	   * associated options object, which can be accessed during
	   * compilation steps as `this.constructor.options`.
	   *
	   * These can be seen as the default options of every
	   * Vue instance.
	   */
	
	  Vue.options = {
	    directives: directives,
	    elementDirectives: elementDirectives,
	    filters: filters,
	    transitions: {},
	    components: {},
	    partials: {},
	    replace: true
	  };
	
	  /**
	   * Expose useful internals
	   */
	
	  Vue.util = util;
	  Vue.config = config;
	  Vue.set = set;
	  Vue['delete'] = del;
	  Vue.nextTick = nextTick;
	
	  /**
	   * The following are exposed for advanced usage / plugins
	   */
	
	  Vue.compiler = compiler;
	  Vue.FragmentFactory = FragmentFactory;
	  Vue.internalDirectives = internalDirectives;
	  Vue.parsers = {
	    path: path,
	    text: text,
	    template: template,
	    directive: directive,
	    expression: expression
	  };
	
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   *
	   * @param {Object} extendOptions
	   */
	
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var isFirstExtend = Super.cid === 0;
	    if (isFirstExtend && extendOptions._Ctor) {
	      return extendOptions._Ctor;
	    }
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
	        name = null;
	      }
	    }
	    var Sub = createClass(name || 'VueComponent');
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(Super.options, extendOptions);
	    Sub['super'] = Super;
	    // allow further extension
	    Sub.extend = Super.extend;
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    config._assetTypes.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	    // cache constructor
	    if (isFirstExtend) {
	      extendOptions._Ctor = Sub;
	    }
	    return Sub;
	  };
	
	  /**
	   * A function that returns a sub-class constructor with the
	   * given name. This gives us much nicer output when
	   * logging instances in the console.
	   *
	   * @param {String} name
	   * @return {Function}
	   */
	
	  function createClass(name) {
	    /* eslint-disable no-new-func */
	    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
	    /* eslint-enable no-new-func */
	  }
	
	  /**
	   * Plugin system
	   *
	   * @param {Object} plugin
	   */
	
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return;
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this;
	  };
	
	  /**
	   * Apply a global mixin by merging it into the default
	   * options.
	   */
	
	  Vue.mixin = function (mixin) {
	    Vue.options = mergeOptions(Vue.options, mixin);
	  };
	
	  /**
	   * Create asset registration methods with the following
	   * signature:
	   *
	   * @param {String} id
	   * @param {*} definition
	   */
	
	  config._assetTypes.forEach(function (type) {
	    Vue[type] = function (id, definition) {
	      if (!definition) {
	        return this.options[type + 's'][id];
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
	            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          if (!definition.name) {
	            definition.name = id;
	          }
	          definition = Vue.extend(definition);
	        }
	        this.options[type + 's'][id] = definition;
	        return definition;
	      }
	    };
	  });
	
	  // expose internal transition API
	  extend(Vue.transition, transition);
	}
	
	installGlobalAPI(Vue);
	
	Vue.version = '1.0.28';
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue);
	    } else if (false) {
	      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
	    }
	  }
	}, 0);
	
	module.exports = Vue;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bus = __webpack_require__(7);
	
	var Vue = __webpack_require__(15);
	// 配置vue 生产环境配置为true
	Vue.config.debug = false;
	
	//加载异步请求插件
	var vueResource = __webpack_require__(43);
	Vue.use(vueResource);
	// 配置请求根域名
	
	
	Vue.http.options.root = window.location.origin;
	// 伪装为formData数据类型
	Vue.http.options.emulateJSON = true;
	
	Vue.http.options.credentials = true;
	Vue.http.options.xhr = { withCredentials: true };
	
	if (false) Vue.http.options.root = 'https://dev.web.joyincar.cn';else Vue.http.options.root = window.location.origin;
	
	//增加token，由于token是放在参数中的，所以需要参数合并
	//由于get方式params本身里又有params参数包装
	// Vue.http.get=(url,params)=>{
	// 	if(params&&params.params) params=Object.assign(params.params,{token:'1',source:'2'})
	// 	else params=Object.assign({params:{token:'1',source:'2'}})
	// 	return Vue.http.get(url,params)
	// }
	
	
	var md5 = __webpack_require__(25);
	var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
	var guid = function guid() {
		var chars = CHARS,
		    uuid = new Array(36),
		    rnd = 0,
		    r;
		for (var i = 0; i < 36; i++) {
			if (i == 8 || i == 13 || i == 18 || i == 23) {
				uuid[i] = '-';
			} else if (i == 14) {
				uuid[i] = '4';
			} else {
				if (rnd <= 0x02) rnd = 0x2000000 + Math.random() * 0x1000000 | 0;
				r = rnd & 0xf;
				rnd = rnd >> 4;
				uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
			}
		}
		return uuid.join('');
	};
	
	var key = 'E727FF9FE8286779EAD4138A5994B861';
	var createHeader = function createHeader() {
		//鉴权签名算法
		//SeqNo：唯一请求序列号，客户端识别码(0W代表web端，0I代表ios端，0A代表Android端)+UUID
		var TimeStamp = parseInt(new Date().getTime() / 1000),
		    SeqNo = '0W' + guid(),
		    SignTemp = void 0,
		    Sign = void 0;
		SignTemp = 'SeqNo=' + SeqNo + '&TimeStamp=' + TimeStamp + '&Key=' + key;
		Sign = md5(SignTemp).toUpperCase();
	
		return {
			TimeStamp: TimeStamp,
			SeqNo: SeqNo,
			Sign: Sign
		};
	};
	
	// 配置请求凭证,header中
	
	
	// 局部配置模板
	// new Vue({
	
	//   http: {
	//     root: '/root',
	//     headers: {
	//       Authorization: 'Basic YXBpOnBhc3N3b3Jk'
	//     }
	//   }
	
	// })
	
	
	// 注册异步loading全局组件
	Vue.component('async-load-tip', __webpack_require__(45));
	Vue.component('async-load-tip-rem', __webpack_require__(46));
	
	// 请求拦截器
	Vue.http.interceptors.push(function (request, next) {
		//只能在当前域名下添加headers，第三方域名会不支持
	
		if (request && request.root && request.url && request.url.indexOf('http') == -1 && request.url.indexOf('https') == -1) {
	
			var car_rental_userinfo = { token: '', source: 'WxPublic', user_id: '' };
			if (localStorage.getItem('car_rental_web_token')) {
				car_rental_userinfo = JSON.parse(localStorage.getItem('car_rental_web_token'));
				car_rental_userinfo.source = 'WxPublic';
			}
	
			var deta = createHeader();
	
			request.credentials = true;
	
			//url拼接，前缀root
			/*vueResource只设置root没用，只能拦截器处理*/
			request.url = request.root + "/" + request.url;
	
			request.headers.set('Token', car_rental_userinfo.token);
			request.headers.set('Source', car_rental_userinfo.source);
			request.headers.set('UserId', car_rental_userinfo.user_id + '');
			request.headers.set('AppVersion', '');
			request.headers.set('MobileModel', '');
			//加入鉴权机制
			request.headers.set('TimeStamp', deta.TimeStamp + '');
			request.headers.set('SeqNo', deta.SeqNo);
			request.headers.set('Sign', deta.Sign + '');
		}
		// 发布异步开始加载事件
		bus.$emit('begin-async');
	
		next(function (response) {
	
			var temp = /order_red_packet/.test(window.location.href);
			// 如果temp为true则不执行token失效自动跳转登陆的逻辑
	
			if (response && response.body && response.body.result && response.body.result == 20009 && !temp) {
				//清除Storage  token信息和userid信息
				localStorage.removeItem('car-rent-userinfo');
				localStorage.removeItem('rent-car-userinfo');
				localStorage.removeItem('car_rental_web_token');
				window.location.href = 'login.html' + '?back=true';
			}
			// return response
			// 发布结束异步加载事件
			bus.$emit('over-async');
		});
	});
	
	// 注册日期顾虑器
	// Vue.filter('', function (value) {
	//   return value.split('').reverse().join('')
	// });
	
	Vue.filter('toLocaleDate', function (value) {
	
		var ms = +value * 1000;
		var date = new Date(ms);
	
		var year = date.getFullYear();
		var mouth = date.getMonth() + 1;
		if (mouth < 10) {
			mouth = '0' + mouth;
		};
	
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		};
		var hours = date.getHours();
		if (hours < 10) {
			hours = '0' + hours;
		};
		var minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes;
		};
	
		return year + '-' + mouth + '-' + day + '  ' + hours + ':' + minutes;
	});
	
	Vue.filter('toLocaleDate2', function (value) {
	
		var ms = +value * 1000;
		var date = new Date(ms);
	
		var year = date.getFullYear();
		var mouth = date.getMonth() + 1;
		if (mouth < 10) {
			mouth = '0' + mouth;
		};
	
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		};
		var hours = date.getHours();
		if (hours < 10) {
			hours = '0' + hours;
		};
		var minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes;
		};
	
		return year + '/' + mouth + '/' + day;
	});
	Vue.filter('toLocaleDate3', function (value) {
	
		var ms = +value * 1000;
		var date = new Date(ms);
	
		var year = date.getFullYear();
		var mouth = date.getMonth() + 1;
		if (mouth < 10) {
			mouth = '0' + mouth;
		};
	
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		};
		var hours = date.getHours();
		if (hours < 10) {
			hours = '0' + hours;
		};
		var minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes;
		};
	
		return year + '.' + mouth + '.' + day;
	});
	
	Vue.filter('toLocaleDate4', function (value) {
	
		var ms = +value * 1000;
		var date = new Date(ms);
	
		var year = date.getFullYear();
		var mouth = date.getMonth() + 1;
		if (mouth < 10) {
			mouth = '0' + mouth;
		};
	
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		};
		var hours = date.getHours();
		if (hours < 10) {
			hours = '0' + hours;
		};
		var minutes = date.getMinutes();
		if (minutes < 10) {
			minutes = '0' + minutes;
		};
	
		var secconds = date.getSeconds();
		if (secconds < 10) {
			secconds = '0' + secconds;
		};
	
		return year + '-' + mouth + '-' + day + '  ' + hours + ':' + minutes + ':' + secconds;
	});
	
	// 转换时间过滤器
	Vue.filter('formatSeconds', function (value) {
		var s, min, h;
		if (value < 60) {
			return value + '秒';
		}
		if (60 <= value && value < 3600) {
			min = parseInt(value / 60);
			s = value % 60;
			return min + '分' + s + '秒';
		};
	
		if (value >= 3600) {
			h = parseInt(value / 3600);
			min = parseInt(value % 3600 / 60);
			s = value % 3600 % 60;
	
			return h + '时' + min + '分' + s + '秒';
		}
	});
	
	// 转换时间过滤器
	Vue.filter('formatSeconds_copy', function (value) {
		var s, min, h;
		if (value < 60) {
			return value + '秒';
		}
		if (60 <= value && value < 3600) {
			min = parseInt(value / 60);
			s = value % 60;
			return min + '分' + s + '秒';
		};
	
		if (value >= 3600) {
			h = parseInt(value / 3600);
			min = parseInt(value % 3600 / 60);
			s = value % 3600 % 60;
	
			return h + '时' + min + '分' + s + '秒';
		}
	});
	
	// 距离转化器  大于1000米 取整已千米为单位  小于一千米 用米为单位
	Vue.filter('distanceTurn', function (value) {
		if (value < 1000) {
			return parseInt(+value) + 'm';
		} else {
			return (value / 1000).toFixed(2) + 'km';
		}
	});
	
	// 加载Vuetouch插件
	var VueTouch = __webpack_require__(44);
	// change the threshold for all swipe recognizers
	VueTouch.config.swipe = {
		threshold: 200
	};
	Vue.use(VueTouch);
	
	// 注册静态步行导航寻车方法
	Vue.prototype.$navLookWalk = function (formLng, formLat, toLng, toLat) {
		var url = '' + 'http://uri.amap.com/navigation?' + 'from=' + formLng + ',' + formLat + ',' + 'startpoint' + '&' + 'to=' + toLng + ',' + toLat + ',' + 'endpoint' + '&' + 'mode=walk' + '&' + 'coordinate=gaode&callnative=0';
	
		location.href = url;
	};
	
	// 注册静态驾驶寻车方法
	Vue.prototype.$navLookCar = function (formLng, formLat, toLng, toLat) {
		var url = '' + 'http://uri.amap.com/navigation?' + 'from=' + formLng + ',' + formLat + ',' + 'startpoint' + '&' + 'to=' + toLng + ',' + toLat + ',' + 'endpoint' + '&' + 'mode=car' + '&' + 'coordinate=gaode';
	
		location.href = url;
	};
	
	Vue.prototype.$getUrlParams = function () {
		var search = decodeURI(location.search).slice(1);
		var params = search.split('&');
		var res = {};
	
		for (var i = 0, p; p = params[i++];) {
			var temp = p.split('=');
			res[temp[0]] = temp[1];
		}
	
		return res;
	};
	
	//gps类型坐标 计算连个坐标点距离
	Vue.prototype.$getDisance = function (lat1, lng1, lat2, lng2) {
		function toRad(d) {
			return d * Math.PI / 180;
		}
		var dis = 0;
		var radLat1 = toRad(lat1);
		var radLat2 = toRad(lat2);
		var deltaLat = radLat1 - radLat2;
		var deltaLng = toRad(lng1) - toRad(lng2);
		var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
		return dis * 6378137;
	};
	
	//添加顶部警告
	Vue.prototype.$appendTopWarn = function (text, dom) {
		var warnDom = document.createElement('div');
		warnDom.setAttribute('class', 'top-warn');
		warnDom.innerHTML = text;
	
		var firstChild = dom.firstChild.nodeType === 3 ? dom.childNodes[1] : dom.firstChild;
	
		dom.insertBefore(warnDom, firstChild);
	};
	module.exports = Vue;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	(function(){
	  var crypt = __webpack_require__(28),
	      utf8 = __webpack_require__(12).utf8,
	      isBuffer = __webpack_require__(29),
	      bin = __webpack_require__(12).bin,
	
	  // The core
	  md5 = function (message, options) {
	    // Convert to byte array
	    if (message.constructor == String)
	      if (options && options.encoding === 'binary')
	        message = bin.stringToBytes(message);
	      else
	        message = utf8.stringToBytes(message);
	    else if (isBuffer(message))
	      message = Array.prototype.slice.call(message, 0);
	    else if (!Array.isArray(message))
	      message = message.toString();
	    // else, assume byte array already
	
	    var m = crypt.bytesToWords(message),
	        l = message.length * 8,
	        a =  1732584193,
	        b = -271733879,
	        c = -1732584194,
	        d =  271733878;
	
	    // Swap endian
	    for (var i = 0; i < m.length; i++) {
	      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
	             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
	    }
	
	    // Padding
	    m[l >>> 5] |= 0x80 << (l % 32);
	    m[(((l + 64) >>> 9) << 4) + 14] = l;
	
	    // Method shortcuts
	    var FF = md5._ff,
	        GG = md5._gg,
	        HH = md5._hh,
	        II = md5._ii;
	
	    for (var i = 0; i < m.length; i += 16) {
	
	      var aa = a,
	          bb = b,
	          cc = c,
	          dd = d;
	
	      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
	      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
	      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
	      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
	      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
	      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
	      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
	      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
	      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
	      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
	      c = FF(c, d, a, b, m[i+10], 17, -42063);
	      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
	      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
	      d = FF(d, a, b, c, m[i+13], 12, -40341101);
	      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
	      b = FF(b, c, d, a, m[i+15], 22,  1236535329);
	
	      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
	      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
	      c = GG(c, d, a, b, m[i+11], 14,  643717713);
	      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
	      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
	      d = GG(d, a, b, c, m[i+10],  9,  38016083);
	      c = GG(c, d, a, b, m[i+15], 14, -660478335);
	      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
	      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
	      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
	      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
	      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
	      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
	      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
	      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
	      b = GG(b, c, d, a, m[i+12], 20, -1926607734);
	
	      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
	      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
	      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
	      b = HH(b, c, d, a, m[i+14], 23, -35309556);
	      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
	      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
	      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
	      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
	      a = HH(a, b, c, d, m[i+13],  4,  681279174);
	      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
	      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
	      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
	      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
	      d = HH(d, a, b, c, m[i+12], 11, -421815835);
	      c = HH(c, d, a, b, m[i+15], 16,  530742520);
	      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);
	
	      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
	      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
	      c = II(c, d, a, b, m[i+14], 15, -1416354905);
	      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
	      a = II(a, b, c, d, m[i+12],  6,  1700485571);
	      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
	      c = II(c, d, a, b, m[i+10], 15, -1051523);
	      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
	      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
	      d = II(d, a, b, c, m[i+15], 10, -30611744);
	      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
	      b = II(b, c, d, a, m[i+13], 21,  1309151649);
	      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
	      d = II(d, a, b, c, m[i+11], 10, -1120210379);
	      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
	      b = II(b, c, d, a, m[i+ 9], 21, -343485551);
	
	      a = (a + aa) >>> 0;
	      b = (b + bb) >>> 0;
	      c = (c + cc) >>> 0;
	      d = (d + dd) >>> 0;
	    }
	
	    return crypt.endian([a, b, c, d]);
	  };
	
	  // Auxiliary functions
	  md5._ff  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._gg  = function (a, b, c, d, x, s, t) {
	    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._hh  = function (a, b, c, d, x, s, t) {
	    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	  md5._ii  = function (a, b, c, d, x, s, t) {
	    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	    return ((n << s) | (n >>> (32 - s))) + b;
	  };
	
	  // Package private blocksize
	  md5._blocksize = 16;
	  md5._digestsize = 16;
	
	  module.exports = function (message, options) {
	    if (message === undefined || message === null)
	      throw new Error('Illegal argument ' + message);
	
	    var digestbytes = crypt.wordsToBytes(md5(message, options));
	    return options && options.asBytes ? digestbytes :
	        options && options.asString ? bin.bytesToString(digestbytes) :
	        crypt.bytesToHex(digestbytes);
	  };
	
	})();


/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	(function() {
	  var base64map
	      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	
	  crypt = {
	    // Bit-wise rotation left
	    rotl: function(n, b) {
	      return (n << b) | (n >>> (32 - b));
	    },
	
	    // Bit-wise rotation right
	    rotr: function(n, b) {
	      return (n << (32 - b)) | (n >>> b);
	    },
	
	    // Swap big-endian to little-endian and vice versa
	    endian: function(n) {
	      // If number given, swap endian
	      if (n.constructor == Number) {
	        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	      }
	
	      // Else, assume array and swap all items
	      for (var i = 0; i < n.length; i++)
	        n[i] = crypt.endian(n[i]);
	      return n;
	    },
	
	    // Generate an array of any length of random bytes
	    randomBytes: function(n) {
	      for (var bytes = []; n > 0; n--)
	        bytes.push(Math.floor(Math.random() * 256));
	      return bytes;
	    },
	
	    // Convert a byte array to big-endian 32-bit words
	    bytesToWords: function(bytes) {
	      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
	        words[b >>> 5] |= bytes[i] << (24 - b % 32);
	      return words;
	    },
	
	    // Convert big-endian 32-bit words to a byte array
	    wordsToBytes: function(words) {
	      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
	        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	      return bytes;
	    },
	
	    // Convert a byte array to a hex string
	    bytesToHex: function(bytes) {
	      for (var hex = [], i = 0; i < bytes.length; i++) {
	        hex.push((bytes[i] >>> 4).toString(16));
	        hex.push((bytes[i] & 0xF).toString(16));
	      }
	      return hex.join('');
	    },
	
	    // Convert a hex string to a byte array
	    hexToBytes: function(hex) {
	      for (var bytes = [], c = 0; c < hex.length; c += 2)
	        bytes.push(parseInt(hex.substr(c, 2), 16));
	      return bytes;
	    },
	
	    // Convert a byte array to a base-64 string
	    bytesToBase64: function(bytes) {
	      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
	        for (var j = 0; j < 4; j++)
	          if (i * 8 + j * 6 <= bytes.length * 8)
	            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
	          else
	            base64.push('=');
	      }
	      return base64.join('');
	    },
	
	    // Convert a base-64 string to a byte array
	    base64ToBytes: function(base64) {
	      // Remove non-base-64 characters
	      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
	          imod4 = ++i % 4) {
	        if (imod4 == 0) continue;
	        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
	            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
	            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
	      }
	      return bytes;
	    }
	  };
	
	  module.exports = crypt;
	})();


/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <script>
	var bus = __webpack_require__(7);
	module.exports = {
	    ready: function ready() {
	        var _this = this;
	
	        // 监听 异步加载开始事件 展示loading
	        bus.$on('begin-async', function () {
	            _this.show = true;
	        });
	
	        // 监听 异步结束事件 隐藏loading
	        bus.$on('over-async', function () {
	            _this.show = false;
	        });
	    },
	
	    data: function data() {
	        return {
	            show: false
	        };
	    }
	    // </script>
	    //
	    //
	    //
	    // <template>
	    //     <div class="async-load" v-if="show">
	    //         <div class="back-block">
	    //             <div class="roting"></div>
	    //         </div>
	    //     </div>
	    // </template>
	    //
	    //
	    // <style lang="sass"  scoped>
	    //     .async-load {
	    //         position: absolute;
	    //         overflow: hidden;
	    //         z-index: 100000;
	    //         left: 0;
	    //         right: 0;
	    //         top: 0;
	    //         bottom: 0;
	    //         background: rgba(0,0,0,0.40);
	    //
	    //         .back-block {
	    //             position: absolute;
	    //             left: 50%;
	    //             top: 50%;
	    //
	    //             width: 220px;
	    //             height: 204px;
	    //             margin-left: -110px;
	    //             margin-top: -102px;
	    //
	    //             background: rgba(0,0,0,0.80);
	    //             border-radius: 2px;
	    //             .roting {
	    //                 position: absolute;
	    //                 left: 50%;
	    //                 top: 50%;
	    //
	    //                 width: 40px;
	    //                 height: 40px;
	    //                 margin-left: -20px;
	    //                 margin-top: -20px;
	    //
	    //                 background: url(./img/rotate.png) no-repeat center;
	    //
	    //                 animation: rotate 0.8s infinite linear;
	    //
	    //             }
	    //         }
	    //     }
	    //
	    //     @keyframes rotate {
	    //         0% { transform: rotate(0)}
	    //
	    //         100% {transform: rotate(-360deg)}
	    //     }
	    //
	    // </style>
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <script>
	var bus = __webpack_require__(7);
	module.exports = {
	    ready: function ready() {
	        var _this = this;
	
	        // 监听 异步加载开始事件 展示loading
	        bus.$on('begin-async', function () {
	            _this.show = true;
	        });
	
	        // 监听 异步结束事件 隐藏loading
	        bus.$on('over-async', function () {
	            _this.show = false;
	        });
	    },
	
	    data: function data() {
	        return {
	            show: false
	        };
	    }
	    // </script>
	    //
	    //
	    //
	    // <template>
	    //     <div class="async-load" v-if="show">
	    //         <div class="back-block">
	    //             <div class="roting"></div>
	    //         </div>
	    //     </div>
	    // </template>
	    //
	    //
	    // <style lang="sass"  scoped>
	    //     /*导入全局样式函数*/
	    //     @import '../../common/css/function.scss';
	    //     .async-load {
	    //         position: absolute;
	    //         overflow: hidden;
	    //         z-index: 100000;
	    //         left: 0;
	    //         right: 0;
	    //         top: 0;
	    //         bottom: 0;
	    //         background: rgba(0,0,0,0.40);
	    //
	    //         .back-block {
	    //             position: absolute;
	    //             left: 50%;
	    //             top: 50%;
	    //
	    //             width: rem(220);
	    //             height: rem(204);
	    //             margin-left: rem(-110);
	    //             margin-top: rem(-102);
	    //
	    //             background: rgba(0,0,0,0.80);
	    //             border-radius: 2px;
	    //             .roting {
	    //                 position: absolute;
	    //                 left: 50%;
	    //                 top: 50%;
	    //
	    //                 width: rem(40);
	    //                 height: rem(40);
	    //                 margin-left: rem(-20);
	    //                 margin-top: rem(-20);
	    //
	    //                 background: url(./img/rotate.png) no-repeat center;
	    //                 background-size: cover;
	    //                 animation: rotate 0.8s infinite linear;
	    //
	    //             }
	    //         }
	    //     }
	    //
	    //     @keyframes rotate {
	    //         0% { transform: rotate(0)}
	    //
	    //         100% {transform: rotate(-360deg)}
	    //     }
	    //
	    // </style>
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".async-load[_v-49806384]{position:absolute;overflow:hidden;z-index:100000;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,.4)}.async-load .back-block[_v-49806384]{position:absolute;left:50%;top:50%;width:220px;height:204px;margin-left:-110px;margin-top:-102px;background:rgba(0,0,0,.8);border-radius:2px}.async-load .back-block .roting[_v-49806384]{position:absolute;left:50%;top:50%;width:40px;height:40px;margin-left:-20px;margin-top:-20px;background:url(" + __webpack_require__(14) + ") no-repeat center;animation:rotate .8s infinite linear}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(-360deg)}}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-49806384&file=async_loading.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/async_loading/async_loading.vue.style"],"names":[],"mappings":"AAAA,yBAAY,kBAAkB,gBAAgB,eAAe,OAAO,QAAQ,MAAM,SAAS,yBAA0B,CAAC,qCAAwB,kBAAkB,SAAS,QAAQ,YAAY,aAAa,mBAAmB,kBAAkB,0BAA2B,iBAAiB,CAAC,6CAAgC,kBAAkB,SAAS,QAAQ,WAAW,YAAY,kBAAkB,iBAAiB,0DAAkD,oCAAqC,CAAC,kBAAkB,GAAG,mBAAmB,CAAC,GAAK,yBAAyB,CAAC,CAAC","file":"async_loading.vue","sourcesContent":[".async-load{position:absolute;overflow:hidden;z-index:100000;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,0.4)}.async-load .back-block{position:absolute;left:50%;top:50%;width:220px;height:204px;margin-left:-110px;margin-top:-102px;background:rgba(0,0,0,0.8);border-radius:2px}.async-load .back-block .roting{position:absolute;left:50%;top:50%;width:40px;height:40px;margin-left:-20px;margin-top:-20px;background:url(./img/rotate.png) no-repeat center;animation:rotate 0.8s infinite linear}@keyframes rotate{0%{transform:rotate(0)}100%{transform:rotate(-360deg)}}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".async-load[_v-71cd0d99]{position:absolute;overflow:hidden;z-index:100000;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,.4)}.async-load .back-block[_v-71cd0d99]{position:absolute;left:50%;top:50%;width:2.93333rem;height:2.72rem;margin-left:-1.46667rem;margin-top:-1.36rem;background:rgba(0,0,0,.8);border-radius:2px}.async-load .back-block .roting[_v-71cd0d99]{position:absolute;left:50%;top:50%;width:.53333rem;height:.53333rem;margin-left:-.26667rem;margin-top:-.26667rem;background:url(" + __webpack_require__(14) + ") no-repeat center;background-size:cover;animation:rotate .8s infinite linear}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(-360deg)}}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-71cd0d99&file=async_loading_rem.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/async_loading/async_loading_rem.vue.style"],"names":[],"mappings":"AAAA,yBAAY,kBAAkB,gBAAgB,eAAe,OAAO,QAAQ,MAAM,SAAS,yBAA0B,CAAC,qCAAwB,kBAAkB,SAAS,QAAQ,iBAAiB,eAAe,wBAAwB,oBAAoB,0BAA2B,iBAAiB,CAAC,6CAAgC,kBAAkB,SAAS,QAAQ,gBAAgB,iBAAiB,uBAAuB,sBAAsB,0DAAkD,sBAAsB,oCAAqC,CAAC,kBAAkB,GAAG,mBAAmB,CAAC,GAAK,yBAAyB,CAAC,CAAC","file":"async_loading_rem.vue","sourcesContent":[".async-load{position:absolute;overflow:hidden;z-index:100000;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,0.4)}.async-load .back-block{position:absolute;left:50%;top:50%;width:2.93333rem;height:2.72rem;margin-left:-1.46667rem;margin-top:-1.36rem;background:rgba(0,0,0,0.8);border-radius:2px}.async-load .back-block .roting{position:absolute;left:50%;top:50%;width:.53333rem;height:.53333rem;margin-left:-.26667rem;margin-top:-.26667rem;background:url(./img/rotate.png) no-repeat center;background-size:cover;animation:rotate 0.8s infinite linear}@keyframes rotate{0%{transform:rotate(0)}100%{transform:rotate(-360deg)}}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(36);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-49806384&file=async_loading.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./async_loading.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-49806384&file=async_loading.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./async_loading.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(37);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-71cd0d99&file=async_loading_rem.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./async_loading_rem.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-71cd0d99&file=async_loading_rem.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./async_loading_rem.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	module.exports = " <div class=async-load v-if=show _v-49806384=\"\"> <div class=back-block _v-49806384=\"\"> <div class=roting _v-49806384=\"\"></div> </div> </div> ";

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	module.exports = " <div class=async-load v-if=show _v-71cd0d99=\"\"> <div class=back-block _v-71cd0d99=\"\"> <div class=roting _v-71cd0d99=\"\"></div> </div> </div> ";

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-resource v1.5.3
	 * https://github.com/pagekit/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	function Promise$1(executor) {
	  this.state = PENDING;
	  this.value = undefined;
	  this.deferred = [];
	  var promise = this;
	
	  try {
	    executor(function (x) {
	      promise.resolve(x);
	    }, function (r) {
	      promise.reject(r);
	    });
	  } catch (e) {
	    promise.reject(e);
	  }
	}
	
	Promise$1.reject = function (r) {
	  return new Promise$1(function (resolve, reject) {
	    reject(r);
	  });
	};
	
	Promise$1.resolve = function (x) {
	  return new Promise$1(function (resolve, reject) {
	    resolve(x);
	  });
	};
	
	Promise$1.all = function all(iterable) {
	  return new Promise$1(function (resolve, reject) {
	    var count = 0,
	        result = [];
	
	    if (iterable.length === 0) {
	      resolve(result);
	    }
	
	    function resolver(i) {
	      return function (x) {
	        result[i] = x;
	        count += 1;
	
	        if (count === iterable.length) {
	          resolve(result);
	        }
	      };
	    }
	
	    for (var i = 0; i < iterable.length; i += 1) {
	      Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	    }
	  });
	};
	
	Promise$1.race = function race(iterable) {
	  return new Promise$1(function (resolve, reject) {
	    for (var i = 0; i < iterable.length; i += 1) {
	      Promise$1.resolve(iterable[i]).then(resolve, reject);
	    }
	  });
	};
	
	var p = Promise$1.prototype;
	
	p.resolve = function resolve(x) {
	  var promise = this;
	
	  if (promise.state === PENDING) {
	    if (x === promise) {
	      throw new TypeError('Promise settled with itself.');
	    }
	
	    var called = false;
	
	    try {
	      var then = x && x['then'];
	
	      if (x !== null && typeof x === 'object' && typeof then === 'function') {
	        then.call(x, function (x) {
	          if (!called) {
	            promise.resolve(x);
	          }
	
	          called = true;
	        }, function (r) {
	          if (!called) {
	            promise.reject(r);
	          }
	
	          called = true;
	        });
	        return;
	      }
	    } catch (e) {
	      if (!called) {
	        promise.reject(e);
	      }
	
	      return;
	    }
	
	    promise.state = RESOLVED;
	    promise.value = x;
	    promise.notify();
	  }
	};
	
	p.reject = function reject(reason) {
	  var promise = this;
	
	  if (promise.state === PENDING) {
	    if (reason === promise) {
	      throw new TypeError('Promise settled with itself.');
	    }
	
	    promise.state = REJECTED;
	    promise.value = reason;
	    promise.notify();
	  }
	};
	
	p.notify = function notify() {
	  var promise = this;
	  nextTick(function () {
	    if (promise.state !== PENDING) {
	      while (promise.deferred.length) {
	        var deferred = promise.deferred.shift(),
	            onResolved = deferred[0],
	            onRejected = deferred[1],
	            resolve = deferred[2],
	            reject = deferred[3];
	
	        try {
	          if (promise.state === RESOLVED) {
	            if (typeof onResolved === 'function') {
	              resolve(onResolved.call(undefined, promise.value));
	            } else {
	              resolve(promise.value);
	            }
	          } else if (promise.state === REJECTED) {
	            if (typeof onRejected === 'function') {
	              resolve(onRejected.call(undefined, promise.value));
	            } else {
	              reject(promise.value);
	            }
	          }
	        } catch (e) {
	          reject(e);
	        }
	      }
	    }
	  });
	};
	
	p.then = function then(onResolved, onRejected) {
	  var promise = this;
	  return new Promise$1(function (resolve, reject) {
	    promise.deferred.push([onResolved, onRejected, resolve, reject]);
	    promise.notify();
	  });
	};
	
	p["catch"] = function (onRejected) {
	  return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	  window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	  if (executor instanceof Promise) {
	    this.promise = executor;
	  } else {
	    this.promise = new Promise(executor.bind(context));
	  }
	
	  this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	  return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	  return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	  return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	  return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p$1 = PromiseObj.prototype;
	
	p$1.bind = function (context) {
	  this.context = context;
	  return this;
	};
	
	p$1.then = function (fulfilled, rejected) {
	  if (fulfilled && fulfilled.bind && this.context) {
	    fulfilled = fulfilled.bind(this.context);
	  }
	
	  if (rejected && rejected.bind && this.context) {
	    rejected = rejected.bind(this.context);
	  }
	
	  return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p$1["catch"] = function (rejected) {
	  if (rejected && rejected.bind && this.context) {
	    rejected = rejected.bind(this.context);
	  }
	
	  return new PromiseObj(this.promise["catch"](rejected), this.context);
	};
	
	p$1["finally"] = function (callback) {
	  return this.then(function (value) {
	    callback.call(this);
	    return value;
	  }, function (reason) {
	    callback.call(this);
	    return Promise.reject(reason);
	  });
	};
	
	/**
	 * Utility functions.
	 */
	var _ref = {},
	    hasOwnProperty = _ref.hasOwnProperty,
	    slice = [].slice,
	    debug = false,
	    ntick;
	var inBrowser = typeof window !== 'undefined';
	function Util (_ref2) {
	  var config = _ref2.config,
	      nextTick = _ref2.nextTick;
	  ntick = nextTick;
	  debug = config.debug || !config.silent;
	}
	function warn(msg) {
	  if (typeof console !== 'undefined' && debug) {
	    console.warn('[VueResource warn]: ' + msg);
	  }
	}
	function error(msg) {
	  if (typeof console !== 'undefined') {
	    console.error(msg);
	  }
	}
	function nextTick(cb, ctx) {
	  return ntick(cb, ctx);
	}
	function trim(str) {
	  return str ? str.replace(/^\s*|\s*$/g, '') : '';
	}
	function trimEnd(str, chars) {
	  if (str && chars === undefined) {
	    return str.replace(/\s+$/, '');
	  }
	
	  if (!str || !chars) {
	    return str;
	  }
	
	  return str.replace(new RegExp("[" + chars + "]+$"), '');
	}
	function toLower(str) {
	  return str ? str.toLowerCase() : '';
	}
	function toUpper(str) {
	  return str ? str.toUpperCase() : '';
	}
	var isArray = Array.isArray;
	function isString(val) {
	  return typeof val === 'string';
	}
	function isFunction(val) {
	  return typeof val === 'function';
	}
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object';
	}
	function isPlainObject(obj) {
	  return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	function isBlob(obj) {
	  return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	function isFormData(obj) {
	  return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	function when(value, fulfilled, rejected) {
	  var promise = PromiseObj.resolve(value);
	
	  if (arguments.length < 2) {
	    return promise;
	  }
	
	  return promise.then(fulfilled, rejected);
	}
	function options(fn, obj, opts) {
	  opts = opts || {};
	
	  if (isFunction(opts)) {
	    opts = opts.call(obj);
	  }
	
	  return merge(fn.bind({
	    $vm: obj,
	    $options: opts
	  }), fn, {
	    $options: opts
	  });
	}
	function each(obj, iterator) {
	  var i, key;
	
	  if (isArray(obj)) {
	    for (i = 0; i < obj.length; i++) {
	      iterator.call(obj[i], obj[i], i);
	    }
	  } else if (isObject(obj)) {
	    for (key in obj) {
	      if (hasOwnProperty.call(obj, key)) {
	        iterator.call(obj[key], obj[key], key);
	      }
	    }
	  }
	
	  return obj;
	}
	var assign = Object.assign || _assign;
	function merge(target) {
	  var args = slice.call(arguments, 1);
	  args.forEach(function (source) {
	    _merge(target, source, true);
	  });
	  return target;
	}
	function defaults(target) {
	  var args = slice.call(arguments, 1);
	  args.forEach(function (source) {
	    for (var key in source) {
	      if (target[key] === undefined) {
	        target[key] = source[key];
	      }
	    }
	  });
	  return target;
	}
	
	function _assign(target) {
	  var args = slice.call(arguments, 1);
	  args.forEach(function (source) {
	    _merge(target, source);
	  });
	  return target;
	}
	
	function _merge(target, source, deep) {
	  for (var key in source) {
	    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	        target[key] = {};
	      }
	
	      if (isArray(source[key]) && !isArray(target[key])) {
	        target[key] = [];
	      }
	
	      _merge(target[key], source[key], deep);
	    } else if (source[key] !== undefined) {
	      target[key] = source[key];
	    }
	  }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	function root (options$$1, next) {
	  var url = next(options$$1);
	
	  if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
	    url = trimEnd(options$$1.root, '/') + '/' + url;
	  }
	
	  return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	function query (options$$1, next) {
	  var urlParams = Object.keys(Url.options.params),
	      query = {},
	      url = next(options$$1);
	  each(options$$1.params, function (value, key) {
	    if (urlParams.indexOf(key) === -1) {
	      query[key] = value;
	    }
	  });
	  query = Url.params(query);
	
	  if (query) {
	    url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	  }
	
	  return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	function expand(url, params, variables) {
	  var tmpl = parse(url),
	      expanded = tmpl.expand(params);
	
	  if (variables) {
	    variables.push.apply(variables, tmpl.vars);
	  }
	
	  return expanded;
	}
	function parse(template) {
	  var operators = ['+', '#', '.', '/', ';', '?', '&'],
	      variables = [];
	  return {
	    vars: variables,
	    expand: function expand(context) {
	      return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
	        if (expression) {
	          var operator = null,
	              values = [];
	
	          if (operators.indexOf(expression.charAt(0)) !== -1) {
	            operator = expression.charAt(0);
	            expression = expression.substr(1);
	          }
	
	          expression.split(/,/g).forEach(function (variable) {
	            var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
	            values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	            variables.push(tmp[1]);
	          });
	
	          if (operator && operator !== '+') {
	            var separator = ',';
	
	            if (operator === '?') {
	              separator = '&';
	            } else if (operator !== '#') {
	              separator = operator;
	            }
	
	            return (values.length !== 0 ? operator : '') + values.join(separator);
	          } else {
	            return values.join(',');
	          }
	        } else {
	          return encodeReserved(literal);
	        }
	      });
	    }
	  };
	}
	
	function getValues(context, operator, key, modifier) {
	  var value = context[key],
	      result = [];
	
	  if (isDefined(value) && value !== '') {
	    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	      value = value.toString();
	
	      if (modifier && modifier !== '*') {
	        value = value.substring(0, parseInt(modifier, 10));
	      }
	
	      result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	    } else {
	      if (modifier === '*') {
	        if (Array.isArray(value)) {
	          value.filter(isDefined).forEach(function (value) {
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	          });
	        } else {
	          Object.keys(value).forEach(function (k) {
	            if (isDefined(value[k])) {
	              result.push(encodeValue(operator, value[k], k));
	            }
	          });
	        }
	      } else {
	        var tmp = [];
	
	        if (Array.isArray(value)) {
	          value.filter(isDefined).forEach(function (value) {
	            tmp.push(encodeValue(operator, value));
	          });
	        } else {
	          Object.keys(value).forEach(function (k) {
	            if (isDefined(value[k])) {
	              tmp.push(encodeURIComponent(k));
	              tmp.push(encodeValue(operator, value[k].toString()));
	            }
	          });
	        }
	
	        if (isKeyOperator(operator)) {
	          result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	        } else if (tmp.length !== 0) {
	          result.push(tmp.join(','));
	        }
	      }
	    }
	  } else {
	    if (operator === ';') {
	      result.push(encodeURIComponent(key));
	    } else if (value === '' && (operator === '&' || operator === '?')) {
	      result.push(encodeURIComponent(key) + '=');
	    } else if (value === '') {
	      result.push('');
	    }
	  }
	
	  return result;
	}
	
	function isDefined(value) {
	  return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	  return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	  value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	  if (key) {
	    return encodeURIComponent(key) + '=' + value;
	  } else {
	    return value;
	  }
	}
	
	function encodeReserved(str) {
	  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	    if (!/%[0-9A-Fa-f]/.test(part)) {
	      part = encodeURI(part);
	    }
	
	    return part;
	  }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	function template (options) {
	  var variables = [],
	      url = expand(options.url, options.params, variables);
	  variables.forEach(function (key) {
	    delete options.params[key];
	  });
	  return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	function Url(url, params) {
	  var self = this || {},
	      options$$1 = url,
	      transform;
	
	  if (isString(url)) {
	    options$$1 = {
	      url: url,
	      params: params
	    };
	  }
	
	  options$$1 = merge({}, Url.options, self.$options, options$$1);
	  Url.transforms.forEach(function (handler) {
	    if (isString(handler)) {
	      handler = Url.transform[handler];
	    }
	
	    if (isFunction(handler)) {
	      transform = factory(handler, transform, self.$vm);
	    }
	  });
	  return transform(options$$1);
	}
	/**
	 * Url options.
	 */
	
	Url.options = {
	  url: '',
	  root: null,
	  params: {}
	};
	/**
	 * Url transforms.
	 */
	
	Url.transform = {
	  template: template,
	  query: query,
	  root: root
	};
	Url.transforms = ['template', 'query', 'root'];
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	  var params = [],
	      escape = encodeURIComponent;
	
	  params.add = function (key, value) {
	    if (isFunction(value)) {
	      value = value();
	    }
	
	    if (value === null) {
	      value = '';
	    }
	
	    this.push(escape(key) + '=' + escape(value));
	  };
	
	  serialize(params, obj);
	  return params.join('&').replace(/%20/g, '+');
	};
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	
	Url.parse = function (url) {
	  var el = document.createElement('a');
	
	  if (document.documentMode) {
	    el.href = url;
	    url = el.href;
	  }
	
	  el.href = url;
	  return {
	    href: el.href,
	    protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	    port: el.port,
	    host: el.host,
	    hostname: el.hostname,
	    pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	    search: el.search ? el.search.replace(/^\?/, '') : '',
	    hash: el.hash ? el.hash.replace(/^#/, '') : ''
	  };
	};
	
	function factory(handler, next, vm) {
	  return function (options$$1) {
	    return handler.call(vm, options$$1, next);
	  };
	}
	
	function serialize(params, obj, scope) {
	  var array = isArray(obj),
	      plain = isPlainObject(obj),
	      hash;
	  each(obj, function (value, key) {
	    hash = isObject(value) || isArray(value);
	
	    if (scope) {
	      key = scope + '[' + (plain || hash ? key : '') + ']';
	    }
	
	    if (!scope && array) {
	      params.add(value.name, value.value);
	    } else if (hash) {
	      serialize(params, value, key);
	    } else {
	      params.add(key, value);
	    }
	  });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	function xdrClient (request) {
	  return new PromiseObj(function (resolve) {
	    var xdr = new XDomainRequest(),
	        handler = function handler(_ref) {
	      var type = _ref.type;
	      var status = 0;
	
	      if (type === 'load') {
	        status = 200;
	      } else if (type === 'error') {
	        status = 500;
	      }
	
	      resolve(request.respondWith(xdr.responseText, {
	        status: status
	      }));
	    };
	
	    request.abort = function () {
	      return xdr.abort();
	    };
	
	    xdr.open(request.method, request.getUrl());
	
	    if (request.timeout) {
	      xdr.timeout = request.timeout;
	    }
	
	    xdr.onload = handler;
	    xdr.onabort = handler;
	    xdr.onerror = handler;
	    xdr.ontimeout = handler;
	
	    xdr.onprogress = function () {};
	
	    xdr.send(request.getBody());
	  });
	}
	
	/**
	 * CORS Interceptor.
	 */
	var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
	function cors (request) {
	  if (inBrowser) {
	    var orgUrl = Url.parse(location.href);
	    var reqUrl = Url.parse(request.getUrl());
	
	    if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
	      request.crossOrigin = true;
	      request.emulateHTTP = false;
	
	      if (!SUPPORTS_CORS) {
	        request.client = xdrClient;
	      }
	    }
	  }
	}
	
	/**
	 * Form data Interceptor.
	 */
	function form (request) {
	  if (isFormData(request.body)) {
	    request.headers["delete"]('Content-Type');
	  } else if (isObject(request.body) && request.emulateJSON) {
	    request.body = Url.params(request.body);
	    request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	  }
	}
	
	/**
	 * JSON Interceptor.
	 */
	function json (request) {
	  var type = request.headers.get('Content-Type') || '';
	
	  if (isObject(request.body) && type.indexOf('application/json') === 0) {
	    request.body = JSON.stringify(request.body);
	  }
	
	  return function (response) {
	    return response.bodyText ? when(response.text(), function (text) {
	      var type = response.headers.get('Content-Type') || '';
	
	      if (type.indexOf('application/json') === 0 || isJson(text)) {
	        try {
	          response.body = JSON.parse(text);
	        } catch (e) {
	          response.body = null;
	        }
	      } else {
	        response.body = text;
	      }
	
	      return response;
	    }) : response;
	  };
	}
	
	function isJson(str) {
	  var start = str.match(/^\s*(\[|\{)/);
	  var end = {
	    '[': /]\s*$/,
	    '{': /}\s*$/
	  };
	  return start && end[start[1]].test(str);
	}
	
	/**
	 * JSONP client (Browser).
	 */
	function jsonpClient (request) {
	  return new PromiseObj(function (resolve) {
	    var name = request.jsonp || 'callback',
	        callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2),
	        body = null,
	        handler,
	        script;
	
	    handler = function handler(_ref) {
	      var type = _ref.type;
	      var status = 0;
	
	      if (type === 'load' && body !== null) {
	        status = 200;
	      } else if (type === 'error') {
	        status = 500;
	      }
	
	      if (status && window[callback]) {
	        delete window[callback];
	        document.body.removeChild(script);
	      }
	
	      resolve(request.respondWith(body, {
	        status: status
	      }));
	    };
	
	    window[callback] = function (result) {
	      body = JSON.stringify(result);
	    };
	
	    request.abort = function () {
	      handler({
	        type: 'abort'
	      });
	    };
	
	    request.params[name] = callback;
	
	    if (request.timeout) {
	      setTimeout(request.abort, request.timeout);
	    }
	
	    script = document.createElement('script');
	    script.src = request.getUrl();
	    script.type = 'text/javascript';
	    script.async = true;
	    script.onload = handler;
	    script.onerror = handler;
	    document.body.appendChild(script);
	  });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	function jsonp (request) {
	  if (request.method == 'JSONP') {
	    request.client = jsonpClient;
	  }
	}
	
	/**
	 * Before Interceptor.
	 */
	function before (request) {
	  if (isFunction(request.before)) {
	    request.before.call(this, request);
	  }
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	function method (request) {
	  if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	    request.headers.set('X-HTTP-Method-Override', request.method);
	    request.method = 'POST';
	  }
	}
	
	/**
	 * Header Interceptor.
	 */
	function header (request) {
	  var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
	  each(headers, function (value, name) {
	    if (!request.headers.has(name)) {
	      request.headers.set(name, value);
	    }
	  });
	}
	
	/**
	 * XMLHttp client (Browser).
	 */
	function xhrClient (request) {
	  return new PromiseObj(function (resolve) {
	    var xhr = new XMLHttpRequest(),
	        handler = function handler(event) {
	      var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
	        status: xhr.status === 1223 ? 204 : xhr.status,
	        // IE9 status bug
	        statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	      });
	      each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	        response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	      });
	      resolve(response);
	    };
	
	    request.abort = function () {
	      return xhr.abort();
	    };
	
	    xhr.open(request.method, request.getUrl(), true);
	
	    if (request.timeout) {
	      xhr.timeout = request.timeout;
	    }
	
	    if (request.responseType && 'responseType' in xhr) {
	      xhr.responseType = request.responseType;
	    }
	
	    if (request.withCredentials || request.credentials) {
	      xhr.withCredentials = true;
	    }
	
	    if (!request.crossOrigin) {
	      request.headers.set('X-Requested-With', 'XMLHttpRequest');
	    } // deprecated use downloadProgress
	
	
	    if (isFunction(request.progress) && request.method === 'GET') {
	      xhr.addEventListener('progress', request.progress);
	    }
	
	    if (isFunction(request.downloadProgress)) {
	      xhr.addEventListener('progress', request.downloadProgress);
	    } // deprecated use uploadProgress
	
	
	    if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
	      xhr.upload.addEventListener('progress', request.progress);
	    }
	
	    if (isFunction(request.uploadProgress) && xhr.upload) {
	      xhr.upload.addEventListener('progress', request.uploadProgress);
	    }
	
	    request.headers.forEach(function (value, name) {
	      xhr.setRequestHeader(name, value);
	    });
	    xhr.onload = handler;
	    xhr.onabort = handler;
	    xhr.onerror = handler;
	    xhr.ontimeout = handler;
	    xhr.send(request.getBody());
	  });
	}
	
	/**
	 * Http client (Node).
	 */
	function nodeClient (request) {
	  var client = __webpack_require__(48);
	
	  return new PromiseObj(function (resolve) {
	    var url = request.getUrl();
	    var body = request.getBody();
	    var method = request.method;
	    var headers = {},
	        handler;
	    request.headers.forEach(function (value, name) {
	      headers[name] = value;
	    });
	    client(url, {
	      body: body,
	      method: method,
	      headers: headers
	    }).then(handler = function handler(resp) {
	      var response = request.respondWith(resp.body, {
	        status: resp.statusCode,
	        statusText: trim(resp.statusMessage)
	      });
	      each(resp.headers, function (value, name) {
	        response.headers.set(name, value);
	      });
	      resolve(response);
	    }, function (error$$1) {
	      return handler(error$$1.response);
	    });
	  });
	}
	
	/**
	 * Base client.
	 */
	function Client (context) {
	  var reqHandlers = [sendRequest],
	      resHandlers = [];
	
	  if (!isObject(context)) {
	    context = null;
	  }
	
	  function Client(request) {
	    while (reqHandlers.length) {
	      var handler = reqHandlers.pop();
	
	      if (isFunction(handler)) {
	        var _ret = function () {
	          var response = void 0,
	              next = void 0;
	          response = handler.call(context, request, function (val) {
	            return next = val;
	          }) || next;
	
	          if (isObject(response)) {
	            return {
	              v: new PromiseObj(function (resolve, reject) {
	                resHandlers.forEach(function (handler) {
	                  response = when(response, function (response) {
	                    return handler.call(context, response) || response;
	                  }, reject);
	                });
	                when(response, resolve, reject);
	              }, context)
	            };
	          }
	
	          if (isFunction(response)) {
	            resHandlers.unshift(response);
	          }
	        }();
	
	        if (typeof _ret === "object") return _ret.v;
	      } else {
	        warn("Invalid interceptor of type " + typeof handler + ", must be a function");
	      }
	    }
	  }
	
	  Client.use = function (handler) {
	    reqHandlers.push(handler);
	  };
	
	  return Client;
	}
	
	function sendRequest(request) {
	  var client = request.client || (inBrowser ? xhrClient : nodeClient);
	  return client(request);
	}
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = /*#__PURE__*/function () {
	  function Headers(headers) {
	    var _this = this;
	
	    this.map = {};
	    each(headers, function (value, name) {
	      return _this.append(name, value);
	    });
	  }
	
	  var _proto = Headers.prototype;
	
	  _proto.has = function has(name) {
	    return getName(this.map, name) !== null;
	  };
	
	  _proto.get = function get(name) {
	    var list = this.map[getName(this.map, name)];
	    return list ? list.join() : null;
	  };
	
	  _proto.getAll = function getAll(name) {
	    return this.map[getName(this.map, name)] || [];
	  };
	
	  _proto.set = function set(name, value) {
	    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	  };
	
	  _proto.append = function append(name, value) {
	    var list = this.map[getName(this.map, name)];
	
	    if (list) {
	      list.push(trim(value));
	    } else {
	      this.set(name, value);
	    }
	  };
	
	  _proto["delete"] = function _delete(name) {
	    delete this.map[getName(this.map, name)];
	  };
	
	  _proto.deleteAll = function deleteAll() {
	    this.map = {};
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    var _this2 = this;
	
	    each(this.map, function (list, name) {
	      each(list, function (value) {
	        return callback.call(thisArg, value, name, _this2);
	      });
	    });
	  };
	
	  return Headers;
	}();
	
	function getName(map, name) {
	  return Object.keys(map).reduce(function (prev, curr) {
	    return toLower(name) === toLower(curr) ? curr : prev;
	  }, null);
	}
	
	function normalizeName(name) {
	  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	    throw new TypeError('Invalid character in header field name');
	  }
	
	  return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = /*#__PURE__*/function () {
	  function Response(body, _ref) {
	    var url = _ref.url,
	        headers = _ref.headers,
	        status = _ref.status,
	        statusText = _ref.statusText;
	    this.url = url;
	    this.ok = status >= 200 && status < 300;
	    this.status = status || 0;
	    this.statusText = statusText || '';
	    this.headers = new Headers(headers);
	    this.body = body;
	
	    if (isString(body)) {
	      this.bodyText = body;
	    } else if (isBlob(body)) {
	      this.bodyBlob = body;
	
	      if (isBlobText(body)) {
	        this.bodyText = blobText(body);
	      }
	    }
	  }
	
	  var _proto = Response.prototype;
	
	  _proto.blob = function blob() {
	    return when(this.bodyBlob);
	  };
	
	  _proto.text = function text() {
	    return when(this.bodyText);
	  };
	
	  _proto.json = function json() {
	    return when(this.text(), function (text) {
	      return JSON.parse(text);
	    });
	  };
	
	  return Response;
	}();
	Object.defineProperty(Response.prototype, 'data', {
	  get: function get() {
	    return this.body;
	  },
	  set: function set(body) {
	    this.body = body;
	  }
	});
	
	function blobText(body) {
	  return new PromiseObj(function (resolve) {
	    var reader = new FileReader();
	    reader.readAsText(body);
	
	    reader.onload = function () {
	      resolve(reader.result);
	    };
	  });
	}
	
	function isBlobText(body) {
	  return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = /*#__PURE__*/function () {
	  function Request(options$$1) {
	    this.body = null;
	    this.params = {};
	    assign(this, options$$1, {
	      method: toUpper(options$$1.method || 'GET')
	    });
	
	    if (!(this.headers instanceof Headers)) {
	      this.headers = new Headers(this.headers);
	    }
	  }
	
	  var _proto = Request.prototype;
	
	  _proto.getUrl = function getUrl() {
	    return Url(this);
	  };
	
	  _proto.getBody = function getBody() {
	    return this.body;
	  };
	
	  _proto.respondWith = function respondWith(body, options$$1) {
	    return new Response(body, assign(options$$1 || {}, {
	      url: this.getUrl()
	    }));
	  };
	
	  return Request;
	}();
	
	/**
	 * Service for sending network requests.
	 */
	var COMMON_HEADERS = {
	  'Accept': 'application/json, text/plain, */*'
	};
	var JSON_CONTENT_TYPE = {
	  'Content-Type': 'application/json;charset=utf-8'
	};
	function Http(options$$1) {
	  var self = this || {},
	      client = Client(self.$vm);
	  defaults(options$$1 || {}, self.$options, Http.options);
	  Http.interceptors.forEach(function (handler) {
	    if (isString(handler)) {
	      handler = Http.interceptor[handler];
	    }
	
	    if (isFunction(handler)) {
	      client.use(handler);
	    }
	  });
	  return client(new Request(options$$1)).then(function (response) {
	    return response.ok ? response : PromiseObj.reject(response);
	  }, function (response) {
	    if (response instanceof Error) {
	      error(response);
	    }
	
	    return PromiseObj.reject(response);
	  });
	}
	Http.options = {};
	Http.headers = {
	  put: JSON_CONTENT_TYPE,
	  post: JSON_CONTENT_TYPE,
	  patch: JSON_CONTENT_TYPE,
	  "delete": JSON_CONTENT_TYPE,
	  common: COMMON_HEADERS,
	  custom: {}
	};
	Http.interceptor = {
	  before: before,
	  method: method,
	  jsonp: jsonp,
	  json: json,
	  form: form,
	  header: header,
	  cors: cors
	};
	Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
	['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
	  Http[method$$1] = function (url, options$$1) {
	    return this(assign(options$$1 || {}, {
	      url: url,
	      method: method$$1
	    }));
	  };
	});
	['post', 'put', 'patch'].forEach(function (method$$1) {
	  Http[method$$1] = function (url, body, options$$1) {
	    return this(assign(options$$1 || {}, {
	      url: url,
	      method: method$$1,
	      body: body
	    }));
	  };
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	function Resource(url, params, actions, options$$1) {
	  var self = this || {},
	      resource = {};
	  actions = assign({}, Resource.actions, actions);
	  each(actions, function (action, name) {
	    action = merge({
	      url: url,
	      params: assign({}, params)
	    }, options$$1, action);
	
	    resource[name] = function () {
	      return (self.$http || Http)(opts(action, arguments));
	    };
	  });
	  return resource;
	}
	
	function opts(action, args) {
	  var options$$1 = assign({}, action),
	      params = {},
	      body;
	
	  switch (args.length) {
	    case 2:
	      params = args[0];
	      body = args[1];
	      break;
	
	    case 1:
	      if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
	        body = args[0];
	      } else {
	        params = args[0];
	      }
	
	      break;
	
	    case 0:
	      break;
	
	    default:
	      throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
	  }
	
	  options$$1.body = body;
	  options$$1.params = assign({}, options$$1.params, params);
	  return options$$1;
	}
	
	Resource.actions = {
	  get: {
	    method: 'GET'
	  },
	  save: {
	    method: 'POST'
	  },
	  query: {
	    method: 'GET'
	  },
	  update: {
	    method: 'PUT'
	  },
	  remove: {
	    method: 'DELETE'
	  },
	  "delete": {
	    method: 'DELETE'
	  }
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	  if (plugin.installed) {
	    return;
	  }
	
	  Util(Vue);
	  Vue.url = Url;
	  Vue.http = Http;
	  Vue.resource = Resource;
	  Vue.Promise = PromiseObj;
	  Object.defineProperties(Vue.prototype, {
	    $url: {
	      get: function get() {
	        return options(Vue.url, this, this.$options.url);
	      }
	    },
	    $http: {
	      get: function get() {
	        return options(Vue.http, this, this.$options.http);
	      }
	    },
	    $resource: {
	      get: function get() {
	        return Vue.resource.bind(this);
	      }
	    },
	    $promise: {
	      get: function get() {
	        var _this = this;
	
	        return function (executor) {
	          return new Vue.Promise(executor, _this);
	        };
	      }
	    }
	  });
	}
	
	if (typeof window !== 'undefined' && window.Vue && !window.Vue.resource) {
	  window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	;(function () {
	
	  var vueTouch = {}
	  var Hammer =  true
	    ? __webpack_require__(38)
	    : window.Hammer
	  var gestures = ['tap', 'pan', 'pinch', 'press', 'rotate', 'swipe']
	  var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all']
	  var customEvents = {}
	
	  if (!Hammer) {
	    throw new Error('[vue-touch] cannot locate Hammer.js.')
	  }
	
	  // exposed global options
	  vueTouch.config = {}
	
	  vueTouch.install = function (Vue) {
	
	    Vue.directive('touch', {
	
	      isFn: true,
	      acceptStatement: true,
	      priority: Vue.directive('on').priority,
	
	      bind: function () {
	        if (!this.el.hammer) {
	          this.el.hammer = new Hammer.Manager(this.el)
	        }
	        var mc = this.mc = this.el.hammer
	        // determine event type
	        var event = this.arg
	        if (!event) {
	          console.warn('[vue-touch] event type argument is required.')
	        }
	        var recognizerType, recognizer
	
	        if (customEvents[event]) {
	          // custom event
	          var custom = customEvents[event]
	          recognizerType = custom.type
	          recognizer = new Hammer[capitalize(recognizerType)](custom)
	          recognizer.recognizeWith(mc.recognizers)
	          mc.add(recognizer)
	        } else {
	          // built-in event
	          for (var i = 0; i < gestures.length; i++) {
	            if (event.indexOf(gestures[i]) === 0) {
	              recognizerType = gestures[i]
	              break
	            }
	          }
	          if (!recognizerType) {
	            console.warn('[vue-touch] invalid event type: ' + event)
	            return
	          }
	          recognizer = mc.get(recognizerType)
	          if (!recognizer) {
	            // add recognizer
	            recognizer = new Hammer[capitalize(recognizerType)]()
	            // make sure multiple recognizers work together...
	            recognizer.recognizeWith(mc.recognizers)
	            mc.add(recognizer)
	          }
	          // apply global options
	          var globalOptions = vueTouch.config[recognizerType]
	          if (globalOptions) {
	            guardDirections(globalOptions)
	            recognizer.set(globalOptions)
	          }
	          // apply local options
	          var localOptions =
	            this.el.hammerOptions &&
	            this.el.hammerOptions[recognizerType]
	          if (localOptions) {
	            guardDirections(localOptions)
	            recognizer.set(localOptions)
	          }
	        }
	        this.recognizer = recognizer
	      },
	
	      update: function (fn) {
	        var mc = this.mc
	        var event = this.arg
	        // teardown old handler
	        if (this.handler) {
	          mc.off(event, this.handler)
	        }
	        if (typeof fn !== 'function') {
	          this.handler = null
	          console.warn(
	            '[vue-touch] invalid handler function for v-touch: ' +
	            this.arg + '="' + this.descriptor.raw
	          )
	        } else {
	          mc.on(event, (this.handler = fn))
	        }
	      },
	
	      unbind: function () {
	        if (this.handler) {
	          this.mc.off(this.arg, this.handler)
	        }
	        if (!Object.keys(this.mc.handlers).length) {
	          this.mc.destroy()
	          this.el.hammer = null
	        }
	      }
	    })
	
	    Vue.directive('touch-options', {
	      priority: Vue.directive('on').priority + 1,
	      update: function (options) {
	        var opts = this.el.hammerOptions || (this.el.hammerOptions = {})
	        if (!this.arg) {
	          console.warn('[vue-touch] recognizer type argument for v-touch-options is required.')
	        } else {
	          opts[this.arg] = options
	        }
	      }
	    })
	  }
	
	  /**
	   * Register a custom event.
	   *
	   * @param {String} event
	   * @param {Object} options - a Hammer.js recognizer option object.
	   *                           required fields:
	   *                           - type: the base recognizer to use for this event
	   */
	
	  vueTouch.registerCustomEvent = function (event, options) {
	    options.event = event
	    customEvents[event] = options
	  }
	
	  function capitalize (str) {
	    return str.charAt(0).toUpperCase() + str.slice(1)
	  }
	
	  function guardDirections (options) {
	    var dir = options.direction
	    if (typeof dir === 'string') {
	      var hammerDirection = 'DIRECTION_' + dir.toUpperCase()
	      if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
	        options.direction = Hammer[hammerDirection]
	      } else {
	        console.warn('[vue-touch] invalid direction: ' + dir)
	      }
	    }
	  }
	
	  if (true) {
	    module.exports = vueTouch
	  } else if (typeof define == "function" && define.amd) {
	    define([], function(){ return vueTouch })
	  } else if (window.Vue) {
	    window.VueTouch = vueTouch
	    Vue.use(vueTouch)
	  }
	
	})()


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(39)
	__vue_script__ = __webpack_require__(33)
	__vue_template__ = __webpack_require__(41)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(40)
	__vue_script__ = __webpack_require__(34)
	__vue_template__ = __webpack_require__(42)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(77)
	__vue_template__ = __webpack_require__(81)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, "*{-webkit-tap-highlight-color:transparent}blockquote,body,button,caption,dd,div,dl,dt,fieldset,figure,form,h1,h2,h3,h4,h5,h6,hr,html,input,legend,li,menu,ol,p,pre,table,td,textarea,th,ul{margin:0;padding:0}address,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}table{border-collapse:collapse;border-spacing:0}caption,th{text-align:left;font-weight:400}abbr,body,fieldset,html,iframe,img{border:0}address,cite,dfn,em,i,var{font-style:normal}[hidefocus],summary{outline:0}li{list-style:none}h1,h2,h3,h4,h5,h6,small{font-size:100%}sub,sup{font-size:83%}code,kbd,pre,samp{font-family:inherit}q:after,q:before{content:none}textarea{overflow:auto;resize:none}label,summary{cursor:default}a,button{cursor:pointer}b,em,h1,h2,h3,h4,h5,h6,strong{font-weight:700}a,a:hover,del,ins,s,u{text-decoration:none}body,button,input,keygen,legend,select,textarea{font:9pt/1.14 \"\\5FAE\\8F6F\\96C5\\9ED1\",arial,\\5b8b\\4f53;color:#333;outline:0}body{background:#fff;height:100%}a{color:#424242}html{height:100%}img{max-width:100%}body,html{width:100%}.page{width:100%}.page,.page1{box-sizing:border-box;position:relative;min-height:100%}.page1{width:750px}.f-fl{float:left}.f-fr{float:right}.f-fix:after,.f-fix:before{display:table;height:0;line-height:0;content:'';clear:both}.f-fs12{font-size:9pt!important}.f-fs14{font-size:14px!important}.f-fs16{font-size:1pc!important}.f-fs18{font-size:18px!important}.f-fs22{font-size:22px!important}.f-fs24{font-size:24px!important}.f-fs30{font-size:30px!important}.f-fs36{font-size:36px!important}.f-cb{color:#424242}.f-cw{color:#fff}.f-cg{color:#969696}.f-cr{color:#e51937}.f-co{color:#ff9d00}.f-ellipsis{overflow:hidden;word-wrap:normal;white-space:nowrap;text-overflow:ellipsis}f-bg{background:#f8f8f8}.u-mask-layer{position:absolute;width:100%;overflow:hidden;z-index:100000;left:0;right:0;top:0;bottom:0;height:100%;background:rgba(0,0,0,.4)}@media only screen and (min-width:768px){html body{position:absolute;left:50%;transform:translateX(-50%);width:750px}}.top-warn{position:absolute;top:0;left:0;width:100%;background:#fcfdee;color:red;font-size:24px;height:60px;line-height:60px;text-align:left;padding-left:20px}", ""]);
	
	// exports


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(59);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js?sourceMap!./global_flexible.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js?sourceMap!./global_flexible.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setTitle = setTitle;
	exports.isWebview = isWebview;
	/**
	 * Created by Jerry on 2017/10/17.
	 */
	
	//设置微信标题
	function setTitle(title) {
	    if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
	        document.title = title;
	        var i = document.createElement('iframe');
	        i.style.display = 'none';
	        i.onload = function () {
	            setTimeout(function () {
	                i.remove();
	            }, 9);
	        };
	        document.body.appendChild(i);
	    } else document.title = title;
	}
	
	//判断是否在小程序环境
	function isWebview(cb) {
	    if (window.__wxjs_environment) wx.miniProgram.getEnv(function (res) {
	        if (res.miniprogram) cb(true);else cb(false);
	    });else cb(false);
	}
	
	var Vue = __webpack_require__(23),
	    vm = new Vue();
	
	var mixin = {
	    methods: {
	        /*检测实际支付是否成功的查询接口*/
	        checkPay: function checkPay(pay_order_sn, payment_platform) {
	            if (!payment_platform) payment_platform = 'WeixinJSAPI';
	            return vm.$http.post('/api/pay_params/check_pay_status', {
	                pay_order_sn: pay_order_sn,
	                payment_platform: payment_platform
	            }).then(function (res) {
	                return res.json();
	            });
	        }
	    }
	};
	exports.default = mixin;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _common = __webpack_require__(61);
	
	module.exports = {
	    // 左侧引导文本 左侧连接 标题 右侧文本  右侧连接
	    //type默认不写则不显示  1.文字，2.分享，3.二维码，等等
	    props: ['left_text', 'left_href', 'title', 'right_text', 'right_href', 'type'],
	    created: function created() {
	        if (this.title) (0, _common.setTitle)(this.title);
	    },
	    ready: function ready() {
	        if (this.title) (0, _common.setTitle)(this.title);
	    }
	};
	// </script>
	//
	//
	/* generated by vue-loader */
	// <template>
	// </template>
	// <script>

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	module.exports = " ";

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-router v0.7.13
	 * (c) 2016 Evan You
	 * Released under the MIT License.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.VueRouter = factory();
	}(this, function () { 'use strict';
	
	  var babelHelpers = {};
	
	  babelHelpers.classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	  function Target(path, matcher, delegate) {
	    this.path = path;
	    this.matcher = matcher;
	    this.delegate = delegate;
	  }
	
	  Target.prototype = {
	    to: function to(target, callback) {
	      var delegate = this.delegate;
	
	      if (delegate && delegate.willAddRoute) {
	        target = delegate.willAddRoute(this.matcher.target, target);
	      }
	
	      this.matcher.add(this.path, target);
	
	      if (callback) {
	        if (callback.length === 0) {
	          throw new Error("You must have an argument in the function passed to `to`");
	        }
	        this.matcher.addChild(this.path, target, callback, this.delegate);
	      }
	      return this;
	    }
	  };
	
	  function Matcher(target) {
	    this.routes = {};
	    this.children = {};
	    this.target = target;
	  }
	
	  Matcher.prototype = {
	    add: function add(path, handler) {
	      this.routes[path] = handler;
	    },
	
	    addChild: function addChild(path, target, callback, delegate) {
	      var matcher = new Matcher(target);
	      this.children[path] = matcher;
	
	      var match = generateMatch(path, matcher, delegate);
	
	      if (delegate && delegate.contextEntered) {
	        delegate.contextEntered(target, match);
	      }
	
	      callback(match);
	    }
	  };
	
	  function generateMatch(startingPath, matcher, delegate) {
	    return function (path, nestedCallback) {
	      var fullPath = startingPath + path;
	
	      if (nestedCallback) {
	        nestedCallback(generateMatch(fullPath, matcher, delegate));
	      } else {
	        return new Target(startingPath + path, matcher, delegate);
	      }
	    };
	  }
	
	  function addRoute(routeArray, path, handler) {
	    var len = 0;
	    for (var i = 0, l = routeArray.length; i < l; i++) {
	      len += routeArray[i].path.length;
	    }
	
	    path = path.substr(len);
	    var route = { path: path, handler: handler };
	    routeArray.push(route);
	  }
	
	  function eachRoute(baseRoute, matcher, callback, binding) {
	    var routes = matcher.routes;
	
	    for (var path in routes) {
	      if (routes.hasOwnProperty(path)) {
	        var routeArray = baseRoute.slice();
	        addRoute(routeArray, path, routes[path]);
	
	        if (matcher.children[path]) {
	          eachRoute(routeArray, matcher.children[path], callback, binding);
	        } else {
	          callback.call(binding, routeArray);
	        }
	      }
	    }
	  }
	
	  function map (callback, addRouteCallback) {
	    var matcher = new Matcher();
	
	    callback(generateMatch("", matcher, this.delegate));
	
	    eachRoute([], matcher, function (route) {
	      if (addRouteCallback) {
	        addRouteCallback(this, route);
	      } else {
	        this.add(route);
	      }
	    }, this);
	  }
	
	  var specials = ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\'];
	
	  var escapeRegex = new RegExp('(\\' + specials.join('|\\') + ')', 'g');
	
	  var noWarning = false;
	  function warn(msg) {
	    if (!noWarning && typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  function tryDecode(uri, asComponent) {
	    try {
	      return asComponent ? decodeURIComponent(uri) : decodeURI(uri);
	    } catch (e) {
	      warn('malformed URI' + (asComponent ? ' component: ' : ': ') + uri);
	    }
	  }
	
	  function isArray(test) {
	    return Object.prototype.toString.call(test) === "[object Array]";
	  }
	
	  // A Segment represents a segment in the original route description.
	  // Each Segment type provides an `eachChar` and `regex` method.
	  //
	  // The `eachChar` method invokes the callback with one or more character
	  // specifications. A character specification consumes one or more input
	  // characters.
	  //
	  // The `regex` method returns a regex fragment for the segment. If the
	  // segment is a dynamic of star segment, the regex fragment also includes
	  // a capture.
	  //
	  // A character specification contains:
	  //
	  // * `validChars`: a String with a list of all valid characters, or
	  // * `invalidChars`: a String with a list of all invalid characters
	  // * `repeat`: true if the character specification can repeat
	
	  function StaticSegment(string) {
	    this.string = string;
	  }
	  StaticSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      var string = this.string,
	          ch;
	
	      for (var i = 0, l = string.length; i < l; i++) {
	        ch = string.charAt(i);
	        callback({ validChars: ch });
	      }
	    },
	
	    regex: function regex() {
	      return this.string.replace(escapeRegex, '\\$1');
	    },
	
	    generate: function generate() {
	      return this.string;
	    }
	  };
	
	  function DynamicSegment(name) {
	    this.name = name;
	  }
	  DynamicSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "/", repeat: true });
	    },
	
	    regex: function regex() {
	      return "([^/]+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function StarSegment(name) {
	    this.name = name;
	  }
	  StarSegment.prototype = {
	    eachChar: function eachChar(callback) {
	      callback({ invalidChars: "", repeat: true });
	    },
	
	    regex: function regex() {
	      return "(.+)";
	    },
	
	    generate: function generate(params) {
	      var val = params[this.name];
	      return val == null ? ":" + this.name : val;
	    }
	  };
	
	  function EpsilonSegment() {}
	  EpsilonSegment.prototype = {
	    eachChar: function eachChar() {},
	    regex: function regex() {
	      return "";
	    },
	    generate: function generate() {
	      return "";
	    }
	  };
	
	  function parse(route, names, specificity) {
	    // normalize route as not starting with a "/". Recognition will
	    // also normalize.
	    if (route.charAt(0) === "/") {
	      route = route.substr(1);
	    }
	
	    var segments = route.split("/"),
	        results = [];
	
	    // A routes has specificity determined by the order that its different segments
	    // appear in. This system mirrors how the magnitude of numbers written as strings
	    // works.
	    // Consider a number written as: "abc". An example would be "200". Any other number written
	    // "xyz" will be smaller than "abc" so long as `a > z`. For instance, "199" is smaller
	    // then "200", even though "y" and "z" (which are both 9) are larger than "0" (the value
	    // of (`b` and `c`). This is because the leading symbol, "2", is larger than the other
	    // leading symbol, "1".
	    // The rule is that symbols to the left carry more weight than symbols to the right
	    // when a number is written out as a string. In the above strings, the leading digit
	    // represents how many 100's are in the number, and it carries more weight than the middle
	    // number which represents how many 10's are in the number.
	    // This system of number magnitude works well for route specificity, too. A route written as
	    // `a/b/c` will be more specific than `x/y/z` as long as `a` is more specific than
	    // `x`, irrespective of the other parts.
	    // Because of this similarity, we assign each type of segment a number value written as a
	    // string. We can find the specificity of compound routes by concatenating these strings
	    // together, from left to right. After we have looped through all of the segments,
	    // we convert the string to a number.
	    specificity.val = '';
	
	    for (var i = 0, l = segments.length; i < l; i++) {
	      var segment = segments[i],
	          match;
	
	      if (match = segment.match(/^:([^\/]+)$/)) {
	        results.push(new DynamicSegment(match[1]));
	        names.push(match[1]);
	        specificity.val += '3';
	      } else if (match = segment.match(/^\*([^\/]+)$/)) {
	        results.push(new StarSegment(match[1]));
	        specificity.val += '2';
	        names.push(match[1]);
	      } else if (segment === "") {
	        results.push(new EpsilonSegment());
	        specificity.val += '1';
	      } else {
	        results.push(new StaticSegment(segment));
	        specificity.val += '4';
	      }
	    }
	
	    specificity.val = +specificity.val;
	
	    return results;
	  }
	
	  // A State has a character specification and (`charSpec`) and a list of possible
	  // subsequent states (`nextStates`).
	  //
	  // If a State is an accepting state, it will also have several additional
	  // properties:
	  //
	  // * `regex`: A regular expression that is used to extract parameters from paths
	  //   that reached this accepting state.
	  // * `handlers`: Information on how to convert the list of captures into calls
	  //   to registered handlers with the specified parameters
	  // * `types`: How many static, dynamic or star segments in this route. Used to
	  //   decide which route to use if multiple registered routes match a path.
	  //
	  // Currently, State is implemented naively by looping over `nextStates` and
	  // comparing a character specification against a character. A more efficient
	  // implementation would use a hash of keys pointing at one or more next states.
	
	  function State(charSpec) {
	    this.charSpec = charSpec;
	    this.nextStates = [];
	  }
	
	  State.prototype = {
	    get: function get(charSpec) {
	      var nextStates = this.nextStates;
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        var child = nextStates[i];
	
	        var isEqual = child.charSpec.validChars === charSpec.validChars;
	        isEqual = isEqual && child.charSpec.invalidChars === charSpec.invalidChars;
	
	        if (isEqual) {
	          return child;
	        }
	      }
	    },
	
	    put: function put(charSpec) {
	      var state;
	
	      // If the character specification already exists in a child of the current
	      // state, just return that state.
	      if (state = this.get(charSpec)) {
	        return state;
	      }
	
	      // Make a new state for the character spec
	      state = new State(charSpec);
	
	      // Insert the new state as a child of the current state
	      this.nextStates.push(state);
	
	      // If this character specification repeats, insert the new state as a child
	      // of itself. Note that this will not trigger an infinite loop because each
	      // transition during recognition consumes a character.
	      if (charSpec.repeat) {
	        state.nextStates.push(state);
	      }
	
	      // Return the new state
	      return state;
	    },
	
	    // Find a list of child states matching the next character
	    match: function match(ch) {
	      // DEBUG "Processing `" + ch + "`:"
	      var nextStates = this.nextStates,
	          child,
	          charSpec,
	          chars;
	
	      // DEBUG "  " + debugState(this)
	      var returned = [];
	
	      for (var i = 0, l = nextStates.length; i < l; i++) {
	        child = nextStates[i];
	
	        charSpec = child.charSpec;
	
	        if (typeof (chars = charSpec.validChars) !== 'undefined') {
	          if (chars.indexOf(ch) !== -1) {
	            returned.push(child);
	          }
	        } else if (typeof (chars = charSpec.invalidChars) !== 'undefined') {
	          if (chars.indexOf(ch) === -1) {
	            returned.push(child);
	          }
	        }
	      }
	
	      return returned;
	    }
	
	    /** IF DEBUG
	    , debug: function() {
	      var charSpec = this.charSpec,
	          debug = "[",
	          chars = charSpec.validChars || charSpec.invalidChars;
	       if (charSpec.invalidChars) { debug += "^"; }
	      debug += chars;
	      debug += "]";
	       if (charSpec.repeat) { debug += "+"; }
	       return debug;
	    }
	    END IF **/
	  };
	
	  /** IF DEBUG
	  function debug(log) {
	    console.log(log);
	  }
	
	  function debugState(state) {
	    return state.nextStates.map(function(n) {
	      if (n.nextStates.length === 0) { return "( " + n.debug() + " [accepting] )"; }
	      return "( " + n.debug() + " <then> " + n.nextStates.map(function(s) { return s.debug() }).join(" or ") + " )";
	    }).join(", ")
	  }
	  END IF **/
	
	  // Sort the routes by specificity
	  function sortSolutions(states) {
	    return states.sort(function (a, b) {
	      return b.specificity.val - a.specificity.val;
	    });
	  }
	
	  function recognizeChar(states, ch) {
	    var nextStates = [];
	
	    for (var i = 0, l = states.length; i < l; i++) {
	      var state = states[i];
	
	      nextStates = nextStates.concat(state.match(ch));
	    }
	
	    return nextStates;
	  }
	
	  var oCreate = Object.create || function (proto) {
	    function F() {}
	    F.prototype = proto;
	    return new F();
	  };
	
	  function RecognizeResults(queryParams) {
	    this.queryParams = queryParams || {};
	  }
	  RecognizeResults.prototype = oCreate({
	    splice: Array.prototype.splice,
	    slice: Array.prototype.slice,
	    push: Array.prototype.push,
	    length: 0,
	    queryParams: null
	  });
	
	  function findHandler(state, path, queryParams) {
	    var handlers = state.handlers,
	        regex = state.regex;
	    var captures = path.match(regex),
	        currentCapture = 1;
	    var result = new RecognizeResults(queryParams);
	
	    for (var i = 0, l = handlers.length; i < l; i++) {
	      var handler = handlers[i],
	          names = handler.names,
	          params = {};
	
	      for (var j = 0, m = names.length; j < m; j++) {
	        params[names[j]] = captures[currentCapture++];
	      }
	
	      result.push({ handler: handler.handler, params: params, isDynamic: !!names.length });
	    }
	
	    return result;
	  }
	
	  function addSegment(currentState, segment) {
	    segment.eachChar(function (ch) {
	      var state;
	
	      currentState = currentState.put(ch);
	    });
	
	    return currentState;
	  }
	
	  function decodeQueryParamPart(part) {
	    // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.4.1
	    part = part.replace(/\+/gm, '%20');
	    return tryDecode(part, true);
	  }
	
	  // The main interface
	
	  var RouteRecognizer = function RouteRecognizer() {
	    this.rootState = new State();
	    this.names = {};
	  };
	
	  RouteRecognizer.prototype = {
	    add: function add(routes, options) {
	      var currentState = this.rootState,
	          regex = "^",
	          specificity = {},
	          handlers = [],
	          allSegments = [],
	          name;
	
	      var isEmpty = true;
	
	      for (var i = 0, l = routes.length; i < l; i++) {
	        var route = routes[i],
	            names = [];
	
	        var segments = parse(route.path, names, specificity);
	
	        allSegments = allSegments.concat(segments);
	
	        for (var j = 0, m = segments.length; j < m; j++) {
	          var segment = segments[j];
	
	          if (segment instanceof EpsilonSegment) {
	            continue;
	          }
	
	          isEmpty = false;
	
	          // Add a "/" for the new segment
	          currentState = currentState.put({ validChars: "/" });
	          regex += "/";
	
	          // Add a representation of the segment to the NFA and regex
	          currentState = addSegment(currentState, segment);
	          regex += segment.regex();
	        }
	
	        var handler = { handler: route.handler, names: names };
	        handlers.push(handler);
	      }
	
	      if (isEmpty) {
	        currentState = currentState.put({ validChars: "/" });
	        regex += "/";
	      }
	
	      currentState.handlers = handlers;
	      currentState.regex = new RegExp(regex + "$");
	      currentState.specificity = specificity;
	
	      if (name = options && options.as) {
	        this.names[name] = {
	          segments: allSegments,
	          handlers: handlers
	        };
	      }
	    },
	
	    handlersFor: function handlersFor(name) {
	      var route = this.names[name],
	          result = [];
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      for (var i = 0, l = route.handlers.length; i < l; i++) {
	        result.push(route.handlers[i]);
	      }
	
	      return result;
	    },
	
	    hasRoute: function hasRoute(name) {
	      return !!this.names[name];
	    },
	
	    generate: function generate(name, params) {
	      var route = this.names[name],
	          output = "";
	      if (!route) {
	        throw new Error("There is no route named " + name);
	      }
	
	      var segments = route.segments;
	
	      for (var i = 0, l = segments.length; i < l; i++) {
	        var segment = segments[i];
	
	        if (segment instanceof EpsilonSegment) {
	          continue;
	        }
	
	        output += "/";
	        output += segment.generate(params);
	      }
	
	      if (output.charAt(0) !== '/') {
	        output = '/' + output;
	      }
	
	      if (params && params.queryParams) {
	        output += this.generateQueryString(params.queryParams);
	      }
	
	      return output;
	    },
	
	    generateQueryString: function generateQueryString(params) {
	      var pairs = [];
	      var keys = [];
	      for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	          keys.push(key);
	        }
	      }
	      keys.sort();
	      for (var i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        var value = params[key];
	        if (value == null) {
	          continue;
	        }
	        var pair = encodeURIComponent(key);
	        if (isArray(value)) {
	          for (var j = 0, l = value.length; j < l; j++) {
	            var arrayPair = key + '[]' + '=' + encodeURIComponent(value[j]);
	            pairs.push(arrayPair);
	          }
	        } else {
	          pair += "=" + encodeURIComponent(value);
	          pairs.push(pair);
	        }
	      }
	
	      if (pairs.length === 0) {
	        return '';
	      }
	
	      return "?" + pairs.join("&");
	    },
	
	    parseQueryString: function parseQueryString(queryString) {
	      var pairs = queryString.split("&"),
	          queryParams = {};
	      for (var i = 0; i < pairs.length; i++) {
	        var pair = pairs[i].split('='),
	            key = decodeQueryParamPart(pair[0]),
	            keyLength = key.length,
	            isArray = false,
	            value;
	        if (pair.length === 1) {
	          value = 'true';
	        } else {
	          //Handle arrays
	          if (keyLength > 2 && key.slice(keyLength - 2) === '[]') {
	            isArray = true;
	            key = key.slice(0, keyLength - 2);
	            if (!queryParams[key]) {
	              queryParams[key] = [];
	            }
	          }
	          value = pair[1] ? decodeQueryParamPart(pair[1]) : '';
	        }
	        if (isArray) {
	          queryParams[key].push(value);
	        } else {
	          queryParams[key] = value;
	        }
	      }
	      return queryParams;
	    },
	
	    recognize: function recognize(path, silent) {
	      noWarning = silent;
	      var states = [this.rootState],
	          pathLen,
	          i,
	          l,
	          queryStart,
	          queryParams = {},
	          isSlashDropped = false;
	
	      queryStart = path.indexOf('?');
	      if (queryStart !== -1) {
	        var queryString = path.substr(queryStart + 1, path.length);
	        path = path.substr(0, queryStart);
	        if (queryString) {
	          queryParams = this.parseQueryString(queryString);
	        }
	      }
	
	      path = tryDecode(path);
	      if (!path) return;
	
	      // DEBUG GROUP path
	
	      if (path.charAt(0) !== "/") {
	        path = "/" + path;
	      }
	
	      pathLen = path.length;
	      if (pathLen > 1 && path.charAt(pathLen - 1) === "/") {
	        path = path.substr(0, pathLen - 1);
	        isSlashDropped = true;
	      }
	
	      for (i = 0, l = path.length; i < l; i++) {
	        states = recognizeChar(states, path.charAt(i));
	        if (!states.length) {
	          break;
	        }
	      }
	
	      // END DEBUG GROUP
	
	      var solutions = [];
	      for (i = 0, l = states.length; i < l; i++) {
	        if (states[i].handlers) {
	          solutions.push(states[i]);
	        }
	      }
	
	      states = sortSolutions(solutions);
	
	      var state = solutions[0];
	
	      if (state && state.handlers) {
	        // if a trailing slash was dropped and a star segment is the last segment
	        // specified, put the trailing slash back
	        if (isSlashDropped && state.regex.source.slice(-5) === "(.+)$") {
	          path = path + "/";
	        }
	        return findHandler(state, path, queryParams);
	      }
	    }
	  };
	
	  RouteRecognizer.prototype.map = map;
	
	  var genQuery = RouteRecognizer.prototype.generateQueryString;
	
	  // export default for holding the Vue reference
	  var exports$1 = {};
	  /**
	   * Warn stuff.
	   *
	   * @param {String} msg
	   */
	
	  function warn$1(msg) {
	    /* istanbul ignore next */
	    if (typeof console !== 'undefined') {
	      console.error('[vue-router] ' + msg);
	    }
	  }
	
	  /**
	   * Resolve a relative path.
	   *
	   * @param {String} base
	   * @param {String} relative
	   * @param {Boolean} append
	   * @return {String}
	   */
	
	  function resolvePath(base, relative, append) {
	    var query = base.match(/(\?.*)$/);
	    if (query) {
	      query = query[1];
	      base = base.slice(0, -query.length);
	    }
	    // a query!
	    if (relative.charAt(0) === '?') {
	      return base + relative;
	    }
	    var stack = base.split('/');
	    // remove trailing segment if:
	    // - not appending
	    // - appending to trailing slash (last segment is empty)
	    if (!append || !stack[stack.length - 1]) {
	      stack.pop();
	    }
	    // resolve relative path
	    var segments = relative.replace(/^\//, '').split('/');
	    for (var i = 0; i < segments.length; i++) {
	      var segment = segments[i];
	      if (segment === '.') {
	        continue;
	      } else if (segment === '..') {
	        stack.pop();
	      } else {
	        stack.push(segment);
	      }
	    }
	    // ensure leading slash
	    if (stack[0] !== '') {
	      stack.unshift('');
	    }
	    return stack.join('/');
	  }
	
	  /**
	   * Forgiving check for a promise
	   *
	   * @param {Object} p
	   * @return {Boolean}
	   */
	
	  function isPromise(p) {
	    return p && typeof p.then === 'function';
	  }
	
	  /**
	   * Retrive a route config field from a component instance
	   * OR a component contructor.
	   *
	   * @param {Function|Vue} component
	   * @param {String} name
	   * @return {*}
	   */
	
	  function getRouteConfig(component, name) {
	    var options = component && (component.$options || component.options);
	    return options && options.route && options.route[name];
	  }
	
	  /**
	   * Resolve an async component factory. Have to do a dirty
	   * mock here because of Vue core's internal API depends on
	   * an ID check.
	   *
	   * @param {Object} handler
	   * @param {Function} cb
	   */
	
	  var resolver = undefined;
	
	  function resolveAsyncComponent(handler, cb) {
	    if (!resolver) {
	      resolver = {
	        resolve: exports$1.Vue.prototype._resolveComponent,
	        $options: {
	          components: {
	            _: handler.component
	          }
	        }
	      };
	    } else {
	      resolver.$options.components._ = handler.component;
	    }
	    resolver.resolve('_', function (Component) {
	      handler.component = Component;
	      cb(Component);
	    });
	  }
	
	  /**
	   * Map the dynamic segments in a path to params.
	   *
	   * @param {String} path
	   * @param {Object} params
	   * @param {Object} query
	   */
	
	  function mapParams(path, params, query) {
	    if (params === undefined) params = {};
	
	    path = path.replace(/:([^\/]+)/g, function (_, key) {
	      var val = params[key];
	      /* istanbul ignore if */
	      if (!val) {
	        warn$1('param "' + key + '" not found when generating ' + 'path for "' + path + '" with params ' + JSON.stringify(params));
	      }
	      return val || '';
	    });
	    if (query) {
	      path += genQuery(query);
	    }
	    return path;
	  }
	
	  var hashRE = /#.*$/;
	
	  var HTML5History = (function () {
	    function HTML5History(_ref) {
	      var root = _ref.root;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HTML5History);
	
	      if (root && root !== '/') {
	        // make sure there's the starting slash
	        if (root.charAt(0) !== '/') {
	          root = '/' + root;
	        }
	        // remove trailing slash
	        this.root = root.replace(/\/$/, '');
	        this.rootRE = new RegExp('^\\' + this.root);
	      } else {
	        this.root = null;
	      }
	      this.onChange = onChange;
	      // check base tag
	      var baseEl = document.querySelector('base');
	      this.base = baseEl && baseEl.getAttribute('href');
	    }
	
	    HTML5History.prototype.start = function start() {
	      var _this = this;
	
	      this.listener = function (e) {
	        var url = location.pathname + location.search;
	        if (_this.root) {
	          url = url.replace(_this.rootRE, '');
	        }
	        _this.onChange(url, e && e.state, location.hash);
	      };
	      window.addEventListener('popstate', this.listener);
	      this.listener();
	    };
	
	    HTML5History.prototype.stop = function stop() {
	      window.removeEventListener('popstate', this.listener);
	    };
	
	    HTML5History.prototype.go = function go(path, replace, append) {
	      var url = this.formatPath(path, append);
	      if (replace) {
	        history.replaceState({}, '', url);
	      } else {
	        // record scroll position by replacing current state
	        history.replaceState({
	          pos: {
	            x: window.pageXOffset,
	            y: window.pageYOffset
	          }
	        }, '', location.href);
	        // then push new state
	        history.pushState({}, '', url);
	      }
	      var hashMatch = path.match(hashRE);
	      var hash = hashMatch && hashMatch[0];
	      path = url
	      // strip hash so it doesn't mess up params
	      .replace(hashRE, '')
	      // remove root before matching
	      .replace(this.rootRE, '');
	      this.onChange(path, null, hash);
	    };
	
	    HTML5History.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/'
	      // absolute path
	      ? this.root ? this.root + '/' + path.replace(/^\//, '') : path : resolvePath(this.base || location.pathname, path, append);
	    };
	
	    return HTML5History;
	  })();
	
	  var HashHistory = (function () {
	    function HashHistory(_ref) {
	      var hashbang = _ref.hashbang;
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, HashHistory);
	
	      this.hashbang = hashbang;
	      this.onChange = onChange;
	    }
	
	    HashHistory.prototype.start = function start() {
	      var self = this;
	      this.listener = function () {
	        var path = location.hash;
	        var raw = path.replace(/^#!?/, '');
	        // always
	        if (raw.charAt(0) !== '/') {
	          raw = '/' + raw;
	        }
	        var formattedPath = self.formatPath(raw);
	        if (formattedPath !== path) {
	          location.replace(formattedPath);
	          return;
	        }
	        // determine query
	        // note it's possible to have queries in both the actual URL
	        // and the hash fragment itself.
	        var query = location.search && path.indexOf('?') > -1 ? '&' + location.search.slice(1) : location.search;
	        self.onChange(path.replace(/^#!?/, '') + query);
	      };
	      window.addEventListener('hashchange', this.listener);
	      this.listener();
	    };
	
	    HashHistory.prototype.stop = function stop() {
	      window.removeEventListener('hashchange', this.listener);
	    };
	
	    HashHistory.prototype.go = function go(path, replace, append) {
	      path = this.formatPath(path, append);
	      if (replace) {
	        location.replace(path);
	      } else {
	        location.hash = path;
	      }
	    };
	
	    HashHistory.prototype.formatPath = function formatPath(path, append) {
	      var isAbsoloute = path.charAt(0) === '/';
	      var prefix = '#' + (this.hashbang ? '!' : '');
	      return isAbsoloute ? prefix + path : prefix + resolvePath(location.hash.replace(/^#!?/, ''), path, append);
	    };
	
	    return HashHistory;
	  })();
	
	  var AbstractHistory = (function () {
	    function AbstractHistory(_ref) {
	      var onChange = _ref.onChange;
	      babelHelpers.classCallCheck(this, AbstractHistory);
	
	      this.onChange = onChange;
	      this.currentPath = '/';
	    }
	
	    AbstractHistory.prototype.start = function start() {
	      this.onChange('/');
	    };
	
	    AbstractHistory.prototype.stop = function stop() {
	      // noop
	    };
	
	    AbstractHistory.prototype.go = function go(path, replace, append) {
	      path = this.currentPath = this.formatPath(path, append);
	      this.onChange(path);
	    };
	
	    AbstractHistory.prototype.formatPath = function formatPath(path, append) {
	      return path.charAt(0) === '/' ? path : resolvePath(this.currentPath, path, append);
	    };
	
	    return AbstractHistory;
	  })();
	
	  /**
	   * Determine the reusability of an existing router view.
	   *
	   * @param {Directive} view
	   * @param {Object} handler
	   * @param {Transition} transition
	   */
	
	  function canReuse(view, handler, transition) {
	    var component = view.childVM;
	    if (!component || !handler) {
	      return false;
	    }
	    // important: check view.Component here because it may
	    // have been changed in activate hook
	    if (view.Component !== handler.component) {
	      return false;
	    }
	    var canReuseFn = getRouteConfig(component, 'canReuse');
	    return typeof canReuseFn === 'boolean' ? canReuseFn : canReuseFn ? canReuseFn.call(component, {
	      to: transition.to,
	      from: transition.from
	    }) : true; // defaults to true
	  }
	
	  /**
	   * Check if a component can deactivate.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canDeactivate(view, transition, next) {
	    var fromComponent = view.childVM;
	    var hook = getRouteConfig(fromComponent, 'canDeactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHook(hook, fromComponent, next, {
	        expectBoolean: true
	      });
	    }
	  }
	
	  /**
	   * Check if a component can activate.
	   *
	   * @param {Object} handler
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function canActivate(handler, transition, next) {
	    resolveAsyncComponent(handler, function (Component) {
	      // have to check due to async-ness
	      if (transition.aborted) {
	        return;
	      }
	      // determine if this component can be activated
	      var hook = getRouteConfig(Component, 'canActivate');
	      if (!hook) {
	        next();
	      } else {
	        transition.callHook(hook, null, next, {
	          expectBoolean: true
	        });
	      }
	    });
	  }
	
	  /**
	   * Call deactivate hooks for existing router-views.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Function} next
	   */
	
	  function deactivate(view, transition, next) {
	    var component = view.childVM;
	    var hook = getRouteConfig(component, 'deactivate');
	    if (!hook) {
	      next();
	    } else {
	      transition.callHooks(hook, component, next);
	    }
	  }
	
	  /**
	   * Activate / switch component for a router-view.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   * @param {Number} depth
	   * @param {Function} [cb]
	   */
	
	  function activate(view, transition, depth, cb, reuse) {
	    var handler = transition.activateQueue[depth];
	    if (!handler) {
	      saveChildView(view);
	      if (view._bound) {
	        view.setComponent(null);
	      }
	      cb && cb();
	      return;
	    }
	
	    var Component = view.Component = handler.component;
	    var activateHook = getRouteConfig(Component, 'activate');
	    var dataHook = getRouteConfig(Component, 'data');
	    var waitForData = getRouteConfig(Component, 'waitForData');
	
	    view.depth = depth;
	    view.activated = false;
	
	    var component = undefined;
	    var loading = !!(dataHook && !waitForData);
	
	    // "reuse" is a flag passed down when the parent view is
	    // either reused via keep-alive or as a child of a kept-alive view.
	    // of course we can only reuse if the current kept-alive instance
	    // is of the correct type.
	    reuse = reuse && view.childVM && view.childVM.constructor === Component;
	
	    if (reuse) {
	      // just reuse
	      component = view.childVM;
	      component.$loadingRouteData = loading;
	    } else {
	      saveChildView(view);
	
	      // unbuild current component. this step also destroys
	      // and removes all nested child views.
	      view.unbuild(true);
	
	      // build the new component. this will also create the
	      // direct child view of the current one. it will register
	      // itself as view.childView.
	      component = view.build({
	        _meta: {
	          $loadingRouteData: loading
	        },
	        created: function created() {
	          this._routerView = view;
	        }
	      });
	
	      // handle keep-alive.
	      // when a kept-alive child vm is restored, we need to
	      // add its cached child views into the router's view list,
	      // and also properly update current view's child view.
	      if (view.keepAlive) {
	        component.$loadingRouteData = loading;
	        var cachedChildView = component._keepAliveRouterView;
	        if (cachedChildView) {
	          view.childView = cachedChildView;
	          component._keepAliveRouterView = null;
	        }
	      }
	    }
	
	    // cleanup the component in case the transition is aborted
	    // before the component is ever inserted.
	    var cleanup = function cleanup() {
	      component.$destroy();
	    };
	
	    // actually insert the component and trigger transition
	    var insert = function insert() {
	      if (reuse) {
	        cb && cb();
	        return;
	      }
	      var router = transition.router;
	      if (router._rendered || router._transitionOnLoad) {
	        view.transition(component);
	      } else {
	        // no transition on first render, manual transition
	        /* istanbul ignore if */
	        if (view.setCurrent) {
	          // 0.12 compat
	          view.setCurrent(component);
	        } else {
	          // 1.0
	          view.childVM = component;
	        }
	        component.$before(view.anchor, null, false);
	      }
	      cb && cb();
	    };
	
	    var afterData = function afterData() {
	      // activate the child view
	      if (view.childView) {
	        activate(view.childView, transition, depth + 1, null, reuse || view.keepAlive);
	      }
	      insert();
	    };
	
	    // called after activation hook is resolved
	    var afterActivate = function afterActivate() {
	      view.activated = true;
	      if (dataHook && waitForData) {
	        // wait until data loaded to insert
	        loadData(component, transition, dataHook, afterData, cleanup);
	      } else {
	        // load data and insert at the same time
	        if (dataHook) {
	          loadData(component, transition, dataHook);
	        }
	        afterData();
	      }
	    };
	
	    if (activateHook) {
	      transition.callHooks(activateHook, component, afterActivate, {
	        cleanup: cleanup,
	        postActivate: true
	      });
	    } else {
	      afterActivate();
	    }
	  }
	
	  /**
	   * Reuse a view, just reload data if necessary.
	   *
	   * @param {Directive} view
	   * @param {Transition} transition
	   */
	
	  function reuse(view, transition) {
	    var component = view.childVM;
	    var dataHook = getRouteConfig(component, 'data');
	    if (dataHook) {
	      loadData(component, transition, dataHook);
	    }
	  }
	
	  /**
	   * Asynchronously load and apply data to component.
	   *
	   * @param {Vue} component
	   * @param {Transition} transition
	   * @param {Function} hook
	   * @param {Function} cb
	   * @param {Function} cleanup
	   */
	
	  function loadData(component, transition, hook, cb, cleanup) {
	    component.$loadingRouteData = true;
	    transition.callHooks(hook, component, function () {
	      component.$loadingRouteData = false;
	      component.$emit('route-data-loaded', component);
	      cb && cb();
	    }, {
	      cleanup: cleanup,
	      postActivate: true,
	      processData: function processData(data) {
	        // handle promise sugar syntax
	        var promises = [];
	        if (isPlainObject(data)) {
	          Object.keys(data).forEach(function (key) {
	            var val = data[key];
	            if (isPromise(val)) {
	              promises.push(val.then(function (resolvedVal) {
	                component.$set(key, resolvedVal);
	              }));
	            } else {
	              component.$set(key, val);
	            }
	          });
	        }
	        if (promises.length) {
	          return promises[0].constructor.all(promises);
	        }
	      }
	    });
	  }
	
	  /**
	   * Save the child view for a kept-alive view so that
	   * we can restore it when it is switched back to.
	   *
	   * @param {Directive} view
	   */
	
	  function saveChildView(view) {
	    if (view.keepAlive && view.childVM && view.childView) {
	      view.childVM._keepAliveRouterView = view.childView;
	    }
	    view.childView = null;
	  }
	
	  /**
	   * Check plain object.
	   *
	   * @param {*} val
	   */
	
	  function isPlainObject(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  /**
	   * A RouteTransition object manages the pipeline of a
	   * router-view switching process. This is also the object
	   * passed into user route hooks.
	   *
	   * @param {Router} router
	   * @param {Route} to
	   * @param {Route} from
	   */
	
	  var RouteTransition = (function () {
	    function RouteTransition(router, to, from) {
	      babelHelpers.classCallCheck(this, RouteTransition);
	
	      this.router = router;
	      this.to = to;
	      this.from = from;
	      this.next = null;
	      this.aborted = false;
	      this.done = false;
	    }
	
	    /**
	     * Abort current transition and return to previous location.
	     */
	
	    RouteTransition.prototype.abort = function abort() {
	      if (!this.aborted) {
	        this.aborted = true;
	        // if the root path throws an error during validation
	        // on initial load, it gets caught in an infinite loop.
	        var abortingOnLoad = !this.from.path && this.to.path === '/';
	        if (!abortingOnLoad) {
	          this.router.replace(this.from.path || '/');
	        }
	      }
	    };
	
	    /**
	     * Abort current transition and redirect to a new location.
	     *
	     * @param {String} path
	     */
	
	    RouteTransition.prototype.redirect = function redirect(path) {
	      if (!this.aborted) {
	        this.aborted = true;
	        if (typeof path === 'string') {
	          path = mapParams(path, this.to.params, this.to.query);
	        } else {
	          path.params = path.params || this.to.params;
	          path.query = path.query || this.to.query;
	        }
	        this.router.replace(path);
	      }
	    };
	
	    /**
	     * A router view transition's pipeline can be described as
	     * follows, assuming we are transitioning from an existing
	     * <router-view> chain [Component A, Component B] to a new
	     * chain [Component A, Component C]:
	     *
	     *  A    A
	     *  | => |
	     *  B    C
	     *
	     * 1. Reusablity phase:
	     *   -> canReuse(A, A)
	     *   -> canReuse(B, C)
	     *   -> determine new queues:
	     *      - deactivation: [B]
	     *      - activation: [C]
	     *
	     * 2. Validation phase:
	     *   -> canDeactivate(B)
	     *   -> canActivate(C)
	     *
	     * 3. Activation phase:
	     *   -> deactivate(B)
	     *   -> activate(C)
	     *
	     * Each of these steps can be asynchronous, and any
	     * step can potentially abort the transition.
	     *
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.start = function start(cb) {
	      var transition = this;
	
	      // determine the queue of views to deactivate
	      var deactivateQueue = [];
	      var view = this.router._rootView;
	      while (view) {
	        deactivateQueue.unshift(view);
	        view = view.childView;
	      }
	      var reverseDeactivateQueue = deactivateQueue.slice().reverse();
	
	      // determine the queue of route handlers to activate
	      var activateQueue = this.activateQueue = toArray(this.to.matched).map(function (match) {
	        return match.handler;
	      });
	
	      // 1. Reusability phase
	      var i = undefined,
	          reuseQueue = undefined;
	      for (i = 0; i < reverseDeactivateQueue.length; i++) {
	        if (!canReuse(reverseDeactivateQueue[i], activateQueue[i], transition)) {
	          break;
	        }
	      }
	      if (i > 0) {
	        reuseQueue = reverseDeactivateQueue.slice(0, i);
	        deactivateQueue = reverseDeactivateQueue.slice(i).reverse();
	        activateQueue = activateQueue.slice(i);
	      }
	
	      // 2. Validation phase
	      transition.runQueue(deactivateQueue, canDeactivate, function () {
	        transition.runQueue(activateQueue, canActivate, function () {
	          transition.runQueue(deactivateQueue, deactivate, function () {
	            // 3. Activation phase
	
	            // Update router current route
	            transition.router._onTransitionValidated(transition);
	
	            // trigger reuse for all reused views
	            reuseQueue && reuseQueue.forEach(function (view) {
	              return reuse(view, transition);
	            });
	
	            // the root of the chain that needs to be replaced
	            // is the top-most non-reusable view.
	            if (deactivateQueue.length) {
	              var _view = deactivateQueue[deactivateQueue.length - 1];
	              var depth = reuseQueue ? reuseQueue.length : 0;
	              activate(_view, transition, depth, cb);
	            } else {
	              cb();
	            }
	          });
	        });
	      });
	    };
	
	    /**
	     * Asynchronously and sequentially apply a function to a
	     * queue.
	     *
	     * @param {Array} queue
	     * @param {Function} fn
	     * @param {Function} cb
	     */
	
	    RouteTransition.prototype.runQueue = function runQueue(queue, fn, cb) {
	      var transition = this;
	      step(0);
	      function step(index) {
	        if (index >= queue.length) {
	          cb();
	        } else {
	          fn(queue[index], transition, function () {
	            step(index + 1);
	          });
	        }
	      }
	    };
	
	    /**
	     * Call a user provided route transition hook and handle
	     * the response (e.g. if the user returns a promise).
	     *
	     * If the user neither expects an argument nor returns a
	     * promise, the hook is assumed to be synchronous.
	     *
	     * @param {Function} hook
	     * @param {*} [context]
	     * @param {Function} [cb]
	     * @param {Object} [options]
	     *                 - {Boolean} expectBoolean
	     *                 - {Boolean} postActive
	     *                 - {Function} processData
	     *                 - {Function} cleanup
	     */
	
	    RouteTransition.prototype.callHook = function callHook(hook, context, cb) {
	      var _ref = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	      var _ref$expectBoolean = _ref.expectBoolean;
	      var expectBoolean = _ref$expectBoolean === undefined ? false : _ref$expectBoolean;
	      var _ref$postActivate = _ref.postActivate;
	      var postActivate = _ref$postActivate === undefined ? false : _ref$postActivate;
	      var processData = _ref.processData;
	      var cleanup = _ref.cleanup;
	
	      var transition = this;
	      var nextCalled = false;
	
	      // abort the transition
	      var abort = function abort() {
	        cleanup && cleanup();
	        transition.abort();
	      };
	
	      // handle errors
	      var onError = function onError(err) {
	        postActivate ? next() : abort();
	        if (err && !transition.router._suppress) {
	          warn$1('Uncaught error during transition: ');
	          throw err instanceof Error ? err : new Error(err);
	        }
	      };
	
	      // since promise swallows errors, we have to
	      // throw it in the next tick...
	      var onPromiseError = function onPromiseError(err) {
	        try {
	          onError(err);
	        } catch (e) {
	          setTimeout(function () {
	            throw e;
	          }, 0);
	        }
	      };
	
	      // advance the transition to the next step
	      var next = function next() {
	        if (nextCalled) {
	          warn$1('transition.next() should be called only once.');
	          return;
	        }
	        nextCalled = true;
	        if (transition.aborted) {
	          cleanup && cleanup();
	          return;
	        }
	        cb && cb();
	      };
	
	      var nextWithBoolean = function nextWithBoolean(res) {
	        if (typeof res === 'boolean') {
	          res ? next() : abort();
	        } else if (isPromise(res)) {
	          res.then(function (ok) {
	            ok ? next() : abort();
	          }, onPromiseError);
	        } else if (!hook.length) {
	          next();
	        }
	      };
	
	      var nextWithData = function nextWithData(data) {
	        var res = undefined;
	        try {
	          res = processData(data);
	        } catch (err) {
	          return onError(err);
	        }
	        if (isPromise(res)) {
	          res.then(next, onPromiseError);
	        } else {
	          next();
	        }
	      };
	
	      // expose a clone of the transition object, so that each
	      // hook gets a clean copy and prevent the user from
	      // messing with the internals.
	      var exposed = {
	        to: transition.to,
	        from: transition.from,
	        abort: abort,
	        next: processData ? nextWithData : next,
	        redirect: function redirect() {
	          transition.redirect.apply(transition, arguments);
	        }
	      };
	
	      // actually call the hook
	      var res = undefined;
	      try {
	        res = hook.call(context, exposed);
	      } catch (err) {
	        return onError(err);
	      }
	
	      if (expectBoolean) {
	        // boolean hooks
	        nextWithBoolean(res);
	      } else if (isPromise(res)) {
	        // promise
	        if (processData) {
	          res.then(nextWithData, onPromiseError);
	        } else {
	          res.then(next, onPromiseError);
	        }
	      } else if (processData && isPlainOjbect(res)) {
	        // data promise sugar
	        nextWithData(res);
	      } else if (!hook.length) {
	        next();
	      }
	    };
	
	    /**
	     * Call a single hook or an array of async hooks in series.
	     *
	     * @param {Array} hooks
	     * @param {*} context
	     * @param {Function} cb
	     * @param {Object} [options]
	     */
	
	    RouteTransition.prototype.callHooks = function callHooks(hooks, context, cb, options) {
	      var _this = this;
	
	      if (Array.isArray(hooks)) {
	        this.runQueue(hooks, function (hook, _, next) {
	          if (!_this.aborted) {
	            _this.callHook(hook, context, next, options);
	          }
	        }, cb);
	      } else {
	        this.callHook(hooks, context, cb, options);
	      }
	    };
	
	    return RouteTransition;
	  })();
	
	  function isPlainOjbect(val) {
	    return Object.prototype.toString.call(val) === '[object Object]';
	  }
	
	  function toArray(val) {
	    return val ? Array.prototype.slice.call(val) : [];
	  }
	
	  var internalKeysRE = /^(component|subRoutes|fullPath)$/;
	
	  /**
	   * Route Context Object
	   *
	   * @param {String} path
	   * @param {Router} router
	   */
	
	  var Route = function Route(path, router) {
	    var _this = this;
	
	    babelHelpers.classCallCheck(this, Route);
	
	    var matched = router._recognizer.recognize(path);
	    if (matched) {
	      // copy all custom fields from route configs
	      [].forEach.call(matched, function (match) {
	        for (var key in match.handler) {
	          if (!internalKeysRE.test(key)) {
	            _this[key] = match.handler[key];
	          }
	        }
	      });
	      // set query and params
	      this.query = matched.queryParams;
	      this.params = [].reduce.call(matched, function (prev, cur) {
	        if (cur.params) {
	          for (var key in cur.params) {
	            prev[key] = cur.params[key];
	          }
	        }
	        return prev;
	      }, {});
	    }
	    // expose path and router
	    this.path = path;
	    // for internal use
	    this.matched = matched || router._notFoundHandler;
	    // internal reference to router
	    Object.defineProperty(this, 'router', {
	      enumerable: false,
	      value: router
	    });
	    // Important: freeze self to prevent observation
	    Object.freeze(this);
	  };
	
	  function applyOverride (Vue) {
	    var _Vue$util = Vue.util;
	    var extend = _Vue$util.extend;
	    var isArray = _Vue$util.isArray;
	    var defineReactive = _Vue$util.defineReactive;
	
	    // override Vue's init and destroy process to keep track of router instances
	    var init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      options = options || {};
	      var root = options._parent || options.parent || this;
	      var router = root.$router;
	      var route = root.$route;
	      if (router) {
	        // expose router
	        this.$router = router;
	        router._children.push(this);
	        /* istanbul ignore if */
	        if (this._defineMeta) {
	          // 0.12
	          this._defineMeta('$route', route);
	        } else {
	          // 1.0
	          defineReactive(this, '$route', route);
	        }
	      }
	      init.call(this, options);
	    };
	
	    var destroy = Vue.prototype._destroy;
	    Vue.prototype._destroy = function () {
	      if (!this._isBeingDestroyed && this.$router) {
	        this.$router._children.$remove(this);
	      }
	      destroy.apply(this, arguments);
	    };
	
	    // 1.0 only: enable route mixins
	    var strats = Vue.config.optionMergeStrategies;
	    var hooksToMergeRE = /^(data|activate|deactivate)$/;
	
	    if (strats) {
	      strats.route = function (parentVal, childVal) {
	        if (!childVal) return parentVal;
	        if (!parentVal) return childVal;
	        var ret = {};
	        extend(ret, parentVal);
	        for (var key in childVal) {
	          var a = ret[key];
	          var b = childVal[key];
	          // for data, activate and deactivate, we need to merge them into
	          // arrays similar to lifecycle hooks.
	          if (a && hooksToMergeRE.test(key)) {
	            ret[key] = (isArray(a) ? a : [a]).concat(b);
	          } else {
	            ret[key] = b;
	          }
	        }
	        return ret;
	      };
	    }
	  }
	
	  function View (Vue) {
	
	    var _ = Vue.util;
	    var componentDef =
	    // 0.12
	    Vue.directive('_component') ||
	    // 1.0
	    Vue.internalDirectives.component;
	    // <router-view> extends the internal component directive
	    var viewDef = _.extend({}, componentDef);
	
	    // with some overrides
	    _.extend(viewDef, {
	
	      _isRouterView: true,
	
	      bind: function bind() {
	        var route = this.vm.$route;
	        /* istanbul ignore if */
	        if (!route) {
	          warn$1('<router-view> can only be used inside a ' + 'router-enabled app.');
	          return;
	        }
	        // force dynamic directive so v-component doesn't
	        // attempt to build right now
	        this._isDynamicLiteral = true;
	        // finally, init by delegating to v-component
	        componentDef.bind.call(this);
	
	        // locate the parent view
	        var parentView = undefined;
	        var parent = this.vm;
	        while (parent) {
	          if (parent._routerView) {
	            parentView = parent._routerView;
	            break;
	          }
	          parent = parent.$parent;
	        }
	        if (parentView) {
	          // register self as a child of the parent view,
	          // instead of activating now. This is so that the
	          // child's activate hook is called after the
	          // parent's has resolved.
	          this.parentView = parentView;
	          parentView.childView = this;
	        } else {
	          // this is the root view!
	          var router = route.router;
	          router._rootView = this;
	        }
	
	        // handle late-rendered view
	        // two possibilities:
	        // 1. root view rendered after transition has been
	        //    validated;
	        // 2. child view rendered after parent view has been
	        //    activated.
	        var transition = route.router._currentTransition;
	        if (!parentView && transition.done || parentView && parentView.activated) {
	          var depth = parentView ? parentView.depth + 1 : 0;
	          activate(this, transition, depth);
	        }
	      },
	
	      unbind: function unbind() {
	        if (this.parentView) {
	          this.parentView.childView = null;
	        }
	        componentDef.unbind.call(this);
	      }
	    });
	
	    Vue.elementDirective('router-view', viewDef);
	  }
	
	  var trailingSlashRE = /\/$/;
	  var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	  var queryStringRE = /\?.*$/;
	
	  // install v-link, which provides navigation support for
	  // HTML5 history mode
	  function Link (Vue) {
	    var _Vue$util = Vue.util;
	    var _bind = _Vue$util.bind;
	    var isObject = _Vue$util.isObject;
	    var addClass = _Vue$util.addClass;
	    var removeClass = _Vue$util.removeClass;
	
	    var onPriority = Vue.directive('on').priority;
	    var LINK_UPDATE = '__vue-router-link-update__';
	
	    var activeId = 0;
	
	    Vue.directive('link-active', {
	      priority: 9999,
	      bind: function bind() {
	        var _this = this;
	
	        var id = String(activeId++);
	        // collect v-links contained within this element.
	        // we need do this here before the parent-child relationship
	        // gets messed up by terminal directives (if, for, components)
	        var childLinks = this.el.querySelectorAll('[v-link]');
	        for (var i = 0, l = childLinks.length; i < l; i++) {
	          var link = childLinks[i];
	          var existingId = link.getAttribute(LINK_UPDATE);
	          var value = existingId ? existingId + ',' + id : id;
	          // leave a mark on the link element which can be persisted
	          // through fragment clones.
	          link.setAttribute(LINK_UPDATE, value);
	        }
	        this.vm.$on(LINK_UPDATE, this.cb = function (link, path) {
	          if (link.activeIds.indexOf(id) > -1) {
	            link.updateClasses(path, _this.el);
	          }
	        });
	      },
	      unbind: function unbind() {
	        this.vm.$off(LINK_UPDATE, this.cb);
	      }
	    });
	
	    Vue.directive('link', {
	      priority: onPriority - 2,
	
	      bind: function bind() {
	        var vm = this.vm;
	        /* istanbul ignore if */
	        if (!vm.$route) {
	          warn$1('v-link can only be used inside a router-enabled app.');
	          return;
	        }
	        this.router = vm.$route.router;
	        // update things when the route changes
	        this.unwatch = vm.$watch('$route', _bind(this.onRouteUpdate, this));
	        // check v-link-active ids
	        var activeIds = this.el.getAttribute(LINK_UPDATE);
	        if (activeIds) {
	          this.el.removeAttribute(LINK_UPDATE);
	          this.activeIds = activeIds.split(',');
	        }
	        // no need to handle click if link expects to be opened
	        // in a new window/tab.
	        /* istanbul ignore if */
	        if (this.el.tagName === 'A' && this.el.getAttribute('target') === '_blank') {
	          return;
	        }
	        // handle click
	        this.handler = _bind(this.onClick, this);
	        this.el.addEventListener('click', this.handler);
	      },
	
	      update: function update(target) {
	        this.target = target;
	        if (isObject(target)) {
	          this.append = target.append;
	          this.exact = target.exact;
	          this.prevActiveClass = this.activeClass;
	          this.activeClass = target.activeClass;
	        }
	        this.onRouteUpdate(this.vm.$route);
	      },
	
	      onClick: function onClick(e) {
	        // don't redirect with control keys
	        /* istanbul ignore if */
	        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
	        // don't redirect when preventDefault called
	        /* istanbul ignore if */
	        if (e.defaultPrevented) return;
	        // don't redirect on right click
	        /* istanbul ignore if */
	        if (e.button !== 0) return;
	
	        var target = this.target;
	        if (target) {
	          // v-link with expression, just go
	          e.preventDefault();
	          this.router.go(target);
	        } else {
	          // no expression, delegate for an <a> inside
	          var el = e.target;
	          while (el.tagName !== 'A' && el !== this.el) {
	            el = el.parentNode;
	          }
	          if (el.tagName === 'A' && sameOrigin(el)) {
	            e.preventDefault();
	            var path = el.pathname;
	            if (this.router.history.root) {
	              path = path.replace(this.router.history.rootRE, '');
	            }
	            this.router.go({
	              path: path,
	              replace: target && target.replace,
	              append: target && target.append
	            });
	          }
	        }
	      },
	
	      onRouteUpdate: function onRouteUpdate(route) {
	        // router.stringifyPath is dependent on current route
	        // and needs to be called again whenver route changes.
	        var newPath = this.router.stringifyPath(this.target);
	        if (this.path !== newPath) {
	          this.path = newPath;
	          this.updateActiveMatch();
	          this.updateHref();
	        }
	        if (this.activeIds) {
	          this.vm.$emit(LINK_UPDATE, this, route.path);
	        } else {
	          this.updateClasses(route.path, this.el);
	        }
	      },
	
	      updateActiveMatch: function updateActiveMatch() {
	        this.activeRE = this.path && !this.exact ? new RegExp('^' + this.path.replace(/\/$/, '').replace(queryStringRE, '').replace(regexEscapeRE, '\\$&') + '(\\/|$)') : null;
	      },
	
	      updateHref: function updateHref() {
	        if (this.el.tagName !== 'A') {
	          return;
	        }
	        var path = this.path;
	        var router = this.router;
	        var isAbsolute = path.charAt(0) === '/';
	        // do not format non-hash relative paths
	        var href = path && (router.mode === 'hash' || isAbsolute) ? router.history.formatPath(path, this.append) : path;
	        if (href) {
	          this.el.href = href;
	        } else {
	          this.el.removeAttribute('href');
	        }
	      },
	
	      updateClasses: function updateClasses(path, el) {
	        var activeClass = this.activeClass || this.router._linkActiveClass;
	        // clear old class
	        if (this.prevActiveClass && this.prevActiveClass !== activeClass) {
	          toggleClasses(el, this.prevActiveClass, removeClass);
	        }
	        // remove query string before matching
	        var dest = this.path.replace(queryStringRE, '');
	        path = path.replace(queryStringRE, '');
	        // add new class
	        if (this.exact) {
	          if (dest === path ||
	          // also allow additional trailing slash
	          dest.charAt(dest.length - 1) !== '/' && dest === path.replace(trailingSlashRE, '')) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        } else {
	          if (this.activeRE && this.activeRE.test(path)) {
	            toggleClasses(el, activeClass, addClass);
	          } else {
	            toggleClasses(el, activeClass, removeClass);
	          }
	        }
	      },
	
	      unbind: function unbind() {
	        this.el.removeEventListener('click', this.handler);
	        this.unwatch && this.unwatch();
	      }
	    });
	
	    function sameOrigin(link) {
	      return link.protocol === location.protocol && link.hostname === location.hostname && link.port === location.port;
	    }
	
	    // this function is copied from v-bind:class implementation until
	    // we properly expose it...
	    function toggleClasses(el, key, fn) {
	      key = key.trim();
	      if (key.indexOf(' ') === -1) {
	        fn(el, key);
	        return;
	      }
	      var keys = key.split(/\s+/);
	      for (var i = 0, l = keys.length; i < l; i++) {
	        fn(el, keys[i]);
	      }
	    }
	  }
	
	  var historyBackends = {
	    abstract: AbstractHistory,
	    hash: HashHistory,
	    html5: HTML5History
	  };
	
	  // late bind during install
	  var Vue = undefined;
	
	  /**
	   * Router constructor
	   *
	   * @param {Object} [options]
	   */
	
	  var Router = (function () {
	    function Router() {
	      var _this = this;
	
	      var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      var _ref$hashbang = _ref.hashbang;
	      var hashbang = _ref$hashbang === undefined ? true : _ref$hashbang;
	      var _ref$abstract = _ref.abstract;
	      var abstract = _ref$abstract === undefined ? false : _ref$abstract;
	      var _ref$history = _ref.history;
	      var history = _ref$history === undefined ? false : _ref$history;
	      var _ref$saveScrollPosition = _ref.saveScrollPosition;
	      var saveScrollPosition = _ref$saveScrollPosition === undefined ? false : _ref$saveScrollPosition;
	      var _ref$transitionOnLoad = _ref.transitionOnLoad;
	      var transitionOnLoad = _ref$transitionOnLoad === undefined ? false : _ref$transitionOnLoad;
	      var _ref$suppressTransitionError = _ref.suppressTransitionError;
	      var suppressTransitionError = _ref$suppressTransitionError === undefined ? false : _ref$suppressTransitionError;
	      var _ref$root = _ref.root;
	      var root = _ref$root === undefined ? null : _ref$root;
	      var _ref$linkActiveClass = _ref.linkActiveClass;
	      var linkActiveClass = _ref$linkActiveClass === undefined ? 'v-link-active' : _ref$linkActiveClass;
	      babelHelpers.classCallCheck(this, Router);
	
	      /* istanbul ignore if */
	      if (!Router.installed) {
	        throw new Error('Please install the Router with Vue.use() before ' + 'creating an instance.');
	      }
	
	      // Vue instances
	      this.app = null;
	      this._children = [];
	
	      // route recognizer
	      this._recognizer = new RouteRecognizer();
	      this._guardRecognizer = new RouteRecognizer();
	
	      // state
	      this._started = false;
	      this._startCb = null;
	      this._currentRoute = {};
	      this._currentTransition = null;
	      this._previousTransition = null;
	      this._notFoundHandler = null;
	      this._notFoundRedirect = null;
	      this._beforeEachHooks = [];
	      this._afterEachHooks = [];
	
	      // trigger transition on initial render?
	      this._rendered = false;
	      this._transitionOnLoad = transitionOnLoad;
	
	      // history mode
	      this._root = root;
	      this._abstract = abstract;
	      this._hashbang = hashbang;
	
	      // check if HTML5 history is available
	      var hasPushState = typeof window !== 'undefined' && window.history && window.history.pushState;
	      this._history = history && hasPushState;
	      this._historyFallback = history && !hasPushState;
	
	      // create history object
	      var inBrowser = Vue.util.inBrowser;
	      this.mode = !inBrowser || this._abstract ? 'abstract' : this._history ? 'html5' : 'hash';
	
	      var History = historyBackends[this.mode];
	      this.history = new History({
	        root: root,
	        hashbang: this._hashbang,
	        onChange: function onChange(path, state, anchor) {
	          _this._match(path, state, anchor);
	        }
	      });
	
	      // other options
	      this._saveScrollPosition = saveScrollPosition;
	      this._linkActiveClass = linkActiveClass;
	      this._suppress = suppressTransitionError;
	    }
	
	    /**
	     * Allow directly passing components to a route
	     * definition.
	     *
	     * @param {String} path
	     * @param {Object} handler
	     */
	
	    // API ===================================================
	
	    /**
	    * Register a map of top-level paths.
	    *
	    * @param {Object} map
	    */
	
	    Router.prototype.map = function map(_map) {
	      for (var route in _map) {
	        this.on(route, _map[route]);
	      }
	      return this;
	    };
	
	    /**
	     * Register a single root-level path
	     *
	     * @param {String} rootPath
	     * @param {Object} handler
	     *                 - {String} component
	     *                 - {Object} [subRoutes]
	     *                 - {Boolean} [forceRefresh]
	     *                 - {Function} [before]
	     *                 - {Function} [after]
	     */
	
	    Router.prototype.on = function on(rootPath, handler) {
	      if (rootPath === '*') {
	        this._notFound(handler);
	      } else {
	        this._addRoute(rootPath, handler, []);
	      }
	      return this;
	    };
	
	    /**
	     * Set redirects.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.redirect = function redirect(map) {
	      for (var path in map) {
	        this._addRedirect(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set aliases.
	     *
	     * @param {Object} map
	     */
	
	    Router.prototype.alias = function alias(map) {
	      for (var path in map) {
	        this._addAlias(path, map[path]);
	      }
	      return this;
	    };
	
	    /**
	     * Set global before hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.beforeEach = function beforeEach(fn) {
	      this._beforeEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Set global after hook.
	     *
	     * @param {Function} fn
	     */
	
	    Router.prototype.afterEach = function afterEach(fn) {
	      this._afterEachHooks.push(fn);
	      return this;
	    };
	
	    /**
	     * Navigate to a given path.
	     * The path can be an object describing a named path in
	     * the format of { name: '...', params: {}, query: {}}
	     * The path is assumed to be already decoded, and will
	     * be resolved against root (if provided)
	     *
	     * @param {String|Object} path
	     * @param {Boolean} [replace]
	     */
	
	    Router.prototype.go = function go(path) {
	      var replace = false;
	      var append = false;
	      if (Vue.util.isObject(path)) {
	        replace = path.replace;
	        append = path.append;
	      }
	      path = this.stringifyPath(path);
	      if (path) {
	        this.history.go(path, replace, append);
	      }
	    };
	
	    /**
	     * Short hand for replacing current path
	     *
	     * @param {String} path
	     */
	
	    Router.prototype.replace = function replace(path) {
	      if (typeof path === 'string') {
	        path = { path: path };
	      }
	      path.replace = true;
	      this.go(path);
	    };
	
	    /**
	     * Start the router.
	     *
	     * @param {VueConstructor} App
	     * @param {String|Element} container
	     * @param {Function} [cb]
	     */
	
	    Router.prototype.start = function start(App, container, cb) {
	      /* istanbul ignore if */
	      if (this._started) {
	        warn$1('already started.');
	        return;
	      }
	      this._started = true;
	      this._startCb = cb;
	      if (!this.app) {
	        /* istanbul ignore if */
	        if (!App || !container) {
	          throw new Error('Must start vue-router with a component and a ' + 'root container.');
	        }
	        /* istanbul ignore if */
	        if (App instanceof Vue) {
	          throw new Error('Must start vue-router with a component, not a ' + 'Vue instance.');
	        }
	        this._appContainer = container;
	        var Ctor = this._appConstructor = typeof App === 'function' ? App : Vue.extend(App);
	        // give it a name for better debugging
	        Ctor.options.name = Ctor.options.name || 'RouterApp';
	      }
	
	      // handle history fallback in browsers that do not
	      // support HTML5 history API
	      if (this._historyFallback) {
	        var _location = window.location;
	        var _history = new HTML5History({ root: this._root });
	        var path = _history.root ? _location.pathname.replace(_history.rootRE, '') : _location.pathname;
	        if (path && path !== '/') {
	          _location.assign((_history.root || '') + '/' + this.history.formatPath(path) + _location.search);
	          return;
	        }
	      }
	
	      this.history.start();
	    };
	
	    /**
	     * Stop listening to route changes.
	     */
	
	    Router.prototype.stop = function stop() {
	      this.history.stop();
	      this._started = false;
	    };
	
	    /**
	     * Normalize named route object / string paths into
	     * a string.
	     *
	     * @param {Object|String|Number} path
	     * @return {String}
	     */
	
	    Router.prototype.stringifyPath = function stringifyPath(path) {
	      var generatedPath = '';
	      if (path && typeof path === 'object') {
	        if (path.name) {
	          var extend = Vue.util.extend;
	          var currentParams = this._currentTransition && this._currentTransition.to.params;
	          var targetParams = path.params || {};
	          var params = currentParams ? extend(extend({}, currentParams), targetParams) : targetParams;
	          generatedPath = encodeURI(this._recognizer.generate(path.name, params));
	        } else if (path.path) {
	          generatedPath = encodeURI(path.path);
	        }
	        if (path.query) {
	          // note: the generated query string is pre-URL-encoded by the recognizer
	          var query = this._recognizer.generateQueryString(path.query);
	          if (generatedPath.indexOf('?') > -1) {
	            generatedPath += '&' + query.slice(1);
	          } else {
	            generatedPath += query;
	          }
	        }
	      } else {
	        generatedPath = encodeURI(path ? path + '' : '');
	      }
	      return generatedPath;
	    };
	
	    // Internal methods ======================================
	
	    /**
	    * Add a route containing a list of segments to the internal
	    * route recognizer. Will be called recursively to add all
	    * possible sub-routes.
	    *
	    * @param {String} path
	    * @param {Object} handler
	    * @param {Array} segments
	    */
	
	    Router.prototype._addRoute = function _addRoute(path, handler, segments) {
	      guardComponent(path, handler);
	      handler.path = path;
	      handler.fullPath = (segments.reduce(function (path, segment) {
	        return path + segment.path;
	      }, '') + path).replace('//', '/');
	      segments.push({
	        path: path,
	        handler: handler
	      });
	      this._recognizer.add(segments, {
	        as: handler.name
	      });
	      // add sub routes
	      if (handler.subRoutes) {
	        for (var subPath in handler.subRoutes) {
	          // recursively walk all sub routes
	          this._addRoute(subPath, handler.subRoutes[subPath],
	          // pass a copy in recursion to avoid mutating
	          // across branches
	          segments.slice());
	        }
	      }
	    };
	
	    /**
	     * Set the notFound route handler.
	     *
	     * @param {Object} handler
	     */
	
	    Router.prototype._notFound = function _notFound(handler) {
	      guardComponent('*', handler);
	      this._notFoundHandler = [{ handler: handler }];
	    };
	
	    /**
	     * Add a redirect record.
	     *
	     * @param {String} path
	     * @param {String} redirectPath
	     */
	
	    Router.prototype._addRedirect = function _addRedirect(path, redirectPath) {
	      if (path === '*') {
	        this._notFoundRedirect = redirectPath;
	      } else {
	        this._addGuard(path, redirectPath, this.replace);
	      }
	    };
	
	    /**
	     * Add an alias record.
	     *
	     * @param {String} path
	     * @param {String} aliasPath
	     */
	
	    Router.prototype._addAlias = function _addAlias(path, aliasPath) {
	      this._addGuard(path, aliasPath, this._match);
	    };
	
	    /**
	     * Add a path guard.
	     *
	     * @param {String} path
	     * @param {String} mappedPath
	     * @param {Function} handler
	     */
	
	    Router.prototype._addGuard = function _addGuard(path, mappedPath, _handler) {
	      var _this2 = this;
	
	      this._guardRecognizer.add([{
	        path: path,
	        handler: function handler(match, query) {
	          var realPath = mapParams(mappedPath, match.params, query);
	          _handler.call(_this2, realPath);
	        }
	      }]);
	    };
	
	    /**
	     * Check if a path matches any redirect records.
	     *
	     * @param {String} path
	     * @return {Boolean} - if true, will skip normal match.
	     */
	
	    Router.prototype._checkGuard = function _checkGuard(path) {
	      var matched = this._guardRecognizer.recognize(path, true);
	      if (matched) {
	        matched[0].handler(matched[0], matched.queryParams);
	        return true;
	      } else if (this._notFoundRedirect) {
	        matched = this._recognizer.recognize(path);
	        if (!matched) {
	          this.replace(this._notFoundRedirect);
	          return true;
	        }
	      }
	    };
	
	    /**
	     * Match a URL path and set the route context on vm,
	     * triggering view updates.
	     *
	     * @param {String} path
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._match = function _match(path, state, anchor) {
	      var _this3 = this;
	
	      if (this._checkGuard(path)) {
	        return;
	      }
	
	      var currentRoute = this._currentRoute;
	      var currentTransition = this._currentTransition;
	
	      if (currentTransition) {
	        if (currentTransition.to.path === path) {
	          // do nothing if we have an active transition going to the same path
	          return;
	        } else if (currentRoute.path === path) {
	          // We are going to the same path, but we also have an ongoing but
	          // not-yet-validated transition. Abort that transition and reset to
	          // prev transition.
	          currentTransition.aborted = true;
	          this._currentTransition = this._prevTransition;
	          return;
	        } else {
	          // going to a totally different path. abort ongoing transition.
	          currentTransition.aborted = true;
	        }
	      }
	
	      // construct new route and transition context
	      var route = new Route(path, this);
	      var transition = new RouteTransition(this, route, currentRoute);
	
	      // current transition is updated right now.
	      // however, current route will only be updated after the transition has
	      // been validated.
	      this._prevTransition = currentTransition;
	      this._currentTransition = transition;
	
	      if (!this.app) {
	        (function () {
	          // initial render
	          var router = _this3;
	          _this3.app = new _this3._appConstructor({
	            el: _this3._appContainer,
	            created: function created() {
	              this.$router = router;
	            },
	            _meta: {
	              $route: route
	            }
	          });
	        })();
	      }
	
	      // check global before hook
	      var beforeHooks = this._beforeEachHooks;
	      var startTransition = function startTransition() {
	        transition.start(function () {
	          _this3._postTransition(route, state, anchor);
	        });
	      };
	
	      if (beforeHooks.length) {
	        transition.runQueue(beforeHooks, function (hook, _, next) {
	          if (transition === _this3._currentTransition) {
	            transition.callHook(hook, null, next, {
	              expectBoolean: true
	            });
	          }
	        }, startTransition);
	      } else {
	        startTransition();
	      }
	
	      if (!this._rendered && this._startCb) {
	        this._startCb.call(null);
	      }
	
	      // HACK:
	      // set rendered to true after the transition start, so
	      // that components that are acitvated synchronously know
	      // whether it is the initial render.
	      this._rendered = true;
	    };
	
	    /**
	     * Set current to the new transition.
	     * This is called by the transition object when the
	     * validation of a route has succeeded.
	     *
	     * @param {Transition} transition
	     */
	
	    Router.prototype._onTransitionValidated = function _onTransitionValidated(transition) {
	      // set current route
	      var route = this._currentRoute = transition.to;
	      // update route context for all children
	      if (this.app.$route !== route) {
	        this.app.$route = route;
	        this._children.forEach(function (child) {
	          child.$route = route;
	        });
	      }
	      // call global after hook
	      if (this._afterEachHooks.length) {
	        this._afterEachHooks.forEach(function (hook) {
	          return hook.call(null, {
	            to: transition.to,
	            from: transition.from
	          });
	        });
	      }
	      this._currentTransition.done = true;
	    };
	
	    /**
	     * Handle stuff after the transition.
	     *
	     * @param {Route} route
	     * @param {Object} [state]
	     * @param {String} [anchor]
	     */
	
	    Router.prototype._postTransition = function _postTransition(route, state, anchor) {
	      // handle scroll positions
	      // saved scroll positions take priority
	      // then we check if the path has an anchor
	      var pos = state && state.pos;
	      if (pos && this._saveScrollPosition) {
	        Vue.nextTick(function () {
	          window.scrollTo(pos.x, pos.y);
	        });
	      } else if (anchor) {
	        Vue.nextTick(function () {
	          var el = document.getElementById(anchor.slice(1));
	          if (el) {
	            window.scrollTo(window.scrollX, el.offsetTop);
	          }
	        });
	      }
	    };
	
	    return Router;
	  })();
	
	  function guardComponent(path, handler) {
	    var comp = handler.component;
	    if (Vue.util.isPlainObject(comp)) {
	      comp = handler.component = Vue.extend(comp);
	    }
	    /* istanbul ignore if */
	    if (typeof comp !== 'function') {
	      handler.component = null;
	      warn$1('invalid component for route "' + path + '".');
	    }
	  }
	
	  /* Installation */
	
	  Router.installed = false;
	
	  /**
	   * Installation interface.
	   * Install the necessary directives.
	   */
	
	  Router.install = function (externalVue) {
	    /* istanbul ignore if */
	    if (Router.installed) {
	      warn$1('already installed.');
	      return;
	    }
	    Vue = externalVue;
	    applyOverride(Vue);
	    View(Vue);
	    Link(Vue);
	    exports$1.Vue = Vue;
	    Router.installed = true;
	  };
	
	  // auto install
	  /* istanbul ignore if */
	  if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(Router);
	  }
	
	  return Router;
	
	}));

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var env = exports.env =  true ? ('production') : 'dev';
	var oss_urls = {
	  dev: 'https://joyincar-oss-dev.oss-cn-shenzhen.aliyuncs.com',
	  test: 'https://joyincar-oss-test.oss-cn-shenzhen.aliyuncs.com',
	  production: 'https://joyincar-oss.oss-cn-shenzhen.aliyuncs.com'
	
	  /*oss上传地址url(此为地址后缀，需要拼接环境)*/
	};var oss_url = exports.oss_url = oss_urls[env];
	
	var test = exports.test = env;

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <template>
	//     <div class="common-problem">
	//         <hd title="常见问题"></hd>
	//         <div class="block">
	//             <dl>
	//                 <dt>1、什么是分时租赁？</dt>
	//                 <dd>
	//                     分时租赁是租车行业新兴的一种租车模式。意指以小时计算提供汽车的随取即用租赁服务，消费者可以按个人用车需求和用车时间预订租车的小时数，其收费将按小时来计算。
	//                 </dd>
	//
	//                 <dt>2、分时租赁与其他租赁形式有何区别？</dt>
	//                 <dd>
	//                     分时租赁指按小时进行租赁，其他租赁方式以天作为单位进行租赁。不同于传统意义的汽车租赁,这种短时多人共享的方式有特有的便利性。
	//                 </dd>
	//
	//                 <dt>3、分时租赁的优势在哪里？</dt>
	//                 <dd>
	//                    环保。汽车共享对于减少环境污染来说是非常行之有效的方法，可以有效地提高汽车的使用效率，不必人人都拥有一辆车，对节能环保，减少碳排放和汽车尾气污染有积极意义。降低出行成本。分时租车就是为了提高车辆的使用率，可以为出行者减少购买汽车的费用和燃油费用支出，将资金效益最大化。 
	//                 </dd>
	//
	//
	//                 <dt>4、响车车提供哪些服务？</dt>
	//                 <dd>
	//                     我们为所有需要短途自驾用车的客人提供新能源电动汽车的分时自助租赁服务。响车车提倡按需租车，分时共享。响车车提供你心动价格的优质服务。 手机APP、微信、电脑电话多种渠道随时随地下单租车。响车车，您手机上的私家车。 自助取车服务。全程手机操作，无人值守，您用车，我供车；比起私家车，省去维修、保养、保险、折旧等一系列支出。响车车，你的租车管家！
	//                 </dd>
	//
	//
	//                 <dt>5、如何查询车辆租用的相关合同及规范文件？</dt>
	//                 <dd>
	//                     在APP“个人中心”-“使用帮助”中查询，或在您下载APP注册会员、下单预定等过程时，请务必知晓并详阅平台用户协议。
	//                 </dd>
	//
	//
	//                 <dt>6、车辆的整洁情况由谁负责？</dt>
	//                 <dd>
	//                        响车车提供的所有车辆均经过响车车《车辆整备标准》进行整备，如果您对车辆状况有任何疑问请手机拍照上传至微信并致电客服热线 400-863-7833 反馈，也请您尽量维护车辆整洁。 如车辆内部在您使用过后太过脏乱或遗留垃圾，以致影响其他客户的使用，将汽车以内部肮脏状态归还的会员需要自行清洗或者委托我们清洗，费用按实际标准收取（50-200元不等）。所以您需要注意，不要将咖啡、可乐等易着色饮料或液体沾染在座套上，影响下位客户的使用。
	//                 </dd>
	//
	//                 <dt>7、车辆的车钥匙在哪里？</dt>
	//                 <dd>
	//                     整个租车过程是无需使用车辆钥匙的，所有的操作都是经过手机端完成，如发现任何手机功能失效，请立即致电客服热线4008-637-833转2向客服反馈 。 
	//                 </dd>
	//
	//                 <dt>8、车辆可同时乘坐几位乘客？</dt>
	//                 <dd>
	//                     响车车车辆乘坐不得超过 5 位乘客（含驾驶人）。具体按照具体车型为准，请您根据有关交通法规的标准安全载客。
	//                 </dd>
	//
	//
	//                 <dt>9、可以在车内吸烟吗？</dt>
	//                 <dd>
	//                     为了您和其他客户的优质体验及行车安全，在车内抽烟是被严格禁止的，工作人员一旦发现， 租客在车内抽烟或允许他人抽烟将被收取抽烟违约金100元。
	//                 </dd>
	//
	//
	//
	//                 <dt>10、没有驾照可以租车吗？</dt>
	//                 <dd>
	//                    如果您没有驾照是无法使用响车车平台车辆的，我们非常欢迎您在获得《中华人民共和国机动车驾驶证》后体验响车车服务。为了您的和他人的安全，请您遵守道路法律法规。
	//                 </dd>
	//
	//
	//                 <dt>11、个人物品落在车内怎么办？如果在车内发现他人遗留物品怎么办？</dt>
	//                 <dd>
	//                    请您下车时仔细查看随身物品。 如果您发现个人物品遗落在车内，请您及时拨打客服热线 4008-637-833转1，我们会协助您进行后续跟踪找寻。 如果您在用车时发现他人物品遗留在车内，请您拍照上传至微信并拨打客服热线 4008-637-833转1，我们会为失物找到它的主人。响车车不对任何会员个人财物的损坏或丢失负责。车内承载、放置或遗留的任何个人财物均不对响车车构成任何委托责任。
	//                 </dd>
	//
	//
	//                 <dt>12、是否可以在响车车停车点停放其他车辆？</dt>
	//                 <dd>
	//                     响车车停车点都是经过授权之后的专用停车点，为了避免造成您的麻烦，请您不要将不属于响车车的车辆停入停车点。
	//                 </dd>
	//
	//             </dl>
	//         </div>
	//
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .common-problem{
	    //     width: 100%;
	    //     padding:.32rem .32rem .026667rem;
	    //     font-size: .426667rem;
	    //     background: #fff;
	    //     box-sizing:border-box;
	    //     .block{
	    //         dl {
	    //             width: 100%;
	    //             line-height: .666667rem;
	    //             dt {
	    //                 line-height: .666667rem;
	    //                 padding: .133333rem 0;
	    //                 font-weight: bold;
	    //             }
	    //             dd {
	    //                 line-height: .666667rem;
	    //                 margin-bottom: .8rem;
	    //             }
	    //         }
	    //
	    //     }
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <template>
	//     <div class="coupon">
	//         <hd title="优惠券说明"></hd>
	//         <div class="coupon-box">
	//             <div class="coupon-title">使用说明</div>
	//             <ol class="coupon-content">
	//                 <li>优惠券不可叠加使用。</li>
	//                 <li>产生退款的情况下，优惠券不退回。</li>
	//                 <li>每张优惠券只可使用一次。</li>
	//                 <li>选择套餐的情况下，不能使用优惠券。</li>
	//                 <li>长时间未支付自动扣款的订单，无法使用优惠券。</li>
	//             </ol>
	//         </div>
	//         <div class="coupon-box">
	//             <div class="coupon-title">体验券</div>
	//             <ol class="coupon-content">
	//                 <li>体验券仅供分时用车且消费总额大于0时使用；</li>
	//                 <li>体验券可抵扣所有费用：时租费、套餐费、电费、车辆调度费。</li>
	//             </ol>
	//         </div>
	//         <div class="coupon-box">
	//             <div class="coupon-title">满减券</div>
	//             <ol class="coupon-content">
	//                 <li>满减券仅供分时车、共享车且时租费大于0时使用；</li>
	//                 <li>满减券只能抵扣时租费，不能抵扣套餐费、电费、车辆调度费、违约金；</li>
	//                 <li>满减券可通过响币兑换、新用户注册、邀请好友注册认证和充值金额获得。</li>
	//             </ol>
	//         </div>
	//         <div class="coupon-box">
	//             <div class="coupon-title">代金券</div>
	//             <ol class="coupon-content">
	//                 <li>代金券仅供分时车、共享车且时租费大于0时使用；</li>
	//                 <li>代金券只能抵扣时租费，不能抵扣套餐费、电费、车辆调度费、违约金；</li>
	//                 <li>代金券可通过做任务、开红包车、响活动兑换码活动获得。</li>
	//             </ol>
	//         </div>
	//         <div class="coupon-box">
	//             <div class="coupon-title">购车券</div>
	//             <ol class="coupon-content">
	//                 <li>购车券仅供成为共享车主时使用；</li>
	//                 <li>购车券可通过扫描商家二维码成为共享车主获得。</li>
	//             </ol>
	//         </div>
	//         <div class="coupon-box">
	//             <div class="coupon-title">代步券</div>
	//             <ol class="coupon-content">
	//                 <li>代步券仅供代步车业务使用。</li>
	//                 <li>代步券可以抵扣时租费、套餐费、电费，不能抵扣车辆调度费。</li>
	//             </ol>
	//         </div>
	//
	//
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .coupon{
	    //     width:100%;
	    //     min-height:100%;
	    //     padding:0.02rem 0.32rem 0.32rem;
	    //     box-sizing:border-box;
	    //     .coupon-box{
	    //         width:100%;
	    //         padding:0.32rem;
	    //         background-color:#fff;
	    //         box-sizing:border-box;
	    //         margin-top:0.213rem;
	    //         border-radius: 0.106rem;
	    //         box-shadow: 0px 0px 0px 0.02rem rgba(37,47,58,0.2);
	    //         .coupon-title{
	    //             font-size:.426667rem;
	    //             color: #252F3A;
	    //             font-weight: bold;
	    //         }
	    //         .coupon-content{
	    //             padding-left: 0.4rem;
	    //             margin-top: 0.213rem;
	    //             box-sizing:border-box;
	    //             li{
	    //                 font-size: 0.373rem;
	    //                 color: #666D75;
	    //                 line-height:0.64rem;
	    //                 list-style: decimal;
	    //             }
	    //         }
	    //     }
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <script>
	module.exports = {
	    methods: {
	        jump: function jump(index) {
	            location.href = "#/helpDetail/" + index;
	        }
	    },
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    //
	    //
	    //
	    // <template>
	    //     <div class="help">
	    //         <hd title="使用帮助"></hd>
	    //         <div class="black"></div>
	    //         <div class="help_wrapper">
	    //             <h1 class="title">常见问题</h1>
	    //             <ul>
	    //                 <li v-touch:tap="jump(1)">用车指导及注意事项</li>
	    //                 <li v-touch:tap="jump(2)">车辆续航及充电</li>
	    //                 <li v-touch:tap="jump(3)">用车规则</li>
	    //             </ul>
	    //             <h1 class="title">违章及事故处理</h1>
	    //             <ul>
	    //                 <li v-touch:tap="jump(4)">事故处理步骤</li>
	    //                 <li v-touch:tap="jump(5)">违章查询及处理</li>
	    //             </ul>
	    //             <h1 class="title">费用问题</h1>
	    //             <ul>
	    //                 <li v-touch:tap="jump(6)">关于押金</li>
	    //                 <li v-touch:tap="jump(7)">用车收费</li>
	    //                 <li v-touch:tap="jump(8)">其他违规情况收费</li>
	    //             </ul>
	    //             <h1 class="title">其他问题</h1>
	    //             <ul>
	    //                 <li v-touch:tap="jump(9)">取消订单次数过多无法下单？</li>
	    //                 <li v-touch:tap="jump(10)">无法使用优惠券？</li>
	    //             </ul>
	    //         </div>
	    //     </div>
	    //
	    // </template>
	    //
	    //
	    // <style lang="sass"  scoped>
	    //      .help{
	    //         width:100%;
	    //         min-height:100%;
	    //         .black{
	    //             height: .213333rem;
	    //         }
	    //         .m-t8{
	    //             margin-top:.213333rem;
	    //         }
	    //         .help_wrapper{
	    //             background:#fff;
	    //             .title{
	    //                 height: 1.146667rem;
	    //                 line-height: 1.146667rem;
	    //                 padding-left:.426667rem;
	    //                 box-sizing:border-box;
	    //                 position:relative;
	    //                 font-size:16px;
	    //                 margin-top:.106667rem;
	    //                 &:first-child{
	    //                     margin-top:0;
	    //                 }
	    //                 &:before{
	    //                     content:"";
	    //                     position:absolute;
	    //                     left:0;
	    //                     top:50%;
	    //                     transform:translateY(-50%);
	    //                     height:100%;
	    //                     width:4px;
	    //                     height:14px;
	    //                     background: #4097FC;
	    //                 }
	    //             }
	    //         }
	    //         ul{
	    //             width: 100%;
	    //             padding-left: .64rem;
	    //             box-sizing:border-box;
	    //             li{
	    //                 width: 100%;
	    //                 height: 1.146667rem;
	    //                 line-height: 1.146667rem;
	    //                 font-size: .373333rem;
	    //                 color: #252F3A;
	    //                 position:relative;
	    //                 &:before{
	    //                     content: "";
	    //                     position: absolute;
	    //                     width: .213333rem;
	    //                     height: .213333rem;
	    //                     right: .373333rem;
	    //                     top: 50%;
	    //                     border-top: 1px solid #666D75;
	    //                     border-right: 1px solid #666D75;
	    //                     transform: translateY(-50%) rotate(45deg);
	    //                 }
	    //             }
	    //         }
	    //      }
	    // </style>
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	"use strict";
	
	// <script>
	
	module.exports = {
	    ready: function ready() {
	        var that = this;
	        this.show_part_index = this.$route.params.index;
	    },
	    data: function data() {
	        return {
	            show_part_index: 1
	        };
	    },
	
	    methods: {}
	    // </script>
	    //
	    //
	    //
	    // <template>   
	    //     <div id="scroller">
	    //         <div class="block" v-if="show_part_index == 1">  
	    //             <h1>用车指导及注意事项</h1>
	    //             <dl>
	    //                 <dt>1、如何找车？</dt>
	    //                 <dd>
	    //                     选择车辆进入用车界面后，此时如果离停车场较远，可点击“导航”可直接导航至停车场；到达停车场如果车辆较多无法确认，可点击“鸣笛寻车”，车辆会打开双闪鸣笛四声，点击“开门”即可开始用车。
	    //                 </dd>
	    //
	    //                 <dt>2、检查车辆状态</dt>
	    //                 <p>
	    //                     2.1、检查车辆是否在充电
	    //                 </p>
	    //                 <dd>
	    //                     找到车后，注意先检查车辆是否处于充电状态，如果车辆正在连接充电桩充电，请先联系“响车车”客服中心400-863-7833转1，待客服远程结束充电后，将充电枪拔出放回充电桩。
	    //                 </dd>
	    //                 <p>
	    //                     2.2、检查车身
	    //                 </p>
	    //                 <dd>
	    //                     随后注意仔细观察车身或后视镜，是否出现划痕/破损，轮胎磨损/没气等情况，可通过APP取车页面“车况上报”拍照上传；车辆正常则点击“车况正常”，（如您发现伤痕但未做车况上报，系统自动默认用车前车是正常的，一旦下一个用户拍照反馈有新伤痕，我们将追责到您身上）所以在用车前，一定要仔细观察车身，拍照上传保障自己的权益。开门取车后如发现车内设备有损坏或丢失，车辆内部的任何配备设施异常或者车内有异味，可通过APP用车页面的“车况上报”进行报备，或致电客服热线 400-863-7833转1 反馈。
	    //                 </dd>
	    //                 <p>
	    //                     2.3、调节好座椅及后视镜
	    //                 </p>
	    //                 <dd>
	    //                     后视镜均为手动调节                
	    //                 </dd>
	    //
	    //                 <dt>3、车钥匙在哪？</dt>
	    //                 <dd>
	    //                        “响车车”所有车辆全部由APP控制，无需车钥匙，有问题请联系客服400-863-7833；
	    //                 </dd>
	    //
	    //                 <dt>4、如何启动车辆</dt>
	    //                 <dd>
	    //                     手机APP点击“启动”，仪表盘绿色“READY”标志亮时就可以正常使用车辆(东风景逸的车型要踩住刹车按启动)。踩下刹车，挂到D档（前进）或R档（倒车），仪表盘档位字母常亮挂挡成功，放手刹。
	    //                 </dd>
	    //
	    //                 <dt>5、停车注意事项</dt>
	    //                 <dd>
	    //                     需要临时停车但不还车时，请将档位挂回N档，拉手刹，关闭所有灯光，关好车窗，手机点击APP“临停”即可完成熄火操作，下车后，关上门自动上锁（请注意别把手机遗留在车上）。
	    //                 </dd>
	    //
	    //                 <dt>6、如何还车</dt>
	    //                 <dd>
	    //                     用车完毕后，请将档位挂回N档，拉手刹，关闭所有灯光，关好车窗，手机点击APP“还车”，车辆自动熄火。下车后，关门自动上锁，再点还车结算费用。（注意：请务必把车辆停放在网点，离开车辆后再操作还车结算，否则订单还在计费当中。）<br/>
	    //                     还车目前不支持跨城市还车，用户在租用车辆前，可通过app“还车网点”查看当前租用车辆去到目的地附近是否有可还车网点，再决定租用车辆，当前A点借A点还车的是广州，深圳。A点借B点还车是湛江，中山，柳州，东莞。其他城市会陆续上线，请敬请关注
	    //                 </dd>
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 2">  
	    //             <h1>车辆续航及充电</h1>
	    //             <dl>
	    //                 <dt>1、关于续航里程</dt>
	    //                 <dd>
	    //                     不同车辆的电池电量，以及续航里程不一样，选车时请参照APP上显示的电量，选择续航里程足够您出行计划来回的车辆，同时建议提前计划好寻找充电桩进行补电，使用过程中请随时电量状况，发现电量快低于30% 时，请及时充电，确保不影响您正常用车，以免因没电而产生救援费。
	    //                 </dd>
	    //
	    //                 <dt>2、假如车辆半路电量不足怎么办？</dt>
	    //                 <dd>
	    //                     可以寻找就近的羊城充、星星充电、特来电和爱电牛等充电桩进行充电，或将车辆还回租车网点并结算后，更换其它电量充足车辆继续使用。                
	    //                 </dd>
	    //
	    //                 <dt>3、每充一次电需要花多长时间？</dt>
	    //                 <dd>
	    //                     常规充电设备：需要6至8小时能完成整个充电过程。快速充电设备：空电量车大概需要1至3小时完成整个充电过程。具体根据车辆剩余续航里程以及充电桩电流输出实际情况而定。
	    //                 </dd>
	    //
	    //                 <dt>4、如何区分快速充电设备和常规充电设备？</dt>
	    //                 <dd>
	    //                     <!--<img style="width: 700px; height: 454px" :src="imgurl"/>-->
	    //                     APP上通常都将有对应标识，交流桩就是俗称的“慢充”、直流桩为俗称的”快充“，如您有疑问，请拨打客服热线400-863-7833，我们将为您服务。
	    //                 </dd>
	    //
	    //                 <dt>5、给车充电安全吗？</dt>
	    //                 <dd>
	    //                     响车车的车辆以及充电设施均经过安全测试，但在极端天气如：大暴雨天气，为了您的安全建议不要随便拔插充电枪，如有疑问请您在操作前致电400-863-7833。
	    //                 </dd>
	    //
	    //                 <dt>6、给响车车的车辆充电的操作步骤是什么？</dt>
	    //                 <dd>
	    //                     a.公共充电桩参考充电流程：<br/>
	    //                     （1）车辆处于熄火状态；<br/>
	    //                     （2）拔出充电桩上的充电枪；<br/>
	    //                     （3）打开车辆充电口；<br/>
	    //                     （4）将充电枪插入车辆充电口，并确保充电枪和车辆连接牢固；<br/>
	    //                     （5）用相应的APP扫码开始充电，车内有充电显示，表明已经成功开始充电；<br/>
	    //                 </dd>
	    //                 <dd>
	    //                     b.家用交流充电流程：注意以下条件：接地线、220V，空调插座，<br/>
	    //                     （1）车辆处于熄火状态；<br/>
	    //                     （2）找到充电开关、打开充电盖；<br/>
	    //                     （3）将充电枪插紧交流（慢充）充电口，打开电源，没有红色故障灯亮起，即表示充电成功；
	    //                 </dd>
	    //
	    //                 <dt>7、哪些地方可以充电？</dt>
	    //                 <dd>
	    //                     除响车车的网点外，还可以在国家电网、羊城充、星星充电、特来电和爱电牛等充电桩进行充电，但须您自备充电卡或下载相应的APP进行充电和费用支付。
	    //                 </dd>
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 3">  
	    //             <h1>用车规则</h1>
	    //             <dl>
	    //                 <dt>
	    //                    1、租用响车车车辆需具备以下条件：
	    //                 </dt>
	    //                 <dd>
	    //                    （1）需获得《中华人民共和国机动车驾驶证》，为了您的和他人的安全，请您遵守道路法律法规。<br/>
	    //                    （2）如已获得驾驶证但未满一年，属于实习期，会员在租用响车车运营车辆需自备实习标志贴，贴至后档玻璃的右上角。实习期驾龄会员在高速上行驶需有驾龄一年以上人员陪同方属于合法，如未按照规定会员私自驾驶响车车运营车辆导致被交警部门罚款、扣分以及保险公司不理赔范围由会员本人自行承担，并追究相应的法律责任，我司不作处理。<br/>
	    //                    （3）驾照必须有效并能够准驾自动挡车型，没有被吊销、没收、失效或以其它方式作废。如用户的驾照在任何时间被吊销、没收、失效或其状态发生变化，用户必须立即通知“响车车”，此时用户将不能使用或预定任何“响车车”车辆，否则自行承担全责。
	    //                 </dd>
	    //
	    //                 <dt>2、用车需保持人证合一</dt>
	    //                 <dd>
	    //                     为了保障您的个人权益驾驶证、身份证与实际驾驶人必须保持一致，防止他人在未经您许可的情况下使用您的证件。
	    //                 </dd>
	    //
	    //                 <dt>3、不得将会员帐号或车辆给其他人使用</dt>
	    //                 <dd>
	    //                     响车车会通过车内设备识别驾驶员身份，禁止会员将自己的会员帐号及密码交付第三人使用。若第三者凭正确的用户会员帐号及密码进行网络活动（网络预订等），或使用您的个人资料（包括但不限于手机号或会员号）进行电话预订，将被响车车视为该会员自身行为，而该行为引起的一切法律后果由会员承担。响车车会员亦不得以任何方式将车辆提供给任何非认证驾驶人驾驶。如响车车会员将汽车交予非认证驾驶人驾驶，将被永久取消会员资格，并需依法承担相应责任。
	    //                 </dd>
	    //
	    //                 <dt>4、车辆严禁超载</dt>
	    //                 <dd>
	    //                    响车车车辆乘坐不得超过 5 位乘客（含驾驶人）。具体按照具体车型为准，请您根据有关交通法规的标准安全载客。
	    //                 </dd>
	    //
	    //                 <dt>5、请不要在车内吸烟</dt>
	    //                 <dd>
	    //                     为了您和其他客户的优质体验及行车安全，请不要在车内吸烟，工作人员一旦发现租客在车内抽烟或允许他人抽烟，将被收取抽烟违约金100元。
	    //                 </dd>
	    //
	    //                 <dt>6、个人物品落在车内怎么办？如果在车内发现他人遗留物品怎么办？</dt>
	    //                 <dd>
	    //                     请您下车时仔细查看随身物品。 如果您发现个人物品遗落在车内，请您及时拨打客服热线 4008-637-833转1，我们会协助您进行后续跟踪找寻。 如果您在用车时发现他人物品遗留在车内，请您拍照上传至微信并拨打客服热线 4008-637-833转1，我们会为失物找到它的主人。响车车不对任何会员个人财物的损坏或丢失负责。车内承载、放置或遗留的任何个人财物均不对响车车构成任何委托责任。
	    //                 </dd>
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 4">  
	    //             <h1>事故处理</h1>
	    //             <dl>
	    //                 <dt>1、车辆在租赁过程中发生交通事故如何处理？</dt>
	    //                 <dd>
	    //                     如果在路上发生交通事故，请不要着急，如果有人员受伤，立即拨打120救援电话，拨打交通事故报警电话报警122，再拨打保险公司客服报案，同时拨打客服热线4008637833转2报备。不影响交通秩序的前提下保留第一现场，把警示牌放于事故车后150米，等待交警和保险查勘人员到达现场处理；如影响交通，请拍好第一现场照片，将车辆移开，等待交警和保险查勘人员到达现场。处理完毕后将车辆还回网点，把保险资料交给外勤工作人员处理。
	    //                 </dd>
	    //                 <dt>2、车险理赔是如何？</dt>
	    //                 <dd>
	    //                     （1）以下情况及其他保险公司不予赔偿的情况，造成的所有经济损失和后果将由您自行承担，请您务必避免：<br/>
	    //                     a. 超过48小时报案；<br/>
	    //                     b. 饮酒后驾驶车辆；<br/>
	    //                     c. 无证驾驶车辆；<br/>
	    //                     d. 持逾期未审验的驾驶执照驾驶车辆；<br/>
	    //                     e. 发生事故后驾车逃逸。
	    //                 </dd>
	    //                 <dd>
	    //                    （2）如车辆不慎出险，请您注意人身安全，并立即致电客服热线400-863-7833转2报案、收集理赔材料，齐全的理赔材料可以节省您的理赔等待时间。<br/>
	    //                     在您还车并提交了齐全的理赔资料时，您不需要垫付本车维修等保险公司应付费用，仅需：<br/>
	    //                     a)支付上表列明的保险责任内的由承租方承担的损失，以及保险责任外的所有责任和损失（如您已经购买不计免赔服务，保险责任范围外的轮胎损失您可以免于承担）；<br/>
	    //                     b)垫付第三方损失，该费用将在保险公司完成理赔后返还给您；(在您全责或主责的情况下，如第三方同意在响车车指定维修单位定损、维修，该费用将无需您垫付) <br/>
	    //                     c)在您还车不能提供齐全的理赔资料时，请根据预估的车辆损失刷取最低1500元的维修押金，该押金将在您提交完材料后的15个工作日发起退款（到账时间以各银行为准）。
	    //                 </dd>
	    //                 <dd>
	    //                     （3）在您用车期间，如有车辆盗抢与报废发生，您需支付公安部门立案或车管部门出具报废证明之前的车辆租赁费用。
	    //                 </dd>
	    //             </dl>
	    //
	    //             <h1>车辆故障处理</h1>
	    //             <dl>
	    //                 <dt>1、车辆在租赁过程中发生故障如何处理？</dt>
	    //                 <dd>
	    //                     如果车辆发生故障无法启动、仪表盘出现故障码、车辆爆胎、漏气等情况，先把警示牌放于车后150米，然后拨打电话客服热线4008637833转2咨询指导，等待救援。
	    //                 </dd>
	    //
	    //                 <dt>2、车辆在行驶过程中爆胎，保险赔偿吗？</dt>
	    //                 <dd>
	    //                     请您在行驶过程中尽量选择安全路况行驶，并在取车时或者开车前进行检查，如有车辆安全隐患方面的疑问请及时致电客服热线400-863-7833转2，；如果遇到现场爆胎，请将车辆移至安全地带，并致电客服热线400-863-7833转2我们会及时为您处理。 车辆爆胎是不属于保险赔偿范围的，如客人在租赁过程中发生非轮胎质量范围外的爆胎，我们将按照4S店的标准向您收费。
	    //                 </dd>
	    //
	    //                 <dt>3、停车被划伤如何处理？</dt>
	    //                 <dd>
	    //                     请您在取车时进行检查，如发现已存在车辆划伤的情况，请通过APP中的“拍照取证”或者拍照并上传至微信公众号——响车车，我们将为您进行备案。如在租赁过程中发现新的刮伤，也请您第一时间拍照上传至微信公众号——响车车，我们将根据车辆刮伤情况具体定损，如您未拍照上传，我们之后查询在您行驶中出现了新的刮伤，您有可能需要支付全款并支付车辆修理停运费用。如有疑问，请致电400-863-7833转2客服中心。
	    //                 </dd>
	    //
	    //                 <dt>4、车辆救援范围以及是否收费？</dt>
	    //                 <dd>
	    //                     车辆在城区范围内，我们均会为您提供救援服务。如因车辆故障问题引起的救援服务，我们将为您提供免费服务。如因您个人原因造成车辆电量耗尽而造成车辆无法行驶，我们将会根据实际情况进行有偿救援服务。
	    //                 </dd>
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 5">  
	    //             <h1>违章查询及处理</h1>
	    //             <dl>
	    //                 <dt>1、如何查询违章</dt>
	    //                 <dd>
	    //                     可在个人中心，违章信息中查看，或者“响车车”平台（以下简称平台）在收到车管所或交警大队对车辆的违章通知后，由平台客服人员通过电话或者短信的形式通知。
	    //                 </dd>
	    //
	    //                 <dt>2、如何进行违章处理</dt>
	    //                 <dd>
	    //                     用户可在接到电话通知起7天内自行前往车管所或交警支队处理，亦可委托平台代为处理。对于吊销驾照或单次违章扣分6分及以上的严重交通违法行为，平台有权拒绝接受委托处理。如用户接到电话通知超过7天未处理，将被视为用户自动委托“响车车”处理相关违章。“响车车”有权在违章用户账户内扣除违章罚款及代办费用。
	    //                 </dd>
	    //
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 6"> 
	    //             <h1>关于违章保证金</h1>
	    //             <dl>
	    //                 <dt>1、使用车辆是否收取违章保证金？</dt>
	    //                 <dd>
	    //                     响车车会员在使用租车服务时，需要会员账户缴纳达到违章保证金的最低标准即1000元人民币作为违章保证金。
	    //                 </dd>
	    //
	    //                 <dt>2、违章保证金如何退还？</dt>
	    //                 <dd>
	    //                     用户在确定不再用车以后，本人可用绑定注册的手机号码在APP“个人中心”内的“违章保证金余额”中进行“退违章保证金”操作，或致电“响车车”客服中心4008637833转1咨询。我们将确认用户租车期间没有违章和事故或者违章和事故已经处理完的前提下，在15个工作日（15个工作日即最后订单结算算起，不含周末跟节假日）将违章保证金退还到钱包余额，注明：余额可随时提现。
	    //                 </dd>
	    //                 <dt>3、免违章保证金说明</dt>
	    //                 <dd>
	    //                     3.1 满足芝麻信用评分550分及以上，且没有相关不良记录，可申请芝麻信用服务。<br/><br/>
	    //                     3.2 解除授权后将失去免违章保证金服务，需重新授权芝麻信用获得免违章保证金服务。<br/><br/>
	    //                     3.3 规范用车履约行为将有助于你的信用积累，恶意破坏违约将会影响信用记录。<br/><br/>
	    //                     3.4 当你会员等级达到黄金及以上等级时，可申请享受会员权益免违章保证金服务。<br/><br/>
	    //                 </dd>
	    //             </dl>
	    //         </div>
	    //
	    //         <div class="block" v-if="show_part_index == 7">  
	    //             <h1>用车收费</h1>
	    //             <dl>
	    //                 <dt>1、响车车项目标准费用是多少？</dt>
	    //                 <dd>
	    //                     每个地区不同车型的费用计算根据当地实际定价而定，请在选择车辆时查看相应的计费标准。
	    //                 </dd>
	    //
	    //                 <dt>2、响车车费用如何结算？</dt>
	    //                 <dd>
	    //                     服务结束后，响车车APP系统会根据你的消费自动结算。例：时租费用+电费=本次总租车费用
	    //                 </dd>
	    //
	    //                 <dt>3、如果发现我的结算费用有误怎么办？</dt>
	    //                 <dd>
	    //                     如果您对结算费用产生质疑，您可以拨打客服热线4008-637-833转3进行咨询，将有专职的客服人员为您核查并解决问题。
	    //                 </dd>
	    //
	    //                 <dt>4、预订成功后，如果没有取车还会收费吗？</dt>
	    //                 <dd>
	    //                     根据预定时间，我们为您免费保留15分钟取车时间，订单超过15分钟将取消订单。当天取消订单累计2次，第3次将开始自动计费。如果您没有在上述规定时间前取消预定，则取消无效，我们的系统将默认执行预定订单，相应收取车辆使用费。<br/>
	    //                     例如：您预订了一小时10元的服务，但您未能取车，也没有取消订单、订单超过15分钟系统将自动取消订单，若您是在取车后才取消订单，我们将收取您10元的车辆租赁费用。为了方便您和其他会员体验更好的服务，请您理解。
	    //                 </dd>
	    //
	    //                 <dt>5.如何享受38块包夜套餐呢？</dt>
	    //                 <dd>
	    //                     您只需要用车时长累计完结20小时后，成为白银会员及白银以上的会员，就可以享受38元包夜套餐。
	    //                 </dd>
	    //
	    //                 <dt>6、响车车用户付费方式？</dt>
	    //                 <dd>
	    //                     “响车车”服务采用账户余额支付，微信支付、支付宝支付，企业帐户支付等付费方式。用户在使用分时租车服务前将支付宝或微信绑定至账户，即可进行充值。
	    //                 </dd>
	    //
	    //                 <dt>7、如何查看我的消费和充值记录？</dt>
	    //                 <dd>
	    //                     您可以进入手机APP客户端或者微信公众号客户端登陆后，进入“个人中心”的“消费记录”查阅充值记录，查阅消费可以进入“我的订单”页面查看历史记录。
	    //                 </dd>
	    //
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 8">
	    //             <h1>其他可能产生的费用</h1>
	    //             <dl>
	    //                 <dt>1、预定违约费用</dt>
	    //                 <dd>
	    //                    根据预定时间，“响车车”为用户免费保留15分钟取车时间，订单超过15分钟将取消订单。当天取消订单累计2次，第3次将开始自动计费。
	    //                 </dd>
	    //
	    //                 <dt>2、损失费用</dt>
	    //                 <dd>
	    //                     由于用户在汽车熄火时未关闭灯光，收音机等耗电部件，以致汽车无法再次正常启动，“响车车”将为汽车实行有偿紧急救援。用户将被收取100元的蓄电池抢修费，以及蓄电池损耗费50元。
	    //                 </dd>
	    //
	    //                 <dt>3、维修费用</dt>
	    //                 <dd>
	    //                     用户恶意损害车内行车记录仪等车内设备，将视损坏程度按实际价值收取维修费用。
	    //                 </dd>
	    //
	    //                 <dt>4、驾驶违约费用</dt>
	    //                 <dd>
	    //                     如“响车车”预定用户将汽车交予非授权驾驶人驾驶，用户将被收取1000元驾驶违约费用。
	    //                 </dd>
	    //
	    //                 <dt>5、清洁费用</dt>
	    //                 <dd>
	    //                     将宠物带入车内或者将汽车以内部肮脏状态归还的用户应支付车辆清洁费用50-200元不等。
	    //                 </dd>
	    //
	    //                 <dt>6、禁烟违约费用</dt>
	    //                 <dd>
	    //                     在车内抽烟是被严格禁止的，工作人员一旦发现， 用户在车内抽烟或允许他人抽烟将被收取禁烟违约费用100元。
	    //                 </dd>
	    //
	    //                 <dt>7、共享车主违约费用</dt>
	    //                 <dd>
	    //                     根据共享时间，“响车车共享车主”为用户设定可租用时间段内必须在指定还车点还车，逾期归还则按照30元/小时的标准收取逾期惩罚金。
	    //                 </dd>
	    //
	    //                 <dt>8、车辆车身贴纸费用</dt>
	    //                 <dd>
	    //                     车辆车身的贴纸如故意性损坏需赔偿100元。
	    //                 </dd>
	    //             </dl>
	    //         </div>
	    //
	    //
	    //         <div class="block" v-if="show_part_index == 9">
	    //             <h1>订单取消次数过多无法下单</h1>
	    //             <dl>
	    //                 <dd>
	    //                     1、如果您因取消订单次数过多导致无法下单，请联系客服进行处理，同时希望您在选择车辆出行之前，确认好自己的行程，以免产生不必要的麻烦。
	    //                 </dd>
	    //
	    //             </dl>
	    //         </div>
	    //
	    //         <div class="block" v-if="show_part_index == 10">  
	    //             <h1>无法使用优惠券</h1>
	    //             <dl class="son_mb20">
	    //                 <p>
	    //                     1.请先确认您的用车订单符合优惠券的使用规则，不在优惠券使用范围内的订单，是无法使用优惠券的。
	    //                 </p>
	    //                 <p>
	    //                     2.优惠券是否满足了满减的条件，不达到对应满减条件则无法使用优惠券。
	    //                 </p>
	    //                 <p>
	    //                     3.共享用车无法使用优惠券。
	    //                 </p>
	    //                 <p>
	    //                     4.企业用车无法使用优惠券。
	    //                 </p>
	    //                 <p>
	    //                     5.套餐无法使用优惠券。
	    //                 </p>
	    //             </dl>
	    //         </div>
	    //
	    //         <div style="height: 1px"></div>
	    //     </div>
	    // </template>
	    //
	    //
	    // <style lang="sass" scoped> 
	    //     #scroller{
	    //         width: 100%;
	    //         padding-left: .32rem;
	    //         padding-right: .32rem;
	    //         font-size: 32px;
	    //         background: #fff;
	    //         box-sizing:border-box;
	    //         position:relative;
	    //         overflow-y:scroll;
	    //         -webkit-overflow-scrolling:touch;
	    //         .block{
	    //             h1 {
	    //                 width: 100%;
	    //                 height: 1.066667rem;
	    //                 line-height: 1.066667rem;
	    //                 color: #333;
	    //                 font-weight: bold;     
	    //                 font-size:.426667rem;          
	    //                 border-bottom:1px solid #DDDDDD;
	    //             }
	    //
	    //             dl {
	    //                 width: 100%;
	    //                 line-height: .64rem;
	    //
	    //                 dt {
	    //
	    //                     line-height: .64rem;
	    //                     font-size: .426667rem;
	    //                     padding: .16rem 0;
	    //                     font-weight: bold;
	    //
	    //                 }
	    //
	    //                 dd {
	    //                     line-height: .8rem;
	    //                     font-size: .426667rem;
	    //                     margin-bottom: .8rem;
	    //                 }
	    //             }
	    //             p{
	    //                 line-height: .8rem;
	    //                     font-size: .426667rem;
	    //             }
	    //             .son_mb20{
	    //                 p{
	    //                     margin-bottom:.266667rem;
	    //                 }
	    //             }
	    //         }
	    //     }
	    //
	    //
	    //
	    //
	    // </style>
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// <template>
	//     <div class="help">
	//         <hd title="法律条款和隐私政策"></hd>
	//         <ul>
	//             <li v-touch:tap="jump(1)">响车车平台协议</li>
	//             <li v-touch:tap="jump(2)">车辆租赁合同</li>
	//             <li v-touch:tap="jump(3)">隐私政策</li>
	// 			<li v-touch:tap="jump(4)">证照信息</li>
	//         </ul>
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    methods: {
	        jump: function jump(index) {
	            switch (index) {
	                case 1:
	                    location.href = "static_page.html#!/platformProtocol";
	                    break;
	                case 2:
	                    location.href = "static_page.html#!/leasingContract";
	                    break;
	                case 3:
	                    location.href = "static_page.html#!/privacyPolicy";
	                    break;
	                case 4:
	                    location.href = "static_page.html#!/licenseInformation";
	                    break;
	            }
	        }
	    },
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .help{
	    //     width:100%;
	    //     min-height:100%;
	    //     padding-top:0.01rem;
	    //     box-sizing:border-box;
	    //     ul{
	    //         width: 100%;
	    //         padding-left: .32rem;
	    //         box-sizing:border-box;
	    //         background: #FFFFFF;
	    //         border-bottom: 1px solid #DDDDDD;
	    //         border-top: 1px solid #DDDDDD;
	    //         margin-top:.213333rem;
	    //         li{
	    //             width: 100%;
	    //             height: 1.146667rem;
	    //             line-height: 1.146667rem;
	    //             border-bottom: 1px solid #DDDDDD;
	    //             font-size: .426667rem;
	    //             color: #252F3A;
	    //             position:relative;
	    //             &:last-child{
	    //                 border: none;
	    //             }
	    //             &:before{
	    //                 content: "";
	    //                 position: absolute;
	    //                 width: .213333rem;
	    //                 height: .213333rem;
	    //                 right: .373333rem;
	    //                 top: 50%;
	    //                 border-top: .03rem solid #666D75;
	    //                 border-right: .03rem solid #666D75;
	    //                 transform: translateY(-50%) rotate(45deg);
	    //             }
	    //         }
	    //     } 
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <template>
	//     <div class="platform-protocol">
	//         <hd title="车辆租赁合同"></hd>
	//         <div>
	//             <h1 class="pr-title">车辆租赁合同</h1>
	//             <p>合同编号：（以具体合同编号为准）</p>
	//             <p>出租方（甲方）：广州响车车科技有限公司</p>
	//             <p>承租方（乙方）：</p>
	//             <p>*“响车车”以下代指“广州响车车科技有限公司”。</p>
	//             <p>双方在平等自愿的基础上，经友好协商，就本次租赁事宜达成如下条款：</p>
	//             <p class="f-bold">第一条、汽车租赁</p>
	//             <p>乙方向甲方租赁分时租车辆壹台，车牌号为粤A***** （以下简称“租赁车辆”），时租费为XXX元/小时（不含电费），日租费为XXX元/日（不含电费）；租期为乙方通过“响车车”APP会员账号点击开门起算至还车结算之时结束。</p>
	//             <p class="f-bold">第二条、甲方的权利和义务</p>
	//             <p>2.1、甲方享有租赁汽车的所有权，甲方有权通过合理方式随时检查租赁汽车的使用情况和安全状态。</p>
	//             <p>2.2、甲方依约为乙方提供租赁汽车及该汽车行驶必备的法定证件。</p>
	//            <p>2.3 、乙方未按时结清本合同及附件项下费用的，甲方有权从乙方交纳的押金，预付款，充值的余额或刷取的预授权中直接扣除。乙方基于本合同及附件交纳的押金，预付款，充值的金额或刷取的预授权亦可用于支付乙方拖欠甲方的其它债务费用。</p>
	//             <p>2.4、乙方在使用租赁汽车时如出现动向异常、逾期不还、抵押、预留联系方式不正确或无法有效联系等情形的，甲方有权立即收回租赁汽车，由此产生的责任及费用均由乙方承担。</p>
	//            <p>2.5、 甲方提供乙方租车时使用的APP，甲方保证乙方可正常使用该APP，如有问题须提供电话、手机短信等补救服务。</p>
	//             <p>2.6、甲方承担“响车车”平台协议中列明的义务和享有平台协议中列明的权利。</p>
	//             <p class="f-bold">第三条、乙方的权利和义务</p>
	//             <p>3.1、乙方于租车期内享有租赁汽车符合租赁用途的使用权。</p>
	//             <p>3.2、乙方确认是“响车车”平台APP乙方账户的认证驾驶人使用租赁汽车，如是非账户认证驾驶人，请停止使用或租赁汽车，否则乙方须承担由此造成的直接和间接责任及损失，并赔偿甲方经济损失及违约金。如乙方驾驶员因不符合有关法律法规使用汽车，导致的一切损失及后果由乙方承担，并赔偿甲方经济损失及违约金。如因此造成交通事故，保险公司以此为由拒绝赔付，乙方须承担由此造成的直接和间接责任及损失，并赔偿甲方经济损失及违约金。</p>
	//            <p>3.3、乙方须下载并使用甲方提供的“响车车”APP，并在租赁汽车前浏览APP中的平台协议，乙方同意租赁汽车则表示同意该APP中的平台协议，如不同意，请终止使用。乙方保证通信畅通，因自己手机通讯故障出现问题的应自行承担责任和损失。</p>
	//            <p>3.4、乙方在使用“响车车”APP租赁汽车期间，如平台有欠费提醒，请及时充值；如平台提示电量警告，请及时充电，因乙方原因导致汽车不能正常运营，乙方须承担由此造成的直接和间接责任及损失，并赔偿甲方经济损失。</p>
	//             <p>3.5、乙方应自行承担使用租赁汽车时发生的充电费、停车费和路桥费等费用，自行负责车上人员及财产安全，乙方在使用租赁汽车时应当严格遵守道路交通规则，独立承担因交通事故产生的在租赁汽车保单赔付范围外的相关责任及经济损失。</p>
	//             <p>3.6、如租赁汽车出现故障或异常，乙方应立即通知甲方，配合甲方的安排更换汽车或者停止使用租赁汽车。</p>
	//             <p>3.7、乙方须按照“响车车”平台协议规定合法合规使用租赁汽车。</p>
	//             <p>3.8、乙方须承担非甲方原因致租赁汽车被第三方扣押的全部责任，如乙方在车辆被扣起算三个月内没有将车辆取回或交回甲方，则乙方应向甲方赔偿车辆价值原值的价款（新车价），车辆归乙方所有。车辆停运期间的租金损失（停运期间的租金损失按该车系统的日租金标准计算），由乙方向甲方支付，此租金损失一直延续支付到车辆赔偿时为止，不受租赁合同到期的影响。</p>
	//             <p>3.9 、在车辆租赁期内发生的道路交通安全违法行为和交通事故，乙方应当将涉及该车的道路交通安全违法行为和交通事故处理完毕，如乙方未及时处理完毕则向甲方支付10万元违约金，另有损失的应当赔偿甲方损失。</p>
	//             <p>3.10、车辆在租赁期内发生交通违章被记分、违章罚款，乙方应当立即消分处理及处理违章罚款，如不及时消分处理及处理违章罚款，每记一分向甲方支付一万元的违约金，以及向甲方支付违章罚款，不论该违章罚款甲方是否已经代乙方缴纳，乙方均应支付。</p>
	//             <p>3.11、车辆在租赁期内发生交通违章被记达到12分或者累计三次违章未处理，车辆应即刻停止上路行驶或者车辆由甲方收回保管停止上路。车辆停运期间的租金损失（停运期间的每日租金损失按日租费计），由乙方向甲方支付，此租金损失一直延续支付到车辆消分及处理违章为止，不受租赁合同到期的影响。</p>
	//             <p>3.12、鉴于公安部《机动车登记规定》第49条之规定，车辆在租赁期内发生包括交通违章被记分、罚款等道路交通安全违法行为和交通事故未处理完毕，致使车辆不能年检年审或者发生交通违章被记达到12分时起超过三个月乙方未消分处理，乙方应向甲方赔偿车辆价值原值的价款（新车价），车辆归乙方所有。</p>
	//             <p>3.13、因乙方违约不将车辆交还于甲方，乙方应向甲方赔偿车辆价值原值的价款（新车价），车辆归乙方所有，乙方须另向甲方支付10万元违约金。</p>
	//             <p>3.14、因乙方原因致使车辆损坏，乙方应赔偿维修费用，致使车辆损毁的应赔偿车辆价值原值的价款。如果乙方不予赔偿的，应向甲方支付违约金5万元。</p>
	//             <p>3.15、因乙方违约不将车辆证件、随车备件交还于甲方，乙方须向甲方支付3万元违约金。</p>
	//             <p>3.16、乙方使用虚假证件（机动车驾驶证、身份证等其它证件）租赁车辆、使用车辆的向甲方支付5万元违约金，并承担给甲方造成的损失。</p>
	//             <p class="f-bold">第四条、租赁汽车的相关规定</p>
	//             <p>4.1、租赁汽车为乙方在“响车车”平台上使用APP乙方账号预定的或直接开锁取车的汽车。乙方通过APP的操作完成租赁汽车的取车、使用、还车以及结算。</p>
	//             <p>4.2、因租赁汽车本身问题导致汽车不能继续使用的情况：按小时计算租金的，本次租赁结束，甲方不收取本次租赁费用。按天租赁的，收取已发生租赁天数的租金，本次租赁结束。按套餐租赁的，收取已发生租赁时段的对应比例租金，本次租赁结束。</p>
	//             <p>4.3、由于乙方遗失汽车证照或因违法违规用车被扣等情况造成租赁汽车停运的，乙方应承担由此造成的汽车停运损失费。乙方按该车日租金标准向甲方支付停运损失费，该费用计算至租赁汽车补齐证照可合法使用或汽车归还之日止。</p>
	//             <p>4.4、乙方应在报警电量以上（30%）的情形下使用租赁汽车。因乙方未及时充电原因而导致的电池没电、汽车抛锚，乙方须承担电池抢修费用及汽车有偿救援费用。乙方须在符合安全标准的充电场所充电，并承担因充电不当导致的一切责任，赔偿甲方经济损失及违约金。</p>
	//             <p>4.5、 乙方须按照平台协议中第7款规定合法合规使用租赁汽车，如违反第7款规定，甲方可在不向乙方发出通知的情况下，终止其使用租赁汽车的权利和资格。甲方保留法律规定的权利，包括但不限于不经过法律程序向乙方发出通知而扣押租赁汽车，乙方有义务支付甲方为将租赁汽车追回所发生的一切费用。如果乙方在使用权利终止后继续使用租赁汽车，甲方有权通知公安机关汽车被盗并配合公安机关追回租赁汽车。乙方使用资格终止后，乙方仍须承担支付所有拖欠费用的责任，包括但不限于截至终止日前发生的或在终止日期后经甲方发现的任何赔偿费和罚金。</p>
	//             <p>4.6、甲方已给租赁汽车购买汽车损失险（按照汽车销售发票金额），事故第三者险（限额100万），车上司乘人员险（限额5万/人），乙方发生任何交通事故或违章违法行为，按照“响车车”平台协议中第8款约定处理。如果乙方在交通事故中负有责任且租赁汽车维修金额超过一万元的，乙方须承担汽车维修金额的20%作为折旧费用。租赁汽车发生交通事故或违章违法行为被扣留、定损或维修，导致不能正常对外租赁，乙方应根据该车系统的天租金标准乘以停运天数支付停运费用。因乙方责任导致全车损失或盗抢，租赁汽车需要报废的，乙方须承担汽车保险不能赔付部分的折旧费用及其他损失。</p>
	//             <p>4.7、 甲方接到交管部门的汽车违章通知后，通过查询确认并通知承租人，承租人须按照“响车车”平台协议第10款约定处理。</p>
	//             <p>4.8、 甲方在任何情况下对乙方的唯一补救责任为退回乙方没有使用预定汽车的用车费用。乙方放弃所有针对甲方的间接、惩罚性和附带损害的索赔权利。</p>
	//             <p class="f-bold">第五条、租赁费用</p>
	//             <p>5.1、乙方使用甲方提供的租赁服务，须支付包括但不限于汽车租金、汽车充电费、租赁套餐费用、特殊服务费用、汽车违章罚金及违章处理费用、有偿救援服务、蓄电池抢救及耗损费、预定违约费用、驾驶违约费用、汽车清洁费用、禁烟违约费用、汽车非保险损坏修复费用、事故中保险不赔偿或不足额赔偿部分、汽车折旧费用、汽车停驶费用、因乙方拒不归还汽车发生的追偿费用等，计算标准详见“响车车”平台协议第6款和第8款以及甲方网站中公示的价格及说明，具体以APP中列明的金额及甲方向乙方电话、短信或书面通知为准。</p>
	//             <p>5.2、乙方在取车时对汽车状态有疑问的，应立即向甲方客服人员咨询，确认后才可使用租赁汽车。归还租赁汽车后，甲方如发现汽车状态或证件等出现问题，如有证据可确认是乙方责任的，乙方须承担赔偿责任及违约金。</p>
	//             <p>5.3、 乙方承诺向甲方租赁车辆，并已提交订单，乙方因自身原因需提前解约，按照甲方在“响车车”APP中公布的标准支付违约金。</p>
	//             <p>5.4、乙方承诺向甲方租赁日租车辆，在预约期间甲方未能在乙方的时间要求内完成车辆交付，在乙方不愿等待的情况下甲方退还乙方的租赁费用。</p>
	//             <p>5.5、乙方在租赁甲方的日租车辆时，因车辆自身原因造成车辆故障，甲方安排同款替换车辆给予乙方，如乙方因车辆自身故障不再使用甲方租赁车辆，甲方退回车辆自发生故障之时起剩余租期的租赁费用给乙方。</p>
	//             <p>5.6、乙方在租赁甲方的日租车辆时，因乙方自身原因发生交通事故或导致车辆无法行驶，乙方须承担租赁期间的全部租赁费用。</p>
	//             <p>5.7、乙方租赁甲方的日租车辆未能按时还车，甲方按“响车车”APP分时统一收费标准收取乙方超时部分的租赁费用。</p>
	//             <p class="f-bold">第六条、违约责任</p>
	//             <p>6.1、 任何一方未严格履行本合同及平台协议中义务的，另一方有权要求对方承担违约责任并赔偿损失及违约金，双方同意违约金标准定为10万元。</p>
	//             <p>6.2、乙方在控制租赁汽车期间应依约、合理、合法、合规使用汽车，同时须对汽车尽到善良的管理义务，否则即视为违约，承担方应承担一切责任，并赔偿甲方经济损失及违约金。</p>
	//             <p class="f-bold">第七条、其他补充</p>
	//             <p>7.1、乙方承诺并保证其在本协议履行期间均已获得信息主体的充分、合法的书面授权，即：甲方向乙方明确告知甲方将向第三方申请数据服务（需查询、使用和存储与数据服务相关的乙方所有个人信息，包括但不限于乙方身份信息、信用信息以及其他任何信息）用以判断乙方业务风险。乙方同意甲方及其合作的第三方采集和存储前述数据，甲方应妥善存档备查。同样，乙方请求与甲方发生相关信息或数据交互，要求甲方提供信息或数据的（已经公开的信息除外），应当事先告知甲方并应获得甲方的授权。</p>
	//            <p>7.2、乙方账号中甲方提供的通知联系方式、APP中的“响车车”平台协议、出租方官方网站的价格公示等，构成本合同的附件，与本合同具有同等法律效力。乙方在租赁汽车前已对该等内容清楚知晓，并无异议。</p>
	//            <p>7.3、乙方于签署本合同前己清楚知晓甲方公示的最新政策，并同意将该等政策作为本合同附件遵守。</p>
	//            <p>7.4、乙方确认，通过“响车车”APP内的通知联系方式，为甲方向乙方履行告知义务的唯一有效方式，甲方通过乙方账号中关联的电话、短信，电子邮件或邮递等任何一种方式履行告知后，即视为乙方收悉。</p>
	//             <p>7.5、争议的解决：因本合同产生的、或与本合同有关的任何争议，应由甲乙双方协商解决。无法协商解决的，向甲方所在地的人民法院提起诉讼。本合同生效后，各方均应全面履行本合同约定的义务。任何一方不履行或不完全履行本合同约定义务的，应当承担相应的违约责任，并赔偿由此给守约方造成的损失，包括守约方为实现债权而发生的律师费（律师费以每件案2万元计算）、保全费、诉讼收费、交通费、住宿费等。</p>
	//            <p>7.6、本合同自乙方在“响车车”APP中确认后生效。</p>
	//             <p>甲方：广州响车车科技有限公司</p>
	//             <p>签约人：</p>
	//             <p class="m-t20">乙方：</p>
	//             <p>签约人：</p>
	//             <p>联系方式：</p>
	//             <p>签约日期：</p>
	//         </div>
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .platform-protocol{
	    //     width:100%;
	    //     min-height:100%;
	    //     padding:.32rem;
	    //     box-sizing:border-box;
	    //     background:#fff;
	    //     color: #252F3A;
	    //     .pr-title{
	    //         font-size:.48rem;
	    //         text-align: center;
	    //         margin-bottom: .2rem;
	    //     }
	    //     p{
	    //         font-size:.346667rem;
	    //         line-height:.586667rem;
	    //     }
	    //     .f-bold{
	    //         font-weight: bold;
	    //     }
	    //     .m-t20{
	    //         margin-top:.533333rem;
	    //     }
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _const = __webpack_require__(233);
	
	module.exports = {
		data: function data() {
			return {
				oss_url: _const.oss_url
			};
		},
	
		components: {
			'hd': __webpack_require__(47)
		}
		// </script>
		//
		// <style lang="sass" scoped>
		// .platform-protocol{
		//     width:100%;
		//     min-height:100%;
		//     padding:.32rem;
		//     box-sizing:border-box;
		//     background:#fff;
		//     color: #252F3A;
		// }
		// </style>
		//
		//
		/* generated by vue-loader */
	
	}; // <template>
	// 	<div class="platform-protocol">
	// 		<hd title="证照信息"></hd>
	// 		<div>
	// 			<img alt="license_information" :src="oss_url + '/car_rental/license_information/license_information.jpg'"/>
	// 		</div>
	// 	</div>
	// </template>
	//
	// <script>

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <template>
	//     <div class="platform-protocol">
	//         <hd title="响车车平台协议"></hd>
	//         <div>
	// 			<h1 class="pr-title">响车车平台协议</h1>
	// 			<p class="f-bold">特别提示：</p>
	// 			<p class="f-bold" style="text-indent:2em;">本网络平台是由“广州响车车科技有限公司”提供，及其下属子公司负责运营。本协议是以下定义中所指与平台之间关于其使用网络平台服务所订立的协议。</p>
	// 			<p class="f-bold">一、定义</p>
	// 			<p>1、“会员”，是指在响车车用车平台（以下简称“平台”）有效注册后取得服务的使用人。根据会员账号的使用时长、信誉度、贡献值等，平台可给予会员由低到高依次为「青铜」、「白银」、「黄金」、「铂金」、「钻石」的会员等级，并享有对应特权，具体等级评定及特权规则以平台实际运营情况为准。</p>
	// 			<p>2、“注册人”，是指自愿提供个人信息按照平台要求进行注册并获得会员资格的人。</p>
	// 			<p>3、“用车人”，是指使用或者驾驶通过平台获得车辆的人。</p>
	// 			<p>4、“账号”，是指注册人通过平台注册得到的可以使用平台服务的账号。</p>
	// 			<p>5、“车辆”，是指通过平台发布租赁信息的、符合法律法规、平台标准和要求的可用于租赁的车辆。</p>
	// 			<p>6、“第三方运营机构”，是指除广州响车车科技有限公司以及子公司以外的，在平台上及线下提供车辆租赁相关产品服务的其他公司。</p>
	// 			<p>7、在完成平台会员注册之前，需详细阅读本协议。本协议在接受注册时生效，是和平台之间具有法律意义的文件，双方将同时受到本协议条款的约束。会员注册成功后，可通过手机验证码登录，对获得的验证码严格保管，未经平台书面许可不可随意透露给第三人。应对其注册的平台账号进行的所有活动和事件承担法律责任，包括但不限于车辆损坏维修费、车辆停运损失费、交通事故赔偿费用、平台维权所产生的律师费、诉讼费、差旅费等。</p>
	// 			<p>8、平台有权根据运营的实际情况对本协议之条款内容进行单方面的变更，并在平台官方网站、官方公众号及官方APP以公告的方式予以公布，无需另行单独通知。若在本协议之条款内容公告变更后继续使用本服务，表示已充分阅读、理解并接受修改后的条款内容，也将遵循修改后的条款内容使用本服务。</p>
	//
	// 			<p class="f-bold">二、 会员资格及注册</p>
	// 			<p>1、凡年龄在18周岁（含）以上、持有中华人民共和国有效身份证件（二代身份证）和中华人民共和国有效驾驶执照（准驾车型为C1或C2（含）以上）可申请入平台。港澳居民来往内地通行证、大陆通行证、护照、外籍人士暂无法申请。</p>
	// 			<p>2、如果会员的驾照在任何时间被吊销、没收、失效或其状态发生变化，会员必须立即通知平台, 且在此期间会员不得使用或预订任何平台用车服务。</p>
	// 			<p>3、会员账号的所有权归平台享有，会员必须使用本人的有效信息完成注册申请手续后，才可获得平台账号的使用权。会员应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽、准确的要求。所有原始键入的资料将作为注册资料。平台有权就会员所提交资料与信息，通过第三方平台，就其真实性、可靠性及信用等级进行评估。</p>
	// 			<p>4、如果因会员注册信息不真实而引起的一切问题及其产生的后果，平台不负任何责任，且平台有权对会员账号进行停封。如对平台造成损失，平台有权追究会员责任及索赔损失。</p>
	//
	// 			<p class="f-bold">三、 会员权利及义务</p>
	// 			<p>1、会员享有使用平台产品和服务的权益，且会员在使用平台的产品时均不限行驶里程（有固定里程限制的产品除外）。</p>
	// 			<p>2、会员须如实告知或填写相关信息（包括但不限于身份证件、联系方式等），保证相关证件和信息真实有效，并保证同一证件只允许关联一个会员账号信息，并且使用车辆期间会员信息所载明的联系方式有效。若出现注册人与用车人信息不对称，则由此产生的后果/责任均由注册人自行承担。</p>
	// 			<p>3、会员使用平台车辆服务期间，必须随身携带有效的中国大陆交管部门核发的并按要求审验的《中华人民共和国机动车驾驶证》，才可驾驶平台车辆。</p>
	// 			<p>4、会员须自行承担车辆租赁使用中产生的过路、过桥、停车、车辆电费等费用（包含但不限于以上自付费项目或因会员原因而产生的费用），自行负责车上人员及财产的安全。</p>
	// 			<p>5、会员在使用平台服务时应当严格遵守道路交通规则，不得酒驾、醉驾、超速驾驶及其他违反道路交通规则行为，对车辆造成损失，应由会员承担相应及由此带来的一切损失，并独立承担因交通事故产生的相关责任。</p>
	// 			<p>6、如车辆出现故障或异常，会员应立即通知平台，不得擅自拆卸、更换原车设备及零件并到平台指定的地点修理。</p>
	// 			<p>7、平台所有车辆只能作为自用车辆使用，会员不得将车辆用于营利性运营、竞赛、抵押、测试、实验、教练等活动；不得将车辆用于承载有毒有害及违禁物品；不得将车辆用于从事违法、违规活动。否则，会员除了赔偿平台及车辆停运等的相关损失外，构成刑事犯罪的，将被追究刑事责任。</p>
	// 			<p>8、会员不得有转租、转借、抵押、倒卖或其它任何损害平台车辆所有权和使用权的行为，否则，将承担由此产生的一切损失及相关法律责任。</p>
	// 			<p>9、会员在使用车辆期间，应保持车辆外观、内饰的整洁、完好。此外，车内禁止携带宠物、海鲜、食醋等会污损内饰及异味较大的物品。在用车期间如产生污损或异味应清洁整洁后返还车辆。如未清理，会员需承担车辆整备费用及造成的损失。</p>
	// 			<p>10、会员还车时，由于会员个人原因致使车辆牌照、车钥匙、证件等车内物品丢失，除支付补办相关物品的全部费用外，还应当承担补办相关物品期间给平台造成的停运损失。</p>
	// 			<p>11、会员不得携带没有配备安全座椅或未正确使用安全座椅的不满4周岁的儿童驾驶平台车辆，也不得携带未满12周岁的未成年人乘坐在副驾驶位置。</p>
	// 			<p>12、会员不得将个人平台的账号、密码转让或出借予他人使用。如会员将从平台获得的车辆交予本人外的其他任何人使用或者驾驶，一经发现，平台有权立即通过会员账号所绑定的任何支付方式和支付渠道（包括但不限支付宝、网银等）扣除1000元作为违约金，且有权冻结会员的账号。</p>
	// 			<p>13、如会员发现账号遭他人非法使用，应立即通知平台。因黑客行为或会员个人的保管疏忽导致账号、密码遭他人非法使用，平台将不承担任何责任。</p>
	//
	// 			<p class="f-bold">四、 会员使用规则</p>
	// 			<p>1、 会员在使用平台服务时，必须遵守中华人民共和国相关法律法规的规定，会员不得利用平台服务进行任何违法或不正当的活动，会员不得有包括但不限于如下行为：</p>
	// 			<p>(1) 提供虚假信息，或盗用他人信息的；</p>
	// 			<p>(2) 未按约定用途使用车辆的或违反相关法律法规使用车辆的；</p>
	// 			<p>(3) 转卖、抵押、典当、转借、转租或确有证据证明可能存在上述情况的；</p>
	// 			<p>(4) 不按协议约定交纳各项费用、使用车辆、保管车辆、归还车辆的；</p>
	// 			<p>(5) 利用车辆从事违法犯罪活动的；</p>
	// 			<p>(6) 擅自对车辆改装、更换、拆卸或增设它物的；</p>
	// 			<p>(7) 利用任何方式方法危害平台安全的；</p>
	// 			<p>(8) 利用平台或其提供的车辆，损害任何第三人合法权益的；</p>
	// 			<p>(9) 为任何非法目的而使用平台网络服务系统；</p>
	// 			<p>(10) 对平台服务任何部分通过平台服务任何部分或使用平台服务获得的任何内容，进行复制、拷贝、出售、转售或用于任何其它商业目的。</p>
	// 			<p>(11) 利用平台网络服务系统复制、发布含有下列内容信息的：</p>
	// 			<p>1) 反对宪法所确定的基本原则的；</p>
	// 			<p>2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；</p>
	// 			<p>3) 损害国家荣誉和利益；</p>
	// 			<p>4) 煽动民族仇恨、民族歧视，破坏民族团结；</p>
	// 			<p>5) 破坏国家宗教政策，宣扬邪教和封建迷信；</p>
	// 			<p>6) 散布谣言，扰乱社会秩序，破坏社会稳定；</p>
	// 			<p>7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；</p>
	// 			<p>8) 侮辱或者诽谤他人，侵害他人合法权利的；</p>
	// 			<p>9) 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵，或其它道德上令人反感的内容；</p>
	// 			<p>10) 恶意诋毁平台的（包括在平台以及在其他任何地方）；</p>
	// 			<p>11) 含有法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其他内容的。</p>
	// 			<p style="text-indent:2em;">如平台发现或收到第三方举报、投诉获知，会员存在或涉嫌违反以上规定的，平台有权依据其合理判断并经通知后立即采取一切必要措施以减轻或消除相关行为造成的影响，由此造成的损失及后果由会员自行独立承担。采取的一切必要措施包括但不限于以下一项或多项：</p>
	// 			<p>A. 更改、删除或屏蔽相关内容；</p>
	// 			<p>B. 警告违规会员账号、账号禁言；</p>
	// 			<p>C. 冻结违规会员账户资金，用于弥补给平台及其关联公司、他人造成的损失；</p>
	// 			<p>D. 变更、限制或禁止违规会员账号部分或全部功能；</p>
	// 			<p>E. 暂停、限制或终止会员使用平台服务的权利、注销会员账号等；</p>
	// 			<p>F. 向有关监管部门或国家机关报告；</p>
	// 			<p>G. 其他平台认为合理的措施。</p>
	// 			<p>2、 会员使用平台服务应遵守平台通过移动客户端、微信公众号等官方渠道已发布及将来不定期更新的相关使用规范及使用指引。</p>
	// 			<p>3、 会员应按本协议约定和平台发布的使用规范及使用规则订车、取车与还车。</p>
	// 			<p>4、 不得以任何方式盗开平台车辆，否则平台有权追索损失，并追究相应法律责任。</p>
	// 			<p>5、 会员使用车辆的过程中，不得乱停乱放，否则会员将自行承担因乱停乱放引起的交通违章、罚款责任，平台有权追索损失，并追究相应法律责任。</p>
	//
	// 			<p class="f-bold">五、 服务说明</p>
	// 			<p>1、 平台网络服务的具体内容由平台根据实际情况提供，平台对其提供之服务拥有最终解释权。</p>
	// 			<p>2、 除非本服务协议另有其它明确规定，平台在会员注册后所推出的新产品、新功能、新服务，均受到本服务协议之规范和约束。</p>
	// 			<p>3、 鉴于网络服务的特殊性，会员同意平台有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。平台不担保网络服务不会中断，对网络服务的及时性、安全性、准确性均不作担保。</p>
	// 			<p>4、 平台需定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，平台无需为此承担任何责任。平台保留不经事先通知为维修保养、升级或其它目的暂停全部或部分的网络服务的权利。</p>
	// 			<p>5、 会员明确同意其使用平台网络服务所存在的风险将完全由其自己承担。</p>
	// 			<p>6、 平台有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，平台对会员和任何第三人均无需承担任何责任。</p>
	// 			<p>7、 会员同意平台有权基于其自行之考虑，因任何理由，包含但不限于会员长时间未使用车辆，或平台认为会员已经违反本协议的文字及精神，终止会员的密码、账号或平台服务之使用（或服务之任何部分），并将会员在平台服务内任何内容加以移除并删除。会员同意依本协议任何规定提供之平台服务，无需进行事先通知即可中断或终止；会员承认并同意，平台可立即关闭或删除会员的帐号及会员账号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，会员同意若本服务之使用被中断或终止或会员的账号及相关信息和文件被关闭或删除，平台对会员或任何第三人均不承担任何责任。</p>
	// 			<p>8、 如会员提出发票要求的，会员订单结束后在微信公众号“响车车”留言开票信息，平台每周五统一开具有效等额发票。</p>
	// 			<p>9、 通过平台发布的车辆符合以下标准：</p>
	// 			<p>(1) 行驶证件原件或复印件齐全有效且为平台所有或有使用权；</p>
	// 			<p>(2) 已按照国家、本市有关规定和本合同约定办理相应保险；</p>
	// 			<p>(3) 技术性能良好、符合安全行驶条件；</p>
	// 			<p>(4) 车内配备有效的车用灭火器、故障车警示标志牌和必要的维修工具（根据具体车型而定）。</p>
	// 			<p>10、 平台为保证车辆车况，安排专业人员为车辆及附属品等提供全方位的保障服务，保障车辆安全有效。</p>
	//
	// 			<p class="f-bold">六、预定、取、还车说明</p>
	// 			<p>1、 预定说明</p>
	// 			<p>(1) 会员可以通过平台在手机APP客户端以及微信小程序等互联网方式来进行下单取车。</p>
	// 			<p>(2) 会员相关证件有效期须至少超过当次使用期限的一个月以上，否则需联系平台客服及时更新相关证件。</p>
	// 			<p>2、 取车说明</p>
	// 			<p>(1) 预订方式:会员需使用手机客户端/微信小程序预订车辆。会员预订时,可选择车辆，预订页面将显示计价规则、车辆具体信息等订单信息。</p>
	// 			<p>(2) 会员预定车辆后可免费为其保留15分钟（限每天三次），超过15分钟后将开始计费，若在计费后30分钟（含）以上，车辆没有启动，平台有权自动取消该订单，会员需支付预定该车辆30分钟内所产生的费用。</p>
	// 			<p>(3) 取车时，会员应当确认车辆及附属品的实际状况拍照上传车况，如有疑问请会员拍照并且请致电客服。如取车时未及时上报车辆情况而导致后续车辆损失追责的，会员应当承担相应责任。</p>
	// 			<p>3、 还车说明</p>
	// 			<p>(1) 还车时会员应将车辆开至平台指定服务网点位置（暂不支持跨城市还车），还车时间以会员实际操作完成还车流程的时间为准，确认所有订单完成后终止合同。</p>
	// 			<p>(2) 车辆（连同其钥匙和所有的附属物品，包括行驶本，手册，车轮防盗螺母，备胎，充电线等）须一并归还，且要保持和使用开始前一致的状况，如发生丢失或损坏需照价赔偿，相应产生的停运损失费及其它费用需一并赔偿。</p>
	// 			<p>(3) 会员应在归还车辆时，确保车内无任何个人财物。如还车时，有任何会员的个人财物落在车中，所产生的相应责任由会员个人承担，平台不承担任何责任。</p>
	// 			<p>4、 未按约定还车说明</p>
	// 			<p>(1) 会员结束订单时，应将车辆归还至平台指定服务网点位置，并确认车辆状态完好，查看无误后在会员端操作还车。</p>
	// 			<p>(2) 如会员还车时，未将车辆停放至营业网点指定区域，由此给平台造成的一切损失由会员承担，同时平台有权追究会员的法律责任，并有权取消违约会员的资格。</p>
	// 			<p>(3) 如在承租期间，弃车或者将车辆停放至影响交通的地方，需赔偿一定损失并收取车辆调度费用。</p>
	//
	// 			<p class="f-bold">七、 计费规则及收费项目</p>
	// 			<p>1、 用车费用：</p>
	// 			<p>（1）计费模式分为分时计费、小时计费、套餐计费，实际费用可能因优惠活动、车型不同而调整，最终价格以平台官方APP显示为标准。</p>
	// 			<p>（2）如因优惠活动、优惠套餐等导致实际费用高于按原固定收费标准结算的费用，则按原固定收费标准据实结算，会员可联系平台客服复核订单并申请返还差额部分费用。</p>
	// 			<p>（3）平台客服复核确认存在上述第（2）条所述情形的，平台除返还订单差额部分费用外，不存在任何欺诈、恶意收费等行为，不因此承担任何法律责任。</p>
	// 			<p>2、 押金：会员在注册时需缴纳一定额度的押金，具体以平台官方APP显示为准。会员拖欠平台费用和/或给平台造成损失的，平台有权从该会员缴纳的押金中抵扣该会员欠付平台的费用和/或损失赔偿金，如押金不足以抵扣该会员欠付平台的费用和/或损失赔偿金的，就未能抵扣的部分，该会员应向平台另行支付。当会员押金被抵扣后，剩余押金金额低于平台制订的押金额度时，该会员应在收到平台通知后立即补足押金，否则平台有权终止该会员的账号。</p>
	// 			<p>3、 特别声明：</p>
	// 			<p>（1）会员需在车辆损坏后应第一时间向平台报备车损情况，否则视为自动放弃相应的服务权益；所有损失必须由会员承担；</p>
	// 			<p>（2）平台提供相应服务仅针对账号关联自然人驾驶而言；</p>
	// 			<p>（3）如会员恶意破坏车辆，则无法获得相应服务。</p>
	// 			<p>4、 维修费用说明（具体费用要联系运维查询）</p>
	// 			<table border="1" class="pp-table">
	// 				<tr>
	// 					<td colspan="4" align="center">车辆损失费</td>  
	// 				</tr>
	// 				<tr>
	// 					<th>车损类型</th> 
	// 					<th>说明</th>
	// 					<th>维修价格（元）</th> 
	// 					<th>备注</th> 
	// 				</tr>
	// 				<tr>
	// 					<td>前、后杠损伤</td>
	// 					<td>每件</td>
	// 					<td>300</td>
	// 					<td>按每件计算，前、后分别计算；如需更换零件，材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td>叶子板、车门剐蹭及凹陷</td>
	// 					<td>每一面</td>
	// 					<td>350</td>
	// 					<td>按每个面计算。如左前门，算一个面。如需更换零件，材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td>前后盖剐蹭及凹陷</td>
	// 					<td>每一面</td>
	// 					<td>500</td>
	// 					<td>按每个面计算，前、后分别计算</td>
	// 				</tr>
	// 				<tr>
	// 					<td>后视镜破损</td>
	// 					<td>每一边</td>
	// 					<td>50</td>
	// 					<td>如需更换零件，材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td>前挡玻璃破损</td>
	// 					<td>一面</td>
	// 					<td>200</td>
	// 					<td>材料费另计。</td>
	// 				</tr>
	// 			   <tr>
	// 					<td>后挡玻璃破损</td>
	// 					<td>一面</td>
	// 					<td>200</td>
	// 					<td>材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td>车窗玻璃破损</td>
	// 					<td>每一面</td>
	// 					<td>100</td>
	// 					<td>按每个面计算。如左前窗，算一个面。材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td>不带漆硬质塑料件断裂、破损需要更换的</td>
	// 					<td>每一件</td>
	// 					<td>100</td>
	// 					<td>材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td rowspan="3">前大灯面、尾灯面</td> 
	// 					<td>大灯划痕</td> 
	// 					<td>100</td> 
	// 					<td></td>  
	// 				</tr>
	// 				<tr> 
	// 					<td>灯脚修复</td> 
	// 					<td>150</td> 
	// 					<td></td>  
	// 				</tr>
	// 				<tr> 
	// 					<td>破损、开裂需要跟换</td> 
	// 					<td>50</td> 
	// 					<td>材料费另计。</td>  
	// 				</tr>
	// 				<tr>
	// 					<td>轮毂</td>
	// 					<td>轮毂缺口、翻边</td>
	// 					<td>50</td>
	// 					<td>如需更换零件，材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td>轮胎</td>
	// 					<td>鼓包、开裂、其他无法修复情况</td>
	// 					<td>50</td>
	// 					<td>材料费另计。</td>
	// 				</tr>
	// 				<tr>
	// 					<td rowspan="2">充电枪插口</td> 
	// 					<td>充电枪插口变形</td> 
	// 					<td>150</td> 
	// 					<td>如需更换零件，材料费另计。</td>  
	// 				</tr>
	// 				<tr> 
	// 					<td>充电枪插口支架变形</td> 
	// 					<td>300</td> 
	// 					<td>如需更换零件，材料费另计。</td>  
	// 				</tr>
	// 				<tr>
	// 					<td colspan="4">说明：以上材料费报价，以指定维修厂报价为准（不高于4S店零配件价格）</td>  
	// 				</tr>
	// 			</table>
	// 			<p>5、 网点取还车相关费用：</p>
	// 			<p>（1）取车相关费用：部分网点取车，由于场地原因，需要支付一定停车费用，具体费用根据网点显示为准，可在订单结束后7个工作日内上传停车票报销。</p>
	// 			<p>（2）还车相关费用：</p>
	// 			<p> a）部分网点不通还，由于场地原因，不在车辆所关联的还车点操作还车；若在非车辆所关联的还车点还车时,需额外支付调度费和停车费用,包括自主关联还车点还车及因原因导致车辆故障或事故而关联还车点还车,具体收费标准如下:调度费=起步价+里程单价（元/KM）*行驶里程（行驶里程计算起点为取车地,终点为预约还车点。）</p>
	// 			<table border="1" class="pp-table">
	// 				<tr>
	// 					<th>还车地/故障发生地</th>
	// 					<th>起步价</th>
	// 					<th>里程单价</th>
	// 				</tr>
	// 				<tr>
	// 					<td>广东</td>
	// 					<td>200元</td>
	// 					<td>5元/KM</td>
	// 				</tr>
	// 				<tr>
	// 					<td>广西</td>
	// 					<td>500元</td>
	// 					<td>20元/KM</td>
	// 				</tr>
	// 				<tr>
	// 					<td>在预约还车点所在城区内的非预约还车点(200元封顶）</td>
	// 					<td>50元</td>
	// 					<td>20元/KM</td>
	// 				</tr>
	// 			</table>
	// 			<p> b）如造成违章停车并被处罚的,需自行解决或承担违章责任和相关费用。平台有权追究的法律责任,并有权取消的租车资格。</p>
	// 			<p> c）网点取还车会根据运营情况做调整，用车时请仔细查询阅读。</p>
	// 			<p>6、 其他收费标准：</p>
	// 			<p>(1) 除本协议另有约定外，会员在使用服务期间，如有物品损坏、遗失的，损失赔偿标准详见下表，如表中无相关项目，以实际损失为准。</p>
	// 			<table border="1" class="pp-table">
	// 				<tr>
	// 					<th>项目</th>
	// 					<th>赔偿价格</th>
	// 					<th>备注</th>
	// 				</tr>
	// 				<tr>
	// 					<td>行驶证</td>
	// 					<td>500元</td>
	// 					<td>造成车辆停运的，还需支付停运损失费</td>
	// 				</tr>
	// 				<tr>
	// 					<td>交强险标</td>
	// 					<td>50元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>年检标</td>
	// 					<td>50元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>环保标</td>
	// 					<td>50元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>车钥匙</td>
	// 					<td>600元</td>
	// 					<td>造成车辆停运的，还需支付停运损失费</td>
	// 				</tr>
	// 				<tr>
	// 					<td>故障警示牌</td>
	// 					<td>100元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>充电线</td>
	// 					<td>30元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>灭火器</td>
	// 					<td>100元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>停车场停车卡或凭证</td>
	// 					<td>100元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>车身车贴</td>
	// 					<td>200元</td>
	// 					<td></td>
	// 				</tr>
	//
	// 				<tr>
	// 					<td>拖车钩</td>
	// 					<td>100元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>尾箱隔板</td>
	// 					<td>400元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>地毯</td>
	// 					<td>200元</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>其他物品</td>
	// 					<td>视实际费用而定</td>
	// 					<td></td>
	// 				</tr>
	// 			</table>
	// 			<p>备注：以上费用根据不同车型会有程度不等的价格浮动调整。</p>
	// 			<p>(2) 除本协议另有约定外，会员在使用服务期间，如有以下非法或不文明行为的，平台有权按下表要求会员赔偿损失。</p>
	// 			<table border="1" class="pp-table">
	// 				<tr>
	// 					<th>赔偿项</th>
	// 					<th>描述</th>
	// 					<th>赔偿金额</th>
	// 					<th>其他</th>
	// 					<th>赔偿总金额</th>
	// 				</tr>
	// 				<tr>
	// 					<td rowspan="3">影响车内整洁</td>
	// 					<td>乱扔垃圾影响车内整洁（轻度污染）</td>
	// 					<td>50元</td>
	// 					<td align="center">-</td>
	// 					<td>50元</td>
	// 				</tr>
	// 				<tr>
	// 					<td>呕吐、排泄、带宠物以及海鲜水产等严重影响车内整洁（重度污染）</td>
	// 					<td>300元</td>
	// 					<td align="center">-</td>
	// 					<td>300元</td>
	// 				</tr>
	// 				<tr>
	// 					<td>因烟头、呕吐、饮料等造成座椅损伤或者损害（污染且损坏）</td>
	// 					<td>500元</td>
	// 					<td align="center">-</td>
	// 					<td>500元</td>
	// 				</tr>
	// 				<tr>
	// 					<td rowspan="2">乱停乱放</td>
	// 					<td>未还车至营业网点指定区域，乱停放车辆</td>
	// 					<td>100元</td>
	// 					<td>因乱停车产生的费用</td>
	// 					<td>100元+因乱停造成的费用</td>
	// 				</tr>
	// 				<tr>
	// 					<td>使用途中弃车或者将车辆停放至影响交通的地方</td>
	// 					<td>200元</td>
	// 					<td>车辆调度费用 5元/km</td>
	// 					<td>200元+车辆调度费用</td>
	// 				</tr>
	// 				<tr>
	// 					<td>盗开车辆</td>
	// 					<td>使用各种不正当手段，绕开产品平台使用车辆</td>
	// 					<td>1000元</td>
	// 					<td>违章押金：1000元</td>
	// 					<td>1000元+其他所有损失</td>
	// 				</tr>
	// 				<tr>
	// 					<td>非本人使用账号用车</td>
	// 					<td>将账号给予他们使用</td>
	// 					<td>1000元</td>
	// 					<td align="center">-</td>
	// 					<td>1000元+其他所有损失</td>
	// 				</tr>
	// 				<tr>
	// 					<td>从事违法犯罪行为</td>
	// 					<td>利用车辆从事违反犯罪行为</td>
	// 					<td>1000元</td>
	// 					<td align="center">-</td>
	// 					<td>1000元+其他所有损失</td>
	// 				</tr>
	// 				<tr>
	// 					<td>车辆被查扣</td>
	// 					<td>因会员原因，导致车辆被扣</td>
	// 					<td align="center">-</td>
	// 					<td>相应损失</td>
	// 					<td>相应损失</td>
	// 				</tr>
	// 				<tr>
	// 					<td colspan="5" align="center">注：以上行为如导致车辆停运的，还需根据实际停运天数，收取停运损失费用</td>  
	// 				</tr>
	// 			</table>
	//
	// 			<p class="f-bold">八、 事故处理及保险理赔</p>
	// 			<p>1、 如车辆不慎出险，请您注意人身安全，并立即致电客服中心报案，车辆需由保险公司定损后再修理；</p>
	// 			<p>2、 为避免处理不当给您带来损失，请您按以下指引处理事故：</p>
	// 			<p>(1) 双方交通事故：</p>
	// 			<p>1) 请您立即停车，记录相关事故车辆的车牌号码，索要对方电话号码。</p>
	// 			<p>2) 检查对方驾驶执照，如对方无有效驾照，请立即拨打110报警。</p>
	// 			<p>3) 依据《交通事故快速处理办法》所列的事故情形明确双方责任，如能达成一致：</p>
	// 			<p>A. 拍摄第一现场照片：全景照片（现场位置、痕迹、事故损失全貌），物证及特写照片（车牌号、受损部位、受损程度等）。</p>
	// 			<p>B. 驶离现场至不妨碍交通的地方。</p>
	// 			<p>C. 填写《交通事故快速处理协议书》，当事各方各持一份。</p>
	// 			<p>D. 拨打保险公司报案，获得报案号和报险建议。</p>
	// 			<p>注：《交通事故快速处理协议书》填写项目要齐全，时间精确到分，事故地点具体到所在区域及道路具体名称，各方驾驶证、电话号码需进行核对；保险“报案号”待报案后会获得。</p>
	// 			<p>(2) 如不能明确双方责任：</p>
	// 			<p>1) 请立即报警（110）等待警察处理。</p>
	// 			<p>2) 请于事故车后100米处安放随车附带的三角警示牌，同时将车辆双闪警示灯打开，以便使行驶车辆安全避让。</p>
	// 			<p>3) 立即致电平台客服中心400-863-7833报备。</p>
	// 			<p>4) 请根据报险处理建议，携带车辆行驶本和驾照，将车辆送到指定地点定损（定损时需要事故车辆同时到场以便勘察定损）。</p>
	// 			<p>5) 请按指导收集理赔所需材料，并将材料交与指定维修人员。</p>
	// 			<p>(3) 如遇对方车辆肇事逃逸的、对方车辆无号牌的、对方驾驶员无驾驶证或饮酒后驾驶车辆的，请您记录相关信息（如：车牌号，车辆品牌，颜色以及肇事地点）并立即报警（110），等候交警处理，同时请您致电客服中心以获得保险方面的咨询和建议。</p>
	// 			<p>(4) 如车辆与障碍物、建筑物发生碰撞，或车辆停放期间被碰撞而找不到肇事者，请您将车辆损坏部位以及碰撞物体进行比对拍照，并致电平台客服中心，以便车辆能够得到及时修复。</p>
	// 			<p>(5) 如遇重大交通事故且有人员伤亡的，请保护现场，并拨打120及110交通事故报警台求助，同时请立即致电平台客服中心获得保险方面的咨询和建议。</p>
	// 			<p>(6) 如因会员原因，导致事故车辆保险公司不予以受理，出险拒赔的，应当承担赔偿相应损失的责任，包括但不限于车辆的维修费用、加速折旧费、停运损失费用以及由其引起的律师费、诉讼费、差旅费等。</p>
	// 			<p>3、 平台向提供的车辆都已投保了交通责任强制险、车损险、第三者责任险壹佰万元（个别车辆视投保情况而定）、座位险，如车辆出现事故定损额超出保险理赔额度，超出部分由会员承担。</p>
	// 			<p>4、 车辆事故保险理赔情况说明：</p>
	// 			<p style="text-indent:2em;">在使用平台车辆的过程中发生交通事故产生的所有费用（包含车辆维修费用、人伤医疗费用、三者财产损失费用等）均需由会员垫付，会员需保存好垫付费用凭证或者相应发票。</p>
	// 			<p style="text-indent:2em;">为避免保险公司拒赔或视会员放弃理赔，请会员务必在出险之日起15日内（特大人伤事故，或费用超 1万元，可延长7日）将保险理赔所需事故材料完整提供给平台。</p>
	// 			<p style="text-indent:2em;">垫付的费用中涉及保险公司理赔金额的,平台在保险公司赔付款到账后7个工作日内返还给会员。对于超出理赔金额,或者不属于理赔范围的维修费用,由会员自行承担。</p>
	// 			<p>根据车辆事故具体情况定为会员主责事故和会员非主责事故，具体说明如下：</p>
	// 			<p>* 如事故为会员主责事故,平台（车主）车辆维修费用在1000元以下,由会员自行承担车损维修费用，并协助平台取消保险报案。但如果会员使用车辆时已额外向平台购买保险服务，则当事故为会员主责事故且平台（车主）车辆维修费用在1000元以下（需会员主动上报事故），该费用由平台（车主）承担。（如不主动上报将不予以免责）。如事故为会员主责事故,平台（车主）车辆维修费用在1000元以上，可由商业险赔付，但会员需支付1500元/次的保险增幅费用。</p>
	// 			<p>* 如事故为会员主责事故,平台车辆维修费用在2000元以上，可由商业险赔付，但会员需支付1500元/次的保险增幅费用。</p>
	// 			<p>* 如事故为会员主责事故,平台车辆维修费用≥10000元，会员需支付1500元/次的保险增幅费用及按车辆定损金额的20%车辆加速折旧费用。</p>
	// 			<p>备注：发生事故后，请勿擅自维修事故车辆，否则会员将承担赔偿损失等违约责任。</p>
	// 			<p>* 如事故为会员主责事故,第三者损失在2000元以内触发保险理赔时,属于交强险理赔的维修费用由会员先行垫付；</p>
	// 			<p>* 如事故为会员主责事故，第三者损失超过2000元可用商业保险理赔的,三者及商业险维修费用由会员垫付。会员还应支付1500元/次的保险增幅费。</p>
	// 			<p>* 如事故为会员无责事故，会员有义务协调平台走完保险事故理赔处理流程，会员不承担平台车辆维修费用及相应车辆停运损失费。</p>
	// 			<p>5、 平台（车主）车辆事故停运费收取标准及说明：</p>
	// 			<p>* 会员在使用服务期间发生有责事故导致平台（车主）车辆停运，平台（车主）有权收取停运损失费用，具体收费标准视车辆定损金额而定。</p>
	// 			<table border="1" class="pp-table">
	// 				<tr>
	// 					<th>车辆定损金额</th>
	// 					<th>事故停运费天数</th>
	// 					<th>收费标准</th>
	// 				</tr>
	// 				<tr>
	// 					<td>1000元以下</td>
	// 					<td>1天</td>
	// 					<td rowspan="4">车型日租车辆价格*事故停运天数</td>
	// 				</tr>
	// 				<tr>
	// 					<td>1000元-10000元</td>
	// 					<td>5天</td>
	// 				</tr>
	// 				<tr>
	// 					<td>10000元-30000元</td>
	// 					<td>10天</td>
	// 				</tr>
	// 				<tr>
	// 					<td>30000元以上</td>
	// 					<td>20天</td>
	// 				</tr>
	// 			</table>
	// 			<p>* 因会员拒绝垫付理赔费用及会员其他原因，导致平台（车主）车辆未能及时维修,会员还应承担自事故发生日期起至车辆开始维修期间的停运损失费用。（每日停运费用按照车型日租车辆价格计算）</p>
	// 			<p>6、 会员在使用服务期间发生交通事故的，均需及时报警报案并联系平台客服中心。未能立即报告事故和配合事故调查，会员承担全部责任和费用。会员对于在汽车使用期间发生任何保险理赔的问题，有责任全力配合平台和保险公司的工作。会员不得隐瞒使用服务期间车辆发生的任何意外事故。如发生事故，会员应及时通知平台客服中心（电话400-863-7833），并及时向当地公安机关及保险公司报案，以便平台协助处理保险理赔事宜。</p>
	// 			<p>7、 如发生事故后，会员擅自离开现场或者逃逸，会员需承担因此造成所有的损失。同时，平台保留追责以及起诉的权力。</p>
	// 			<p>8、 会员使用服务期间因车辆事故导致的侵权或违法及其他间接损失由会员自行承担。</p>
	// 			<p>9、 保险公司不予理赔的损失包括但不限于以下情况造成的损失，该等损失和后果将由自行承担：</p>
	// 			<p>1) 超过保险承保范围的,例如由于故意的不当操作或严重疏忽造成的损坏;</p>
	// 			<p>2) 不通知平台和不为及时索赔提供必要的支持;</p>
	// 			<p>3) 无证驾驶,持逾期未审验的驾驶执照驾驶车辆;</p>
	// 			<p>4) 在药物影响下驾驶,酒后驾车,鲁莽驾驶,</p>
	// 			<p>5) 肇事逃逸,破坏证据;若在用车期间发生事故出险,需要第一时间拍摄现场照片并向平台进行报案登记,订单结束仍未报案的,则视为不报,不予赔付,责任由会员自己承担。</p>
	// 			<p>10、 如果车辆在使用服务期内（或在服务期以外的，会员仍然占有或负责车辆的任何时段）被盗，会员必须在得知情况后尽快电话通知平台和警方。</p>
	// 			<p>11、 车辆发生各类机件故障、事故车修复，应当到平台指定的4S店进行检测及修理。如因会员原因导致损坏，会员应当支付由此造成的修理费用、施救费用及维修期间平台的营业损失（损失以实际维修所用时间的平台本应收取的车型日租车辆价格为单位计算）由此给平台或第三方造成其他损失的，会员应予赔偿。</p>
	//
	// 			<p class="f-bold">九、 救援服务</p>
	// 			<p>平台向使用车辆的会员提供“7X24小时”的救援服务。会员遇到紧急情况，可致电24小时会员服务中心400-863-7833。</p>
	// 			<p>1、 由于车辆本身故障，导致车辆无法使用，平台将提供现场紧急修理服务，救援费用由平台承担。</p>
	// 			<p>(1) 若车辆故障无法现场修复，会员可将车辆交与平台指定的救援商。</p>
	// 			<p>(2) 若在平台服务点覆盖范围内，会员可到就近平台网点处理更换车辆（提供备用车），平台优先为会员提供同级别或高级别车辆，费用按原车型计费；如无车辆，将为会员提供低级别车辆（费用按低级别车辆价格计费），如均无法为会员提供解决方案，可选择退单如有具体补偿细节，按当时情况进行处理。</p>
	// 			<p>(3) 若在平台网点覆盖范围外，会员需按平台指导联系救援商救援车辆。</p>
	// 			<p>2、 非车辆本身故障导致无法正常行驶的（包含且不限于人为操作失误、保险事故等），救援费用由会员承担（保险公司承担除外）。会员可自行选择救援商或平台提供的道路救援服务，相关费用由会员自行承担。</p>
	// 			<p style="text-align: center;">道路救援服务内容表</p>
	// 			<table border="1" class="pp-table">
	// 				<tr>
	// 					<th>服务项目</th>
	// 					<th>服务描述</th>
	// 					<th>服务价格</th>
	// 					<th>备注</th>
	// 				</tr>
	// 				<tr>
	// 					<td>更换轮胎</td>
	// 					<td>车辆因会员原因，导致轮胎损坏无法行驶时，提供更换备胎服务</td>
	// 					<td>350元/次</td>
	// 					<td>具体视车型而定</td>
	// 				</tr>
	// 				<tr>
	// 					<td>开锁服务</td>
	// 					<td>车辆钥匙遗失，或者因会员原因导致车辆被锁或者车辆离线，平台提供开锁服务（补钥匙费用另算）</td>
	// 					<td>200元/次</td>
	// 					<td></td>
	// 				</tr>
	// 				<tr>
	// 					<td>拖车服务</td>
	// 					<td>车辆因会员原因，导致电瓶缺电无法启动车辆，提供拖车服务</td>
	// 					<td>200-500元/次</td>
	// 					<td>高速上拖车视实际拖车费用而定</td>
	// 				</tr>
	// 			</table>
	//
	// 			<p class="f-bold">十、 违章说明</p>
	// 			<p>1、 会员使用服务期内的违章及相关费用等责任由会员自行承担，平台将短信或电话通知会员使用服务期内的车辆违章，届时请查询短信、响车车APP内违章信息或致电客服电话询问详情。</p>
	// 			<p>2、 违反交通安全法规时，如现场被告知（比如违反规定停放车辆，被贴条等），应在被告知的5个工作日内接受处罚；如非现场被告知，平台可发出通知（包括电话、微信、电子邮件、短信等方式）会员交通违章信息，会员收到通知后，应于7个工作日内自行处理，逾期未处理，视为会员自动委托平台处理相关违章，平台有权采取必要措施，平台有权在违章会员账户内扣除违章罚款等同金额及每次违法行为所产生的损失费用，具体扣款金额以平台根据违章会员的违章情形向违章会员发出的通知为准。会员如拒绝接受处罚，会员应承担由此给平台造成所有的损失，并且平台保留追究法律责任及善后处理的一切权利。</p>
	//
	// 			<p class="f-bold">十一、 会员违约</p>
	// 			<p>1、会员因违法违规使用车辆导致车辆被扣的或不能上路行驶而导致车辆停运的，自停运之日起，会员需按相应车型标准承担停运损失费以及违约金，同时，如有其它经济损失，也一并由会员承担。</p>
	// 			<p>2、会员因违约导致平台提前解除与会员的服务协议，如会员不按照平台要求归还车辆时，平台有权利用备用的车辆钥匙径直将车辆取回，对于车辆中的物品平台有权留置或返还，由此而造成会员损失的，平台不承担任何赔偿责任。同时，平台有权向会员主张相关的租金、违约金及取车产生的相关费用。</p>
	// 			<p>3、 会员不按平台规定及平台会员使用规则使用车辆给平台造成损失的，平台有权向会员追责或索赔，包括但不限于违约金、车辆损坏维修费、车辆停运损失费、交通事故赔偿费用、平台维权所产生的律师费、诉讼费、差旅费等。</p>
	//
	// 			<p class="f-bold">十二、免责条款</p>
	// 			<p>1、 有下列情况之一的，平台不承担任何法律责任：</p>
	// 			<p>（1） 会员将注册账户、密码告知他人或与他人共享注册账户，而导致的任何个人资料泄露的；</p>
	// 			<p>（2） 任何由于计算机千年虫问题、黑客攻击、计算机病毒侵入或发作、政府管制等造成的暂时性关闭，使网络无法正常运行而造成的个人资料泄露、丢失、被盗用或被窜改；</p>
	// 			<p>（3） 由于与本网站链接的其他网站所造成个人资料泄露及由此而导致的任何法律争议和后果；</p>
	// 			<p>（4） 因不可抗力而引起的任何后果。</p>
	// 			<p>2、 平台对于任何自本公司平台、网站、论坛而获得的他人的信息、内容或者广告宣传等任何资讯（以下统称“信息”），不保证其真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，须自行甄别真伪和谨慎预防风险。否则，无论何种原因，本公司不对任何非与平台直接发生的交易和/或行为承担任何直接、间接、附带或衍生的损失和责任。</p>
	// 			<p>3、 平台将致力于保护您的个人信息，尽全力保证这些信息的安全。由于网上技术的发展突飞猛进，平台会随时更新信息保密制度，所有的修订将在平台官方渠道公布。</p>
	// 			<p>4、 平台鼓励会员自行按照充电标准为车辆充电，但因会员未按照充电标准为车辆充电导致的人员伤亡、车辆损毁或其他损失均由会员自行承担。</p>
	//
	// 			<p class="f-bold">十三、远程处理与隐私保护</p>
	// 			<p>1、 汽车载有卫星定位系统（GPS）、行车记录仪、远程处理系统以及记录有关汽车运行的资料。平台承诺保护每位会员的隐私。会员同意平台检索并使用车载远程处理装置所记录所有的资料。</p>
	// 			<p>2、 平台按隐私政策限制其员工及其它有关方使用会员的个人信息， 防止非公开个人资料遭到非授权散布。但以下情形除外：</p>
	// 			<p>（1）事先获得会员的明确授权；</p>
	// 			<p>（2）只有透露会员的个人资料，才能提供会员所要求的产品和服务；</p>
	// 			<p>（3）根据有关的法律法规要求；</p>
	// 			<p>（4）按照相关政府主管部门的要求；</p>
	// 			<p>（5）为维护社会公众的利益；</p>
	// 			<p>（6）为维护平台的合法权益。</p>
	// 			<p>3、 在不透露单个会员隐私资料的前提下，平台有权对整个会员数据库进行分析并对用户数据库进行商业上的利用。</p>
	//
	// 			<p class="f-bold">十四、附则</p>
	// 			<p>1、 本协议由平台制定，平台拥有最终解释权。</p>
	// 			<p>2、 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
	// 			<p>3、 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向平台所在地的人民法院提起诉讼。</p>
	// 			<p>4、 平台未行使或执行本协议任何权利或规定，不构成对前述权利或权利之放弃。</p>
	// 			<p>5、 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
	// 			<p>6、 无论会员是否正在使用服务，如有突发状况、行程核实、信息核实、追责、风控（包含但不限于以上情况）等情况发生时，会员为第一责任人，平台同时有权追究连带责任人法律责任及善后处理的一切权利。</p>
	// 			<p>7、 任何情况下平台对会员的唯一补救责任为退回会员未使用的充值费用（如有），会员自愿放弃所有针对平台的间接、惩罚性和附带损害的索赔权利。</p>
	// 			<h4>会员声明：</h4>
	// 			<h4 style="text-indent:2em;">本人是具有法律规定的享有完全民事权利能力和民事行为能力，且能够独立承担民事责任的自然人，同意接受本协议之条款并注册成为平台会员。</h4>
	// 		</div>
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .platform-protocol{
	    //     width:100%;
	    //     min-height:100%;
	    //     padding:.32rem;
	    //     box-sizing:border-box;
	    //     background:#fff;
	    //     color: #252F3A;
	    //     .pr-title{
	    //         font-size:.48rem;
	    //         text-align: center;
	    //         margin-bottom: .2rem;
	    //     }
	    //     p{
	    //         font-size:.346667rem;
	    //         line-height:.586667rem;
	    //     }
	    //     .f-bold{
	    //         font-weight: bold;
	    //     }
	    //     .pp-table{
	    //         border: none;
	    //         margin:.213333rem 0;
	    //         th,td{
	    //             font-weight: 400;
	    //             width: 11.1111111%;
	    //             text-align: center;
	    //             padding: .106667rem .053333rem;
	    //             border-color: #999;
	    //         }
	    //         th{
	    //             font-weight:bold;
	    //         }
	    //     }
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <template>
	//     <div class="platform-protocol">
	//         <hd title="隐私政策"></hd>
	//         <div>
	//             <h1 class="pr-title">隐私政策</h1>
	//             <p class="f-bold">一、引言</p>
	//             <p>广州响车车科技有限公司(以下简称“响车车”)重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本隐私政策条款向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本隐私政策条款与您所使用的响车车服务息息相关，希望您仔细阅读，在需要时，按照本隐私政策条款的指引，作出您认为适当的选择。本隐私政策条款中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。</p>
	//             <p>您使用或继续使用我们的服务，即意味着同意我们按照本隐私政策条款收集、使用、储存和分享您的相关信息。</p>
	//             <p>如对本隐私政策条款或相关事宜有任何问题，请通过<a href="http://joyincar.cn/" style="color:blue">http://joyincar.cn/</a>或4008637833与我们联系。</p>
	//             <p class="f-bold">二、我们可能收集的信息</p>
	//             <p>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>
	//             <p>2.1、您提供的信息</p>
	//             <p>您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；</p>
	//             <p>您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</p>
	//             <p>2.2、其他方分享的您的信息</p>
	//             <p>其他方使用我们的服务时所提供有关您的共享信息。</p>
	//             <p class="f-bold">三、我们获取的您的信息</p>
	//             <p>您使用服务时我们可能收集如下信息：</p>
	//             <p>3.1、日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：</p>
	//             <p>3.2、设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；</p>
	//             <p>3.3、有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</p>
	//             <p>3.4、您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</p>
	//             <p>3.5、位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：</p>
	//             <p>您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；</p>
	//             <p>您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；</p>
	//             <p>您可以通过关闭定位功能，停止对您的地理位置信息的收集。</p>
	// 			<p>3.6、设备MAC地址，我们将使用此信息来标志设备的唯一性，用于您账号的安全验证。在登陆有效期间，我们会使用此信息辅助验证登陆的有效性，避免您的身份遭受盗用。</p>
	//             <p class="f-bold">四、我们可能如何使用信息</p>
	//             <p>我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
	//             <p>4.1、向您提供服务；</p>
	//             <p>在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p>
	//             <p>帮助我们设计新服务，改善我们现有服务；</p>
	//             <p>使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的需求，例如语言设定、位置设定、帮助服务和指示，或对您和其他用户作出其他方面的回应；</p>
	//             <p>向您提供与您更加相关的广告以替代普遍投放的广告；</p>
	//             <p>评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</p>
	//             <p>软件认证或管理软件升级；</p>
	//             <p>4.2、让您参与有关我们产品和服务的调查。</p>
	//             <p>为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，用于我们其他的服务。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。</p>
	//             <p class="f-bold">五、您如何访问和控制自己的个人信息</p>
	//             <p>我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。我们可能分享的信息除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
	//             <p>5.1、我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：</p>
	//             <p>5.2、向您提供我们的服务；</p>
	//             <p>5.3、实现“我们可能如何使用信息”部分所述目的；</p>
	//             <p>5.4、履行我们在《响车车服务协议》或本隐私政策条款中的义务和行使我们的权利；理解、维护和改善我们的服务。</p>
	//             <p>5.5、如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本隐私政策条款及我们要求其遵守的其他适当的保密和安全措施。</p>
	//             <p>5.6、随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</p>
	//             <p>5.7、更正个人信息。当您需要更正您的个人信息，或发现响车车平台收集、存储的个人信息有错误时，您有权做出更正或更新。您可以通过将您的更正申请提交给响车车客服，或通过您在响车车平台的账号更正或修改您提供的个人资料信息。</p>
	// 			<p>5.8、删除个人信息。如您希望删除个人信息，可以通过电话联系响车车客服（400-863-7833），提交删除申请。在满足法律法规要求的最短保存期限要求的情况下，我们将对您的个人信息进行删除或匿名化处理。在上述法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。</p>
	//             <p>5.9、注销账户。您可以通过联系响车车客服（400-863-7833）注销账户，处理时间为15个工作日。除法律法规另有规定外，注销账户之后我们将停止为您提供服务。</p>
	//             <p>5.10、如您无法通过上述方式更正、删除个人信息或注销账号，您可以拨打响车车客服电话（400-863-7833）与我们取得联系，响车车客服团队可能需要验证您的身份，并在验证您的身份后15个工作日内做出答复或合理解释。</p>
	// 			<p>5.11、我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p>
	//             <p>遵守适用的法律法规；</p>
	//             <p>遵守相关政府机关的要求；</p>
	//             <p>为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
	//             <p class="f-bold">六、信息安全</p>
	//             <p>我们仅在本隐私政策条款所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。</p>
	//             <p>我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
	//             <p class="f-bold">七、您分享的信息</p>
	//             <p>我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。</p>
	//             <p>7.1、您分享的敏感个人信息</p>
	//             <p>某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。</p>
	//             <p>请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。</p>
	//             <p>7.2、您同意按本隐私政策条款所述的目的和方式来处理您的敏感个人信息。</p>
	//             <p class="f-bold">八、我们可能如何收集信息</p>
	//             <p>我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。</p>
	//             <p>我们使用自己的cookies和web beacon，目的是为您提供更优质的用户体验和服务，并用于以下用途：</p>
	//             <p>8.1、记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；</p>
	//             <p>8.2、分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；</p>
	//             <p>8.3、广告优化。Cookies和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。</p>
	//             <p>我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。</p>
	//             <p>我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web beacon收集和使用该等信息，不受本隐私政策条款约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或web beacon承担责任。</p>
	//             <p>您可以通过APP设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低；</p>
	//             <p>8.4、为保障响车车APP相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现前述目的。我们会尽到审慎义务，对合作方获取信息的SDK进行严格的安全监测，以保护数据安全。</p>
	//             <p>我们接入的第三方SDK主要服务于您以及其他的用户需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK，我们会及时在本说明中向您公开说明接入第三方SDK的最新情况。目前响车车APP接入的第三方SDK列明如下:</p>
	//             <img src="./img/table.jpg" style="width:100%">
	//             <p class="f-bold">九、广告服务</p>
	//             <p>我们可能使用您的相关信息，向您提供与您更加相关的广告。</p>
	//             <p>我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：</p>
	//             <p>9.1、我们的商品或服务，我们的关联公司和合作伙伴的商品或服务，包括即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、付款服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、互联网金融，以及其他社交媒体、娱乐、电子商务、资讯和通讯软件或服务（统称“互联网服务”）；</p>
	//             <p>9.2、第三方互联网服务供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。</p>
	//             <p>9.3、如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。</p>
	//             <p class="f-bold">十、我们可能向您发送的邮件和信息</p>
	//             <p>10.1、邮件和信息推送</p>
	//             <p>您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。</p>
	//             <p>10.2、与服务有关的公告</p>
	//             <p>我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
	//             <p class="f-bold">十一、隐私政策的适用例外</p>
	//             <p>我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：</p>
	//             <p>您利用 “分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；</p>
	//             <p>我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。</p>
	//             <p>该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本隐私政策条款）约束，您需要仔细阅读其条款。本隐私政策条款仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。</p>
	//             <p class="f-bold">十二、隐私政策的适用范围</p>
	//             <p>除某些特定服务外，我们所有的服务均适用本隐私政策条款。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本隐私政策条款的一部分。如相关特定服务的隐私政策与本隐私政策条款有不一致之处，适用该特定服务的隐私政策。</p>
	//             <p>除本隐私政策条款另有规定外，本《隐私条款》所用词语将与《响车车服务协议》所定义的词语具有相同的涵义。</p>
	//             <p>请您注意，本隐私政策条款不适用于以下情况：</p>
	//             <p class="f-bold">十三、变更</p>
	//             <p>我们可能适时修订本隐私政策条款的条款，该等修订构成本隐私政策条款的一部分。如该等修订造成您在本隐私政策条款下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策条款的约束。</p>
	//             <p>广州响车车科技有限公司, 版权所有。</p>
	//         </div>
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .platform-protocol{
	    //     width:100%;
	    //     min-height:100%;
	    //     padding:.32rem;
	    //     box-sizing:border-box;
	    //     background:#fff;
	    //     color: #252F3A;
	    //     .pr-title{
	    //         font-size:.48rem;
	    //         text-align: center;
	    //         margin-bottom: .2rem;
	    //     }
	    //     p{
	    //         font-size:.346667rem;
	    //         line-height:.586667rem;
	    //     }
	    //     .f-bold{
	    //         font-weight: bold;
	    //     }
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// <template>
	//     <div class="coupon">
	//         <hd title="商城说明"></hd>
	//         <div class="coupon-box">
	//             <div class="coupon-title">一、响币商城的由来</div>
	//             <div class="coupon-content">
	//                 <p>您每次使用响车车新能源汽车，都为这美丽的世界节能减排。为了感谢您为这世界作出的环保贡献，我们回馈响币于您，鼓励您使用我们新能源汽车，为全球变暖做出一份贡献。</p>
	//             </div>
	//         </div>
	//         <div class="coupon-box">
	//             <div class="coupon-title">二、兑换规则</div>
	//             <ol class="coupon-content coupon-content1">
	//                 <li>每次订单结算后，我们会根据您消费的金额进行等比例的回馈响币。消费1元对应获得1个响币。消费100元回馈100个响币。</li>
	//                 <li>响币获得后，不可进行转赠。</li>
	//                 <li>兑换规则最终解释权归响车车所有，兑换出现任何问题，请拨打客服热线400-863-7833进行咨询。</li>
	//             </ol>
	//         </div>
	//
	//     </div>
	// </template>
	// <script>
	module.exports = {
	    components: {
	        'hd': __webpack_require__(47)
	    }
	    // </script>
	    // <style lang="sass" scoped>
	    // .coupon{
	    //     width:100%;
	    //     min-height:100%;
	    //     padding:0.02rem 0.32rem 0.32rem;
	    //     box-sizing:border-box;
	    //     .coupon-box{
	    //         width:100%;
	    //         padding:0.32rem;
	    //         background-color:#fff;
	    //         box-sizing:border-box;
	    //         margin-top:0.213rem;
	    //         border-radius: 0.106rem;
	    //         box-shadow: 0px 0px 0px 0.02rem rgba(37,47,58,0.2);
	    //         .coupon-title{
	    //             font-size:.426667rem;
	    //             color: #252F3A;
	    //             font-weight: bold;
	    //         }
	    //         .coupon-content{
	    //             margin-top: 0.213rem;
	    //             box-sizing:border-box;
	    //             li,p{
	    //                 font-size: 0.373rem;
	    //                 color: #666D75;
	    //                 line-height:0.64rem;
	    //                 list-style: decimal;
	    //             }
	    //         }
	    //         .coupon-content1{
	    //             padding-left: 0.4rem;
	    //         }
	    //     }
	    // }
	    // </style>
	    //
	    //
	    /* generated by vue-loader */
	
	};

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, "#scroller[_v-1774411b]{width:100%;padding-left:.32rem;padding-right:.32rem;font-size:2pc;background:#fff;box-sizing:border-box;position:relative;overflow-y:scroll;-webkit-overflow-scrolling:touch}#scroller .block h1[_v-1774411b]{width:100%;height:1.066667rem;line-height:1.066667rem;color:#333;font-weight:700;font-size:.426667rem;border-bottom:1px solid #ddd}#scroller .block dl[_v-1774411b]{width:100%;line-height:.64rem}#scroller .block dl dt[_v-1774411b]{line-height:.64rem;font-size:.426667rem;padding:.16rem 0;font-weight:700}#scroller .block dl dd[_v-1774411b]{margin-bottom:.8rem}#scroller .block dl dd[_v-1774411b],#scroller .block p[_v-1774411b]{line-height:.8rem;font-size:.426667rem}#scroller .block .son_mb20 p[_v-1774411b]{margin-bottom:.266667rem}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-1774411b&file=help_detail.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/help_detail.vue.style"],"names":[],"mappings":"AAAA,uBAAU,WAAW,oBAAoB,qBAAqB,cAAe,gBAAgB,sBAAsB,kBAAkB,kBAAkB,gCAAgC,CAAC,iCAAoB,WAAW,mBAAmB,wBAAwB,WAAW,gBAAiB,qBAAqB,4BAA+B,CAAC,iCAAoB,WAAW,kBAAkB,CAAC,oCAAuB,mBAAmB,qBAAqB,iBAAiB,eAAgB,CAAC,oCAA8D,mBAAmB,CAAC,oEAA3D,kBAAkB,oBAAqB,CAA8E,0CAA6B,wBAAwB,CAAC","file":"help_detail.vue","sourcesContent":["#scroller{width:100%;padding-left:.32rem;padding-right:.32rem;font-size:32px;background:#fff;box-sizing:border-box;position:relative;overflow-y:scroll;-webkit-overflow-scrolling:touch}#scroller .block h1{width:100%;height:1.066667rem;line-height:1.066667rem;color:#333;font-weight:bold;font-size:.426667rem;border-bottom:1px solid #DDDDDD}#scroller .block dl{width:100%;line-height:.64rem}#scroller .block dl dt{line-height:.64rem;font-size:.426667rem;padding:.16rem 0;font-weight:bold}#scroller .block dl dd{line-height:.8rem;font-size:.426667rem;margin-bottom:.8rem}#scroller .block p{line-height:.8rem;font-size:.426667rem}#scroller .block .son_mb20 p{margin-bottom:.266667rem}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".help[_v-194fca2e]{width:100%;min-height:100%;padding-top:.01rem;box-sizing:border-box}.help ul[_v-194fca2e]{width:100%;padding-left:.32rem;box-sizing:border-box;background:#fff;border-bottom:1px solid #ddd;border-top:1px solid #ddd;margin-top:.213333rem}.help ul li[_v-194fca2e]{width:100%;height:1.146667rem;line-height:1.146667rem;border-bottom:1px solid #ddd;font-size:.426667rem;color:#252f3a;position:relative}.help ul li[_v-194fca2e]:last-child{border:none}.help ul li[_v-194fca2e]:before{content:\"\";position:absolute;width:.213333rem;height:.213333rem;right:.373333rem;top:50%;border-top:.03rem solid #666d75;border-right:.03rem solid #666d75;transform:translateY(-50%) rotate(45deg)}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-194fca2e&file=law.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/law.vue.style"],"names":[],"mappings":"AAAA,mBAAM,WAAW,gBAAgB,mBAAoB,qBAAqB,CAAC,sBAAS,WAAW,oBAAoB,sBAAsB,gBAAmB,6BAAgC,0BAA6B,qBAAqB,CAAC,yBAAY,WAAW,mBAAmB,wBAAwB,6BAAgC,qBAAqB,cAAc,iBAAiB,CAAC,oCAAuB,WAAW,CAAC,gCAAmB,WAAW,kBAAkB,iBAAiB,kBAAkB,iBAAiB,QAAQ,gCAAgC,kCAAkC,wCAAwC,CAAC","file":"law.vue","sourcesContent":[".help{width:100%;min-height:100%;padding-top:0.01rem;box-sizing:border-box}.help ul{width:100%;padding-left:.32rem;box-sizing:border-box;background:#FFFFFF;border-bottom:1px solid #DDDDDD;border-top:1px solid #DDDDDD;margin-top:.213333rem}.help ul li{width:100%;height:1.146667rem;line-height:1.146667rem;border-bottom:1px solid #DDDDDD;font-size:.426667rem;color:#252F3A;position:relative}.help ul li:last-child{border:none}.help ul li:before{content:\"\";position:absolute;width:.213333rem;height:.213333rem;right:.373333rem;top:50%;border-top:.03rem solid #666D75;border-right:.03rem solid #666D75;transform:translateY(-50%) rotate(45deg)}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".container[_v-26bd69a6]{width:100%;min-height:100%;background:#f6f8fa;position:relative;overflow-y:scroll}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-26bd69a6&file=app.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/app.vue.style"],"names":[],"mappings":"AAAA,wBAAW,WAAW,gBAAgB,mBAAmB,kBAAkB,iBAAiB,CAAC","file":"app.vue","sourcesContent":[".container{width:100%;min-height:100%;background:#F6F8FA;position:relative;overflow-y:scroll}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".platform-protocol[_v-2846646d]{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252f3a}.platform-protocol .pr-title[_v-2846646d]{font-size:.48rem;text-align:center;margin-bottom:.2rem}.platform-protocol p[_v-2846646d]{font-size:.346667rem;line-height:.586667rem}.platform-protocol .f-bold[_v-2846646d]{font-weight:700}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-2846646d&file=privacy_policy.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/privacy_policy.vue.style"],"names":[],"mappings":"AAAA,gCAAmB,WAAW,gBAAgB,eAAe,sBAAsB,gBAAgB,aAAa,CAAC,0CAA6B,iBAAiB,kBAAkB,mBAAmB,CAAC,kCAAqB,qBAAqB,sBAAsB,CAAC,wCAA2B,eAAgB,CAAC","file":"privacy_policy.vue","sourcesContent":[".platform-protocol{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252F3A}.platform-protocol .pr-title{font-size:.48rem;text-align:center;margin-bottom:.2rem}.platform-protocol p{font-size:.346667rem;line-height:.586667rem}.platform-protocol .f-bold{font-weight:bold}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".platform-protocol[_v-2b4298ba]{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252f3a}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-2b4298ba&file=license_information.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/license_information.vue.style"],"names":[],"mappings":"AAAA,gCAAmB,WAAW,gBAAgB,eAAe,sBAAsB,gBAAgB,aAAa,CAAC","file":"license_information.vue","sourcesContent":[".platform-protocol{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252F3A}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".help[_v-3579c0e5]{width:100%;min-height:100%}.help .black[_v-3579c0e5]{height:.213333rem}.help .m-t8[_v-3579c0e5]{margin-top:.213333rem}.help .help_wrapper[_v-3579c0e5]{background:#fff}.help .help_wrapper .title[_v-3579c0e5]{height:1.146667rem;line-height:1.146667rem;padding-left:.426667rem;box-sizing:border-box;position:relative;font-size:1pc;margin-top:.106667rem}.help .help_wrapper .title[_v-3579c0e5]:first-child{margin-top:0}.help .help_wrapper .title[_v-3579c0e5]:before{content:\"\";position:absolute;left:0;top:50%;transform:translateY(-50%);height:100%;width:4px;height:14px;background:#4097fc}.help ul[_v-3579c0e5]{width:100%;padding-left:.64rem;box-sizing:border-box}.help ul li[_v-3579c0e5]{width:100%;height:1.146667rem;line-height:1.146667rem;font-size:.373333rem;color:#252f3a;position:relative}.help ul li[_v-3579c0e5]:before{content:\"\";position:absolute;width:.213333rem;height:.213333rem;right:.373333rem;top:50%;border-top:1px solid #666d75;border-right:1px solid #666d75;transform:translateY(-50%) rotate(45deg)}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-3579c0e5&file=help.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/help.vue.style"],"names":[],"mappings":"AAAA,mBAAM,WAAW,eAAe,CAAC,0BAAa,iBAAiB,CAAC,yBAAY,qBAAqB,CAAC,iCAAoB,eAAe,CAAC,wCAA2B,mBAAmB,wBAAwB,wBAAwB,sBAAsB,kBAAkB,cAAe,qBAAqB,CAAC,oDAAuC,YAAY,CAAC,+CAAkC,WAAW,kBAAkB,OAAO,QAAQ,2BAA2B,YAAY,UAAU,YAAY,kBAAkB,CAAC,sBAAS,WAAW,oBAAoB,qBAAqB,CAAC,yBAAY,WAAW,mBAAmB,wBAAwB,qBAAqB,cAAc,iBAAiB,CAAC,gCAAmB,WAAW,kBAAkB,iBAAiB,kBAAkB,iBAAiB,QAAQ,6BAA6B,+BAA+B,wCAAwC,CAAC","file":"help.vue","sourcesContent":[".help{width:100%;min-height:100%}.help .black{height:.213333rem}.help .m-t8{margin-top:.213333rem}.help .help_wrapper{background:#fff}.help .help_wrapper .title{height:1.146667rem;line-height:1.146667rem;padding-left:.426667rem;box-sizing:border-box;position:relative;font-size:16px;margin-top:.106667rem}.help .help_wrapper .title:first-child{margin-top:0}.help .help_wrapper .title:before{content:\"\";position:absolute;left:0;top:50%;transform:translateY(-50%);height:100%;width:4px;height:14px;background:#4097FC}.help ul{width:100%;padding-left:.64rem;box-sizing:border-box}.help ul li{width:100%;height:1.146667rem;line-height:1.146667rem;font-size:.373333rem;color:#252F3A;position:relative}.help ul li:before{content:\"\";position:absolute;width:.213333rem;height:.213333rem;right:.373333rem;top:50%;border-top:1px solid #666D75;border-right:1px solid #666D75;transform:translateY(-50%) rotate(45deg)}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".coupon[_v-448e0cc0]{width:100%;min-height:100%;padding:.02rem .32rem .32rem;box-sizing:border-box}.coupon .coupon-box[_v-448e0cc0]{width:100%;padding:.32rem;background-color:#fff;box-sizing:border-box;margin-top:.213rem;border-radius:.106rem;box-shadow:0 0 0 .02rem rgba(37,47,58,.2)}.coupon .coupon-box .coupon-title[_v-448e0cc0]{font-size:.426667rem;color:#252f3a;font-weight:700}.coupon .coupon-box .coupon-content[_v-448e0cc0]{margin-top:.213rem;box-sizing:border-box}.coupon .coupon-box .coupon-content li[_v-448e0cc0],.coupon .coupon-box .coupon-content p[_v-448e0cc0]{font-size:.373rem;color:#666d75;line-height:.64rem;list-style:decimal}.coupon .coupon-box .coupon-content1[_v-448e0cc0]{padding-left:.4rem}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-448e0cc0&file=shop_city.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/shop_city.vue.style"],"names":[],"mappings":"AAAA,qBAAQ,WAAW,gBAAgB,6BAAgC,qBAAqB,CAAC,iCAAoB,WAAW,eAAgB,sBAAsB,sBAAsB,mBAAoB,sBAAuB,yCAAiD,CAAC,+CAAkC,qBAAqB,cAAc,eAAgB,CAAC,iDAAoC,mBAAoB,qBAAqB,CAAC,uGAA6E,kBAAmB,cAAc,mBAAoB,kBAAkB,CAAC,kDAAqC,kBAAmB,CAAC","file":"shop_city.vue","sourcesContent":[".coupon{width:100%;min-height:100%;padding:0.02rem 0.32rem 0.32rem;box-sizing:border-box}.coupon .coupon-box{width:100%;padding:0.32rem;background-color:#fff;box-sizing:border-box;margin-top:0.213rem;border-radius:0.106rem;box-shadow:0px 0px 0px 0.02rem rgba(37,47,58,0.2)}.coupon .coupon-box .coupon-title{font-size:.426667rem;color:#252F3A;font-weight:bold}.coupon .coupon-box .coupon-content{margin-top:0.213rem;box-sizing:border-box}.coupon .coupon-box .coupon-content li,.coupon .coupon-box .coupon-content p{font-size:0.373rem;color:#666D75;line-height:0.64rem;list-style:decimal}.coupon .coupon-box .coupon-content1{padding-left:0.4rem}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".coupon[_v-4ee1c76c]{width:100%;min-height:100%;padding:.02rem .32rem .32rem;box-sizing:border-box}.coupon .coupon-box[_v-4ee1c76c]{width:100%;padding:.32rem;background-color:#fff;box-sizing:border-box;margin-top:.213rem;border-radius:.106rem;box-shadow:0 0 0 .02rem rgba(37,47,58,.2)}.coupon .coupon-box .coupon-title[_v-4ee1c76c]{font-size:.426667rem;color:#252f3a;font-weight:700}.coupon .coupon-box .coupon-content[_v-4ee1c76c]{padding-left:.4rem;margin-top:.213rem;box-sizing:border-box}.coupon .coupon-box .coupon-content li[_v-4ee1c76c]{font-size:.373rem;color:#666d75;line-height:.64rem;list-style:decimal}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-4ee1c76c&file=coupon.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/coupon.vue.style"],"names":[],"mappings":"AAAA,qBAAQ,WAAW,gBAAgB,6BAAgC,qBAAqB,CAAC,iCAAoB,WAAW,eAAgB,sBAAsB,sBAAsB,mBAAoB,sBAAuB,yCAAiD,CAAC,+CAAkC,qBAAqB,cAAc,eAAgB,CAAC,iDAAoC,mBAAoB,mBAAoB,qBAAqB,CAAC,oDAAuC,kBAAmB,cAAc,mBAAoB,kBAAkB,CAAC","file":"coupon.vue","sourcesContent":[".coupon{width:100%;min-height:100%;padding:0.02rem 0.32rem 0.32rem;box-sizing:border-box}.coupon .coupon-box{width:100%;padding:0.32rem;background-color:#fff;box-sizing:border-box;margin-top:0.213rem;border-radius:0.106rem;box-shadow:0px 0px 0px 0.02rem rgba(37,47,58,0.2)}.coupon .coupon-box .coupon-title{font-size:.426667rem;color:#252F3A;font-weight:bold}.coupon .coupon-box .coupon-content{padding-left:0.4rem;margin-top:0.213rem;box-sizing:border-box}.coupon .coupon-box .coupon-content li{font-size:0.373rem;color:#666D75;line-height:0.64rem;list-style:decimal}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".common-problem[_v-6eda5422]{width:100%;padding:.32rem .32rem .026667rem;font-size:.426667rem;background:#fff;box-sizing:border-box}.common-problem .block dl[_v-6eda5422]{width:100%;line-height:.666667rem}.common-problem .block dl dt[_v-6eda5422]{line-height:.666667rem;padding:.133333rem 0;font-weight:700}.common-problem .block dl dd[_v-6eda5422]{line-height:.666667rem;margin-bottom:.8rem}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-6eda5422&file=common_problem.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/common_problem.vue.style"],"names":[],"mappings":"AAAA,6BAAgB,WAAW,iCAAiC,qBAAqB,gBAAgB,qBAAqB,CAAC,uCAA0B,WAAW,sBAAsB,CAAC,0CAA6B,uBAAuB,qBAAqB,eAAgB,CAAC,0CAA6B,uBAAuB,mBAAmB,CAAC","file":"common_problem.vue","sourcesContent":[".common-problem{width:100%;padding:.32rem .32rem .026667rem;font-size:.426667rem;background:#fff;box-sizing:border-box}.common-problem .block dl{width:100%;line-height:.666667rem}.common-problem .block dl dt{line-height:.666667rem;padding:.133333rem 0;font-weight:bold}.common-problem .block dl dd{line-height:.666667rem;margin-bottom:.8rem}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".platform-protocol[_v-6f375ade]{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252f3a}.platform-protocol .pr-title[_v-6f375ade]{font-size:.48rem;text-align:center;margin-bottom:.2rem}.platform-protocol p[_v-6f375ade]{font-size:.346667rem;line-height:.586667rem}.platform-protocol .f-bold[_v-6f375ade]{font-weight:700}.platform-protocol .m-t20[_v-6f375ade]{margin-top:.533333rem}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-6f375ade&file=leasing_contract.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/leasing_contract.vue.style"],"names":[],"mappings":"AAAA,gCAAmB,WAAW,gBAAgB,eAAe,sBAAsB,gBAAgB,aAAa,CAAC,0CAA6B,iBAAiB,kBAAkB,mBAAmB,CAAC,kCAAqB,qBAAqB,sBAAsB,CAAC,wCAA2B,eAAgB,CAAC,uCAA0B,qBAAqB,CAAC","file":"leasing_contract.vue","sourcesContent":[".platform-protocol{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252F3A}.platform-protocol .pr-title{font-size:.48rem;text-align:center;margin-bottom:.2rem}.platform-protocol p{font-size:.346667rem;line-height:.586667rem}.platform-protocol .f-bold{font-weight:bold}.platform-protocol .m-t20{margin-top:.533333rem}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".platform-protocol[_v-d0c6b520]{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252f3a}.platform-protocol .pr-title[_v-d0c6b520]{font-size:.48rem;text-align:center;margin-bottom:.2rem}.platform-protocol p[_v-d0c6b520]{font-size:.346667rem;line-height:.586667rem}.platform-protocol .f-bold[_v-d0c6b520]{font-weight:700}.platform-protocol .pp-table[_v-d0c6b520]{border:none;margin:.213333rem 0}.platform-protocol .pp-table td[_v-d0c6b520],.platform-protocol .pp-table th[_v-d0c6b520]{font-weight:400;width:11.1111111%;text-align:center;padding:.106667rem .053333rem;border-color:#999}.platform-protocol .pp-table th[_v-d0c6b520]{font-weight:700}", "", {"version":3,"sources":["/../../../../../../vue-loader/lib/style-rewriter.js?id=_v-d0c6b520&file=platform_protocol.vue&scoped=true!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/sass-loader/index.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vux-loader/src/style-loader.js!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/node_modules/vue-loader/lib/selector.js?type=style&index=0!/Users/xuanshuiyuan/data/www/xcc/car_rental_web_front/src/component/static_page/platform_protocol.vue.style"],"names":[],"mappings":"AAAA,gCAAmB,WAAW,gBAAgB,eAAe,sBAAsB,gBAAgB,aAAa,CAAC,0CAA6B,iBAAiB,kBAAkB,mBAAmB,CAAC,kCAAqB,qBAAqB,sBAAsB,CAAC,wCAA2B,eAAgB,CAAC,0CAA6B,YAAY,mBAAmB,CAAC,0FAAgE,gBAAgB,kBAAkB,kBAAkB,8BAA8B,iBAAiB,CAAC,6CAAgC,eAAgB,CAAC","file":"platform_protocol.vue","sourcesContent":[".platform-protocol{width:100%;min-height:100%;padding:.32rem;box-sizing:border-box;background:#fff;color:#252F3A}.platform-protocol .pr-title{font-size:.48rem;text-align:center;margin-bottom:.2rem}.platform-protocol p{font-size:.346667rem;line-height:.586667rem}.platform-protocol .f-bold{font-weight:bold}.platform-protocol .pp-table{border:none;margin:.213333rem 0}.platform-protocol .pp-table th,.platform-protocol .pp-table td{font-weight:400;width:11.1111111%;text-align:center;padding:.106667rem .053333rem;border-color:#999}.platform-protocol .pp-table th{font-weight:bold}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(354);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-1774411b&file=help_detail.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./help_detail.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-1774411b&file=help_detail.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./help_detail.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(356);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-194fca2e&file=law.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./law.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-194fca2e&file=law.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./law.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(363);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-26bd69a6&file=app.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./app.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-26bd69a6&file=app.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./app.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(366);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2846646d&file=privacy_policy.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./privacy_policy.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2846646d&file=privacy_policy.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./privacy_policy.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(369);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2b4298ba&file=license_information.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./license_information.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-2b4298ba&file=license_information.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./license_information.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(374);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-3579c0e5&file=help.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./help.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-3579c0e5&file=help.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./help.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(384);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-448e0cc0&file=shop_city.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./shop_city.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-448e0cc0&file=shop_city.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./shop_city.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(389);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-4ee1c76c&file=coupon.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./coupon.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-4ee1c76c&file=coupon.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./coupon.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(406);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6eda5422&file=common_problem.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./common_problem.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6eda5422&file=common_problem.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./common_problem.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(407);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6f375ade&file=leasing_contract.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./leasing_contract.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6f375ade&file=leasing_contract.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./leasing_contract.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(424);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-d0c6b520&file=platform_protocol.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./platform_protocol.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-d0c6b520&file=platform_protocol.vue&scoped=true!../../../node_modules/sass-loader/index.js!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./platform_protocol.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

	module.exports = " <div id=scroller _v-1774411b=\"\"> <div class=block v-if=\"show_part_index == 1\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">用车指导及注意事项</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、如何找车？</dt> <dd _v-1774411b=\"\"> 选择车辆进入用车界面后，此时如果离停车场较远，可点击“导航”可直接导航至停车场；到达停车场如果车辆较多无法确认，可点击“鸣笛寻车”，车辆会打开双闪鸣笛四声，点击“开门”即可开始用车。 </dd> <dt _v-1774411b=\"\">2、检查车辆状态</dt> <p _v-1774411b=\"\"> 2.1、检查车辆是否在充电 </p> <dd _v-1774411b=\"\"> 找到车后，注意先检查车辆是否处于充电状态，如果车辆正在连接充电桩充电，请先联系“响车车”客服中心400-863-7833转1，待客服远程结束充电后，将充电枪拔出放回充电桩。 </dd> <p _v-1774411b=\"\"> 2.2、检查车身 </p> <dd _v-1774411b=\"\"> 随后注意仔细观察车身或后视镜，是否出现划痕/破损，轮胎磨损/没气等情况，可通过APP取车页面“车况上报”拍照上传；车辆正常则点击“车况正常”，（如您发现伤痕但未做车况上报，系统自动默认用车前车是正常的，一旦下一个用户拍照反馈有新伤痕，我们将追责到您身上）所以在用车前，一定要仔细观察车身，拍照上传保障自己的权益。开门取车后如发现车内设备有损坏或丢失，车辆内部的任何配备设施异常或者车内有异味，可通过APP用车页面的“车况上报”进行报备，或致电客服热线 400-863-7833转1 反馈。 </dd> <p _v-1774411b=\"\"> 2.3、调节好座椅及后视镜 </p> <dd _v-1774411b=\"\"> 后视镜均为手动调节 </dd> <dt _v-1774411b=\"\">3、车钥匙在哪？</dt> <dd _v-1774411b=\"\"> “响车车”所有车辆全部由APP控制，无需车钥匙，有问题请联系客服400-863-7833； </dd> <dt _v-1774411b=\"\">4、如何启动车辆</dt> <dd _v-1774411b=\"\"> 手机APP点击“启动”，仪表盘绿色“READY”标志亮时就可以正常使用车辆(东风景逸的车型要踩住刹车按启动)。踩下刹车，挂到D档（前进）或R档（倒车），仪表盘档位字母常亮挂挡成功，放手刹。 </dd> <dt _v-1774411b=\"\">5、停车注意事项</dt> <dd _v-1774411b=\"\"> 需要临时停车但不还车时，请将档位挂回N档，拉手刹，关闭所有灯光，关好车窗，手机点击APP“临停”即可完成熄火操作，下车后，关上门自动上锁（请注意别把手机遗留在车上）。 </dd> <dt _v-1774411b=\"\">6、如何还车</dt> <dd _v-1774411b=\"\"> 用车完毕后，请将档位挂回N档，拉手刹，关闭所有灯光，关好车窗，手机点击APP“还车”，车辆自动熄火。下车后，关门自动上锁，再点还车结算费用。（注意：请务必把车辆停放在网点，离开车辆后再操作还车结算，否则订单还在计费当中。）<br _v-1774411b=\"\"> 还车目前不支持跨城市还车，用户在租用车辆前，可通过app“还车网点”查看当前租用车辆去到目的地附近是否有可还车网点，再决定租用车辆，当前A点借A点还车的是广州，深圳。A点借B点还车是湛江，中山，柳州，东莞。其他城市会陆续上线，请敬请关注 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 2\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">车辆续航及充电</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、关于续航里程</dt> <dd _v-1774411b=\"\"> 不同车辆的电池电量，以及续航里程不一样，选车时请参照APP上显示的电量，选择续航里程足够您出行计划来回的车辆，同时建议提前计划好寻找充电桩进行补电，使用过程中请随时电量状况，发现电量快低于30% 时，请及时充电，确保不影响您正常用车，以免因没电而产生救援费。 </dd> <dt _v-1774411b=\"\">2、假如车辆半路电量不足怎么办？</dt> <dd _v-1774411b=\"\"> 可以寻找就近的羊城充、星星充电、特来电和爱电牛等充电桩进行充电，或将车辆还回租车网点并结算后，更换其它电量充足车辆继续使用。 </dd> <dt _v-1774411b=\"\">3、每充一次电需要花多长时间？</dt> <dd _v-1774411b=\"\"> 常规充电设备：需要6至8小时能完成整个充电过程。快速充电设备：空电量车大概需要1至3小时完成整个充电过程。具体根据车辆剩余续航里程以及充电桩电流输出实际情况而定。 </dd> <dt _v-1774411b=\"\">4、如何区分快速充电设备和常规充电设备？</dt> <dd _v-1774411b=\"\"> APP上通常都将有对应标识，交流桩就是俗称的“慢充”、直流桩为俗称的”快充“，如您有疑问，请拨打客服热线400-863-7833，我们将为您服务。 </dd> <dt _v-1774411b=\"\">5、给车充电安全吗？</dt> <dd _v-1774411b=\"\"> 响车车的车辆以及充电设施均经过安全测试，但在极端天气如：大暴雨天气，为了您的安全建议不要随便拔插充电枪，如有疑问请您在操作前致电400-863-7833。 </dd> <dt _v-1774411b=\"\">6、给响车车的车辆充电的操作步骤是什么？</dt> <dd _v-1774411b=\"\"> a.公共充电桩参考充电流程：<br _v-1774411b=\"\"> （1）车辆处于熄火状态；<br _v-1774411b=\"\"> （2）拔出充电桩上的充电枪；<br _v-1774411b=\"\"> （3）打开车辆充电口；<br _v-1774411b=\"\"> （4）将充电枪插入车辆充电口，并确保充电枪和车辆连接牢固；<br _v-1774411b=\"\"> （5）用相应的APP扫码开始充电，车内有充电显示，表明已经成功开始充电；<br _v-1774411b=\"\"> </dd> <dd _v-1774411b=\"\"> b.家用交流充电流程：注意以下条件：接地线、220V，空调插座，<br _v-1774411b=\"\"> （1）车辆处于熄火状态；<br _v-1774411b=\"\"> （2）找到充电开关、打开充电盖；<br _v-1774411b=\"\"> （3）将充电枪插紧交流（慢充）充电口，打开电源，没有红色故障灯亮起，即表示充电成功； </dd> <dt _v-1774411b=\"\">7、哪些地方可以充电？</dt> <dd _v-1774411b=\"\"> 除响车车的网点外，还可以在国家电网、羊城充、星星充电、特来电和爱电牛等充电桩进行充电，但须您自备充电卡或下载相应的APP进行充电和费用支付。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 3\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">用车规则</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\"> 1、租用响车车车辆需具备以下条件： </dt> <dd _v-1774411b=\"\"> （1）需获得《中华人民共和国机动车驾驶证》，为了您的和他人的安全，请您遵守道路法律法规。<br _v-1774411b=\"\"> （2）如已获得驾驶证但未满一年，属于实习期，会员在租用响车车运营车辆需自备实习标志贴，贴至后档玻璃的右上角。实习期驾龄会员在高速上行驶需有驾龄一年以上人员陪同方属于合法，如未按照规定会员私自驾驶响车车运营车辆导致被交警部门罚款、扣分以及保险公司不理赔范围由会员本人自行承担，并追究相应的法律责任，我司不作处理。<br _v-1774411b=\"\"> （3）驾照必须有效并能够准驾自动挡车型，没有被吊销、没收、失效或以其它方式作废。如用户的驾照在任何时间被吊销、没收、失效或其状态发生变化，用户必须立即通知“响车车”，此时用户将不能使用或预定任何“响车车”车辆，否则自行承担全责。 </dd> <dt _v-1774411b=\"\">2、用车需保持人证合一</dt> <dd _v-1774411b=\"\"> 为了保障您的个人权益驾驶证、身份证与实际驾驶人必须保持一致，防止他人在未经您许可的情况下使用您的证件。 </dd> <dt _v-1774411b=\"\">3、不得将会员帐号或车辆给其他人使用</dt> <dd _v-1774411b=\"\"> 响车车会通过车内设备识别驾驶员身份，禁止会员将自己的会员帐号及密码交付第三人使用。若第三者凭正确的用户会员帐号及密码进行网络活动（网络预订等），或使用您的个人资料（包括但不限于手机号或会员号）进行电话预订，将被响车车视为该会员自身行为，而该行为引起的一切法律后果由会员承担。响车车会员亦不得以任何方式将车辆提供给任何非认证驾驶人驾驶。如响车车会员将汽车交予非认证驾驶人驾驶，将被永久取消会员资格，并需依法承担相应责任。 </dd> <dt _v-1774411b=\"\">4、车辆严禁超载</dt> <dd _v-1774411b=\"\"> 响车车车辆乘坐不得超过 5 位乘客（含驾驶人）。具体按照具体车型为准，请您根据有关交通法规的标准安全载客。 </dd> <dt _v-1774411b=\"\">5、请不要在车内吸烟</dt> <dd _v-1774411b=\"\"> 为了您和其他客户的优质体验及行车安全，请不要在车内吸烟，工作人员一旦发现租客在车内抽烟或允许他人抽烟，将被收取抽烟违约金100元。 </dd> <dt _v-1774411b=\"\">6、个人物品落在车内怎么办？如果在车内发现他人遗留物品怎么办？</dt> <dd _v-1774411b=\"\"> 请您下车时仔细查看随身物品。 如果您发现个人物品遗落在车内，请您及时拨打客服热线 4008-637-833转1，我们会协助您进行后续跟踪找寻。 如果您在用车时发现他人物品遗留在车内，请您拍照上传至微信并拨打客服热线 4008-637-833转1，我们会为失物找到它的主人。响车车不对任何会员个人财物的损坏或丢失负责。车内承载、放置或遗留的任何个人财物均不对响车车构成任何委托责任。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 4\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">事故处理</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、车辆在租赁过程中发生交通事故如何处理？</dt> <dd _v-1774411b=\"\"> 如果在路上发生交通事故，请不要着急，如果有人员受伤，立即拨打120救援电话，拨打交通事故报警电话报警122，再拨打保险公司客服报案，同时拨打客服热线4008637833转2报备。不影响交通秩序的前提下保留第一现场，把警示牌放于事故车后150米，等待交警和保险查勘人员到达现场处理；如影响交通，请拍好第一现场照片，将车辆移开，等待交警和保险查勘人员到达现场。处理完毕后将车辆还回网点，把保险资料交给外勤工作人员处理。 </dd> <dt _v-1774411b=\"\">2、车险理赔是如何？</dt> <dd _v-1774411b=\"\"> （1）以下情况及其他保险公司不予赔偿的情况，造成的所有经济损失和后果将由您自行承担，请您务必避免：<br _v-1774411b=\"\"> a. 超过48小时报案；<br _v-1774411b=\"\"> b. 饮酒后驾驶车辆；<br _v-1774411b=\"\"> c. 无证驾驶车辆；<br _v-1774411b=\"\"> d. 持逾期未审验的驾驶执照驾驶车辆；<br _v-1774411b=\"\"> e. 发生事故后驾车逃逸。 </dd> <dd _v-1774411b=\"\"> （2）如车辆不慎出险，请您注意人身安全，并立即致电客服热线400-863-7833转2报案、收集理赔材料，齐全的理赔材料可以节省您的理赔等待时间。<br _v-1774411b=\"\"> 在您还车并提交了齐全的理赔资料时，您不需要垫付本车维修等保险公司应付费用，仅需：<br _v-1774411b=\"\"> a)支付上表列明的保险责任内的由承租方承担的损失，以及保险责任外的所有责任和损失（如您已经购买不计免赔服务，保险责任范围外的轮胎损失您可以免于承担）；<br _v-1774411b=\"\"> b)垫付第三方损失，该费用将在保险公司完成理赔后返还给您；(在您全责或主责的情况下，如第三方同意在响车车指定维修单位定损、维修，该费用将无需您垫付) <br _v-1774411b=\"\"> c)在您还车不能提供齐全的理赔资料时，请根据预估的车辆损失刷取最低1500元的维修押金，该押金将在您提交完材料后的15个工作日发起退款（到账时间以各银行为准）。 </dd> <dd _v-1774411b=\"\"> （3）在您用车期间，如有车辆盗抢与报废发生，您需支付公安部门立案或车管部门出具报废证明之前的车辆租赁费用。 </dd> </dl> <h1 _v-1774411b=\"\">车辆故障处理</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、车辆在租赁过程中发生故障如何处理？</dt> <dd _v-1774411b=\"\"> 如果车辆发生故障无法启动、仪表盘出现故障码、车辆爆胎、漏气等情况，先把警示牌放于车后150米，然后拨打电话客服热线4008637833转2咨询指导，等待救援。 </dd> <dt _v-1774411b=\"\">2、车辆在行驶过程中爆胎，保险赔偿吗？</dt> <dd _v-1774411b=\"\"> 请您在行驶过程中尽量选择安全路况行驶，并在取车时或者开车前进行检查，如有车辆安全隐患方面的疑问请及时致电客服热线400-863-7833转2，；如果遇到现场爆胎，请将车辆移至安全地带，并致电客服热线400-863-7833转2我们会及时为您处理。 车辆爆胎是不属于保险赔偿范围的，如客人在租赁过程中发生非轮胎质量范围外的爆胎，我们将按照4S店的标准向您收费。 </dd> <dt _v-1774411b=\"\">3、停车被划伤如何处理？</dt> <dd _v-1774411b=\"\"> 请您在取车时进行检查，如发现已存在车辆划伤的情况，请通过APP中的“拍照取证”或者拍照并上传至微信公众号——响车车，我们将为您进行备案。如在租赁过程中发现新的刮伤，也请您第一时间拍照上传至微信公众号——响车车，我们将根据车辆刮伤情况具体定损，如您未拍照上传，我们之后查询在您行驶中出现了新的刮伤，您有可能需要支付全款并支付车辆修理停运费用。如有疑问，请致电400-863-7833转2客服中心。 </dd> <dt _v-1774411b=\"\">4、车辆救援范围以及是否收费？</dt> <dd _v-1774411b=\"\"> 车辆在城区范围内，我们均会为您提供救援服务。如因车辆故障问题引起的救援服务，我们将为您提供免费服务。如因您个人原因造成车辆电量耗尽而造成车辆无法行驶，我们将会根据实际情况进行有偿救援服务。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 5\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">违章查询及处理</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、如何查询违章</dt> <dd _v-1774411b=\"\"> 可在个人中心，违章信息中查看，或者“响车车”平台（以下简称平台）在收到车管所或交警大队对车辆的违章通知后，由平台客服人员通过电话或者短信的形式通知。 </dd> <dt _v-1774411b=\"\">2、如何进行违章处理</dt> <dd _v-1774411b=\"\"> 用户可在接到电话通知起7天内自行前往车管所或交警支队处理，亦可委托平台代为处理。对于吊销驾照或单次违章扣分6分及以上的严重交通违法行为，平台有权拒绝接受委托处理。如用户接到电话通知超过7天未处理，将被视为用户自动委托“响车车”处理相关违章。“响车车”有权在违章用户账户内扣除违章罚款及代办费用。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 6\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">关于违章保证金</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、使用车辆是否收取违章保证金？</dt> <dd _v-1774411b=\"\"> 响车车会员在使用租车服务时，需要会员账户缴纳达到违章保证金的最低标准即1000元人民币作为违章保证金。 </dd> <dt _v-1774411b=\"\">2、违章保证金如何退还？</dt> <dd _v-1774411b=\"\"> 用户在确定不再用车以后，本人可用绑定注册的手机号码在APP“个人中心”内的“违章保证金余额”中进行“退违章保证金”操作，或致电“响车车”客服中心4008637833转1咨询。我们将确认用户租车期间没有违章和事故或者违章和事故已经处理完的前提下，在15个工作日（15个工作日即最后订单结算算起，不含周末跟节假日）将违章保证金退还到钱包余额，注明：余额可随时提现。 </dd> <dt _v-1774411b=\"\">3、免违章保证金说明</dt> <dd _v-1774411b=\"\"> 3.1 满足芝麻信用评分550分及以上，且没有相关不良记录，可申请芝麻信用服务。<br _v-1774411b=\"\"><br _v-1774411b=\"\"> 3.2 解除授权后将失去免违章保证金服务，需重新授权芝麻信用获得免违章保证金服务。<br _v-1774411b=\"\"><br _v-1774411b=\"\"> 3.3 规范用车履约行为将有助于你的信用积累，恶意破坏违约将会影响信用记录。<br _v-1774411b=\"\"><br _v-1774411b=\"\"> 3.4 当你会员等级达到黄金及以上等级时，可申请享受会员权益免违章保证金服务。<br _v-1774411b=\"\"><br _v-1774411b=\"\"> </dd> </dl> </div> <div class=block v-if=\"show_part_index == 7\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">用车收费</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、响车车项目标准费用是多少？</dt> <dd _v-1774411b=\"\"> 每个地区不同车型的费用计算根据当地实际定价而定，请在选择车辆时查看相应的计费标准。 </dd> <dt _v-1774411b=\"\">2、响车车费用如何结算？</dt> <dd _v-1774411b=\"\"> 服务结束后，响车车APP系统会根据你的消费自动结算。例：时租费用+电费=本次总租车费用 </dd> <dt _v-1774411b=\"\">3、如果发现我的结算费用有误怎么办？</dt> <dd _v-1774411b=\"\"> 如果您对结算费用产生质疑，您可以拨打客服热线4008-637-833转3进行咨询，将有专职的客服人员为您核查并解决问题。 </dd> <dt _v-1774411b=\"\">4、预订成功后，如果没有取车还会收费吗？</dt> <dd _v-1774411b=\"\"> 根据预定时间，我们为您免费保留15分钟取车时间，订单超过15分钟将取消订单。当天取消订单累计2次，第3次将开始自动计费。如果您没有在上述规定时间前取消预定，则取消无效，我们的系统将默认执行预定订单，相应收取车辆使用费。<br _v-1774411b=\"\"> 例如：您预订了一小时10元的服务，但您未能取车，也没有取消订单、订单超过15分钟系统将自动取消订单，若您是在取车后才取消订单，我们将收取您10元的车辆租赁费用。为了方便您和其他会员体验更好的服务，请您理解。 </dd> <dt _v-1774411b=\"\">5.如何享受38块包夜套餐呢？</dt> <dd _v-1774411b=\"\"> 您只需要用车时长累计完结20小时后，成为白银会员及白银以上的会员，就可以享受38元包夜套餐。 </dd> <dt _v-1774411b=\"\">6、响车车用户付费方式？</dt> <dd _v-1774411b=\"\"> “响车车”服务采用账户余额支付，微信支付、支付宝支付，企业帐户支付等付费方式。用户在使用分时租车服务前将支付宝或微信绑定至账户，即可进行充值。 </dd> <dt _v-1774411b=\"\">7、如何查看我的消费和充值记录？</dt> <dd _v-1774411b=\"\"> 您可以进入手机APP客户端或者微信公众号客户端登陆后，进入“个人中心”的“消费记录”查阅充值记录，查阅消费可以进入“我的订单”页面查看历史记录。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 8\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">其他可能产生的费用</h1> <dl _v-1774411b=\"\"> <dt _v-1774411b=\"\">1、预定违约费用</dt> <dd _v-1774411b=\"\"> 根据预定时间，“响车车”为用户免费保留15分钟取车时间，订单超过15分钟将取消订单。当天取消订单累计2次，第3次将开始自动计费。 </dd> <dt _v-1774411b=\"\">2、损失费用</dt> <dd _v-1774411b=\"\"> 由于用户在汽车熄火时未关闭灯光，收音机等耗电部件，以致汽车无法再次正常启动，“响车车”将为汽车实行有偿紧急救援。用户将被收取100元的蓄电池抢修费，以及蓄电池损耗费50元。 </dd> <dt _v-1774411b=\"\">3、维修费用</dt> <dd _v-1774411b=\"\"> 用户恶意损害车内行车记录仪等车内设备，将视损坏程度按实际价值收取维修费用。 </dd> <dt _v-1774411b=\"\">4、驾驶违约费用</dt> <dd _v-1774411b=\"\"> 如“响车车”预定用户将汽车交予非授权驾驶人驾驶，用户将被收取1000元驾驶违约费用。 </dd> <dt _v-1774411b=\"\">5、清洁费用</dt> <dd _v-1774411b=\"\"> 将宠物带入车内或者将汽车以内部肮脏状态归还的用户应支付车辆清洁费用50-200元不等。 </dd> <dt _v-1774411b=\"\">6、禁烟违约费用</dt> <dd _v-1774411b=\"\"> 在车内抽烟是被严格禁止的，工作人员一旦发现， 用户在车内抽烟或允许他人抽烟将被收取禁烟违约费用100元。 </dd> <dt _v-1774411b=\"\">7、共享车主违约费用</dt> <dd _v-1774411b=\"\"> 根据共享时间，“响车车共享车主”为用户设定可租用时间段内必须在指定还车点还车，逾期归还则按照30元/小时的标准收取逾期惩罚金。 </dd> <dt _v-1774411b=\"\">8、车辆车身贴纸费用</dt> <dd _v-1774411b=\"\"> 车辆车身的贴纸如故意性损坏需赔偿100元。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 9\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">订单取消次数过多无法下单</h1> <dl _v-1774411b=\"\"> <dd _v-1774411b=\"\"> 1、如果您因取消订单次数过多导致无法下单，请联系客服进行处理，同时希望您在选择车辆出行之前，确认好自己的行程，以免产生不必要的麻烦。 </dd> </dl> </div> <div class=block v-if=\"show_part_index == 10\" _v-1774411b=\"\"> <h1 _v-1774411b=\"\">无法使用优惠券</h1> <dl class=son_mb20 _v-1774411b=\"\"> <p _v-1774411b=\"\"> 1.请先确认您的用车订单符合优惠券的使用规则，不在优惠券使用范围内的订单，是无法使用优惠券的。 </p> <p _v-1774411b=\"\"> 2.优惠券是否满足了满减的条件，不达到对应满减条件则无法使用优惠券。 </p> <p _v-1774411b=\"\"> 3.共享用车无法使用优惠券。 </p> <p _v-1774411b=\"\"> 4.企业用车无法使用优惠券。 </p> <p _v-1774411b=\"\"> 5.套餐无法使用优惠券。 </p> </dl> </div> <div style=\"height: 1px\" _v-1774411b=\"\"></div> </div> ";

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

	module.exports = " <div class=help _v-194fca2e=\"\"> <hd title=法律条款和隐私政策 _v-194fca2e=\"\"></hd> <ul _v-194fca2e=\"\"> <li v-touch:tap=jump(1) _v-194fca2e=\"\">响车车平台协议</li> <li v-touch:tap=jump(2) _v-194fca2e=\"\">车辆租赁合同</li> <li v-touch:tap=jump(3) _v-194fca2e=\"\">隐私政策</li> <li v-touch:tap=jump(4) _v-194fca2e=\"\">证照信息</li> </ul> </div> ";

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

	module.exports = " <div class=container _v-26bd69a6=\"\"> <router-view _v-26bd69a6=\"\"></router-view> </div> ";

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=platform-protocol _v-2846646d=\"\"> <hd title=隐私政策 _v-2846646d=\"\"></hd> <div _v-2846646d=\"\"> <h1 class=pr-title _v-2846646d=\"\">隐私政策</h1> <p class=f-bold _v-2846646d=\"\">一、引言</p> <p _v-2846646d=\"\">广州响车车科技有限公司(以下简称“响车车”)重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本隐私政策条款向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本隐私政策条款与您所使用的响车车服务息息相关，希望您仔细阅读，在需要时，按照本隐私政策条款的指引，作出您认为适当的选择。本隐私政策条款中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。</p> <p _v-2846646d=\"\">您使用或继续使用我们的服务，即意味着同意我们按照本隐私政策条款收集、使用、储存和分享您的相关信息。</p> <p _v-2846646d=\"\">如对本隐私政策条款或相关事宜有任何问题，请通过<a href=http://joyincar.cn/ style=color:blue _v-2846646d=\"\">http://joyincar.cn/</a>或4008637833与我们联系。</p> <p class=f-bold _v-2846646d=\"\">二、我们可能收集的信息</p> <p _v-2846646d=\"\">我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p> <p _v-2846646d=\"\">2.1、您提供的信息</p> <p _v-2846646d=\"\">您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；</p> <p _v-2846646d=\"\">您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</p> <p _v-2846646d=\"\">2.2、其他方分享的您的信息</p> <p _v-2846646d=\"\">其他方使用我们的服务时所提供有关您的共享信息。</p> <p class=f-bold _v-2846646d=\"\">三、我们获取的您的信息</p> <p _v-2846646d=\"\">您使用服务时我们可能收集如下信息：</p> <p _v-2846646d=\"\">3.1、日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：</p> <p _v-2846646d=\"\">3.2、设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；</p> <p _v-2846646d=\"\">3.3、有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</p> <p _v-2846646d=\"\">3.4、您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。</p> <p _v-2846646d=\"\">3.5、位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：</p> <p _v-2846646d=\"\">您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；</p> <p _v-2846646d=\"\">您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；</p> <p _v-2846646d=\"\">您可以通过关闭定位功能，停止对您的地理位置信息的收集。</p> <p _v-2846646d=\"\">3.6、设备MAC地址，我们将使用此信息来标志设备的唯一性，用于您账号的安全验证。在登陆有效期间，我们会使用此信息辅助验证登陆的有效性，避免您的身份遭受盗用。</p> <p class=f-bold _v-2846646d=\"\">四、我们可能如何使用信息</p> <p _v-2846646d=\"\">我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p> <p _v-2846646d=\"\">4.1、向您提供服务；</p> <p _v-2846646d=\"\">在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p> <p _v-2846646d=\"\">帮助我们设计新服务，改善我们现有服务；</p> <p _v-2846646d=\"\">使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的需求，例如语言设定、位置设定、帮助服务和指示，或对您和其他用户作出其他方面的回应；</p> <p _v-2846646d=\"\">向您提供与您更加相关的广告以替代普遍投放的广告；</p> <p _v-2846646d=\"\">评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</p> <p _v-2846646d=\"\">软件认证或管理软件升级；</p> <p _v-2846646d=\"\">4.2、让您参与有关我们产品和服务的调查。</p> <p _v-2846646d=\"\">为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，用于我们其他的服务。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。</p> <p class=f-bold _v-2846646d=\"\">五、您如何访问和控制自己的个人信息</p> <p _v-2846646d=\"\">我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。我们可能分享的信息除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p> <p _v-2846646d=\"\">5.1、我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：</p> <p _v-2846646d=\"\">5.2、向您提供我们的服务；</p> <p _v-2846646d=\"\">5.3、实现“我们可能如何使用信息”部分所述目的；</p> <p _v-2846646d=\"\">5.4、履行我们在《响车车服务协议》或本隐私政策条款中的义务和行使我们的权利；理解、维护和改善我们的服务。</p> <p _v-2846646d=\"\">5.5、如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本隐私政策条款及我们要求其遵守的其他适当的保密和安全措施。</p> <p _v-2846646d=\"\">5.6、随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</p> <p _v-2846646d=\"\">5.7、更正个人信息。当您需要更正您的个人信息，或发现响车车平台收集、存储的个人信息有错误时，您有权做出更正或更新。您可以通过将您的更正申请提交给响车车客服，或通过您在响车车平台的账号更正或修改您提供的个人资料信息。</p> <p _v-2846646d=\"\">5.8、删除个人信息。如您希望删除个人信息，可以通过电话联系响车车客服（400-863-7833），提交删除申请。在满足法律法规要求的最短保存期限要求的情况下，我们将对您的个人信息进行删除或匿名化处理。在上述法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。</p> <p _v-2846646d=\"\">5.9、注销账户。您可以通过联系响车车客服（400-863-7833）注销账户，处理时间为15个工作日。除法律法规另有规定外，注销账户之后我们将停止为您提供服务。</p> <p _v-2846646d=\"\">5.10、如您无法通过上述方式更正、删除个人信息或注销账号，您可以拨打响车车客服电话（400-863-7833）与我们取得联系，响车车客服团队可能需要验证您的身份，并在验证您的身份后15个工作日内做出答复或合理解释。</p> <p _v-2846646d=\"\">5.11、我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p> <p _v-2846646d=\"\">遵守适用的法律法规；</p> <p _v-2846646d=\"\">遵守相关政府机关的要求；</p> <p _v-2846646d=\"\">为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p> <p class=f-bold _v-2846646d=\"\">六、信息安全</p> <p _v-2846646d=\"\">我们仅在本隐私政策条款所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。</p> <p _v-2846646d=\"\">我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p> <p class=f-bold _v-2846646d=\"\">七、您分享的信息</p> <p _v-2846646d=\"\">我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。</p> <p _v-2846646d=\"\">7.1、您分享的敏感个人信息</p> <p _v-2846646d=\"\">某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。</p> <p _v-2846646d=\"\">请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。</p> <p _v-2846646d=\"\">7.2、您同意按本隐私政策条款所述的目的和方式来处理您的敏感个人信息。</p> <p class=f-bold _v-2846646d=\"\">八、我们可能如何收集信息</p> <p _v-2846646d=\"\">我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。</p> <p _v-2846646d=\"\">我们使用自己的cookies和web beacon，目的是为您提供更优质的用户体验和服务，并用于以下用途：</p> <p _v-2846646d=\"\">8.1、记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；</p> <p _v-2846646d=\"\">8.2、分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；</p> <p _v-2846646d=\"\">8.3、广告优化。Cookies和web beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。</p> <p _v-2846646d=\"\">我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。</p> <p _v-2846646d=\"\">我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web beacon。这些cookies和web beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web beacon收集和使用该等信息，不受本隐私政策条款约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或web beacon承担责任。</p> <p _v-2846646d=\"\">您可以通过APP设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低；</p> <p _v-2846646d=\"\">8.4、为保障响车车APP相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现前述目的。我们会尽到审慎义务，对合作方获取信息的SDK进行严格的安全监测，以保护数据安全。</p> <p _v-2846646d=\"\">我们接入的第三方SDK主要服务于您以及其他的用户需求，因此在满足新的服务需求及业务功能变更时，我们可能会调整我们接入的第三方SDK，我们会及时在本说明中向您公开说明接入第三方SDK的最新情况。目前响车车APP接入的第三方SDK列明如下:</p> <img src=" + __webpack_require__(607) + " style=width:100% _v-2846646d=\"\"> <p class=f-bold _v-2846646d=\"\">九、广告服务</p> <p _v-2846646d=\"\">我们可能使用您的相关信息，向您提供与您更加相关的广告。</p> <p _v-2846646d=\"\">我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：</p> <p _v-2846646d=\"\">9.1、我们的商品或服务，我们的关联公司和合作伙伴的商品或服务，包括即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、付款服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、互联网金融，以及其他社交媒体、娱乐、电子商务、资讯和通讯软件或服务（统称“互联网服务”）；</p> <p _v-2846646d=\"\">9.2、第三方互联网服务供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。</p> <p _v-2846646d=\"\">9.3、如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。</p> <p class=f-bold _v-2846646d=\"\">十、我们可能向您发送的邮件和信息</p> <p _v-2846646d=\"\">10.1、邮件和信息推送</p> <p _v-2846646d=\"\">您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。</p> <p _v-2846646d=\"\">10.2、与服务有关的公告</p> <p _v-2846646d=\"\">我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p> <p class=f-bold _v-2846646d=\"\">十一、隐私政策的适用例外</p> <p _v-2846646d=\"\">我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：</p> <p _v-2846646d=\"\">您利用 “分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；</p> <p _v-2846646d=\"\">我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。</p> <p _v-2846646d=\"\">该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本隐私政策条款）约束，您需要仔细阅读其条款。本隐私政策条款仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。</p> <p class=f-bold _v-2846646d=\"\">十二、隐私政策的适用范围</p> <p _v-2846646d=\"\">除某些特定服务外，我们所有的服务均适用本隐私政策条款。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本隐私政策条款的一部分。如相关特定服务的隐私政策与本隐私政策条款有不一致之处，适用该特定服务的隐私政策。</p> <p _v-2846646d=\"\">除本隐私政策条款另有规定外，本《隐私条款》所用词语将与《响车车服务协议》所定义的词语具有相同的涵义。</p> <p _v-2846646d=\"\">请您注意，本隐私政策条款不适用于以下情况：</p> <p class=f-bold _v-2846646d=\"\">十三、变更</p> <p _v-2846646d=\"\">我们可能适时修订本隐私政策条款的条款，该等修订构成本隐私政策条款的一部分。如该等修订造成您在本隐私政策条款下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本隐私政策条款的约束。</p> <p _v-2846646d=\"\">广州响车车科技有限公司, 版权所有。</p> </div> </div> ";

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

	module.exports = " <div class=platform-protocol _v-2b4298ba=\"\"> <hd title=证照信息 _v-2b4298ba=\"\"></hd> <div _v-2b4298ba=\"\"> <img alt=license_information :src=\"oss_url + '/car_rental/license_information/license_information.jpg'\" _v-2b4298ba=\"\"> </div> </div> ";

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

	module.exports = " <div class=help _v-3579c0e5=\"\"> <hd title=使用帮助 _v-3579c0e5=\"\"></hd> <div class=black _v-3579c0e5=\"\"></div> <div class=help_wrapper _v-3579c0e5=\"\"> <h1 class=title _v-3579c0e5=\"\">常见问题</h1> <ul _v-3579c0e5=\"\"> <li v-touch:tap=jump(1) _v-3579c0e5=\"\">用车指导及注意事项</li> <li v-touch:tap=jump(2) _v-3579c0e5=\"\">车辆续航及充电</li> <li v-touch:tap=jump(3) _v-3579c0e5=\"\">用车规则</li> </ul> <h1 class=title _v-3579c0e5=\"\">违章及事故处理</h1> <ul _v-3579c0e5=\"\"> <li v-touch:tap=jump(4) _v-3579c0e5=\"\">事故处理步骤</li> <li v-touch:tap=jump(5) _v-3579c0e5=\"\">违章查询及处理</li> </ul> <h1 class=title _v-3579c0e5=\"\">费用问题</h1> <ul _v-3579c0e5=\"\"> <li v-touch:tap=jump(6) _v-3579c0e5=\"\">关于押金</li> <li v-touch:tap=jump(7) _v-3579c0e5=\"\">用车收费</li> <li v-touch:tap=jump(8) _v-3579c0e5=\"\">其他违规情况收费</li> </ul> <h1 class=title _v-3579c0e5=\"\">其他问题</h1> <ul _v-3579c0e5=\"\"> <li v-touch:tap=jump(9) _v-3579c0e5=\"\">取消订单次数过多无法下单？</li> <li v-touch:tap=jump(10) _v-3579c0e5=\"\">无法使用优惠券？</li> </ul> </div> </div> ";

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

	module.exports = " <div class=coupon _v-448e0cc0=\"\"> <hd title=商城说明 _v-448e0cc0=\"\"></hd> <div class=coupon-box _v-448e0cc0=\"\"> <div class=coupon-title _v-448e0cc0=\"\">一、响币商城的由来</div> <div class=coupon-content _v-448e0cc0=\"\"> <p _v-448e0cc0=\"\">您每次使用响车车新能源汽车，都为这美丽的世界节能减排。为了感谢您为这世界作出的环保贡献，我们回馈响币于您，鼓励您使用我们新能源汽车，为全球变暖做出一份贡献。</p> </div> </div> <div class=coupon-box _v-448e0cc0=\"\"> <div class=coupon-title _v-448e0cc0=\"\">二、兑换规则</div> <ol class=\"coupon-content coupon-content1\" _v-448e0cc0=\"\"> <li _v-448e0cc0=\"\">每次订单结算后，我们会根据您消费的金额进行等比例的回馈响币。消费1元对应获得1个响币。消费100元回馈100个响币。</li> <li _v-448e0cc0=\"\">响币获得后，不可进行转赠。</li> <li _v-448e0cc0=\"\">兑换规则最终解释权归响车车所有，兑换出现任何问题，请拨打客服热线400-863-7833进行咨询。</li> </ol> </div> </div> ";

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

	module.exports = " <div class=coupon _v-4ee1c76c=\"\"> <hd title=优惠券说明 _v-4ee1c76c=\"\"></hd> <div class=coupon-box _v-4ee1c76c=\"\"> <div class=coupon-title _v-4ee1c76c=\"\">使用说明</div> <ol class=coupon-content _v-4ee1c76c=\"\"> <li _v-4ee1c76c=\"\">优惠券不可叠加使用。</li> <li _v-4ee1c76c=\"\">产生退款的情况下，优惠券不退回。</li> <li _v-4ee1c76c=\"\">每张优惠券只可使用一次。</li> <li _v-4ee1c76c=\"\">选择套餐的情况下，不能使用优惠券。</li> <li _v-4ee1c76c=\"\">长时间未支付自动扣款的订单，无法使用优惠券。</li> </ol> </div> <div class=coupon-box _v-4ee1c76c=\"\"> <div class=coupon-title _v-4ee1c76c=\"\">体验券</div> <ol class=coupon-content _v-4ee1c76c=\"\"> <li _v-4ee1c76c=\"\">体验券仅供分时用车且消费总额大于0时使用；</li> <li _v-4ee1c76c=\"\">体验券可抵扣所有费用：时租费、套餐费、电费、车辆调度费。</li> </ol> </div> <div class=coupon-box _v-4ee1c76c=\"\"> <div class=coupon-title _v-4ee1c76c=\"\">满减券</div> <ol class=coupon-content _v-4ee1c76c=\"\"> <li _v-4ee1c76c=\"\">满减券仅供分时车、共享车且时租费大于0时使用；</li> <li _v-4ee1c76c=\"\">满减券只能抵扣时租费，不能抵扣套餐费、电费、车辆调度费、违约金；</li> <li _v-4ee1c76c=\"\">满减券可通过响币兑换、新用户注册、邀请好友注册认证和充值金额获得。</li> </ol> </div> <div class=coupon-box _v-4ee1c76c=\"\"> <div class=coupon-title _v-4ee1c76c=\"\">代金券</div> <ol class=coupon-content _v-4ee1c76c=\"\"> <li _v-4ee1c76c=\"\">代金券仅供分时车、共享车且时租费大于0时使用；</li> <li _v-4ee1c76c=\"\">代金券只能抵扣时租费，不能抵扣套餐费、电费、车辆调度费、违约金；</li> <li _v-4ee1c76c=\"\">代金券可通过做任务、开红包车、响活动兑换码活动获得。</li> </ol> </div> <div class=coupon-box _v-4ee1c76c=\"\"> <div class=coupon-title _v-4ee1c76c=\"\">购车券</div> <ol class=coupon-content _v-4ee1c76c=\"\"> <li _v-4ee1c76c=\"\">购车券仅供成为共享车主时使用；</li> <li _v-4ee1c76c=\"\">购车券可通过扫描商家二维码成为共享车主获得。</li> </ol> </div> <div class=coupon-box _v-4ee1c76c=\"\"> <div class=coupon-title _v-4ee1c76c=\"\">代步券</div> <ol class=coupon-content _v-4ee1c76c=\"\"> <li _v-4ee1c76c=\"\">代步券仅供代步车业务使用。</li> <li _v-4ee1c76c=\"\">代步券可以抵扣时租费、套餐费、电费，不能抵扣车辆调度费。</li> </ol> </div> </div> ";

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

	module.exports = " <div class=common-problem _v-6eda5422=\"\"> <hd title=常见问题 _v-6eda5422=\"\"></hd> <div class=block _v-6eda5422=\"\"> <dl _v-6eda5422=\"\"> <dt _v-6eda5422=\"\">1、什么是分时租赁？</dt> <dd _v-6eda5422=\"\"> 分时租赁是租车行业新兴的一种租车模式。意指以小时计算提供汽车的随取即用租赁服务，消费者可以按个人用车需求和用车时间预订租车的小时数，其收费将按小时来计算。 </dd> <dt _v-6eda5422=\"\">2、分时租赁与其他租赁形式有何区别？</dt> <dd _v-6eda5422=\"\"> 分时租赁指按小时进行租赁，其他租赁方式以天作为单位进行租赁。不同于传统意义的汽车租赁,这种短时多人共享的方式有特有的便利性。 </dd> <dt _v-6eda5422=\"\">3、分时租赁的优势在哪里？</dt> <dd _v-6eda5422=\"\"> 环保。汽车共享对于减少环境污染来说是非常行之有效的方法，可以有效地提高汽车的使用效率，不必人人都拥有一辆车，对节能环保，减少碳排放和汽车尾气污染有积极意义。降低出行成本。分时租车就是为了提高车辆的使用率，可以为出行者减少购买汽车的费用和燃油费用支出，将资金效益最大化。 </dd> <dt _v-6eda5422=\"\">4、响车车提供哪些服务？</dt> <dd _v-6eda5422=\"\"> 我们为所有需要短途自驾用车的客人提供新能源电动汽车的分时自助租赁服务。响车车提倡按需租车，分时共享。响车车提供你心动价格的优质服务。 手机APP、微信、电脑电话多种渠道随时随地下单租车。响车车，您手机上的私家车。 自助取车服务。全程手机操作，无人值守，您用车，我供车；比起私家车，省去维修、保养、保险、折旧等一系列支出。响车车，你的租车管家！ </dd> <dt _v-6eda5422=\"\">5、如何查询车辆租用的相关合同及规范文件？</dt> <dd _v-6eda5422=\"\"> 在APP“个人中心”-“使用帮助”中查询，或在您下载APP注册会员、下单预定等过程时，请务必知晓并详阅平台用户协议。 </dd> <dt _v-6eda5422=\"\">6、车辆的整洁情况由谁负责？</dt> <dd _v-6eda5422=\"\"> 响车车提供的所有车辆均经过响车车《车辆整备标准》进行整备，如果您对车辆状况有任何疑问请手机拍照上传至微信并致电客服热线 400-863-7833 反馈，也请您尽量维护车辆整洁。 如车辆内部在您使用过后太过脏乱或遗留垃圾，以致影响其他客户的使用，将汽车以内部肮脏状态归还的会员需要自行清洗或者委托我们清洗，费用按实际标准收取（50-200元不等）。所以您需要注意，不要将咖啡、可乐等易着色饮料或液体沾染在座套上，影响下位客户的使用。 </dd> <dt _v-6eda5422=\"\">7、车辆的车钥匙在哪里？</dt> <dd _v-6eda5422=\"\"> 整个租车过程是无需使用车辆钥匙的，所有的操作都是经过手机端完成，如发现任何手机功能失效，请立即致电客服热线4008-637-833转2向客服反馈 。 </dd> <dt _v-6eda5422=\"\">8、车辆可同时乘坐几位乘客？</dt> <dd _v-6eda5422=\"\"> 响车车车辆乘坐不得超过 5 位乘客（含驾驶人）。具体按照具体车型为准，请您根据有关交通法规的标准安全载客。 </dd> <dt _v-6eda5422=\"\">9、可以在车内吸烟吗？</dt> <dd _v-6eda5422=\"\"> 为了您和其他客户的优质体验及行车安全，在车内抽烟是被严格禁止的，工作人员一旦发现，&nbsp;租客在车内抽烟或允许他人抽烟将被收取抽烟违约金100元。 </dd> <dt _v-6eda5422=\"\">10、没有驾照可以租车吗？</dt> <dd _v-6eda5422=\"\"> 如果您没有驾照是无法使用响车车平台车辆的，我们非常欢迎您在获得《中华人民共和国机动车驾驶证》后体验响车车服务。为了您的和他人的安全，请您遵守道路法律法规。 </dd> <dt _v-6eda5422=\"\">11、个人物品落在车内怎么办？如果在车内发现他人遗留物品怎么办？</dt> <dd _v-6eda5422=\"\"> 请您下车时仔细查看随身物品。 如果您发现个人物品遗落在车内，请您及时拨打客服热线 4008-637-833转1，我们会协助您进行后续跟踪找寻。 如果您在用车时发现他人物品遗留在车内，请您拍照上传至微信并拨打客服热线 4008-637-833转1，我们会为失物找到它的主人。响车车不对任何会员个人财物的损坏或丢失负责。车内承载、放置或遗留的任何个人财物均不对响车车构成任何委托责任。 </dd> <dt _v-6eda5422=\"\">12、是否可以在响车车停车点停放其他车辆？</dt> <dd _v-6eda5422=\"\"> 响车车停车点都是经过授权之后的专用停车点，为了避免造成您的麻烦，请您不要将不属于响车车的车辆停入停车点。 </dd> </dl> </div> </div> ";

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

	module.exports = " <div class=platform-protocol _v-6f375ade=\"\"> <hd title=车辆租赁合同 _v-6f375ade=\"\"></hd> <div _v-6f375ade=\"\"> <h1 class=pr-title _v-6f375ade=\"\">车辆租赁合同</h1> <p _v-6f375ade=\"\">合同编号：（以具体合同编号为准）</p> <p _v-6f375ade=\"\">出租方（甲方）：广州响车车科技有限公司</p> <p _v-6f375ade=\"\">承租方（乙方）：</p> <p _v-6f375ade=\"\">*“响车车”以下代指“广州响车车科技有限公司”。</p> <p _v-6f375ade=\"\">双方在平等自愿的基础上，经友好协商，就本次租赁事宜达成如下条款：</p> <p class=f-bold _v-6f375ade=\"\">第一条、汽车租赁</p> <p _v-6f375ade=\"\">乙方向甲方租赁分时租车辆壹台，车牌号为粤A***** （以下简称“租赁车辆”），时租费为XXX元/小时（不含电费），日租费为XXX元/日（不含电费）；租期为乙方通过“响车车”APP会员账号点击开门起算至还车结算之时结束。</p> <p class=f-bold _v-6f375ade=\"\">第二条、甲方的权利和义务</p> <p _v-6f375ade=\"\">2.1、甲方享有租赁汽车的所有权，甲方有权通过合理方式随时检查租赁汽车的使用情况和安全状态。</p> <p _v-6f375ade=\"\">2.2、甲方依约为乙方提供租赁汽车及该汽车行驶必备的法定证件。</p> <p _v-6f375ade=\"\">2.3 、乙方未按时结清本合同及附件项下费用的，甲方有权从乙方交纳的押金，预付款，充值的余额或刷取的预授权中直接扣除。乙方基于本合同及附件交纳的押金，预付款，充值的金额或刷取的预授权亦可用于支付乙方拖欠甲方的其它债务费用。</p> <p _v-6f375ade=\"\">2.4、乙方在使用租赁汽车时如出现动向异常、逾期不还、抵押、预留联系方式不正确或无法有效联系等情形的，甲方有权立即收回租赁汽车，由此产生的责任及费用均由乙方承担。</p> <p _v-6f375ade=\"\">2.5、 甲方提供乙方租车时使用的APP，甲方保证乙方可正常使用该APP，如有问题须提供电话、手机短信等补救服务。</p> <p _v-6f375ade=\"\">2.6、甲方承担“响车车”平台协议中列明的义务和享有平台协议中列明的权利。</p> <p class=f-bold _v-6f375ade=\"\">第三条、乙方的权利和义务</p> <p _v-6f375ade=\"\">3.1、乙方于租车期内享有租赁汽车符合租赁用途的使用权。</p> <p _v-6f375ade=\"\">3.2、乙方确认是“响车车”平台APP乙方账户的认证驾驶人使用租赁汽车，如是非账户认证驾驶人，请停止使用或租赁汽车，否则乙方须承担由此造成的直接和间接责任及损失，并赔偿甲方经济损失及违约金。如乙方驾驶员因不符合有关法律法规使用汽车，导致的一切损失及后果由乙方承担，并赔偿甲方经济损失及违约金。如因此造成交通事故，保险公司以此为由拒绝赔付，乙方须承担由此造成的直接和间接责任及损失，并赔偿甲方经济损失及违约金。</p> <p _v-6f375ade=\"\">3.3、乙方须下载并使用甲方提供的“响车车”APP，并在租赁汽车前浏览APP中的平台协议，乙方同意租赁汽车则表示同意该APP中的平台协议，如不同意，请终止使用。乙方保证通信畅通，因自己手机通讯故障出现问题的应自行承担责任和损失。</p> <p _v-6f375ade=\"\">3.4、乙方在使用“响车车”APP租赁汽车期间，如平台有欠费提醒，请及时充值；如平台提示电量警告，请及时充电，因乙方原因导致汽车不能正常运营，乙方须承担由此造成的直接和间接责任及损失，并赔偿甲方经济损失。</p> <p _v-6f375ade=\"\">3.5、乙方应自行承担使用租赁汽车时发生的充电费、停车费和路桥费等费用，自行负责车上人员及财产安全，乙方在使用租赁汽车时应当严格遵守道路交通规则，独立承担因交通事故产生的在租赁汽车保单赔付范围外的相关责任及经济损失。</p> <p _v-6f375ade=\"\">3.6、如租赁汽车出现故障或异常，乙方应立即通知甲方，配合甲方的安排更换汽车或者停止使用租赁汽车。</p> <p _v-6f375ade=\"\">3.7、乙方须按照“响车车”平台协议规定合法合规使用租赁汽车。</p> <p _v-6f375ade=\"\">3.8、乙方须承担非甲方原因致租赁汽车被第三方扣押的全部责任，如乙方在车辆被扣起算三个月内没有将车辆取回或交回甲方，则乙方应向甲方赔偿车辆价值原值的价款（新车价），车辆归乙方所有。车辆停运期间的租金损失（停运期间的租金损失按该车系统的日租金标准计算），由乙方向甲方支付，此租金损失一直延续支付到车辆赔偿时为止，不受租赁合同到期的影响。</p> <p _v-6f375ade=\"\">3.9 、在车辆租赁期内发生的道路交通安全违法行为和交通事故，乙方应当将涉及该车的道路交通安全违法行为和交通事故处理完毕，如乙方未及时处理完毕则向甲方支付10万元违约金，另有损失的应当赔偿甲方损失。</p> <p _v-6f375ade=\"\">3.10、车辆在租赁期内发生交通违章被记分、违章罚款，乙方应当立即消分处理及处理违章罚款，如不及时消分处理及处理违章罚款，每记一分向甲方支付一万元的违约金，以及向甲方支付违章罚款，不论该违章罚款甲方是否已经代乙方缴纳，乙方均应支付。</p> <p _v-6f375ade=\"\">3.11、车辆在租赁期内发生交通违章被记达到12分或者累计三次违章未处理，车辆应即刻停止上路行驶或者车辆由甲方收回保管停止上路。车辆停运期间的租金损失（停运期间的每日租金损失按日租费计），由乙方向甲方支付，此租金损失一直延续支付到车辆消分及处理违章为止，不受租赁合同到期的影响。</p> <p _v-6f375ade=\"\">3.12、鉴于公安部《机动车登记规定》第49条之规定，车辆在租赁期内发生包括交通违章被记分、罚款等道路交通安全违法行为和交通事故未处理完毕，致使车辆不能年检年审或者发生交通违章被记达到12分时起超过三个月乙方未消分处理，乙方应向甲方赔偿车辆价值原值的价款（新车价），车辆归乙方所有。</p> <p _v-6f375ade=\"\">3.13、因乙方违约不将车辆交还于甲方，乙方应向甲方赔偿车辆价值原值的价款（新车价），车辆归乙方所有，乙方须另向甲方支付10万元违约金。</p> <p _v-6f375ade=\"\">3.14、因乙方原因致使车辆损坏，乙方应赔偿维修费用，致使车辆损毁的应赔偿车辆价值原值的价款。如果乙方不予赔偿的，应向甲方支付违约金5万元。</p> <p _v-6f375ade=\"\">3.15、因乙方违约不将车辆证件、随车备件交还于甲方，乙方须向甲方支付3万元违约金。</p> <p _v-6f375ade=\"\">3.16、乙方使用虚假证件（机动车驾驶证、身份证等其它证件）租赁车辆、使用车辆的向甲方支付5万元违约金，并承担给甲方造成的损失。</p> <p class=f-bold _v-6f375ade=\"\">第四条、租赁汽车的相关规定</p> <p _v-6f375ade=\"\">4.1、租赁汽车为乙方在“响车车”平台上使用APP乙方账号预定的或直接开锁取车的汽车。乙方通过APP的操作完成租赁汽车的取车、使用、还车以及结算。</p> <p _v-6f375ade=\"\">4.2、因租赁汽车本身问题导致汽车不能继续使用的情况：按小时计算租金的，本次租赁结束，甲方不收取本次租赁费用。按天租赁的，收取已发生租赁天数的租金，本次租赁结束。按套餐租赁的，收取已发生租赁时段的对应比例租金，本次租赁结束。</p> <p _v-6f375ade=\"\">4.3、由于乙方遗失汽车证照或因违法违规用车被扣等情况造成租赁汽车停运的，乙方应承担由此造成的汽车停运损失费。乙方按该车日租金标准向甲方支付停运损失费，该费用计算至租赁汽车补齐证照可合法使用或汽车归还之日止。</p> <p _v-6f375ade=\"\">4.4、乙方应在报警电量以上（30%）的情形下使用租赁汽车。因乙方未及时充电原因而导致的电池没电、汽车抛锚，乙方须承担电池抢修费用及汽车有偿救援费用。乙方须在符合安全标准的充电场所充电，并承担因充电不当导致的一切责任，赔偿甲方经济损失及违约金。</p> <p _v-6f375ade=\"\">4.5、 乙方须按照平台协议中第7款规定合法合规使用租赁汽车，如违反第7款规定，甲方可在不向乙方发出通知的情况下，终止其使用租赁汽车的权利和资格。甲方保留法律规定的权利，包括但不限于不经过法律程序向乙方发出通知而扣押租赁汽车，乙方有义务支付甲方为将租赁汽车追回所发生的一切费用。如果乙方在使用权利终止后继续使用租赁汽车，甲方有权通知公安机关汽车被盗并配合公安机关追回租赁汽车。乙方使用资格终止后，乙方仍须承担支付所有拖欠费用的责任，包括但不限于截至终止日前发生的或在终止日期后经甲方发现的任何赔偿费和罚金。</p> <p _v-6f375ade=\"\">4.6、甲方已给租赁汽车购买汽车损失险（按照汽车销售发票金额），事故第三者险（限额100万），车上司乘人员险（限额5万/人），乙方发生任何交通事故或违章违法行为，按照“响车车”平台协议中第8款约定处理。如果乙方在交通事故中负有责任且租赁汽车维修金额超过一万元的，乙方须承担汽车维修金额的20%作为折旧费用。租赁汽车发生交通事故或违章违法行为被扣留、定损或维修，导致不能正常对外租赁，乙方应根据该车系统的天租金标准乘以停运天数支付停运费用。因乙方责任导致全车损失或盗抢，租赁汽车需要报废的，乙方须承担汽车保险不能赔付部分的折旧费用及其他损失。</p> <p _v-6f375ade=\"\">4.7、 甲方接到交管部门的汽车违章通知后，通过查询确认并通知承租人，承租人须按照“响车车”平台协议第10款约定处理。</p> <p _v-6f375ade=\"\">4.8、 甲方在任何情况下对乙方的唯一补救责任为退回乙方没有使用预定汽车的用车费用。乙方放弃所有针对甲方的间接、惩罚性和附带损害的索赔权利。</p> <p class=f-bold _v-6f375ade=\"\">第五条、租赁费用</p> <p _v-6f375ade=\"\">5.1、乙方使用甲方提供的租赁服务，须支付包括但不限于汽车租金、汽车充电费、租赁套餐费用、特殊服务费用、汽车违章罚金及违章处理费用、有偿救援服务、蓄电池抢救及耗损费、预定违约费用、驾驶违约费用、汽车清洁费用、禁烟违约费用、汽车非保险损坏修复费用、事故中保险不赔偿或不足额赔偿部分、汽车折旧费用、汽车停驶费用、因乙方拒不归还汽车发生的追偿费用等，计算标准详见“响车车”平台协议第6款和第8款以及甲方网站中公示的价格及说明，具体以APP中列明的金额及甲方向乙方电话、短信或书面通知为准。</p> <p _v-6f375ade=\"\">5.2、乙方在取车时对汽车状态有疑问的，应立即向甲方客服人员咨询，确认后才可使用租赁汽车。归还租赁汽车后，甲方如发现汽车状态或证件等出现问题，如有证据可确认是乙方责任的，乙方须承担赔偿责任及违约金。</p> <p _v-6f375ade=\"\">5.3、 乙方承诺向甲方租赁车辆，并已提交订单，乙方因自身原因需提前解约，按照甲方在“响车车”APP中公布的标准支付违约金。</p> <p _v-6f375ade=\"\">5.4、乙方承诺向甲方租赁日租车辆，在预约期间甲方未能在乙方的时间要求内完成车辆交付，在乙方不愿等待的情况下甲方退还乙方的租赁费用。</p> <p _v-6f375ade=\"\">5.5、乙方在租赁甲方的日租车辆时，因车辆自身原因造成车辆故障，甲方安排同款替换车辆给予乙方，如乙方因车辆自身故障不再使用甲方租赁车辆，甲方退回车辆自发生故障之时起剩余租期的租赁费用给乙方。</p> <p _v-6f375ade=\"\">5.6、乙方在租赁甲方的日租车辆时，因乙方自身原因发生交通事故或导致车辆无法行驶，乙方须承担租赁期间的全部租赁费用。</p> <p _v-6f375ade=\"\">5.7、乙方租赁甲方的日租车辆未能按时还车，甲方按“响车车”APP分时统一收费标准收取乙方超时部分的租赁费用。</p> <p class=f-bold _v-6f375ade=\"\">第六条、违约责任</p> <p _v-6f375ade=\"\">6.1、 任何一方未严格履行本合同及平台协议中义务的，另一方有权要求对方承担违约责任并赔偿损失及违约金，双方同意违约金标准定为10万元。</p> <p _v-6f375ade=\"\">6.2、乙方在控制租赁汽车期间应依约、合理、合法、合规使用汽车，同时须对汽车尽到善良的管理义务，否则即视为违约，承担方应承担一切责任，并赔偿甲方经济损失及违约金。</p> <p class=f-bold _v-6f375ade=\"\">第七条、其他补充</p> <p _v-6f375ade=\"\">7.1、乙方承诺并保证其在本协议履行期间均已获得信息主体的充分、合法的书面授权，即：甲方向乙方明确告知甲方将向第三方申请数据服务（需查询、使用和存储与数据服务相关的乙方所有个人信息，包括但不限于乙方身份信息、信用信息以及其他任何信息）用以判断乙方业务风险。乙方同意甲方及其合作的第三方采集和存储前述数据，甲方应妥善存档备查。同样，乙方请求与甲方发生相关信息或数据交互，要求甲方提供信息或数据的（已经公开的信息除外），应当事先告知甲方并应获得甲方的授权。</p> <p _v-6f375ade=\"\">7.2、乙方账号中甲方提供的通知联系方式、APP中的“响车车”平台协议、出租方官方网站的价格公示等，构成本合同的附件，与本合同具有同等法律效力。乙方在租赁汽车前已对该等内容清楚知晓，并无异议。</p> <p _v-6f375ade=\"\">7.3、乙方于签署本合同前己清楚知晓甲方公示的最新政策，并同意将该等政策作为本合同附件遵守。</p> <p _v-6f375ade=\"\">7.4、乙方确认，通过“响车车”APP内的通知联系方式，为甲方向乙方履行告知义务的唯一有效方式，甲方通过乙方账号中关联的电话、短信，电子邮件或邮递等任何一种方式履行告知后，即视为乙方收悉。</p> <p _v-6f375ade=\"\">7.5、争议的解决：因本合同产生的、或与本合同有关的任何争议，应由甲乙双方协商解决。无法协商解决的，向甲方所在地的人民法院提起诉讼。本合同生效后，各方均应全面履行本合同约定的义务。任何一方不履行或不完全履行本合同约定义务的，应当承担相应的违约责任，并赔偿由此给守约方造成的损失，包括守约方为实现债权而发生的律师费（律师费以每件案2万元计算）、保全费、诉讼收费、交通费、住宿费等。</p> <p _v-6f375ade=\"\">7.6、本合同自乙方在“响车车”APP中确认后生效。</p> <p _v-6f375ade=\"\">甲方：广州响车车科技有限公司</p> <p _v-6f375ade=\"\">签约人：</p> <p class=m-t20 _v-6f375ade=\"\">乙方：</p> <p _v-6f375ade=\"\">签约人：</p> <p _v-6f375ade=\"\">联系方式：</p> <p _v-6f375ade=\"\">签约日期：</p> </div> </div> ";

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

	module.exports = " <div class=platform-protocol _v-d0c6b520=\"\"> <hd title=响车车平台协议 _v-d0c6b520=\"\"></hd> <div _v-d0c6b520=\"\"> <h1 class=pr-title _v-d0c6b520=\"\">响车车平台协议</h1> <p class=f-bold _v-d0c6b520=\"\">特别提示：</p> <p class=f-bold style=text-indent:2em _v-d0c6b520=\"\">本网络平台是由“广州响车车科技有限公司”提供，及其下属子公司负责运营。本协议是以下定义中所指与平台之间关于其使用网络平台服务所订立的协议。</p> <p class=f-bold _v-d0c6b520=\"\">一、定义</p> <p _v-d0c6b520=\"\">1、“会员”，是指在响车车用车平台（以下简称“平台”）有效注册后取得服务的使用人。根据会员账号的使用时长、信誉度、贡献值等，平台可给予会员由低到高依次为「青铜」、「白银」、「黄金」、「铂金」、「钻石」的会员等级，并享有对应特权，具体等级评定及特权规则以平台实际运营情况为准。</p> <p _v-d0c6b520=\"\">2、“注册人”，是指自愿提供个人信息按照平台要求进行注册并获得会员资格的人。</p> <p _v-d0c6b520=\"\">3、“用车人”，是指使用或者驾驶通过平台获得车辆的人。</p> <p _v-d0c6b520=\"\">4、“账号”，是指注册人通过平台注册得到的可以使用平台服务的账号。</p> <p _v-d0c6b520=\"\">5、“车辆”，是指通过平台发布租赁信息的、符合法律法规、平台标准和要求的可用于租赁的车辆。</p> <p _v-d0c6b520=\"\">6、“第三方运营机构”，是指除广州响车车科技有限公司以及子公司以外的，在平台上及线下提供车辆租赁相关产品服务的其他公司。</p> <p _v-d0c6b520=\"\">7、在完成平台会员注册之前，需详细阅读本协议。本协议在接受注册时生效，是和平台之间具有法律意义的文件，双方将同时受到本协议条款的约束。会员注册成功后，可通过手机验证码登录，对获得的验证码严格保管，未经平台书面许可不可随意透露给第三人。应对其注册的平台账号进行的所有活动和事件承担法律责任，包括但不限于车辆损坏维修费、车辆停运损失费、交通事故赔偿费用、平台维权所产生的律师费、诉讼费、差旅费等。</p> <p _v-d0c6b520=\"\">8、平台有权根据运营的实际情况对本协议之条款内容进行单方面的变更，并在平台官方网站、官方公众号及官方APP以公告的方式予以公布，无需另行单独通知。若在本协议之条款内容公告变更后继续使用本服务，表示已充分阅读、理解并接受修改后的条款内容，也将遵循修改后的条款内容使用本服务。</p> <p class=f-bold _v-d0c6b520=\"\">二、 会员资格及注册</p> <p _v-d0c6b520=\"\">1、凡年龄在18周岁（含）以上、持有中华人民共和国有效身份证件（二代身份证）和中华人民共和国有效驾驶执照（准驾车型为C1或C2（含）以上）可申请入平台。港澳居民来往内地通行证、大陆通行证、护照、外籍人士暂无法申请。</p> <p _v-d0c6b520=\"\">2、如果会员的驾照在任何时间被吊销、没收、失效或其状态发生变化，会员必须立即通知平台, 且在此期间会员不得使用或预订任何平台用车服务。</p> <p _v-d0c6b520=\"\">3、会员账号的所有权归平台享有，会员必须使用本人的有效信息完成注册申请手续后，才可获得平台账号的使用权。会员应提供及时、详尽及准确的个人资料，并不断更新注册资料，符合及时、详尽、准确的要求。所有原始键入的资料将作为注册资料。平台有权就会员所提交资料与信息，通过第三方平台，就其真实性、可靠性及信用等级进行评估。</p> <p _v-d0c6b520=\"\">4、如果因会员注册信息不真实而引起的一切问题及其产生的后果，平台不负任何责任，且平台有权对会员账号进行停封。如对平台造成损失，平台有权追究会员责任及索赔损失。</p> <p class=f-bold _v-d0c6b520=\"\">三、 会员权利及义务</p> <p _v-d0c6b520=\"\">1、会员享有使用平台产品和服务的权益，且会员在使用平台的产品时均不限行驶里程（有固定里程限制的产品除外）。</p> <p _v-d0c6b520=\"\">2、会员须如实告知或填写相关信息（包括但不限于身份证件、联系方式等），保证相关证件和信息真实有效，并保证同一证件只允许关联一个会员账号信息，并且使用车辆期间会员信息所载明的联系方式有效。若出现注册人与用车人信息不对称，则由此产生的后果/责任均由注册人自行承担。</p> <p _v-d0c6b520=\"\">3、会员使用平台车辆服务期间，必须随身携带有效的中国大陆交管部门核发的并按要求审验的《中华人民共和国机动车驾驶证》，才可驾驶平台车辆。</p> <p _v-d0c6b520=\"\">4、会员须自行承担车辆租赁使用中产生的过路、过桥、停车、车辆电费等费用（包含但不限于以上自付费项目或因会员原因而产生的费用），自行负责车上人员及财产的安全。</p> <p _v-d0c6b520=\"\">5、会员在使用平台服务时应当严格遵守道路交通规则，不得酒驾、醉驾、超速驾驶及其他违反道路交通规则行为，对车辆造成损失，应由会员承担相应及由此带来的一切损失，并独立承担因交通事故产生的相关责任。</p> <p _v-d0c6b520=\"\">6、如车辆出现故障或异常，会员应立即通知平台，不得擅自拆卸、更换原车设备及零件并到平台指定的地点修理。</p> <p _v-d0c6b520=\"\">7、平台所有车辆只能作为自用车辆使用，会员不得将车辆用于营利性运营、竞赛、抵押、测试、实验、教练等活动；不得将车辆用于承载有毒有害及违禁物品；不得将车辆用于从事违法、违规活动。否则，会员除了赔偿平台及车辆停运等的相关损失外，构成刑事犯罪的，将被追究刑事责任。</p> <p _v-d0c6b520=\"\">8、会员不得有转租、转借、抵押、倒卖或其它任何损害平台车辆所有权和使用权的行为，否则，将承担由此产生的一切损失及相关法律责任。</p> <p _v-d0c6b520=\"\">9、会员在使用车辆期间，应保持车辆外观、内饰的整洁、完好。此外，车内禁止携带宠物、海鲜、食醋等会污损内饰及异味较大的物品。在用车期间如产生污损或异味应清洁整洁后返还车辆。如未清理，会员需承担车辆整备费用及造成的损失。</p> <p _v-d0c6b520=\"\">10、会员还车时，由于会员个人原因致使车辆牌照、车钥匙、证件等车内物品丢失，除支付补办相关物品的全部费用外，还应当承担补办相关物品期间给平台造成的停运损失。</p> <p _v-d0c6b520=\"\">11、会员不得携带没有配备安全座椅或未正确使用安全座椅的不满4周岁的儿童驾驶平台车辆，也不得携带未满12周岁的未成年人乘坐在副驾驶位置。</p> <p _v-d0c6b520=\"\">12、会员不得将个人平台的账号、密码转让或出借予他人使用。如会员将从平台获得的车辆交予本人外的其他任何人使用或者驾驶，一经发现，平台有权立即通过会员账号所绑定的任何支付方式和支付渠道（包括但不限支付宝、网银等）扣除1000元作为违约金，且有权冻结会员的账号。</p> <p _v-d0c6b520=\"\">13、如会员发现账号遭他人非法使用，应立即通知平台。因黑客行为或会员个人的保管疏忽导致账号、密码遭他人非法使用，平台将不承担任何责任。</p> <p class=f-bold _v-d0c6b520=\"\">四、 会员使用规则</p> <p _v-d0c6b520=\"\">1、 会员在使用平台服务时，必须遵守中华人民共和国相关法律法规的规定，会员不得利用平台服务进行任何违法或不正当的活动，会员不得有包括但不限于如下行为：</p> <p _v-d0c6b520=\"\">(1) 提供虚假信息，或盗用他人信息的；</p> <p _v-d0c6b520=\"\">(2) 未按约定用途使用车辆的或违反相关法律法规使用车辆的；</p> <p _v-d0c6b520=\"\">(3) 转卖、抵押、典当、转借、转租或确有证据证明可能存在上述情况的；</p> <p _v-d0c6b520=\"\">(4) 不按协议约定交纳各项费用、使用车辆、保管车辆、归还车辆的；</p> <p _v-d0c6b520=\"\">(5) 利用车辆从事违法犯罪活动的；</p> <p _v-d0c6b520=\"\">(6) 擅自对车辆改装、更换、拆卸或增设它物的；</p> <p _v-d0c6b520=\"\">(7) 利用任何方式方法危害平台安全的；</p> <p _v-d0c6b520=\"\">(8) 利用平台或其提供的车辆，损害任何第三人合法权益的；</p> <p _v-d0c6b520=\"\">(9) 为任何非法目的而使用平台网络服务系统；</p> <p _v-d0c6b520=\"\">(10) 对平台服务任何部分通过平台服务任何部分或使用平台服务获得的任何内容，进行复制、拷贝、出售、转售或用于任何其它商业目的。</p> <p _v-d0c6b520=\"\">(11) 利用平台网络服务系统复制、发布含有下列内容信息的：</p> <p _v-d0c6b520=\"\">1) 反对宪法所确定的基本原则的；</p> <p _v-d0c6b520=\"\">2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；</p> <p _v-d0c6b520=\"\">3) 损害国家荣誉和利益；</p> <p _v-d0c6b520=\"\">4) 煽动民族仇恨、民族歧视，破坏民族团结；</p> <p _v-d0c6b520=\"\">5) 破坏国家宗教政策，宣扬邪教和封建迷信；</p> <p _v-d0c6b520=\"\">6) 散布谣言，扰乱社会秩序，破坏社会稳定；</p> <p _v-d0c6b520=\"\">7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；</p> <p _v-d0c6b520=\"\">8) 侮辱或者诽谤他人，侵害他人合法权利的；</p> <p _v-d0c6b520=\"\">9) 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵，或其它道德上令人反感的内容；</p> <p _v-d0c6b520=\"\">10) 恶意诋毁平台的（包括在平台以及在其他任何地方）；</p> <p _v-d0c6b520=\"\">11) 含有法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其他内容的。</p> <p style=text-indent:2em _v-d0c6b520=\"\">如平台发现或收到第三方举报、投诉获知，会员存在或涉嫌违反以上规定的，平台有权依据其合理判断并经通知后立即采取一切必要措施以减轻或消除相关行为造成的影响，由此造成的损失及后果由会员自行独立承担。采取的一切必要措施包括但不限于以下一项或多项：</p> <p _v-d0c6b520=\"\">A. 更改、删除或屏蔽相关内容；</p> <p _v-d0c6b520=\"\">B. 警告违规会员账号、账号禁言；</p> <p _v-d0c6b520=\"\">C. 冻结违规会员账户资金，用于弥补给平台及其关联公司、他人造成的损失；</p> <p _v-d0c6b520=\"\">D. 变更、限制或禁止违规会员账号部分或全部功能；</p> <p _v-d0c6b520=\"\">E. 暂停、限制或终止会员使用平台服务的权利、注销会员账号等；</p> <p _v-d0c6b520=\"\">F. 向有关监管部门或国家机关报告；</p> <p _v-d0c6b520=\"\">G. 其他平台认为合理的措施。</p> <p _v-d0c6b520=\"\">2、 会员使用平台服务应遵守平台通过移动客户端、微信公众号等官方渠道已发布及将来不定期更新的相关使用规范及使用指引。</p> <p _v-d0c6b520=\"\">3、 会员应按本协议约定和平台发布的使用规范及使用规则订车、取车与还车。</p> <p _v-d0c6b520=\"\">4、 不得以任何方式盗开平台车辆，否则平台有权追索损失，并追究相应法律责任。</p> <p _v-d0c6b520=\"\">5、 会员使用车辆的过程中，不得乱停乱放，否则会员将自行承担因乱停乱放引起的交通违章、罚款责任，平台有权追索损失，并追究相应法律责任。</p> <p class=f-bold _v-d0c6b520=\"\">五、 服务说明</p> <p _v-d0c6b520=\"\">1、 平台网络服务的具体内容由平台根据实际情况提供，平台对其提供之服务拥有最终解释权。</p> <p _v-d0c6b520=\"\">2、 除非本服务协议另有其它明确规定，平台在会员注册后所推出的新产品、新功能、新服务，均受到本服务协议之规范和约束。</p> <p _v-d0c6b520=\"\">3、 鉴于网络服务的特殊性，会员同意平台有权不经事先通知，随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。平台不担保网络服务不会中断，对网络服务的及时性、安全性、准确性均不作担保。</p> <p _v-d0c6b520=\"\">4、 平台需定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，平台无需为此承担任何责任。平台保留不经事先通知为维修保养、升级或其它目的暂停全部或部分的网络服务的权利。</p> <p _v-d0c6b520=\"\">5、 会员明确同意其使用平台网络服务所存在的风险将完全由其自己承担。</p> <p _v-d0c6b520=\"\">6、 平台有权于任何时间暂时或永久修改或终止本服务（或其任何部分），而无论其通知与否，平台对会员和任何第三人均无需承担任何责任。</p> <p _v-d0c6b520=\"\">7、 会员同意平台有权基于其自行之考虑，因任何理由，包含但不限于会员长时间未使用车辆，或平台认为会员已经违反本协议的文字及精神，终止会员的密码、账号或平台服务之使用（或服务之任何部分），并将会员在平台服务内任何内容加以移除并删除。会员同意依本协议任何规定提供之平台服务，无需进行事先通知即可中断或终止；会员承认并同意，平台可立即关闭或删除会员的帐号及会员账号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，会员同意若本服务之使用被中断或终止或会员的账号及相关信息和文件被关闭或删除，平台对会员或任何第三人均不承担任何责任。</p> <p _v-d0c6b520=\"\">8、 如会员提出发票要求的，会员订单结束后在微信公众号“响车车”留言开票信息，平台每周五统一开具有效等额发票。</p> <p _v-d0c6b520=\"\">9、 通过平台发布的车辆符合以下标准：</p> <p _v-d0c6b520=\"\">(1) 行驶证件原件或复印件齐全有效且为平台所有或有使用权；</p> <p _v-d0c6b520=\"\">(2) 已按照国家、本市有关规定和本合同约定办理相应保险；</p> <p _v-d0c6b520=\"\">(3) 技术性能良好、符合安全行驶条件；</p> <p _v-d0c6b520=\"\">(4) 车内配备有效的车用灭火器、故障车警示标志牌和必要的维修工具（根据具体车型而定）。</p> <p _v-d0c6b520=\"\">10、 平台为保证车辆车况，安排专业人员为车辆及附属品等提供全方位的保障服务，保障车辆安全有效。</p> <p class=f-bold _v-d0c6b520=\"\">六、预定、取、还车说明</p> <p _v-d0c6b520=\"\">1、 预定说明</p> <p _v-d0c6b520=\"\">(1) 会员可以通过平台在手机APP客户端以及微信小程序等互联网方式来进行下单取车。</p> <p _v-d0c6b520=\"\">(2) 会员相关证件有效期须至少超过当次使用期限的一个月以上，否则需联系平台客服及时更新相关证件。</p> <p _v-d0c6b520=\"\">2、 取车说明</p> <p _v-d0c6b520=\"\">(1) 预订方式:会员需使用手机客户端/微信小程序预订车辆。会员预订时,可选择车辆，预订页面将显示计价规则、车辆具体信息等订单信息。</p> <p _v-d0c6b520=\"\">(2) 会员预定车辆后可免费为其保留15分钟（限每天三次），超过15分钟后将开始计费，若在计费后30分钟（含）以上，车辆没有启动，平台有权自动取消该订单，会员需支付预定该车辆30分钟内所产生的费用。</p> <p _v-d0c6b520=\"\">(3) 取车时，会员应当确认车辆及附属品的实际状况拍照上传车况，如有疑问请会员拍照并且请致电客服。如取车时未及时上报车辆情况而导致后续车辆损失追责的，会员应当承担相应责任。</p> <p _v-d0c6b520=\"\">3、 还车说明</p> <p _v-d0c6b520=\"\">(1) 还车时会员应将车辆开至平台指定服务网点位置（暂不支持跨城市还车），还车时间以会员实际操作完成还车流程的时间为准，确认所有订单完成后终止合同。</p> <p _v-d0c6b520=\"\">(2) 车辆（连同其钥匙和所有的附属物品，包括行驶本，手册，车轮防盗螺母，备胎，充电线等）须一并归还，且要保持和使用开始前一致的状况，如发生丢失或损坏需照价赔偿，相应产生的停运损失费及其它费用需一并赔偿。</p> <p _v-d0c6b520=\"\">(3) 会员应在归还车辆时，确保车内无任何个人财物。如还车时，有任何会员的个人财物落在车中，所产生的相应责任由会员个人承担，平台不承担任何责任。</p> <p _v-d0c6b520=\"\">4、 未按约定还车说明</p> <p _v-d0c6b520=\"\">(1) 会员结束订单时，应将车辆归还至平台指定服务网点位置，并确认车辆状态完好，查看无误后在会员端操作还车。</p> <p _v-d0c6b520=\"\">(2) 如会员还车时，未将车辆停放至营业网点指定区域，由此给平台造成的一切损失由会员承担，同时平台有权追究会员的法律责任，并有权取消违约会员的资格。</p> <p _v-d0c6b520=\"\">(3) 如在承租期间，弃车或者将车辆停放至影响交通的地方，需赔偿一定损失并收取车辆调度费用。</p> <p class=f-bold _v-d0c6b520=\"\">七、 计费规则及收费项目</p> <p _v-d0c6b520=\"\">1、 用车费用：</p> <p _v-d0c6b520=\"\">（1）计费模式分为分时计费、小时计费、套餐计费，实际费用可能因优惠活动、车型不同而调整，最终价格以平台官方APP显示为标准。</p> <p _v-d0c6b520=\"\">（2）如因优惠活动、优惠套餐等导致实际费用高于按原固定收费标准结算的费用，则按原固定收费标准据实结算，会员可联系平台客服复核订单并申请返还差额部分费用。</p> <p _v-d0c6b520=\"\">（3）平台客服复核确认存在上述第（2）条所述情形的，平台除返还订单差额部分费用外，不存在任何欺诈、恶意收费等行为，不因此承担任何法律责任。</p> <p _v-d0c6b520=\"\">2、 押金：会员在注册时需缴纳一定额度的押金，具体以平台官方APP显示为准。会员拖欠平台费用和/或给平台造成损失的，平台有权从该会员缴纳的押金中抵扣该会员欠付平台的费用和/或损失赔偿金，如押金不足以抵扣该会员欠付平台的费用和/或损失赔偿金的，就未能抵扣的部分，该会员应向平台另行支付。当会员押金被抵扣后，剩余押金金额低于平台制订的押金额度时，该会员应在收到平台通知后立即补足押金，否则平台有权终止该会员的账号。</p> <p _v-d0c6b520=\"\">3、 特别声明：</p> <p _v-d0c6b520=\"\">（1）会员需在车辆损坏后应第一时间向平台报备车损情况，否则视为自动放弃相应的服务权益；所有损失必须由会员承担；</p> <p _v-d0c6b520=\"\">（2）平台提供相应服务仅针对账号关联自然人驾驶而言；</p> <p _v-d0c6b520=\"\">（3）如会员恶意破坏车辆，则无法获得相应服务。</p> <p _v-d0c6b520=\"\">4、 维修费用说明（具体费用要联系运维查询）</p> <table border=1 class=pp-table _v-d0c6b520=\"\"> <tbody _v-d0c6b520=\"\"><tr _v-d0c6b520=\"\"> <td colspan=4 align=center _v-d0c6b520=\"\">车辆损失费</td> </tr> <tr _v-d0c6b520=\"\"> <th _v-d0c6b520=\"\">车损类型</th> <th _v-d0c6b520=\"\">说明</th> <th _v-d0c6b520=\"\">维修价格（元）</th> <th _v-d0c6b520=\"\">备注</th> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">前、后杠损伤</td> <td _v-d0c6b520=\"\">每件</td> <td _v-d0c6b520=\"\">300</td> <td _v-d0c6b520=\"\">按每件计算，前、后分别计算；如需更换零件，材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">叶子板、车门剐蹭及凹陷</td> <td _v-d0c6b520=\"\">每一面</td> <td _v-d0c6b520=\"\">350</td> <td _v-d0c6b520=\"\">按每个面计算。如左前门，算一个面。如需更换零件，材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">前后盖剐蹭及凹陷</td> <td _v-d0c6b520=\"\">每一面</td> <td _v-d0c6b520=\"\">500</td> <td _v-d0c6b520=\"\">按每个面计算，前、后分别计算</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">后视镜破损</td> <td _v-d0c6b520=\"\">每一边</td> <td _v-d0c6b520=\"\">50</td> <td _v-d0c6b520=\"\">如需更换零件，材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">前挡玻璃破损</td> <td _v-d0c6b520=\"\">一面</td> <td _v-d0c6b520=\"\">200</td> <td _v-d0c6b520=\"\">材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">后挡玻璃破损</td> <td _v-d0c6b520=\"\">一面</td> <td _v-d0c6b520=\"\">200</td> <td _v-d0c6b520=\"\">材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">车窗玻璃破损</td> <td _v-d0c6b520=\"\">每一面</td> <td _v-d0c6b520=\"\">100</td> <td _v-d0c6b520=\"\">按每个面计算。如左前窗，算一个面。材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">不带漆硬质塑料件断裂、破损需要更换的</td> <td _v-d0c6b520=\"\">每一件</td> <td _v-d0c6b520=\"\">100</td> <td _v-d0c6b520=\"\">材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td rowspan=3 _v-d0c6b520=\"\">前大灯面、尾灯面</td> <td _v-d0c6b520=\"\">大灯划痕</td> <td _v-d0c6b520=\"\">100</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">灯脚修复</td> <td _v-d0c6b520=\"\">150</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">破损、开裂需要跟换</td> <td _v-d0c6b520=\"\">50</td> <td _v-d0c6b520=\"\">材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">轮毂</td> <td _v-d0c6b520=\"\">轮毂缺口、翻边</td> <td _v-d0c6b520=\"\">50</td> <td _v-d0c6b520=\"\">如需更换零件，材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">轮胎</td> <td _v-d0c6b520=\"\">鼓包、开裂、其他无法修复情况</td> <td _v-d0c6b520=\"\">50</td> <td _v-d0c6b520=\"\">材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td rowspan=2 _v-d0c6b520=\"\">充电枪插口</td> <td _v-d0c6b520=\"\">充电枪插口变形</td> <td _v-d0c6b520=\"\">150</td> <td _v-d0c6b520=\"\">如需更换零件，材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">充电枪插口支架变形</td> <td _v-d0c6b520=\"\">300</td> <td _v-d0c6b520=\"\">如需更换零件，材料费另计。</td> </tr> <tr _v-d0c6b520=\"\"> <td colspan=4 _v-d0c6b520=\"\">说明：以上材料费报价，以指定维修厂报价为准（不高于4S店零配件价格）</td> </tr> </tbody></table> <p _v-d0c6b520=\"\">5、 网点取还车相关费用：</p> <p _v-d0c6b520=\"\">（1）取车相关费用：部分网点取车，由于场地原因，需要支付一定停车费用，具体费用根据网点显示为准，可在订单结束后7个工作日内上传停车票报销。</p> <p _v-d0c6b520=\"\">（2）还车相关费用：</p> <p _v-d0c6b520=\"\"> a）部分网点不通还，由于场地原因，不在车辆所关联的还车点操作还车；若在非车辆所关联的还车点还车时,需额外支付调度费和停车费用,包括自主关联还车点还车及因原因导致车辆故障或事故而关联还车点还车,具体收费标准如下:调度费=起步价+里程单价（元/KM）*行驶里程（行驶里程计算起点为取车地,终点为预约还车点。）</p> <table border=1 class=pp-table _v-d0c6b520=\"\"> <tbody _v-d0c6b520=\"\"><tr _v-d0c6b520=\"\"> <th _v-d0c6b520=\"\">还车地/故障发生地</th> <th _v-d0c6b520=\"\">起步价</th> <th _v-d0c6b520=\"\">里程单价</th> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">广东</td> <td _v-d0c6b520=\"\">200元</td> <td _v-d0c6b520=\"\">5元/KM</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">广西</td> <td _v-d0c6b520=\"\">500元</td> <td _v-d0c6b520=\"\">20元/KM</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">在预约还车点所在城区内的非预约还车点(200元封顶）</td> <td _v-d0c6b520=\"\">50元</td> <td _v-d0c6b520=\"\">20元/KM</td> </tr> </tbody></table> <p _v-d0c6b520=\"\"> b）如造成违章停车并被处罚的,需自行解决或承担违章责任和相关费用。平台有权追究的法律责任,并有权取消的租车资格。</p> <p _v-d0c6b520=\"\"> c）网点取还车会根据运营情况做调整，用车时请仔细查询阅读。</p> <p _v-d0c6b520=\"\">6、 其他收费标准：</p> <p _v-d0c6b520=\"\">(1) 除本协议另有约定外，会员在使用服务期间，如有物品损坏、遗失的，损失赔偿标准详见下表，如表中无相关项目，以实际损失为准。</p> <table border=1 class=pp-table _v-d0c6b520=\"\"> <tbody _v-d0c6b520=\"\"><tr _v-d0c6b520=\"\"> <th _v-d0c6b520=\"\">项目</th> <th _v-d0c6b520=\"\">赔偿价格</th> <th _v-d0c6b520=\"\">备注</th> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">行驶证</td> <td _v-d0c6b520=\"\">500元</td> <td _v-d0c6b520=\"\">造成车辆停运的，还需支付停运损失费</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">交强险标</td> <td _v-d0c6b520=\"\">50元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">年检标</td> <td _v-d0c6b520=\"\">50元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">环保标</td> <td _v-d0c6b520=\"\">50元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">车钥匙</td> <td _v-d0c6b520=\"\">600元</td> <td _v-d0c6b520=\"\">造成车辆停运的，还需支付停运损失费</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">故障警示牌</td> <td _v-d0c6b520=\"\">100元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">充电线</td> <td _v-d0c6b520=\"\">30元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">灭火器</td> <td _v-d0c6b520=\"\">100元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">停车场停车卡或凭证</td> <td _v-d0c6b520=\"\">100元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">车身车贴</td> <td _v-d0c6b520=\"\">200元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">拖车钩</td> <td _v-d0c6b520=\"\">100元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">尾箱隔板</td> <td _v-d0c6b520=\"\">400元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">地毯</td> <td _v-d0c6b520=\"\">200元</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">其他物品</td> <td _v-d0c6b520=\"\">视实际费用而定</td> <td _v-d0c6b520=\"\"></td> </tr> </tbody></table> <p _v-d0c6b520=\"\">备注：以上费用根据不同车型会有程度不等的价格浮动调整。</p> <p _v-d0c6b520=\"\">(2) 除本协议另有约定外，会员在使用服务期间，如有以下非法或不文明行为的，平台有权按下表要求会员赔偿损失。</p> <table border=1 class=pp-table _v-d0c6b520=\"\"> <tbody _v-d0c6b520=\"\"><tr _v-d0c6b520=\"\"> <th _v-d0c6b520=\"\">赔偿项</th> <th _v-d0c6b520=\"\">描述</th> <th _v-d0c6b520=\"\">赔偿金额</th> <th _v-d0c6b520=\"\">其他</th> <th _v-d0c6b520=\"\">赔偿总金额</th> </tr> <tr _v-d0c6b520=\"\"> <td rowspan=3 _v-d0c6b520=\"\">影响车内整洁</td> <td _v-d0c6b520=\"\">乱扔垃圾影响车内整洁（轻度污染）</td> <td _v-d0c6b520=\"\">50元</td> <td align=center _v-d0c6b520=\"\">-</td> <td _v-d0c6b520=\"\">50元</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">呕吐、排泄、带宠物以及海鲜水产等严重影响车内整洁（重度污染）</td> <td _v-d0c6b520=\"\">300元</td> <td align=center _v-d0c6b520=\"\">-</td> <td _v-d0c6b520=\"\">300元</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">因烟头、呕吐、饮料等造成座椅损伤或者损害（污染且损坏）</td> <td _v-d0c6b520=\"\">500元</td> <td align=center _v-d0c6b520=\"\">-</td> <td _v-d0c6b520=\"\">500元</td> </tr> <tr _v-d0c6b520=\"\"> <td rowspan=2 _v-d0c6b520=\"\">乱停乱放</td> <td _v-d0c6b520=\"\">未还车至营业网点指定区域，乱停放车辆</td> <td _v-d0c6b520=\"\">100元</td> <td _v-d0c6b520=\"\">因乱停车产生的费用</td> <td _v-d0c6b520=\"\">100元+因乱停造成的费用</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">使用途中弃车或者将车辆停放至影响交通的地方</td> <td _v-d0c6b520=\"\">200元</td> <td _v-d0c6b520=\"\">车辆调度费用 5元/km</td> <td _v-d0c6b520=\"\">200元+车辆调度费用</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">盗开车辆</td> <td _v-d0c6b520=\"\">使用各种不正当手段，绕开产品平台使用车辆</td> <td _v-d0c6b520=\"\">1000元</td> <td _v-d0c6b520=\"\">违章押金：1000元</td> <td _v-d0c6b520=\"\">1000元+其他所有损失</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">非本人使用账号用车</td> <td _v-d0c6b520=\"\">将账号给予他们使用</td> <td _v-d0c6b520=\"\">1000元</td> <td align=center _v-d0c6b520=\"\">-</td> <td _v-d0c6b520=\"\">1000元+其他所有损失</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">从事违法犯罪行为</td> <td _v-d0c6b520=\"\">利用车辆从事违反犯罪行为</td> <td _v-d0c6b520=\"\">1000元</td> <td align=center _v-d0c6b520=\"\">-</td> <td _v-d0c6b520=\"\">1000元+其他所有损失</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">车辆被查扣</td> <td _v-d0c6b520=\"\">因会员原因，导致车辆被扣</td> <td align=center _v-d0c6b520=\"\">-</td> <td _v-d0c6b520=\"\">相应损失</td> <td _v-d0c6b520=\"\">相应损失</td> </tr> <tr _v-d0c6b520=\"\"> <td colspan=5 align=center _v-d0c6b520=\"\">注：以上行为如导致车辆停运的，还需根据实际停运天数，收取停运损失费用</td> </tr> </tbody></table> <p class=f-bold _v-d0c6b520=\"\">八、 事故处理及保险理赔</p> <p _v-d0c6b520=\"\">1、 如车辆不慎出险，请您注意人身安全，并立即致电客服中心报案，车辆需由保险公司定损后再修理；</p> <p _v-d0c6b520=\"\">2、 为避免处理不当给您带来损失，请您按以下指引处理事故：</p> <p _v-d0c6b520=\"\">(1) 双方交通事故：</p> <p _v-d0c6b520=\"\">1) 请您立即停车，记录相关事故车辆的车牌号码，索要对方电话号码。</p> <p _v-d0c6b520=\"\">2) 检查对方驾驶执照，如对方无有效驾照，请立即拨打110报警。</p> <p _v-d0c6b520=\"\">3) 依据《交通事故快速处理办法》所列的事故情形明确双方责任，如能达成一致：</p> <p _v-d0c6b520=\"\">A. 拍摄第一现场照片：全景照片（现场位置、痕迹、事故损失全貌），物证及特写照片（车牌号、受损部位、受损程度等）。</p> <p _v-d0c6b520=\"\">B. 驶离现场至不妨碍交通的地方。</p> <p _v-d0c6b520=\"\">C. 填写《交通事故快速处理协议书》，当事各方各持一份。</p> <p _v-d0c6b520=\"\">D. 拨打保险公司报案，获得报案号和报险建议。</p> <p _v-d0c6b520=\"\">注：《交通事故快速处理协议书》填写项目要齐全，时间精确到分，事故地点具体到所在区域及道路具体名称，各方驾驶证、电话号码需进行核对；保险“报案号”待报案后会获得。</p> <p _v-d0c6b520=\"\">(2) 如不能明确双方责任：</p> <p _v-d0c6b520=\"\">1) 请立即报警（110）等待警察处理。</p> <p _v-d0c6b520=\"\">2) 请于事故车后100米处安放随车附带的三角警示牌，同时将车辆双闪警示灯打开，以便使行驶车辆安全避让。</p> <p _v-d0c6b520=\"\">3) 立即致电平台客服中心400-863-7833报备。</p> <p _v-d0c6b520=\"\">4) 请根据报险处理建议，携带车辆行驶本和驾照，将车辆送到指定地点定损（定损时需要事故车辆同时到场以便勘察定损）。</p> <p _v-d0c6b520=\"\">5) 请按指导收集理赔所需材料，并将材料交与指定维修人员。</p> <p _v-d0c6b520=\"\">(3) 如遇对方车辆肇事逃逸的、对方车辆无号牌的、对方驾驶员无驾驶证或饮酒后驾驶车辆的，请您记录相关信息（如：车牌号，车辆品牌，颜色以及肇事地点）并立即报警（110），等候交警处理，同时请您致电客服中心以获得保险方面的咨询和建议。</p> <p _v-d0c6b520=\"\">(4) 如车辆与障碍物、建筑物发生碰撞，或车辆停放期间被碰撞而找不到肇事者，请您将车辆损坏部位以及碰撞物体进行比对拍照，并致电平台客服中心，以便车辆能够得到及时修复。</p> <p _v-d0c6b520=\"\">(5) 如遇重大交通事故且有人员伤亡的，请保护现场，并拨打120及110交通事故报警台求助，同时请立即致电平台客服中心获得保险方面的咨询和建议。</p> <p _v-d0c6b520=\"\">(6) 如因会员原因，导致事故车辆保险公司不予以受理，出险拒赔的，应当承担赔偿相应损失的责任，包括但不限于车辆的维修费用、加速折旧费、停运损失费用以及由其引起的律师费、诉讼费、差旅费等。</p> <p _v-d0c6b520=\"\">3、 平台向提供的车辆都已投保了交通责任强制险、车损险、第三者责任险壹佰万元（个别车辆视投保情况而定）、座位险，如车辆出现事故定损额超出保险理赔额度，超出部分由会员承担。</p> <p _v-d0c6b520=\"\">4、 车辆事故保险理赔情况说明：</p> <p style=text-indent:2em _v-d0c6b520=\"\">在使用平台车辆的过程中发生交通事故产生的所有费用（包含车辆维修费用、人伤医疗费用、三者财产损失费用等）均需由会员垫付，会员需保存好垫付费用凭证或者相应发票。</p> <p style=text-indent:2em _v-d0c6b520=\"\">为避免保险公司拒赔或视会员放弃理赔，请会员务必在出险之日起15日内（特大人伤事故，或费用超 1万元，可延长7日）将保险理赔所需事故材料完整提供给平台。</p> <p style=text-indent:2em _v-d0c6b520=\"\">垫付的费用中涉及保险公司理赔金额的,平台在保险公司赔付款到账后7个工作日内返还给会员。对于超出理赔金额,或者不属于理赔范围的维修费用,由会员自行承担。</p> <p _v-d0c6b520=\"\">根据车辆事故具体情况定为会员主责事故和会员非主责事故，具体说明如下：</p> <p _v-d0c6b520=\"\">* 如事故为会员主责事故,平台（车主）车辆维修费用在1000元以下,由会员自行承担车损维修费用，并协助平台取消保险报案。但如果会员使用车辆时已额外向平台购买保险服务，则当事故为会员主责事故且平台（车主）车辆维修费用在1000元以下（需会员主动上报事故），该费用由平台（车主）承担。（如不主动上报将不予以免责）。如事故为会员主责事故,平台（车主）车辆维修费用在1000元以上，可由商业险赔付，但会员需支付1500元/次的保险增幅费用。</p> <p _v-d0c6b520=\"\">* 如事故为会员主责事故,平台车辆维修费用在2000元以上，可由商业险赔付，但会员需支付1500元/次的保险增幅费用。</p> <p _v-d0c6b520=\"\">* 如事故为会员主责事故,平台车辆维修费用≥10000元，会员需支付1500元/次的保险增幅费用及按车辆定损金额的20%车辆加速折旧费用。</p> <p _v-d0c6b520=\"\">备注：发生事故后，请勿擅自维修事故车辆，否则会员将承担赔偿损失等违约责任。</p> <p _v-d0c6b520=\"\">* 如事故为会员主责事故,第三者损失在2000元以内触发保险理赔时,属于交强险理赔的维修费用由会员先行垫付；</p> <p _v-d0c6b520=\"\">* 如事故为会员主责事故，第三者损失超过2000元可用商业保险理赔的,三者及商业险维修费用由会员垫付。会员还应支付1500元/次的保险增幅费。</p> <p _v-d0c6b520=\"\">* 如事故为会员无责事故，会员有义务协调平台走完保险事故理赔处理流程，会员不承担平台车辆维修费用及相应车辆停运损失费。</p> <p _v-d0c6b520=\"\">5、 平台（车主）车辆事故停运费收取标准及说明：</p> <p _v-d0c6b520=\"\">* 会员在使用服务期间发生有责事故导致平台（车主）车辆停运，平台（车主）有权收取停运损失费用，具体收费标准视车辆定损金额而定。</p> <table border=1 class=pp-table _v-d0c6b520=\"\"> <tbody _v-d0c6b520=\"\"><tr _v-d0c6b520=\"\"> <th _v-d0c6b520=\"\">车辆定损金额</th> <th _v-d0c6b520=\"\">事故停运费天数</th> <th _v-d0c6b520=\"\">收费标准</th> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">1000元以下</td> <td _v-d0c6b520=\"\">1天</td> <td rowspan=4 _v-d0c6b520=\"\">车型日租车辆价格*事故停运天数</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">1000元-10000元</td> <td _v-d0c6b520=\"\">5天</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">10000元-30000元</td> <td _v-d0c6b520=\"\">10天</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">30000元以上</td> <td _v-d0c6b520=\"\">20天</td> </tr> </tbody></table> <p _v-d0c6b520=\"\">* 因会员拒绝垫付理赔费用及会员其他原因，导致平台（车主）车辆未能及时维修,会员还应承担自事故发生日期起至车辆开始维修期间的停运损失费用。（每日停运费用按照车型日租车辆价格计算）</p> <p _v-d0c6b520=\"\">6、 会员在使用服务期间发生交通事故的，均需及时报警报案并联系平台客服中心。未能立即报告事故和配合事故调查，会员承担全部责任和费用。会员对于在汽车使用期间发生任何保险理赔的问题，有责任全力配合平台和保险公司的工作。会员不得隐瞒使用服务期间车辆发生的任何意外事故。如发生事故，会员应及时通知平台客服中心（电话400-863-7833），并及时向当地公安机关及保险公司报案，以便平台协助处理保险理赔事宜。</p> <p _v-d0c6b520=\"\">7、 如发生事故后，会员擅自离开现场或者逃逸，会员需承担因此造成所有的损失。同时，平台保留追责以及起诉的权力。</p> <p _v-d0c6b520=\"\">8、 会员使用服务期间因车辆事故导致的侵权或违法及其他间接损失由会员自行承担。</p> <p _v-d0c6b520=\"\">9、 保险公司不予理赔的损失包括但不限于以下情况造成的损失，该等损失和后果将由自行承担：</p> <p _v-d0c6b520=\"\">1) 超过保险承保范围的,例如由于故意的不当操作或严重疏忽造成的损坏;</p> <p _v-d0c6b520=\"\">2) 不通知平台和不为及时索赔提供必要的支持;</p> <p _v-d0c6b520=\"\">3) 无证驾驶,持逾期未审验的驾驶执照驾驶车辆;</p> <p _v-d0c6b520=\"\">4) 在药物影响下驾驶,酒后驾车,鲁莽驾驶,</p> <p _v-d0c6b520=\"\">5) 肇事逃逸,破坏证据;若在用车期间发生事故出险,需要第一时间拍摄现场照片并向平台进行报案登记,订单结束仍未报案的,则视为不报,不予赔付,责任由会员自己承担。</p> <p _v-d0c6b520=\"\">10、 如果车辆在使用服务期内（或在服务期以外的，会员仍然占有或负责车辆的任何时段）被盗，会员必须在得知情况后尽快电话通知平台和警方。</p> <p _v-d0c6b520=\"\">11、 车辆发生各类机件故障、事故车修复，应当到平台指定的4S店进行检测及修理。如因会员原因导致损坏，会员应当支付由此造成的修理费用、施救费用及维修期间平台的营业损失（损失以实际维修所用时间的平台本应收取的车型日租车辆价格为单位计算）由此给平台或第三方造成其他损失的，会员应予赔偿。</p> <p class=f-bold _v-d0c6b520=\"\">九、 救援服务</p> <p _v-d0c6b520=\"\">平台向使用车辆的会员提供“7X24小时”的救援服务。会员遇到紧急情况，可致电24小时会员服务中心400-863-7833。</p> <p _v-d0c6b520=\"\">1、 由于车辆本身故障，导致车辆无法使用，平台将提供现场紧急修理服务，救援费用由平台承担。</p> <p _v-d0c6b520=\"\">(1) 若车辆故障无法现场修复，会员可将车辆交与平台指定的救援商。</p> <p _v-d0c6b520=\"\">(2) 若在平台服务点覆盖范围内，会员可到就近平台网点处理更换车辆（提供备用车），平台优先为会员提供同级别或高级别车辆，费用按原车型计费；如无车辆，将为会员提供低级别车辆（费用按低级别车辆价格计费），如均无法为会员提供解决方案，可选择退单如有具体补偿细节，按当时情况进行处理。</p> <p _v-d0c6b520=\"\">(3) 若在平台网点覆盖范围外，会员需按平台指导联系救援商救援车辆。</p> <p _v-d0c6b520=\"\">2、 非车辆本身故障导致无法正常行驶的（包含且不限于人为操作失误、保险事故等），救援费用由会员承担（保险公司承担除外）。会员可自行选择救援商或平台提供的道路救援服务，相关费用由会员自行承担。</p> <p style=\"text-align: center\" _v-d0c6b520=\"\">道路救援服务内容表</p> <table border=1 class=pp-table _v-d0c6b520=\"\"> <tbody _v-d0c6b520=\"\"><tr _v-d0c6b520=\"\"> <th _v-d0c6b520=\"\">服务项目</th> <th _v-d0c6b520=\"\">服务描述</th> <th _v-d0c6b520=\"\">服务价格</th> <th _v-d0c6b520=\"\">备注</th> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">更换轮胎</td> <td _v-d0c6b520=\"\">车辆因会员原因，导致轮胎损坏无法行驶时，提供更换备胎服务</td> <td _v-d0c6b520=\"\">350元/次</td> <td _v-d0c6b520=\"\">具体视车型而定</td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">开锁服务</td> <td _v-d0c6b520=\"\">车辆钥匙遗失，或者因会员原因导致车辆被锁或者车辆离线，平台提供开锁服务（补钥匙费用另算）</td> <td _v-d0c6b520=\"\">200元/次</td> <td _v-d0c6b520=\"\"></td> </tr> <tr _v-d0c6b520=\"\"> <td _v-d0c6b520=\"\">拖车服务</td> <td _v-d0c6b520=\"\">车辆因会员原因，导致电瓶缺电无法启动车辆，提供拖车服务</td> <td _v-d0c6b520=\"\">200-500元/次</td> <td _v-d0c6b520=\"\">高速上拖车视实际拖车费用而定</td> </tr> </tbody></table> <p class=f-bold _v-d0c6b520=\"\">十、 违章说明</p> <p _v-d0c6b520=\"\">1、 会员使用服务期内的违章及相关费用等责任由会员自行承担，平台将短信或电话通知会员使用服务期内的车辆违章，届时请查询短信、响车车APP内违章信息或致电客服电话询问详情。</p> <p _v-d0c6b520=\"\">2、 违反交通安全法规时，如现场被告知（比如违反规定停放车辆，被贴条等），应在被告知的5个工作日内接受处罚；如非现场被告知，平台可发出通知（包括电话、微信、电子邮件、短信等方式）会员交通违章信息，会员收到通知后，应于7个工作日内自行处理，逾期未处理，视为会员自动委托平台处理相关违章，平台有权采取必要措施，平台有权在违章会员账户内扣除违章罚款等同金额及每次违法行为所产生的损失费用，具体扣款金额以平台根据违章会员的违章情形向违章会员发出的通知为准。会员如拒绝接受处罚，会员应承担由此给平台造成所有的损失，并且平台保留追究法律责任及善后处理的一切权利。</p> <p class=f-bold _v-d0c6b520=\"\">十一、 会员违约</p> <p _v-d0c6b520=\"\">1、会员因违法违规使用车辆导致车辆被扣的或不能上路行驶而导致车辆停运的，自停运之日起，会员需按相应车型标准承担停运损失费以及违约金，同时，如有其它经济损失，也一并由会员承担。</p> <p _v-d0c6b520=\"\">2、会员因违约导致平台提前解除与会员的服务协议，如会员不按照平台要求归还车辆时，平台有权利用备用的车辆钥匙径直将车辆取回，对于车辆中的物品平台有权留置或返还，由此而造成会员损失的，平台不承担任何赔偿责任。同时，平台有权向会员主张相关的租金、违约金及取车产生的相关费用。</p> <p _v-d0c6b520=\"\">3、 会员不按平台规定及平台会员使用规则使用车辆给平台造成损失的，平台有权向会员追责或索赔，包括但不限于违约金、车辆损坏维修费、车辆停运损失费、交通事故赔偿费用、平台维权所产生的律师费、诉讼费、差旅费等。</p> <p class=f-bold _v-d0c6b520=\"\">十二、免责条款</p> <p _v-d0c6b520=\"\">1、 有下列情况之一的，平台不承担任何法律责任：</p> <p _v-d0c6b520=\"\">（1） 会员将注册账户、密码告知他人或与他人共享注册账户，而导致的任何个人资料泄露的；</p> <p _v-d0c6b520=\"\">（2） 任何由于计算机千年虫问题、黑客攻击、计算机病毒侵入或发作、政府管制等造成的暂时性关闭，使网络无法正常运行而造成的个人资料泄露、丢失、被盗用或被窜改；</p> <p _v-d0c6b520=\"\">（3） 由于与本网站链接的其他网站所造成个人资料泄露及由此而导致的任何法律争议和后果；</p> <p _v-d0c6b520=\"\">（4） 因不可抗力而引起的任何后果。</p> <p _v-d0c6b520=\"\">2、 平台对于任何自本公司平台、网站、论坛而获得的他人的信息、内容或者广告宣传等任何资讯（以下统称“信息”），不保证其真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，须自行甄别真伪和谨慎预防风险。否则，无论何种原因，本公司不对任何非与平台直接发生的交易和/或行为承担任何直接、间接、附带或衍生的损失和责任。</p> <p _v-d0c6b520=\"\">3、 平台将致力于保护您的个人信息，尽全力保证这些信息的安全。由于网上技术的发展突飞猛进，平台会随时更新信息保密制度，所有的修订将在平台官方渠道公布。</p> <p _v-d0c6b520=\"\">4、 平台鼓励会员自行按照充电标准为车辆充电，但因会员未按照充电标准为车辆充电导致的人员伤亡、车辆损毁或其他损失均由会员自行承担。</p> <p class=f-bold _v-d0c6b520=\"\">十三、远程处理与隐私保护</p> <p _v-d0c6b520=\"\">1、 汽车载有卫星定位系统（GPS）、行车记录仪、远程处理系统以及记录有关汽车运行的资料。平台承诺保护每位会员的隐私。会员同意平台检索并使用车载远程处理装置所记录所有的资料。</p> <p _v-d0c6b520=\"\">2、 平台按隐私政策限制其员工及其它有关方使用会员的个人信息， 防止非公开个人资料遭到非授权散布。但以下情形除外：</p> <p _v-d0c6b520=\"\">（1）事先获得会员的明确授权；</p> <p _v-d0c6b520=\"\">（2）只有透露会员的个人资料，才能提供会员所要求的产品和服务；</p> <p _v-d0c6b520=\"\">（3）根据有关的法律法规要求；</p> <p _v-d0c6b520=\"\">（4）按照相关政府主管部门的要求；</p> <p _v-d0c6b520=\"\">（5）为维护社会公众的利益；</p> <p _v-d0c6b520=\"\">（6）为维护平台的合法权益。</p> <p _v-d0c6b520=\"\">3、 在不透露单个会员隐私资料的前提下，平台有权对整个会员数据库进行分析并对用户数据库进行商业上的利用。</p> <p class=f-bold _v-d0c6b520=\"\">十四、附则</p> <p _v-d0c6b520=\"\">1、 本协议由平台制定，平台拥有最终解释权。</p> <p _v-d0c6b520=\"\">2、 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p> <p _v-d0c6b520=\"\">3、 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向平台所在地的人民法院提起诉讼。</p> <p _v-d0c6b520=\"\">4、 平台未行使或执行本协议任何权利或规定，不构成对前述权利或权利之放弃。</p> <p _v-d0c6b520=\"\">5、 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p> <p _v-d0c6b520=\"\">6、 无论会员是否正在使用服务，如有突发状况、行程核实、信息核实、追责、风控（包含但不限于以上情况）等情况发生时，会员为第一责任人，平台同时有权追究连带责任人法律责任及善后处理的一切权利。</p> <p _v-d0c6b520=\"\">7、 任何情况下平台对会员的唯一补救责任为退回会员未使用的充值费用（如有），会员自愿放弃所有针对平台的间接、惩罚性和附带损害的索赔权利。</p> <h4 _v-d0c6b520=\"\">会员声明：</h4> <h4 style=text-indent:2em _v-d0c6b520=\"\">本人是具有法律规定的享有完全民事权利能力和民事行为能力，且能够独立承担民事责任的自然人，同意接受本协议之条款并注册成为平台会员。</h4> </div> </div> ";

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(461)
	__vue_template__ = __webpack_require__(642)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(504)
	__vue_script__ = __webpack_require__(301)
	__vue_template__ = __webpack_require__(680)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(487)
	__vue_script__ = __webpack_require__(302)
	__vue_template__ = __webpack_require__(665)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(472)
	__vue_script__ = __webpack_require__(303)
	__vue_template__ = __webpack_require__(652)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(452)
	__vue_script__ = __webpack_require__(304)
	__vue_template__ = __webpack_require__(635)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(454)
	__vue_script__ = __webpack_require__(305)
	__vue_template__ = __webpack_require__(636)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 782:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(505)
	__vue_script__ = __webpack_require__(306)
	__vue_template__ = __webpack_require__(681)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(467)
	__vue_script__ = __webpack_require__(307)
	__vue_template__ = __webpack_require__(647)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 784:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(522)
	__vue_script__ = __webpack_require__(308)
	__vue_template__ = __webpack_require__(695)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(464)
	__vue_script__ = __webpack_require__(309)
	__vue_template__ = __webpack_require__(645)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(482)
	__vue_script__ = __webpack_require__(310)
	__vue_template__ = __webpack_require__(660)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }


/***/ })

/******/ });


// WEBPACK FOOTER //
// static_page.7b23f39ee6fc614a32d69.js